(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Cookie = /*#__PURE__*/function () {
  function Cookie() {
    _classCallCheck(this, Cookie);
  }
  return _createClass(Cookie, [{
    key: "SetCookie",
    value: function SetCookie(CookieName, CookieValue, ExpiresInDays) {
      var d = new Date();
      d.setTime(d.getTime() + ExpiresInDays * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      var cookieToSet = CookieName + "=" + encodeURIComponent(CookieValue) + ";" + expires + ";Secure;SameSite=Lax;path=/";
      document.cookie = cookieToSet;
    }
  }, {
    key: "SetCookieToExpireInHours",
    value: function SetCookieToExpireInHours(CookieName, CookieValue, ExpiresInHours) {
      var d = new Date();
      d.setTime(d.getTime() + ExpiresInHours * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      var cookieToSet = CookieName + "=" + encodeURIComponent(CookieValue) + ";" + expires + ";Secure;SameSite=Lax;path=/";
      document.cookie = cookieToSet;
    }
  }, {
    key: "SetCookieSameSiteNone",
    value: function SetCookieSameSiteNone(CookieName, CookieValue, ExpiresInDays) {
      var d = new Date();
      d.setTime(d.getTime() + ExpiresInDays * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      var cookieToSet = CookieName + "=" + encodeURIComponent(CookieValue) + ";" + expires + ";Secure;SameSite=None;path=/";
      document.cookie = cookieToSet;
    }
  }, {
    key: "SetSessionCookie",
    value: function SetSessionCookie(cname, cvalue) {
      document.cookie = cname + "=" + cvalue + ";Secure;SameSite=Lax;expires=0;path=/";
    }
  }, {
    key: "GetCookie",
    value: function GetCookie(cname) {
      var name = cname + "=";
      var cookie = document.cookie;
      var ca = cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = decodeURIComponent(ca[i]);
        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }
  }, {
    key: "DeleteCookie",
    value: function DeleteCookie(name) {
      document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
    }
  }, {
    key: "GetValue",
    value: function GetValue(requestedValue, data) {
      var nameEQ = requestedValue + "=";
      var splits = data.split("&");
      for (var i = 0; i < splits.length; i++) {
        var c = splits[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
    }
  }]);
}();
var _default = exports["default"] = Cookie;

},{}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* common-shake removed: exports.clearAllBlobs = */ void clearAllBlobs;
exports.deleteImageBlob = deleteImageBlob;
/* common-shake removed: exports.getAllBlobIds = */ void getAllBlobIds;
exports.getAllImageKeys = getAllImageKeys;
exports.getImageBlob = getImageBlob;
exports.saveImageBlob = saveImageBlob;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var DB_NAME = "ForumDraftsDB";
var STORE_NAME = "DraftImages";
var DB_VERSION = 1;
function openDB() {
  return new Promise(function (resolve, reject) {
    var request = indexedDB.open(DB_NAME, DB_VERSION);
    request.onerror = function () {
      return reject(request.error);
    };
    request.onsuccess = function () {
      return resolve(request.result);
    };
    request.onupgradeneeded = function (e) {
      var db = e.target.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    };
  });
}
function saveImageBlob(_x, _x2) {
  return _saveImageBlob.apply(this, arguments);
}
function _saveImageBlob() {
  _saveImageBlob = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(id, blob) {
    var db, tx, store, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          _context.p = 0;
          if (blob instanceof Blob) {
            _context.n = 1;
            break;
          }
          console.warn("⚠️ Attempted to save non-Blob object:", blob);
          return _context.a(2);
        case 1:
          _context.n = 2;
          return openDB();
        case 2:
          db = _context.v;
          tx = db.transaction(STORE_NAME, "readwrite");
          store = tx.objectStore(STORE_NAME);
          _context.n = 3;
          return store.put(blob, id);
        case 3:
          return _context.a(2, new Promise(function (resolve, reject) {
            tx.oncomplete = function () {
              return resolve();
            };
            tx.onerror = function () {
              return reject(tx.error);
            };
            tx.onabort = function () {
              return reject(tx.error);
            };
          }));
        case 4:
          _context.p = 4;
          _t = _context.v;
          console.error("❌ Failed to save blob:", _t);
          throw _t;
        case 5:
          return _context.a(2);
      }
    }, _callee, null, [[0, 4]]);
  }));
  return _saveImageBlob.apply(this, arguments);
}
function getImageBlob(_x3) {
  return _getImageBlob.apply(this, arguments);
}
function _getImageBlob() {
  _getImageBlob = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(id) {
    var db;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          _context2.n = 1;
          return openDB();
        case 1:
          db = _context2.v;
          return _context2.a(2, new Promise(function (resolve, reject) {
            var tx = db.transaction(STORE_NAME, "readonly");
            var store = tx.objectStore(STORE_NAME);
            var request = store.get(id);
            request.onsuccess = function () {
              var result = request.result;
              if (!(result instanceof Blob)) {
                console.warn("\u26A0\uFE0F Retrieved value for ".concat(id, " is not a Blob:"), result);
                resolve(null);
              } else {
                resolve(result);
              }
            };
            request.onerror = function () {
              return reject(request.error);
            };
          }));
      }
    }, _callee2);
  }));
  return _getImageBlob.apply(this, arguments);
}
function clearAllBlobs() {
  return _clearAllBlobs.apply(this, arguments);
}
function _clearAllBlobs() {
  _clearAllBlobs = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
    var db, tx;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          _context3.n = 1;
          return openDB();
        case 1:
          db = _context3.v;
          tx = db.transaction(STORE_NAME, "readwrite");
          tx.objectStore(STORE_NAME).clear();
          return _context3.a(2, new Promise(function (resolve, reject) {
            tx.oncomplete = function () {
              return resolve();
            };
            tx.onerror = function () {
              return reject(tx.error);
            };
            tx.onabort = function () {
              return reject(tx.error);
            };
          }));
      }
    }, _callee3);
  }));
  return _clearAllBlobs.apply(this, arguments);
}
function getAllBlobIds() {
  return _getAllBlobIds.apply(this, arguments);
}
function _getAllBlobIds() {
  _getAllBlobIds = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
    var db, tx, store;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          _context4.n = 1;
          return openDB();
        case 1:
          db = _context4.v;
          tx = db.transaction(STORE_NAME, "readonly");
          store = tx.objectStore(STORE_NAME);
          return _context4.a(2, store.getAllKeys());
      }
    }, _callee4);
  }));
  return _getAllBlobIds.apply(this, arguments);
}
function deleteImageBlob(_x4) {
  return _deleteImageBlob.apply(this, arguments);
}
function _deleteImageBlob() {
  _deleteImageBlob = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(id) {
    var db, tx, store;
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          _context5.n = 1;
          return openDB();
        case 1:
          db = _context5.v;
          tx = db.transaction(STORE_NAME, "readwrite");
          store = tx.objectStore(STORE_NAME);
          store["delete"](id);
          return _context5.a(2, new Promise(function (resolve, reject) {
            tx.oncomplete = function () {
              return resolve();
            };
            tx.onerror = function () {
              return reject(tx.error);
            };
            tx.onabort = function () {
              return reject(tx.error);
            };
          }));
      }
    }, _callee5);
  }));
  return _deleteImageBlob.apply(this, arguments);
}
function getAllImageKeys() {
  return _getAllImageKeys.apply(this, arguments);
}
function _getAllImageKeys() {
  _getAllImageKeys = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
    return _regenerator().w(function (_context6) {
      while (1) switch (_context6.n) {
        case 0:
          return _context6.a(2, new Promise(function (resolve, reject) {
            var request = indexedDB.open("ForumImageDrafts", 1);
            request.onsuccess = function () {
              var db = request.result;
              var tx = db.transaction("images", "readonly");
              var store = tx.objectStore("images");
              var keys = [];
              var cursorRequest = store.openCursor();
              cursorRequest.onsuccess = function (event) {
                var cursor = event.target.result;
                if (cursor) {
                  keys.push(cursor.key);
                  cursor["continue"]();
                } else {
                  resolve(keys);
                }
              };
              cursorRequest.onerror = function () {
                return reject("Failed to list image keys.");
              };
            };
            request.onerror = function () {
              return reject("Failed to open IndexedDB.");
            };
          }));
      }
    }, _callee6);
  }));
  return _getAllImageKeys.apply(this, arguments);
}

},{}],3:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ForumDraftImageStore = require("./ForumDraftImageStore.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorValues(e) { if (null != e) { var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0; if (t) return t.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } }; } throw new TypeError(_typeof(e) + " is not iterable"); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Lightbox = /*#__PURE__*/function () {
  /**
   * Lightbox handles image management and UI for forum post/comment image attachments,
   * including uploading, previewing, deleting, and syncing image data with drafts.
   */
  function Lightbox() {
    _classCallCheck(this, Lightbox);
    this.allowedFileTypes = ["image/jpeg", "image/png", "image/gif", "image/webp", "image/heic", "image/heif", "image/avif", "image/bmp", "image/svg+xml"];
    this.tmp_files = new Map(); // Map of imageId -> metadata { file, name, type, deleted }

    this.tmp_fileOrder = []; // Maintains insertion order of imageIds
    this.imageContexts = new Map(); // Maps imageTempId => context ("draft" or "edit")
    this.currentContext = "draft"; // default to draft mode

    // Lightbox navigation handlers
    $('.lb-nav a.lb-next').on('click', function (e) {
      e.preventDefault();
      var dialogWithNext = $(e.target).closest('.has-next');
      if (dialogWithNext.length) {
        var currentIndex = dialogWithNext.data('currentIndex') || 0;
        var gallery = dialogWithNext.data('gallery');
        var nextIndex = currentIndex + 1;
        dialogWithNext.data('currentIndex', nextIndex);
        if (nextIndex === gallery.length - 1) {
          dialogWithNext.removeClass('has-next');
        } else {
          dialogWithNext.addClass('has-next');
        }
        if (currentIndex === 0) {
          dialogWithNext.addClass('has-prev');
        }
        $('#' + dialogWithNext.attr('id') + " img.lightbox-image").attr('src', gallery[nextIndex].src);
        $('.XofY .x').html(nextIndex + 1);
      }
    });
    $('.lb-nav a.lb-prev').on('click', function (e) {
      e.preventDefault();
      var dialogWithPrevious = $(e.target).closest('.has-prev');
      if (dialogWithPrevious.length) {
        var currentIndex = dialogWithPrevious.data('currentIndex') || 0;
        var gallery = dialogWithPrevious.data('gallery');
        var newIndex = currentIndex - 1;
        dialogWithPrevious.data('currentIndex', newIndex);
        if (newIndex === 0) {
          dialogWithPrevious.removeClass('has-prev');
        }
        if (currentIndex === gallery.length - 1) {
          dialogWithPrevious.addClass('has-next');
        }
        $('#' + dialogWithPrevious.attr('id') + " img.lightbox-image").attr('src', gallery[newIndex].src);
        $('.XofY .x').html(newIndex + 1);
      }
    });
  }

  /**
   * Clears image metadata and optionally blobs from storage.
   * @param {boolean} force - Whether to forcefully clear all entries regardless of draft context.
   * @param {string|null} draftKey - Specific draft key to target, if not forcing.
   */
  return _createClass(Lightbox, [{
    key: "clearImageSession",
    value: (function () {
      var _clearImageSession = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this = this;
        var force,
          draftKey,
          _iterator,
          _step,
          _loop,
          _args2 = arguments,
          _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              force = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : false;
              draftKey = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : null;
              _iterator = _createForOfIteratorHelper(this.tmp_files.entries());
              _context2.p = 1;
              _loop = /*#__PURE__*/_regenerator().m(function _loop() {
                var _step$value, id, meta;
                return _regenerator().w(function (_context) {
                  while (1) switch (_context.n) {
                    case 0:
                      _step$value = _slicedToArray(_step.value, 2), id = _step$value[0], meta = _step$value[1];
                      if (!(force || draftKey && meta.draftKey === draftKey || !draftKey && meta.context === _this.currentContext)) {
                        _context.n = 2;
                        break;
                      }
                      _context.n = 1;
                      return (0, _ForumDraftImageStore.deleteImageBlob)(id);
                    case 1:
                      _this.tmp_files["delete"](id);
                      _this.tmp_fileOrder = _this.tmp_fileOrder.filter(function (fid) {
                        return fid !== id;
                      });
                    case 2:
                      return _context.a(2);
                  }
                }, _loop);
              });
              _iterator.s();
            case 2:
              if ((_step = _iterator.n()).done) {
                _context2.n = 4;
                break;
              }
              return _context2.d(_regeneratorValues(_loop()), 3);
            case 3:
              _context2.n = 2;
              break;
            case 4:
              _context2.n = 6;
              break;
            case 5:
              _context2.p = 5;
              _t = _context2.v;
              _iterator.e(_t);
            case 6:
              _context2.p = 6;
              _iterator.f();
              return _context2.f(6);
            case 7:
              console.log("[Lightbox] Cleared image session for context: ".concat(this.currentContext).concat(draftKey ? " and draftKey: ".concat(draftKey) : ''));
            case 8:
              return _context2.a(2);
          }
        }, _callee, this, [[1, 5, 6, 7]]);
      }));
      function clearImageSession() {
        return _clearImageSession.apply(this, arguments);
      }
      return clearImageSession;
    }()
    /**
     * Attaches change handlers to file inputs for posts and comments,
     * handling validation, format conversion, and image metadata registration.
     */
    )
  }, {
    key: "IgniteAddPostPhotoButton",
    value: function IgniteAddPostPhotoButton() {
      var _this2 = this;
      var handleImageInput = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(file, targetSelector) {
          var mimeType, formData, response, webpBlob, tempId, meta, _window$SocialProfile, draftKey, _t2, _t3, _t4, _t5;
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.p = _context3.n) {
              case 0:
                if (file) {
                  _context3.n = 1;
                  break;
                }
                return _context3.a(2);
              case 1:
                _t2 = file.type;
                if (_t2) {
                  _context3.n = 3;
                  break;
                }
                _context3.n = 2;
                return _this2.getMimeTypeFromHeader(file);
              case 2:
                _t2 = _context3.v;
              case 3:
                mimeType = _t2;
                if (_this2.allowedFileTypes.includes(mimeType)) {
                  _context3.n = 4;
                  break;
                }
                alert(window.INVALID_FILE_TYPE);
                return _context3.a(2);
              case 4:
                if (!(file.size > 26214400)) {
                  _context3.n = 5;
                  break;
                }
                alert(window.FILE_SIZE_TOO_BIG);
                return _context3.a(2);
              case 5:
                if (targetSelector === "#img-post-frames") {
                  $('#submit-post-progress').show();
                } else if (targetSelector === "#img-comment-frames") {
                  $('#submit-comment-progress').show();
                }
                formData = new FormData();
                formData.append("file", file);
                _context3.p = 6;
                _context3.n = 7;
                return fetch("/assets/images/convert/", {
                  method: "POST",
                  body: formData
                });
              case 7:
                response = _context3.v;
                if (response.ok) {
                  _context3.n = 9;
                  break;
                }
                _t3 = Error;
                _context3.n = 8;
                return response.text();
              case 8:
                _t4 = _context3.v;
                throw new _t3(_t4);
              case 9:
                _context3.n = 10;
                return response.blob();
              case 10:
                webpBlob = _context3.v;
                tempId = "img-".concat(crypto.randomUUID());
                _context3.n = 11;
                return (0, _ForumDraftImageStore.saveImageBlob)(tempId, webpBlob);
              case 11:
                meta = {
                  file: webpBlob,
                  name: file.name,
                  type: "new",
                  deleted: false,
                  context: _this2.currentContext
                }; // Only assign draftKey if we're in draft mode
                if (!(_this2.currentContext === "draft")) {
                  _context3.n = 13;
                  break;
                }
                draftKey = _this2.currentDraftKey;
                if (draftKey) {
                  _context3.n = 12;
                  break;
                }
                console.warn("[ImageMeta] Missing draftKey in draft context");
                return _context3.a(2);
              case 12:
                meta.draftKey = draftKey;

                // Now that we're definitely in draft mode, save
                _this2.addImageMeta(tempId, meta);
                _this2.PaintSmart(meta, targetSelector, tempId);
                if (typeof ((_window$SocialProfile = window.SocialProfile) === null || _window$SocialProfile === void 0 ? void 0 : _window$SocialProfile.SaveDraft) === 'function') {
                  console.log("Saving draft after image change");
                  window.SocialProfile.SaveDraft();
                }
                _context3.n = 14;
                break;
              case 13:
                // edit mode: just add/update the image, no draft save
                _this2.addImageMeta(tempId, meta);
                _this2.PaintSmart(meta, targetSelector, tempId);
              case 14:
                _context3.n = 16;
                break;
              case 15:
                _context3.p = 15;
                _t5 = _context3.v;
                console.log(_t5);
                alert("Conversion failed: " + _t5.message);
              case 16:
                _context3.p = 16;
                if (targetSelector === "#img-post-frames") {
                  $('#submit-post-progress').hide();
                } else if (targetSelector === "#img-comment-frames") {
                  $('#submit-comment-progress').hide();
                }
                return _context3.f(16);
              case 17:
                return _context3.a(2);
            }
          }, _callee2, null, [[6, 15, 16, 17]]);
        }));
        return function handleImageInput(_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }();
      if (imgInpPost !== undefined) {
        imgInpPost.onchange = /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(evt) {
            var _imgInpPost$files, file;
            return _regenerator().w(function (_context4) {
              while (1) switch (_context4.n) {
                case 0:
                  _imgInpPost$files = _slicedToArray(imgInpPost.files, 1), file = _imgInpPost$files[0];
                  _context4.n = 1;
                  return handleImageInput.call(_this2, file, "#img-post-frames");
                case 1:
                  return _context4.a(2);
              }
            }, _callee3);
          }));
          return function (_x3) {
            return _ref2.apply(this, arguments);
          };
        }();
      }
      if (imgInpComment !== undefined) {
        imgInpComment.onchange = /*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(evt) {
            var _imgInpComment$files, fileComment;
            return _regenerator().w(function (_context5) {
              while (1) switch (_context5.n) {
                case 0:
                  _imgInpComment$files = _slicedToArray(imgInpComment.files, 1), fileComment = _imgInpComment$files[0];
                  _context5.n = 1;
                  return handleImageInput.call(_this2, fileComment, "#img-comment-frames");
                case 1:
                  return _context5.a(2);
              }
            }, _callee4);
          }));
          return function (_x4) {
            return _ref3.apply(this, arguments);
          };
        }();
      }
    }
  }, {
    key: "getMimeTypeFromHeader",
    value: function () {
      var _getMimeTypeFromHeader = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(file) {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              return _context6.a(2, new Promise(function (resolve, reject) {
                var reader = new FileReader();
                reader.onloadend = function () {
                  var arr = new Uint8Array(reader.result).subarray(0, 12);
                  var hex = Array.from(arr).map(function (b) {
                    return b.toString(16).padStart(2, '0');
                  }).join('');
                  if (hex.includes('6674797068656963')) {
                    resolve('image/heic');
                  } else if (hex.startsWith('ffd8')) {
                    resolve('image/jpeg');
                  } else if (hex.startsWith('89504e47')) {
                    resolve('image/png');
                  } else {
                    resolve('');
                  }
                };
                reader.onerror = function () {
                  return reject("Failed to read file header");
                };
                reader.readAsArrayBuffer(file.slice(0, 12));
              }));
          }
        }, _callee5);
      }));
      function getMimeTypeFromHeader(_x5) {
        return _getMimeTypeFromHeader.apply(this, arguments);
      }
      return getMimeTypeFromHeader;
    }()
  }, {
    key: "LoadServerImage",
    value: function () {
      var _LoadServerImage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(fileName) {
        var frameId,
          url,
          response,
          blob,
          tempId,
          meta,
          draftKey,
          _args7 = arguments,
          _t6;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              frameId = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : "#img-comment-frames";
              _context7.p = 1;
              url = "/local/assets/images/forum/".concat(fileName);
              _context7.n = 2;
              return fetch(url);
            case 2:
              response = _context7.v;
              if (response.ok) {
                _context7.n = 3;
                break;
              }
              throw new Error("Failed to fetch image: ".concat(fileName));
            case 3:
              _context7.n = 4;
              return response.blob();
            case 4:
              blob = _context7.v;
              tempId = "img-".concat(crypto.randomUUID());
              _context7.n = 5;
              return (0, _ForumDraftImageStore.saveImageBlob)(tempId, blob);
            case 5:
              meta = {
                file: blob,
                name: fileName,
                type: "restored",
                deleted: false,
                context: this.currentContext
              }; // Only assign draftKey if in draft mode
              if (!(this.currentContext === "draft")) {
                _context7.n = 7;
                break;
              }
              draftKey = this.currentDraftKey;
              if (draftKey) {
                _context7.n = 6;
                break;
              }
              console.warn("[ImageMeta] Missing draftKey in draft context");
              return _context7.a(2);
            case 6:
              meta.draftKey = draftKey;
            case 7:
              this.addImageMeta(tempId, meta);
              this.PaintSmart(meta, frameId, tempId);
              this.dedupeTmpFileOrder();
              _context7.n = 9;
              break;
            case 8:
              _context7.p = 8;
              _t6 = _context7.v;
              console.error("[LoadServerImage] Error loading server image:", _t6);
            case 9:
              return _context7.a(2);
          }
        }, _callee6, this, [[1, 8]]);
      }));
      function LoadServerImage(_x6) {
        return _LoadServerImage.apply(this, arguments);
      }
      return LoadServerImage;
    }()
  }, {
    key: "RemoveImage",
    value: function () {
      var _RemoveImage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(imageId) {
        var _window$SocialProfile2;
        var frameId,
          meta,
          isEdit,
          draftKey,
          _iterator2,
          _step2,
          id,
          fileMeta,
          belongsToContext,
          _args8 = arguments,
          _t7;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              frameId = _args8.length > 1 && _args8[1] !== undefined ? _args8[1] : "#img-frames";
              meta = this.tmp_files.get(imageId);
              if (meta) {
                _context8.n = 1;
                break;
              }
              return _context8.a(2);
            case 1:
              isEdit = this.currentContext === "edit";
              draftKey = this.currentDraftKey;
              if (!(meta.type === "restored")) {
                _context8.n = 2;
                break;
              }
              meta.deleted = true;
              this.tmp_files.set(imageId, meta); // update in case it's tracked elsewhere
              _context8.n = 6;
              break;
            case 2:
              this.removeImageMeta(imageId);
              _context8.p = 3;
              _context8.n = 4;
              return (0, _ForumDraftImageStore.deleteImageBlob)(imageId);
            case 4:
              console.log("\uD83D\uDDD1\uFE0F Deleted blob from IndexedDB: ".concat(imageId));
              _context8.n = 6;
              break;
            case 5:
              _context8.p = 5;
              _t7 = _context8.v;
              console.error("\u274C Failed to delete blob ".concat(imageId, ":"), _t7);
            case 6:
              // Re-render only images relevant to this draft or edit
              $(frameId).html('');
              _iterator2 = _createForOfIteratorHelper(this.tmp_fileOrder);
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  id = _step2.value;
                  fileMeta = this.tmp_files.get(id);
                  belongsToContext = isEdit ? (fileMeta === null || fileMeta === void 0 ? void 0 : fileMeta.context) === "edit" : (fileMeta === null || fileMeta === void 0 ? void 0 : fileMeta.draftKey) === draftKey;
                  if (fileMeta && !fileMeta.deleted && belongsToContext) {
                    this.PaintSmart(fileMeta, frameId, id);
                  }
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              if (typeof ((_window$SocialProfile2 = window.SocialProfile) === null || _window$SocialProfile2 === void 0 ? void 0 : _window$SocialProfile2.SaveDraft) === 'function') {
                window.SocialProfile.SaveDraft();
              }
            case 7:
              return _context8.a(2);
          }
        }, _callee7, this, [[3, 5]]);
      }));
      function RemoveImage(_x7) {
        return _RemoveImage.apply(this, arguments);
      }
      return RemoveImage;
    }()
  }, {
    key: "PaintImage",
    value: function PaintImage(fileOrBlob) {
      var frameId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "#img-frames";
      var imageId = arguments.length > 2 ? arguments[2] : undefined;
      if (!fileOrBlob || _typeof(fileOrBlob) !== "object") {
        console.warn("[PaintImage] Invalid file/blob:", fileOrBlob);
        return;
      }
      var meta = this.tmp_files.get(imageId);

      // ✅ Skip if deleted or mismatched draftKey (unless in edit mode)
      if (!meta || meta.deleted || this.currentContext !== "edit" && meta.draftKey !== this.currentDraftKey) {
        console.log("[PaintImage] Skipping image: ".concat(imageId, " (deleted or not for current draftKey)"));
        return;
      }
      var url = URL.createObjectURL(fileOrBlob);
      var image = "<div class='attached-files'>\n        <img src='".concat(url, "' class=\"review-image\" />\n        <svg fill=\"currentColor\" onclick=\"window.Lightbox.RemoveImage('").concat(imageId, "','").concat(frameId, "')\"\n             class=\"delete-review-image\" viewBox=\"0 0 40 40\" height=\"25\" width=\"25\"\n             style=\"vertical-align: middle; color: rgb(51, 51, 51);\">\n             <g><path d=\"M10 10 L30 30 M30 10 L10 30\" stroke=\"black\" stroke-width=\"2\"/></g>\n        </svg>\n    </div>");
      $(frameId).append(image);
    }
  }, {
    key: "PaintRestoredImage",
    value: function PaintRestoredImage(blob) {
      var frameId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "#img-frames";
      var imageId = arguments.length > 2 ? arguments[2] : undefined;
      var meta = this.tmp_files.get(imageId);

      // ✅ Allow rendering in "edit" mode without checking draftKey
      if (!meta || meta.deleted || this.currentContext !== "edit" && meta.draftKey !== this.currentDraftKey) {
        console.log("[PaintRestoredImage] Skipping image: ".concat(imageId, " (deleted or not for current draftKey)"));
        return;
      }
      var reader = new FileReader();
      reader.onload = function (e) {
        var html = "<div class='attached-files'>\n            <img src='".concat(e.target.result, "' class=\"review-image\" />\n            <svg fill=\"currentColor\" onclick=\"window.Lightbox.RemoveImage('").concat(imageId, "','").concat(frameId, "')\"\n                class=\"delete-review-image\" viewBox=\"0 0 40 40\" height=\"25\" width=\"25\"\n                style=\"vertical-align: middle; color: rgb(51, 51, 51);\">\n                <g><path d=\"M10 10 L30 30 M30 10 L10 30\" stroke=\"black\" stroke-width=\"2\"/></g>\n            </svg>\n        </div>");
        $(frameId).append(html);
      };
      reader.readAsDataURL(blob);
    }

    /**
     * Chooses whether to paint a restored or new image based on metadata.
     * @param {object} meta - Image metadata object.
     * @param {string} frameId - Target DOM selector.
     * @param {string} imageId - ID of the image blob.
     */
  }, {
    key: "PaintSmart",
    value: function PaintSmart(meta, frameId, imageId) {
      if (meta.type === "restored") {
        this.PaintRestoredImage(meta.file, frameId, imageId);
      } else {
        this.PaintImage(meta.file, frameId, imageId);
      }
    }
  }, {
    key: "RestoreImages",
    value: function () {
      var _RestoreImages = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(imageRefs, frameId) {
        var isEditing, draftKey, _iterator3, _step3, id, blob, meta, _t8;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              isEditing = this.currentContext === "edit";
              draftKey = this.currentDraftKey;
              if (draftKey) {
                _context9.n = 1;
                break;
              }
              console.warn("[ImageMeta] Cannot assign image without draftKey");
              return _context9.a(2);
            case 1:
              _iterator3 = _createForOfIteratorHelper(imageRefs);
              _context9.p = 2;
              _iterator3.s();
            case 3:
              if ((_step3 = _iterator3.n()).done) {
                _context9.n = 6;
                break;
              }
              id = _step3.value;
              _context9.n = 4;
              return (0, _ForumDraftImageStore.getImageBlob)(id);
            case 4:
              blob = _context9.v;
              if (blob) {
                meta = {
                  file: blob,
                  name: id,
                  type: isEditing ? "restored" : "new",
                  deleted: false,
                  context: this.currentContext,
                  draftKey: draftKey
                };
                this.addImageMeta(id, meta);
                this.PaintSmart(meta, frameId, id);
              } else {
                console.warn("⚠️ No blob found for", id);
              }
            case 5:
              _context9.n = 3;
              break;
            case 6:
              _context9.n = 8;
              break;
            case 7:
              _context9.p = 7;
              _t8 = _context9.v;
              _iterator3.e(_t8);
            case 8:
              _context9.p = 8;
              _iterator3.f();
              return _context9.f(8);
            case 9:
              this.dedupeTmpFileOrder();
            case 10:
              return _context9.a(2);
          }
        }, _callee8, this, [[2, 7, 8, 9]]);
      }));
      function RestoreImages(_x8, _x9) {
        return _RestoreImages.apply(this, arguments);
      }
      return RestoreImages;
    }()
  }, {
    key: "getCurrentImageRefs",
    value: function getCurrentImageRefs() {
      var _this3 = this;
      var draftKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.currentDraftKey;
      return this.tmp_fileOrder.filter(function (id) {
        var meta = _this3.tmp_files.get(id);
        return meta && !meta.deleted && meta.draftKey === draftKey;
      });
    }
  }, {
    key: "InitializeLBImages",
    value: function InitializeLBImages(containerClass) {
      var images = $('.' + containerClass + ' img.lightbox-slide:not(.lightbox-image)');
      for (var i = 0; i < images.length; i++) {
        if ($(images[i]).parent().is('a')) continue;
        var srcLink = $(images[i]).attr('src');
        $(images[i]).wrap("<a href='".concat(srcLink, "' data-toggle='lightbox-image' data-target-id='lightbox-image-holder'>"));
      }
      $('[data-toggle="lightbox-image"]').on('click', function (e) {
        var _this4 = this;
        e.preventDefault();
        var clickedIndex = 0;
        var gallery = $(this).closest('.image-row').find('img');
        var id = $(this).data("target-id");
        var srclink = $(this).attr('href');
        $('#' + id + " img.lightbox-image").attr('src', srclink);
        var modelPopUp = $('#' + id);
        modelPopUp.removeClass('has-next has-prev');
        modelPopUp.data('gallery', []);
        if (gallery.length > 1) {
          modelPopUp.data('gallery', gallery);
          gallery.each(function (i, el) {
            if (el.src === _this4.href) clickedIndex = i;
          });
          modelPopUp.data('currentIndex', clickedIndex);
          if (clickedIndex > 0) modelPopUp.addClass('has-prev');
          if (clickedIndex + 1 < gallery.length) modelPopUp.addClass('has-next');
        }
        $('.XofY .x').html(clickedIndex + 1);
        $('.XofY .y').html(gallery.length);
        setTimeout(function () {
          return modelPopUp.modal('show');
        }, 100);
        return false;
      });
    }

    /**
    * Appends image blobs and their state to the form data for submission.
    * Handles both drafts and edit contexts.
    * @param {FormData} formData
    * @param {string|null} draftKey
    */
  }, {
    key: "AppendForumImagesToFormData",
    value: function AppendForumImagesToFormData(formData) {
      var draftKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.currentDraftKey;
      var isEdit = this.currentContext === "edit";
      var deletedRestored = [];
      var preservedRestored = [];
      var _iterator4 = _createForOfIteratorHelper(this.tmp_files.entries()),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _meta$file;
          var _step4$value = _slicedToArray(_step4.value, 2),
            id = _step4$value[0],
            meta = _step4$value[1];
          var belongsToContext = isEdit ? meta.context === "edit" : meta.draftKey === draftKey;
          if (!belongsToContext) continue;
          if (meta.type === "new" && !meta.deleted && (_meta$file = meta.file) !== null && _meta$file !== void 0 && (_meta$file = _meta$file.type) !== null && _meta$file !== void 0 && _meta$file.match('image.*')) {
            formData.append('Files', meta.file, meta.name);
          }
          if (meta.type === "restored" && meta.deleted) {
            deletedRestored.push(meta.name);
          }
          if (meta.type === "restored" && !meta.deleted) {
            preservedRestored.push(meta.name);
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      deletedRestored.forEach(function (name) {
        return formData.append('DeletedFileNames', name);
      });
      preservedRestored.forEach(function (name) {
        return formData.append('PreservedFileNames', name);
      });
    }
  }, {
    key: "addImageMeta",
    value: function addImageMeta(imageId, metadata) {
      // 1. Enforce draftKey presence
      if (!metadata.draftKey && this.currentContext !== "edit") {
        console.warn("[addImageMeta] Missing draftKey for imageId: ".concat(imageId, ". Skipping."));
        return;
      }

      // 2. Enforce current draftKey context
      if (metadata.draftKey !== this.currentDraftKey && this.currentContext !== "edit") {
        console.warn("[addImageMeta] Mismatched draftKey for imageId: ".concat(imageId, ". Expected: ").concat(this.currentDraftKey, ", Got: ").concat(metadata.draftKey, ". Skipping."));
        return;
      }

      // 3. Always update metadata
      this.tmp_files.set(imageId, metadata);

      // 4. Ensure unique order
      if (!this.tmp_fileOrder.includes(imageId)) {
        this.tmp_fileOrder.push(imageId);
      }
    }
  }, {
    key: "removeImageMeta",
    value: function removeImageMeta(imageId) {
      if (this.tmp_files.has(imageId)) {
        this.tmp_files["delete"](imageId);
        this.tmp_fileOrder = this.tmp_fileOrder.filter(function (id) {
          return id !== imageId;
        });
      }
    }
  }, {
    key: "RenderImageRefsFromDraft",
    value: function () {
      var _RenderImageRefsFromDraft = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(imageRefs) {
        var frameId,
          draftKey,
          isEditing,
          _iterator5,
          _step5,
          id,
          blob,
          meta,
          _args0 = arguments,
          _t9;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.p = _context0.n) {
            case 0:
              frameId = _args0.length > 1 && _args0[1] !== undefined ? _args0[1] : "#img-post-frames";
              if (!(!Array.isArray(imageRefs) || imageRefs.length === 0)) {
                _context0.n = 1;
                break;
              }
              return _context0.a(2);
            case 1:
              draftKey = this.currentDraftKey;
              if (draftKey) {
                _context0.n = 2;
                break;
              }
              console.warn("[ImageMeta] Cannot assign image without draftKey");
              return _context0.a(2);
            case 2:
              isEditing = this.currentContext === "edit";
              _iterator5 = _createForOfIteratorHelper(imageRefs);
              _context0.p = 3;
              _iterator5.s();
            case 4:
              if ((_step5 = _iterator5.n()).done) {
                _context0.n = 7;
                break;
              }
              id = _step5.value;
              _context0.n = 5;
              return (0, _ForumDraftImageStore.getImageBlob)(id);
            case 5:
              blob = _context0.v;
              if (blob) {
                meta = {
                  file: blob,
                  name: id,
                  type: isEditing ? "restored" : "new",
                  deleted: false,
                  context: this.currentContext,
                  draftKey: draftKey
                };
                this.addImageMeta(id, meta);
                this.PaintSmart(meta, frameId, id);
                this.dedupeTmpFileOrder();
              } else {
                console.warn("[Lightbox] Skipped missing blob: ".concat(id));
              }
            case 6:
              _context0.n = 4;
              break;
            case 7:
              _context0.n = 9;
              break;
            case 8:
              _context0.p = 8;
              _t9 = _context0.v;
              _iterator5.e(_t9);
            case 9:
              _context0.p = 9;
              _iterator5.f();
              return _context0.f(9);
            case 10:
              return _context0.a(2);
          }
        }, _callee9, this, [[3, 8, 9, 10]]);
      }));
      function RenderImageRefsFromDraft(_x0) {
        return _RenderImageRefsFromDraft.apply(this, arguments);
      }
      return RenderImageRefsFromDraft;
    }()
  }, {
    key: "cleanupUnusedBlobsFromDrafts",
    value: function () {
      var _cleanupUnusedBlobsFromDrafts = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var allDrafts, referencedIds, _iterator6, _step6, draft, keys, deletedCount, _iterator7, _step7, key, _t0;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.p = _context1.n) {
            case 0:
              allDrafts = Object.keys(localStorage).filter(function (k) {
                return k.startsWith('forumDraft-');
              }).map(function (k) {
                try {
                  return JSON.parse(localStorage.getItem(k));
                } catch (_unused) {
                  return null;
                }
              }).filter(Boolean); // Collect all referenced image IDs
              referencedIds = new Set();
              _iterator6 = _createForOfIteratorHelper(allDrafts);
              try {
                for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                  draft = _step6.value;
                  if (Array.isArray(draft.imageRefs)) {
                    draft.imageRefs.forEach(function (id) {
                      return referencedIds.add(id);
                    });
                  }
                }

                // Get all stored blobs from IndexedDB
              } catch (err) {
                _iterator6.e(err);
              } finally {
                _iterator6.f();
              }
              _context1.n = 1;
              return (0, _ForumDraftImageStore.getAllImageKeys)();
            case 1:
              keys = _context1.v;
              deletedCount = 0;
              _iterator7 = _createForOfIteratorHelper(keys);
              _context1.p = 2;
              _iterator7.s();
            case 3:
              if ((_step7 = _iterator7.n()).done) {
                _context1.n = 6;
                break;
              }
              key = _step7.value;
              if (referencedIds.has(key)) {
                _context1.n = 5;
                break;
              }
              _context1.n = 4;
              return window.ForumDraftImageStore.deleteImageBlob(key);
            case 4:
              deletedCount++;
            case 5:
              _context1.n = 3;
              break;
            case 6:
              _context1.n = 8;
              break;
            case 7:
              _context1.p = 7;
              _t0 = _context1.v;
              _iterator7.e(_t0);
            case 8:
              _context1.p = 8;
              _iterator7.f();
              return _context1.f(8);
            case 9:
              console.log("[Lightbox] Cleaned up ".concat(deletedCount, " unused blobs from IndexedDB"));
            case 10:
              return _context1.a(2);
          }
        }, _callee0, null, [[2, 7, 8, 9]]);
      }));
      function cleanupUnusedBlobsFromDrafts() {
        return _cleanupUnusedBlobsFromDrafts.apply(this, arguments);
      }
      return cleanupUnusedBlobsFromDrafts;
    }()
  }, {
    key: "resetTmpFilesForDraft",
    value: function resetTmpFilesForDraft(draftKey) {
      var _this5 = this;
      var _iterator8 = _createForOfIteratorHelper(this.tmp_files.entries()),
        _step8;
      try {
        var _loop2 = function _loop2() {
          var _step8$value = _slicedToArray(_step8.value, 2),
            id = _step8$value[0],
            meta = _step8$value[1];
          if (meta.draftKey === draftKey) {
            _this5.tmp_files["delete"](id);
            _this5.tmp_fileOrder = _this5.tmp_fileOrder.filter(function (fid) {
              return fid !== id;
            });
          }
        };
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          _loop2();
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
    }
  }, {
    key: "dedupeTmpFileOrder",
    value: function dedupeTmpFileOrder() {
      var seen = new Set();
      var deduped = [];
      var _iterator9 = _createForOfIteratorHelper(this.tmp_fileOrder),
        _step9;
      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var id = _step9.value;
          // Only keep unique IDs that still exist in tmp_files
          if (this.tmp_files.has(id) && !seen.has(id)) {
            seen.add(id);
            deduped.push(id);
          }
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
      this.tmp_fileOrder = deduped;
      console.log("[Lightbox] Deduped tmp_fileOrder:", deduped);
    }
  }]);
}();
var _default = exports["default"] = Lightbox;

},{"./ForumDraftImageStore.js":2}],4:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var NewsManager = /*#__PURE__*/function () {
  function NewsManager() {
    _classCallCheck(this, NewsManager);
    this.InitTriggers();
  }
  return _createClass(NewsManager, [{
    key: "InitTriggers",
    value: function InitTriggers() {
      // Remove popup when clicking outside
      $(document).on('click', function (e) {
        if (!$(e.target).closest('.delete-comment-wrapper').length) {
          $('.delete-confirm-popup').remove();
        }
      });
    }

    /**
     * Shows the comments dialog for a specific news item.
     * It initializes the dialog, clears previous comments, and loads new ones.
     * @param {Number} newsId - The ID of the news item to show comments for.
     */
  }, {
    key: "ShowCommentsDialog",
    value: function ShowCommentsDialog(newsId) {
      this.newsId = newsId;
      $('#news-comments-dialog').find('#comment-list').empty();
      $('#news-comments-dialog').find('#comment-content').removeClass('is-invalid');
      $('#news-comments-dialog').find('#comment-content').val('');
      $('#news-comments-dialog').find('#comment-list').html('Loading...');
      $('#news-comments-dialog').modal('show');
      this.LoadComments(newsId);
    }

    /**
     * Loads comments for a specific news item.
     * It makes an AJAX GET request to fetch comments and then renders them.
     * @param {Number} newsId - The ID of the news item to load comments for.
     */
  }, {
    key: "LoadComments",
    value: function LoadComments(newsId) {
      var _this2 = this;
      $('#news-comments-dialog').find("#comment-dlg-progress").show();
      $.ajax({
        url: '/api/news/' + newsId + '/comments',
        type: 'GET',
        dataType: 'json',
        success: function success(data) {
          _this2.RenderComments(data);
          _this2.MarkCommentsAsSeen(newsId);
        },
        complete: function complete() {
          $('#news-comments-dialog').find("#comment-dlg-progress").hide();
        }
      });
    }

    /**
     * Renders the comments in the dialog.
     * It clears the existing comments and appends new ones.
     * @param {Array} comments - The list of comments to render.
     */
  }, {
    key: "RenderComments",
    value: function RenderComments(comments) {
      var _this = this;
      var commentList = $('#news-comments-dialog').find('#comment-list');
      var commentListHtml = '';
      comments.forEach(function (comment) {
        commentListHtml += _this.GetCommentItemHtml(comment);
      });
      commentList.html(commentListHtml);
    }

    /**
     * Generates HTML for a single comment item.
     * It creates a structured HTML representation of a comment.
     * {Object} comment - The comment object containing author name and content.
     * @returns {String} - The HTML string for the comment item.
     */
  }, {
    key: "GetCommentItemHtml",
    value: function GetCommentItemHtml(comment) {
      var now = moment.utc();
      var timeAgo = moment.duration(moment.utc(comment.CreatedAt * 1000).diff(now)).humanize(true);
      var avatar;
      if (comment.ProfileImage) {
        avatar = "<img src=\"".concat(window.ASSET_SERVER || 'https://static.cbfx.io', "/images/profiles/").concat(comment.ProfileImage, "\" alt=\"").concat(comment.AuthorName, "\">");
      } else {
        avatar = "<span class=\"initials\">".concat(comment.AuthorName.charAt(0).toUpperCase(), "</span>");
      }
      var mngItem = function mngItem() {
        if (comment.IsMine) {
          return "<span class=\"delete-comment-wrapper\" style=\"position: relative;\">\n                                <a href=\"javascript:void(0);\" class=\"std-btn icon-btn small tertiary border-rounded-medium\" onclick=\"window.NewsInstance.ShowDeleteConfirm(this, ".concat(comment.Id, ")\" title=\"Delete\">\n                                    <img src=\"/content/dist/images/icons/trash.svg\"/>\n                                </a>\n                           </span>");
        }
        return '';
      };
      return "<div class=\"comment-item\">\n                        <div class=\"d-flex align-items-center\" style=\"gap: 16px;\">\n                            <div class=\"comment-author-avatar\">\n                                ".concat(avatar, "\n                            </div>\n                            <div>\n                                <span class=\"comment-author social-profile-navigate\" data-profile=id=\"").concat(comment.SocialProfileId, "\">").concat(comment.AuthorName, "</a>\n                            </div>\n                            <div class=\"comment-time\">\n                                ").concat(timeAgo, "\n                                ").concat(mngItem(), "\n                            </div>\n                        </div>\n                        <div class=\"comment-content\">\n                            ").concat(comment.Content, "\n                        </div>\n                    </div>");
    }
    /**
     * Sends a comment for the current news item.
     * It retrieves the content from the textarea, validates it, and sends it via AJAX.
     */
  }, {
    key: "SendNewsComment",
    value: function SendNewsComment() {
      var _this3 = this;
      var content = $('#news-comments-dialog').find('#comment-content').val().trim();
      if (!content) {
        $('#news-comments-dialog').find('#comment-content').addClass('is-invalid');
        return;
      }
      $('#news-comments-dialog').find("#comment-dlg-progress");
      $.ajax({
        url: '/api/news/' + this.newsId + '/comments',
        type: 'POST',
        dataType: 'json',
        data: {
          comment: content
        },
        success: function success(response) {
          _this3.LoadComments(_this3.newsId);
          $('#news-comments-dialog').find('#comment-content').val('');
        },
        error: function error() {
          toastr.error('Failed to send comment');
        },
        complete: function complete() {
          $('#news-comments-dialog').find("#comment-dlg-progress");
        }
      });
    }

    /**
     * Deletes a comment by its ID.
     * It makes an AJAX DELETE request to remove the comment and reloads the comments list.
     * @param {Number} commentId - The ID of the comment to delete.
     */
  }, {
    key: "ShowDeleteConfirm",
    value: function ShowDeleteConfirm(btn, commentId) {
      // Remove any existing confirmation popups
      $('.delete-confirm-popup').remove();

      // Create the confirmation popup
      var popup = $("\n                <div class=\"delete-confirm-popup\">\n                    <div style=\"margin-bottom: 8px;\">Delete this comment?</div>\n                    <div class=\"d-flex\" style=\"gap: 8px;\">\n                        <a href=\"javascript:void(0);\" class=\"std-btn small primary\" style=\"margin-right: 8px;\" onclick=\"window.NewsInstance.DeleteComment(".concat(commentId, ")\">Delete</a>\n                        <a href=\"javascript:void(0);\" class=\"std-btn small secondary\" onclick=\"$(this).closest('.delete-confirm-popup').remove()\">Cancel</a>\n                    </div>\n                </div>\n            "));

      // Append popup to the button's wrapper
      $(btn).closest('.delete-comment-wrapper').append(popup);
    }

    /**
     * Deletes a comment by its ID.
     * It makes an AJAX POST request to remove the comment and reloads the comments list.
     * @param {Number} commentId - The ID of the comment to delete.
     */
  }, {
    key: "DeleteComment",
    value: function DeleteComment(commentId) {
      var _this4 = this;
      $('#news-comments-dialog').find("#comment-dlg-progress").show();
      $.ajax({
        url: '/api/news/delete-comments/' + commentId,
        type: 'POST',
        dataType: 'json',
        success: function success(response) {
          toastr.success('Comment deleted successfully');
          _this4.LoadComments(_this4.newsId);
        },
        error: function error() {
          toastr.error('Failed to delete comment');
        },
        complete: function complete() {
          $('#news-comments-dialog').find("#comment-dlg-progress").hide();
        }
      });
    }

    /**
     * Marks comments as seen for a specific news item.
     * It makes an AJAX POST request to update the comment status.
     * @param {Number} newsId - The ID of the news item to mark comments as seen.
     */
  }, {
    key: "MarkCommentsAsSeen",
    value: function MarkCommentsAsSeen(newsId) {
      $.ajax({
        url: '/api/news/' + newsId + '/comments/seen',
        type: 'POST',
        dataType: 'json',
        success: function success(response) {
          // Handle success if needed
        },
        error: function error() {
          // Handle error if needed
        }
      });
    }
  }, {
    key: "ShowPinDialog",
    value: function ShowPinDialog(newsId) {
      this.newsId = newsId;
      var today = new Date(); // YYYY-MM-DD
      console.log(today.toISOString());
      document.getElementById("PinFrom").value = today.toISOString().slice(0, 16);
      var twoDaysLater = new Date(today);
      twoDaysLater.setDate(today.getDate() + 2);
      document.getElementById("PinTo").value = twoDaysLater.toISOString().slice(0, 16);
      $('#news-pin-dialog').modal('show');
    }
  }, {
    key: "SavePinDate",
    value: function SavePinDate() {
      var fromDate = document.getElementById("PinFrom").value;
      var toDate = document.getElementById("PinTo").value;
      if (!fromDate || !toDate) {
        toastr.error('Please select both from and to dates.');
        return;
      }
      if (new Date(fromDate) > new Date(toDate)) {
        toastr.error('"From" date cannot be later than "To" date.');
        return;
      }
      $('#news-pin-dialog').find("#pin-dlg-progress").show();
      $.ajax({
        url: '/api/news/' + this.newsId + '/pin',
        type: 'POST',
        dataType: 'json',
        data: {
          pinFrom: fromDate,
          pinTo: toDate
        },
        success: function success(response) {
          if (response.success == true) {
            toastr.success('News item pinned successfully');
            location.reload();
          }
        },
        error: function error() {
          toastr.error('Failed to pin news item');
        },
        complete: function complete() {
          $('#news-pin-dialog').find("#pin-dlg-progress").hide();
        }
      });
    }
  }, {
    key: "UnpinNews",
    value: function UnpinNews(newsId) {
      $('#news-pin-dialog').find("#pin-dlg-progress").show();
      $.ajax({
        url: '/api/news/' + newsId + '/unpin',
        type: 'POST',
        dataType: 'json',
        success: function success(response) {
          if (response.success == true) {
            toastr.success('News item unpinned successfully');
            location.reload();
          }
        },
        error: function error() {
          toastr.error('Failed to unpin news item');
        },
        complete: function complete() {
          $('#news-pin-dialog').find("#pin-dlg-progress").hide();
        }
      });
    }
  }]);
}();
var _default = exports["default"] = NewsManager;

},{}],5:[function(require,module,exports){
'use strict';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _readOnlyError(r) { throw new TypeError('"' + r + '" is read-only'); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t8 in e) "default" !== _t8 && {}.hasOwnProperty.call(e, _t8) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t8)) && (i.get || i.set) ? o(f, _t8, i) : f[_t8] = e[_t8]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
var DataContainer = /*#__PURE__*/_createClass(function DataContainer() {
  var dataState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var pagerContainer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var forumMode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  var topicId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var categoryId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var moderator = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  _classCallCheck(this, DataContainer);
  this.dataState = dataState; // Object
  this.pagerContainer = pagerContainer; // String
  this.forumMode = forumMode; // String
  this.topicId = topicId; // int
  this.moderator = moderator; // bool
  this.categoryId = categoryId; // int  
});
function debounce(fn, delay) {
  var timer;
  return function () {
    var _this = this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(timer);
    timer = setTimeout(function () {
      return fn.apply(_this, args);
    }, delay);
  };
}

// Badge shown on the author's own content while it awaits moderation (only they receive pending items).
function pendingBadge(item) {
  if (!item || item.PendingModeration !== true && item.Status !== 'pending') return '';
  return "<div class=\"pending-moderation-badge\" style=\"display:inline-block;background:#f0ad4e;color:#fff;font-size:11px;font-weight:600;padding:2px 8px;border-radius:3px;margin:0 0 6px;\">".concat(window.AWAITING_MODERATION || 'Awaiting moderation', "</div>");
}

// Moderator-only inline approve/reject controls shown on pending forum items (right in the forum).
function forumModControls(item, entityId, itemType) {
  if (!window.SocialProfile || window.SocialProfile.moderator !== true) return '';
  if (!item || item.PendingModeration !== true && item.Status !== 'pending') return '';
  return "<div class=\"forum-mod-controls\" style=\"display:inline-block;margin:0 0 6px 8px;\">" + "<a href=\"javascript:void(0)\" style=\"background:#5cb85c;color:#fff;font-size:11px;font-weight:600;padding:2px 8px;border-radius:3px;text-decoration:none;margin-right:4px;\" onclick=\"window.SocialProfile.ModerateForumItem(".concat(entityId, ",'").concat(itemType, "','approved')\">").concat(window.APPROVE || 'Approve', "</a>") + "<a href=\"javascript:void(0)\" style=\"background:#d9534f;color:#fff;font-size:11px;font-weight:600;padding:2px 8px;border-radius:3px;text-decoration:none;\" onclick=\"window.SocialProfile.ModerateForumItem(".concat(entityId, ",'").concat(itemType, "','rejected')\">").concat(window.REJECT || 'Reject', "</a>") + "</div>";
}
var SocialProfile = /*#__PURE__*/function () {
  function SocialProfile(lightbox, cookie) {
    var _this2 = this;
    _classCallCheck(this, SocialProfile);
    this.dataStateMap = new Map();
    this.notificationChangeState = false;
    this.JumpToPostId = 0;
    this.jumpToCommentId = 0;
    this.activeContainerId = null;
    this.LoadedComments = [];
    this.CurrentInputState = {};
    this.now = moment().utc();
    this.Cookie = cookie;
    this.Lightbox = lightbox;
    //this.LoadedComments = [];

    //this.MyPendingComments = [];
    this.MyProfile = {};
    this.DeviceId = localStorage.getItem('SocialProfileDevice');
    this.AnonSocialProfileLikes = [];
    this.imagepath = "/content/dist/social/brokers/images/";
    this.avatarPath = "".concat(window.assetServer, "/assets/images/profiles/");
    this.newsImagePath = "".concat(window.assetServer, "/assets/images/news/image");
    this.imagePathComment = this.imagePathForum = "".concat(window.assetServer, "/assets/images/forum/");
    this.findUserPostsSummaryUrl = '/admin/socialprofile/moderation/user/activity/summary';
    this.findUserActivityStatusUrl = '/admin/socialprofile/moderation/user/activity/status';
    this.banUserUrl = '/admin/socialprofile/moderation/user/ban';
    this.updateUserActivityURl = '/admin/socialprofile/moderation/user/activity/update';
    this.SaveNewComment = this.SaveNewComment.bind(this);
    this.SaveEditedComment = this.SaveEditedComment.bind(this);
    this.IsMasquerade = false;
    $('#heart-rate li').click(function () {
      if ($('#no-rating-checkbox').is(":checked")) {
        $('#no-rating-checkbox').trigger("click");
      }
      $('#heart-rate li').removeClass('clicked');
      $('.hovered').addClass('clicked');
      $('#review-rating').val($('#heart-rate li.clicked').length);
    });
    $(document).on('click', '.clear-draft-btn', function () {
      if ($('#dialog-add-post').hasClass('in') || $('#dialog-add-post').is(':visible')) {
        window.SocialProfile.ClearDraft();
      } else if ($('#dialog-add-comment').hasClass('in') || $('#dialog-add-comment').is(':visible')) {
        window.SocialProfile.ClearForumCommentDraft(); // if you have one
      }
    });
    $(document).on("click", ".postPager a", function (event) {
      var data = {};
      var containerIdValue = '';
      var CurrentPage = event.target.href;
      var query = CurrentPage.split("?");
      if (query[1] !== undefined && query[1] !== null) {
        var urlParams = new URLSearchParams(query[1]);
        var entries = urlParams.entries(); //returns an iterator of decoded [key,value] tuples
        var _iterator = _createForOfIteratorHelper(entries),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _step$value = _slicedToArray(_step.value, 2),
              key = _step$value[0],
              value = _step$value[1];
            // each 'entry' is a [key, value] tupple
            data[key] = value;
            if (key === 'ContainerId' || key === 'containerId') {
              containerIdValue = value;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      $.ajax({
        url: query[0],
        type: 'Post',
        cache: false,
        data: data,
        success: function success(result) {
          var currentState = _this2.GetState(containerIdValue);
          currentState.dataState = result;
          if (result.ForumMode !== undefined && result.ForumMode === "latest") {
            if (result.Posts.length) {
              _this2.WaitForProcessLatestPostsForumData(containerIdValue).then(function () {
                var el = document.getElementById('activity-head');
                el.scrollIntoView({
                  block: "start",
                  behavior: 'smooth'
                });
              });
            }
          } else if (result.ForumMode !== undefined && result.ForumMode === "activity") {
            if (result.Posts.length) {
              _this2.WaitForProcessReviewDataFeed(containerIdValue).then(function () {
                var el = document.getElementById('activity-head');
                el.scrollIntoView({
                  block: "start",
                  behavior: 'smooth'
                });
              });
            }
          } else if (result.ForumMode !== undefined && result.ForumMode === "review-comments") {
            if (result.Posts.length) {
              _this2.WaitForProcessReviewCommentsFeedData(containerIdValue).then(function () {
                var el = document.getElementById('activity-head');
                el.scrollIntoView({
                  block: "start",
                  behavior: 'smooth'
                });
              });
            }
          } else {
            _this2.CurrentForumMode = 'InlineForum';
            if (result.reviewModel.Posts.length) {
              _this2.WaitForProcessInlineForumData(0, 0, containerIdValue).then(function () {
                var el = document.getElementById(containerIdValue);
                el.scrollIntoView({
                  block: "start",
                  behavior: 'smooth'
                });
              });
            } else {}
          }
          if ($('#forum-items-container').length) {
            _this2.Lightbox.InitializeLBImages('forum-items-container');
          }
          if ($('#inline-forum-template').length) {
            _this2.Lightbox.InitializeLBImages('inline-forum-template');
          }
          if ($('#activity-list-wrap').length) {
            _this2.Lightbox.InitializeLBImages('activity-list-wrap');
          }
        },
        error: function error(result) {
          alert("there was an error");
        }
      });
      return false;
    });
    $(document).on("click", "#VotePager a", function (event) {
      var data = {};
      var CurrentTransactionListPage = event.target.href;
      ;
      var query = CurrentTransactionListPage.split("?");
      if (query[1] !== undefined && query[1] !== null) {
        var urlParams = new URLSearchParams(query[1]);
        var entries = urlParams.entries(); //returns an iterator of decoded [key,value] tuples
        var _iterator2 = _createForOfIteratorHelper(entries),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _step2$value = _slicedToArray(_step2.value, 2),
              key = _step2$value[0],
              value = _step2$value[1];
            // each 'entry' is a [key, value] tupple
            data[key] = value;
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
      $.ajax({
        url: query[0],
        type: 'Post',
        cache: false,
        data: data,
        success: function success(result) {
          if (result.Votes !== null && result.Votes !== undefined) {
            _this2.WaitForProcessVotesFeedData(result.Votes).then(function () {
              var el = document.getElementById('activity-head');
              el.scrollIntoView({
                block: "start",
                behavior: 'smooth'
              });
            });
          }
        },
        error: function error(result) {
          alert("there was an error");
        }
      });
      return false;
    });
    $(document).on("click", "#ReviewPager a, #RejectedReviewPager a", function () {
      var data = {
        brokerId: window.SocialProfile.brokerId
      };
      var CurrentTransactionListPage = $(this).attr("href");
      var query = CurrentTransactionListPage.split("?");
      if (query[1] !== undefined && query[1] !== null) {
        var urlParams = new URLSearchParams(query[1]);
        var entries = urlParams.entries(); //returns an iterator of decoded [key,value] tuples
        var _iterator3 = _createForOfIteratorHelper(entries),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _step3$value = _slicedToArray(_step3.value, 2),
              key = _step3$value[0],
              value = _step3$value[1];
            // each 'entry' is a [key, value] tupple
            data[key] = value;
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
      $.ajax({
        url: query[0],
        type: 'Post',
        cache: false,
        data: data,
        success: function success(result) {
          // ReSharper disable once UseOfImplicitGlobalInFunctionScope
          //        AjaxComplete();
          window.SocialProfile.ProcessReviewData(result, data, false);
          //return false;
        },
        error: function error(result) {
          // ReSharper disable once UseOfImplicitGlobalInFunctionScope
          //        AjaxComplete();
          alert("there was an error");
          //return false;
        }
      });
      return false;
    });
    $('.validation-error-killer').on('click', function () {
      $(_this2).removeClass("form-control-danger").closest(".form-group").removeClass("has-danger");
      $(_this2).parent().find('.form-control-feedback').hide();
    });
    $(document).on('click', '.social-posting-navigate', function (e) {
      var entityId = $(e.target).data('entity-id');
      var topicId = $(e.target).data('topic-id');
      var entityType = $(e.target).data('entity-type');
      var expireNotification = $(e.target).data('expire-notification');
      if (isNaN(expireNotification)) {
        expireNotification = 0;
      }
      if (isNaN(topicId)) {
        topicId = 0;
      }
      if (window.CURRENT_LANG === window.DEFAULT_LANG) {
        if (isNaN(entityId)) {
          entityId = 0;
        }
        document.location.href = "/social-post/find/" + entityType + "/" + entityId + "/" + topicId + "/" + expireNotification;
      } else {
        var langSlug = "/" + CURRENT_LANG;
        document.location.href = langSlug + "/social-post/find/" + entityType + "/" + entityId + "/" + topicId + "/" + expireNotification;
      }
    });
  }

  // Method to add a key-value pair
  return _createClass(SocialProfile, [{
    key: "AddState",
    value: function AddState(key) {
      var dataState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pagerId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var forumMode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'InlineForum';
      var topicId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
      var moderator = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
      if (typeof key === "string") {
        var entry = new DataContainer(dataState, pagerId, forumMode, topicId, moderator);
        this.dataStateMap.set(key, entry);
      } else {
        alert("Invalid key type. " + key);
      }
    }
    // Method to remove a key-value pair
  }, {
    key: "RemoveState",
    value: function RemoveState(key) {
      this.dataStateMap["delete"](key);
    }
    // Method to get the value by key
  }, {
    key: "GetState",
    value: function GetState(key) {
      return this.dataStateMap.get(key);
    }
    // Method to check if a key exists
  }, {
    key: "HasState",
    value: function HasState(key) {
      return this.dataStateMap.has(key);
    }
  }, {
    key: "FindUserActivityStatus",
    value: function FindUserActivityStatus(id) {
      return $.ajax({
        url: this.findUserActivityStatusUrl,
        type: 'POST',
        cache: false,
        data: {
          SocialProfileId: id
        },
        success: function success(result) {},
        error: function error(result) {
          alert("there was an error");
        }
      });
    }
  }, {
    key: "UpdateUserActivity",
    value: function UpdateUserActivity(data) {
      return $.ajax({
        url: this.updateUserActivityURl,
        type: 'POST',
        cache: false,
        data: data,
        success: function success(result) {},
        error: function error(result) {
          alert("there was an error");
        }
      });
    }
  }, {
    key: "SetUserAsBanned",
    value: function SetUserAsBanned(data) {
      return $.ajax({
        url: this.banUserUrl,
        type: 'POST',
        cache: false,
        data: data,
        success: function success(result) {},
        error: function error(result) {
          alert("there was an error");
        }
      });
    }
  }, {
    key: "FindUserPosts",
    value: function FindUserPosts(id) {
      return $.ajax({
        url: this.findUserPostsSummaryUrl,
        type: 'POST',
        cache: false,
        data: {
          SocialProfileId: id
        },
        success: function success(result) {},
        error: function error(result) {
          alert("there was an error");
        }
      });
    }
  }, {
    key: "RemoveUserActivity",
    value: function RemoveUserActivity(id) {
      var _this3 = this;
      this.ResetPopOverMenus();
      $('#confirmationModal').on('hidden.bs.modal', function () {
        $('#confirmation-control').on('click', null);
        $('#confirmation-control').unbind('click');
        $('#confirmationModal').unbind('hidden.bs.modal');
      });
      $('#confirmation-message-body').html("Searching for user activity...");
      $('#confirmation-buttons').hide();
      $('#confirmation-progress').show();
      $('#confirmationModal').modal('show');
      this.FindUserPosts(id).done(function (data) {
        $('#confirmation-message-body').html(data.pageView);
        $('#confirmation-buttons').show();
        $('#confirmation-progress').hide();
        $('#confirmation-control').on('click', function () {
          $('#confirmation-progress').show();
          var state = {};
          state.Review = false;
          state.Comment = false;
          state.Vote = false;
          state.Post = false;
          state.Topic = false;
          state.SocialProfileId = id;
          if ($('#review_activity').is(':checked')) {
            state.Review = true;
          }
          if ($('#comment_activity').is(':checked')) {
            state.Comment = true;
          }
          if ($('#vote_activity').is(':checked')) {
            state.Vote = true;
          }
          if ($('#post_activity').is(':checked')) {
            state.Post = true;
          }
          if ($('#topic_activity').is(':checked')) {
            state.Topic = true;
          }
          _this3.UpdateUserActivity(state).done(function (d) {
            $('#confirmationModal').modal('hide');
            $('#confirmation-progress').hide();
            $('#confirmation-control').on('click', null);
            $('#confirmation-control').unbind('click');
            $('#confirmationModal').unbind('hidden.bs.modal');
            SearchSocialProfile();
            if (d.done == true) {
              toastr.success("User activity has been updated");
            } else {
              toastr.error("No user activity was updated");
            }
          }).fail(function (d) {
            $('#confirmationModal').modal('hide');
            $('#confirmation-progress').hide();
            $('#confirmation-control').on('click', null);
            $('#confirmation-control').unbind('click');
            $('#confirmationModal').unbind('hidden.bs.modal');
            toastr.error("An error has occurred");
          });
        });
      });
    }
  }, {
    key: "CurtailUserActivity",
    value: function CurtailUserActivity(id) {
      var _this4 = this;
      this.ResetPopOverMenus();
      $('#confirmationModal').on('hidden.bs.modal', function () {
        $('#confirmation-control').on('click', null);
        $('#confirmation-control').unbind('click');
        $('#confirmationModal').unbind('hidden.bs.modal');
      });
      $('#confirmation-message-body').html("Reading current user activity status...");
      $('#confirmation-buttons').hide();
      $('#confirmation-progress').show();
      $('#confirmationModal').modal('show');
      this.FindUserActivityStatus(id).done(function (data) {
        $('#confirmation-message-body').html(data.pageView);
        $('#confirmation-buttons').show();
        $('#confirmation-progress').hide();
        $('#confirmation-control').on('click', function () {
          $('#confirmation-progress').show();
          var state = {};
          state.Review = false;
          state.Comment = false;
          state.Vote = false;
          state.SocialProfileId = id;
          state.Topic = false;
          state.Message = $('#ban-message').val();
          if ($('#topic_activity').is(':checked')) {
            state.Topic = true;
          }
          if ($('#post_activity').is(':checked')) {
            state.Post = true;
          }
          if ($('#review_activity').is(':checked')) {
            state.Review = true;
          }
          if ($('#comment_activity').is(':checked')) {
            state.Comment = true;
          }
          if ($('#vote_activity').is(':checked')) {
            state.Vote = true;
          }
          _this4.SetUserAsBanned(state).done(function (d) {
            $('#confirmationModal').modal('hide');
            $('#confirmation-progress').hide();
            $('#confirmation-control').on('click', null);
            $('#confirmation-control').unbind('click');
            $('#confirmationModal').unbind('hidden.bs.modal');
            if (d.done == true) {
              toastr.success("User posting permissions have been successfully updated");
            } else {
              toastr.error("NUser posting permissions remain unchanged");
            }
          }).fail(function (d) {
            $('#confirmationModal').modal('hide');
            $('#confirmation-progress').hide();
            $('#confirmation-control').on('click', null);
            $('#confirmation-control').unbind('click');
            $('#confirmationModal').unbind('hidden.bs.modal');
            toastr.error("An error has occurred");
          });
        });
      });
    }
    // Moderator: approve or reject a pending forum post/comment right from the forum.
  }, {
    key: "ModerateForumItem",
    value: function ModerateForumItem(entityId, itemType, status) {
      var _this5 = this;
      $.ajax({
        url: '/api/social/forum/moderation/status/set',
        type: 'POST',
        cache: false,
        data: {
          entityId: entityId,
          itemType: itemType,
          status: status
        },
        success: function success(result) {
          if (result && result.Ok) {
            toastr.success(status === 'approved' ? "Item approved." : "Item rejected.");
            _this5.RefreshAfterModeration(entityId, itemType, status);
          } else {
            toastr.error(result && result.Message || "Could not update the item.");
          }
        },
        error: function error() {
          toastr.error("An error has occurred.");
        }
      });
    }
    // Remove the pending badge/controls after a moderation decision; blank the body if rejected.
  }, {
    key: "RefreshAfterModeration",
    value: function RefreshAfterModeration(entityId, itemType, status) {
      var selector = itemType === 'Post' || itemType === 'Topic' ? "#post-content-".concat(entityId) : "#comment-content-".concat(entityId);
      var $el = $(selector);
      $el.find('.pending-moderation-badge, .forum-mod-controls').remove();
      if (status === 'rejected') {
        $el.html(window.DELETED_POST || 'This content has been removed.');
      }
    }
    // Moderator: put a user in/out of probation (held posts) from the forum context menu.
  }, {
    key: "ManageProbation",
    value: function ManageProbation(id) {
      this.ResetPopOverMenus();
      var input = window.prompt("Set probation for this user.\n\nEnter number of days from now (e.g. 14), or 0 to REMOVE probation:", "14");
      if (input === null) {
        return;
      }
      var days = parseInt(input, 10);
      if (isNaN(days) || days < 0) {
        toastr.error("Please enter a valid number of days (0 to remove).");
        return;
      }
      var data = {
        socialProfileId: id
      };
      if (days > 0) {
        var d = new Date();
        d.setUTCDate(d.getUTCDate() + days);
        data.expires = d.toISOString();
      }
      // days === 0 -> no 'expires' sent -> microservice clears probation (ProbationExpires set to now).
      $.ajax({
        url: '/api/social/forum/moderation/probation/set',
        type: 'POST',
        cache: false,
        data: data,
        success: function success(result) {
          if (result && result.Ok) {
            toastr.success(days > 0 ? "User placed on probation for ".concat(days, " day(s).") : "Probation removed.");
          } else {
            toastr.error(result && result.Message || "Could not update probation.");
          }
        },
        error: function error() {
          toastr.error("An error has occurred updating probation.");
        }
      });
    }
  }, {
    key: "ReviewPager",
    value: function ReviewPager() {}
  }, {
    key: "AcknowledgeNotification",
    value: function AcknowledgeNotification(notificationId) {
      if (isNaN(notificationId)) {} else {
        if (window.CURRENT_LANG === window.DEFAULT_LANG) {
          document.location.href = "/notification/execute/" + notificationId;
        } else {
          var langSlug = "/" + CURRENT_LANG;
          document.location.href = langSlug + "/notification/execute/" + notificationId;
        }
      }
    }
  }, {
    key: "AcknowledgeAllNotifications",
    value: function AcknowledgeAllNotifications() {
      $.ajax({
        url: '/api/social-profile/notifications/acknowledge/all',
        type: 'POST',
        success: function success(data) {
          if (data.result.Success) {
            var $popoverNotificationPayload = $('#notifications-popover-payload');
            var $menuNotificationPayload = $('#notifications-frame');
            if ($popoverNotificationPayload.length === 0 && $menuNotificationPayload === 0) return;
            // Remove .active from direct children and inner (popover notification items)
            $popoverNotificationPayload.children().removeClass('active');
            $popoverNotificationPayload.find('.active').removeClass('active');
            // Remove .active from direct children and inner (menu panel notification items)
            $menuNotificationPayload.children().removeClass('active');
            $menuNotificationPayload.find('.active').removeClass('active');
            // Hide visual unread indicator icon
            $('.notification-ellipse-icon').hide();
          }
        }
      });
    }
  }, {
    key: "SaveDraft",
    value: function SaveDraft() {
      var _this$Lightbox, _this$Lightbox2;
      var draftKey = (_this$Lightbox = this.Lightbox) === null || _this$Lightbox === void 0 ? void 0 : _this$Lightbox.currentDraftKey;
      var context = (_this$Lightbox2 = this.Lightbox) === null || _this$Lightbox2 === void 0 ? void 0 : _this$Lightbox2.currentContext;
      if (context !== "draft") {
        console.warn("[SaveDraft] current context != draft. Exiting.");
        return;
      }
      if (!draftKey) {
        console.warn("[SaveDraft] No currentDraftKey defined.");
        return;
      }
      var isPostDraft = draftKey.startsWith("forumDraft-post-topic-");
      var isCommentDraft = draftKey.startsWith("forumDraft-comment-post-");
      var inputEditorKey = isPostDraft ? 'post-input-editor' : 'comment-input-editor';
      var draft = {
        body: this.ExtractEditorContent(inputEditorKey),
        imageRefs: this.Lightbox.getCurrentImageRefs()
      };
      if (isPostDraft) {
        var containerId = this.activeContainerId;
        var state = this.GetState(containerId);
        if (state !== null && state !== void 0 && state.topicId) {
          draft.topicId = state.topicId;
          draft.containerId = containerId;
        } else {
          console.warn("[SaveDraft] Could not resolve topicId for post draft.");
        }
      }
      if (isCommentDraft) {
        var postId = this.CurrentInputState.postId;
        if (postId) {
          draft.postId = postId;
        } else {
          console.warn("[SaveDraft] Missing postId for comment draft.");
        }
      }
      console.log("[SaveDraft] Saving with key:", draftKey, "=>", draft);
      localStorage.setItem(draftKey, JSON.stringify(draft));
    }
  }, {
    key: "ClearDraft",
    value: function ClearDraft() {
      var _this$Lightbox3, _this$Lightbox4;
      var draftKey = (_this$Lightbox3 = this.Lightbox) === null || _this$Lightbox3 === void 0 ? void 0 : _this$Lightbox3.currentDraftKey;
      var context = (_this$Lightbox4 = this.Lightbox) === null || _this$Lightbox4 === void 0 ? void 0 : _this$Lightbox4.currentContext;
      console.log("[ClearDraft] Clearing draft for:", draftKey);
      if (!draftKey || !context) {
        console.warn("[ClearDraft] Missing draft key or context.");
        return;
      }
      var isPost = !draftKey.includes("comment");
      var frameSelector = isPost ? "#img-post-frames" : "#img-comment-frames";
      var inputSelector = isPost ? "#post-input" : "#comment-input";
      var editorSelector = isPost ? "#post-input-editor" : "#comment-input-editor";
      var clearCellSelector = isPost ? "#clear-post-draft-cell" : "#clear-comment-draft-cell";

      // Remove draft from localStorage
      localStorage.removeItem(draftKey);

      // Clear image blobs and metadata for this specific draftKey only
      this.Lightbox.clearImageSession(false, draftKey);
      this.Lightbox.resetTmpFilesForDraft(draftKey);

      // Clear old textarea (still needed if used in form submit)
      $(inputSelector).val('');

      // Clear the visible contenteditable editor
      var editor = document.querySelector(editorSelector);
      if (editor) {
        editor.innerHTML = '';
      }

      // Clear image preview frames
      $(frameSelector).html('');

      // Hide the clear draft button
      $(clearCellSelector).hide();
      console.log("[ClearDraft] Completed cleanup for ".concat(draftKey));
    }
  }, {
    key: "IgniteInlineForum",
    value: function IgniteInlineForum(topicId, jumpToPostId) {
      var counterId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var jumpToCommentId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var containerId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'inline-forum';
      this.LoadTopicPosts(topicId, jumpToPostId, counterId, jumpToCommentId, containerId);
      this.Lightbox.IgniteAddPostPhotoButton();
    }
  }, {
    key: "IgniteForumTopicPage",
    value: function IgniteForumTopicPage(topicId, jumpToPostId) {
      var jumpToCommentId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      /*this.TopicId = topicId;*/
      this.InitForumTopicPage(topicId, jumpToPostId, jumpToCommentId);
      this.Lightbox.IgniteAddPostPhotoButton();
    }
  }, {
    key: "IgnitePopOverMenus",
    value: function () {
      var _IgnitePopOverMenus = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return this.attachMentionPopoversLazy(document);
            case 1:
              $('[data-toggle="post-edit-menu"]').popover({
                html: true,
                trigger: "click",
                container: 'body',
                content: function content() {
                  var postId = $(this).data('postid');
                  var authorId = $(this).data('authorid');
                  var commentId = $(this).data('commentid');
                  var containerKey = $(this).data('forum-holder');
                  var out = '';
                  if (parseInt(commentId, 10) > 0) {
                    out = "<div class=\"post-edit-menu-options\">\n                        <a href=\"javascript:void(0)\" onclick=\"window.SocialProfile.OpenCommentForEdit('".concat(containerKey, "',").concat(commentId, ", ").concat(postId, ")\">").concat(window.EDIT_COMMENT, "</a>\n                        <a href=\"javascript:void(0)\" onclick=\"window.SocialProfile.DeleteComment('").concat(containerKey, "',").concat(commentId, ", ").concat(postId, ")\">").concat(window.DELETE_COMMENT, "</a>");
                    if (window.SocialProfile.moderator) {
                      out += " <a href=\"javascript:void(0)\" onclick=\"window.SocialProfile.CurtailUserActivity(".concat(authorId, ")\">Ban user</a>\n                            <a href=\"javascript:void(0)\" onclick=\"window.SocialProfile.RemoveUserActivity(").concat(authorId, ")\">Scrub user activity</a>\n                            <a href=\"javascript:void(0)\" onclick=\"window.SocialProfile.ManageProbation(").concat(authorId, ")\">Manage probation</a>");
                    }
                    out += "</div>";
                  } else {
                    out = "<div class=\"post-edit-menu-options\">\n                        <a href=\"javascript:void(0)\" onclick=\"window.SocialProfile.OpenPostForEdit('".concat(containerKey, "',").concat(postId, ")\">").concat(window.EDIT_POST, "</a>\n                        <a href=\"javascript:void(0)\" onclick=\"window.SocialProfile.DeletePost('").concat(containerKey, "',").concat(postId, ")\">").concat(window.DELETE_POST, "</a>");
                    if (window.SocialProfile.moderator) {
                      out += " <a href=\"javascript:void(0)\" onclick=\"window.SocialProfile.CurtailUserActivity(".concat(authorId, ")\">Ban user</a>\n                            <a href=\"javascript:void(0)\" onclick=\"window.SocialProfile.RemoveUserActivity(").concat(authorId, ")\">Scrub user activity</a>\n                            <a href=\"javascript:void(0)\" onclick=\"window.SocialProfile.ManageProbation(").concat(authorId, ")\">Manage probation</a>");
                    }
                    out += "</div>";
                  }
                  return out;
                }
              });
              $('[data-toggle="comment-edit-menu"]').popover({
                html: true,
                trigger: "click",
                container: 'body',
                content: function content() {
                  var commentId = $(this).data('commentid');
                  var authorId = $(this).data('authorid');
                  var postId = $(this).data('postid');
                  var containerKey = $(this).data('forum-holder');
                  var out = "<div class=\"comment-edit-menu-options\">\n                        <a href=\"javascript:void(0)\" onclick=\"window.SocialProfile.OpenCommentForEdit('".concat(containerKey, "',").concat(commentId, ", ").concat(postId, ")\">").concat(window.EDIT_COMMENT, "</a>\n                        <a href=\"javascript:void(0)\" onclick=\"window.SocialProfile.DeleteComment('").concat(containerKey, "',").concat(commentId, ", ").concat(postId, ")\">").concat(window.DELETE_COMMENT, "</a>");
                  if (window.SocialProfile.moderator) {
                    out += " <a href=\"javascript:void(0)\" onclick=\"window.SocialProfile.CurtailUserActivity(".concat(authorId, ")\">Ban user</a>\n                            <a href=\"javascript:void(0)\" onclick=\"window.SocialProfile.RemoveUserActivity(").concat(authorId, ")\">Scrub user activity</a>\n                            <a href=\"javascript:void(0)\" onclick=\"window.SocialProfile.ManageProbation(").concat(authorId, ")\">Manage probation</a>");
                  }
                  out += "</div>";
                  return out;
                }
              });
              $('body').on('click', function (e) {
                window.SocialProfile.ResetPopOverMenus(e);
              });
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function IgnitePopOverMenus() {
        return _IgnitePopOverMenus.apply(this, arguments);
      }
      return IgnitePopOverMenus;
    }()
  }, {
    key: "IgniteReviewerStatusTooltip",
    value: function IgniteReviewerStatusTooltip() {
      $('.reviewer-status.unverified').tooltip('dispose').tooltip({
        boundary: 'window',
        title: window.APPROVED_REVIEWER_POPOVER
      });
      $('.reviewer-status.verified').tooltip('dispose').tooltip({
        boundary: 'window',
        title: window.VERIFIED_REVIEWER_POPOVER
      });
      $('.reviewer-status.suspicious').tooltip('dispose').tooltip({
        boundary: 'window',
        title: window.SUSPICIOUS_REVIEWER_POPOVER
      });
    }
  }, {
    key: "ResetPopOverMenus",
    value: function ResetPopOverMenus(e) {
      if (e === undefined) {
        $('body').trigger('click');
      } else {
        $('[data-toggle="post-edit-menu"]').each(function () {
          // Hide the popover when clicking outside
          if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
            $(this).popover('hide');
          }
        });
        $('[data-toggle="comment-edit-menu"]').each(function () {
          // Hide the popover when clicking outside
          if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
            $(this).popover('hide');
          }
        });
      }
    }
  }, {
    key: "LoadNotificationsSummary",
    value: function LoadNotificationsSummary() {
      var _this6 = this;
      $.ajax({
        url: forumNotificationsSummaryUrl,
        type: 'POST',
        cache: false,
        success: function success(result) {
          // ReSharper disable once UseOfImplicitGlobalInFunctionScope

          if (result && !result.isError && result.data && result.data.length) {
            $('#notifications-popover-payload').html('');
            result.data.forEach(function (num, index) {
              $('#notifications-popover-payload').append(_this6.RenderNotification(result.data[index]));
            });
            $('#notifications-popover-payload').append(_this6.RenderNotificationFooter());
            if (result.hasNew) {
              $('.notification-ellipse-icon').show();
            }
          } else {
            $('#notifications-popover-payload').html('No new notifications');
          }
        },
        error: function error(result) {
          $('#notifications-popover-payload').html('Notifications could not be loaded');
        }
      });
    }
  }, {
    key: "IgniteLatestPostsList",
    value: function IgniteLatestPostsList() {
      this.LoadLatestPosts(1, 'forum-list-wrap');
      this.Lightbox.IgniteAddPostPhotoButton();
    }
  }, {
    key: "ProbeInlineForum",
    value: function ProbeInlineForum(entityId, entityType) {
      var _this7 = this;
      var counterId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var forumContainerId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
      var forumPagerId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
      var addId = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
      var subscribeId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';
      var startButtonId = arguments.length > 7 ? arguments[7] : undefined;
      var tabId = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : '';
      var callback = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : '';
      var urlParams = new URLSearchParams(window.location.search);
      var commentId = urlParams.get('commentId');
      var postId = urlParams.get('postId');
      $.ajax({
        type: "POST",
        cache: false,
        // ReSharper disable once UseOfImplicitGlobalInFunctionScope
        url: window.forumProbeUrl,
        dataType: "json",
        data: {
          entityId: entityId,
          entityType: entityType,
          postId: postId,
          commentId: commentId,
          containerId: forumContainerId
        },
        success: function success(result) {
          if (result.success == true) {
            if (tabId !== '') {
              $("#" + tabId).show();
            }
            _this7.AddState(forumContainerId, result, forumPagerId, 'InlineForum', result.reviewModel.TopicId);
            _this7.moderator = result.Moderate == true;
            if (result.topicExists) {
              if (addId !== '') {
                $("#" + addId).show();
              }
              if (subscribeId !== '') {
                $("#" + subscribeId).show();
              }
              if (counterId !== '' && counterId !== undefined && parseInt(result.reviewModel.TotalPostAndReplies, 10) > 0 && counterId !== null && $('#' + counterId).length) {
                var outString = $('#' + counterId).html();
                $('#' + counterId).html(outString.replace("0", result.reviewModel.TotalPostAndReplies));
              } else if (counterId !== '' && counterId !== undefined && parseInt(result.reviewModel.TotalPosts, 10) > 0 && counterId !== null && $('#' + counterId).length) {
                var _outString = $('#' + counterId).html();
                $('#' + counterId).html(_outString.replace("0", result.reviewModel.TotalPosts));
              }
              _this7.ProcessInlineForumData(postId, commentId, forumContainerId);
            } else {
              if (startButtonId !== '') {
                $("#" + startButtonId).show();
              }
              if ($("#".concat(forumContainerId)).length) {
                $("#".concat(forumContainerId)).html("<h3>".concat(window.BE_THE_FIRST_PERSON_TO_POST_IN_THIS_DISCUSSION, "</h3>"));
              }
            }
          }
          if (callback !== '') {
            if (typeof callback == "string") {
              window[callback](result);
            }
          }
        },
        error: function error(result) {}
      });
    }
  }, {
    key: "IgniteActivityList",
    value: function IgniteActivityList(result) {
      if (result.forum != null && result.forum.Posts != null) {
        var containerId = 'activity-list-wrap';
        this.AddState(containerId, result.forum, 'activity-list-wrap-pager', 'LatestPosts', 0, result.Moderate == true);
        this.ProcessLatestPostsForumData(containerId);
      }
      if (result.review != null && result.review.Posts != null) {
        var _containerId = 'review-list-wrap';
        this.AddState(_containerId, result.review, 'review-list-wrap-pager', 'BrokerReview', 0, result.Moderate == true);
        this.ProcessReviewFeedData(_containerId);
      }
      if (result.review_comments != null && result.review_comments != null) {
        var _containerId2 = 'review-comments-list-wrap';
        this.AddState(_containerId2, result.review_comments, 'review-comments-list-wrap-pager', 'BrokerReview', 0, result.Moderate == true);
        this.ProcessReviewCommentsFeedData(_containerId2);
      }
      this.Lightbox.InitializeLBImages('social-profile-activity');
    }
  }, {
    key: "IgniteVoteActivityList",
    value: function IgniteVoteActivityList(result) {
      if (result.List != null) {
        this.ProcessVotesFeedData(result);
      }
    }
  }, {
    key: "DeleteCategory",
    value: function DeleteCategory(categoryId) {
      $('#dialog-delete-forum-category').modal('show').data('categoryid', categoryId);
    }
  }, {
    key: "DeleteTopic",
    value: function DeleteTopic(topicId) {
      $('#dialog-delete-forum-topic').modal('show').data('topicid', topicId);
    }
  }, {
    key: "DeletePost",
    value: function DeletePost(statekey, postid) {
      $('#dialog-delete-forum-post').modal('show').data('postid', postid).data('statekey', statekey);
    }
  }, {
    key: "DeleteComment",
    value: function DeleteComment(statekey, commentid, postid) {
      $('#dialog-delete-forum-comment').modal('show').data('postid', postid).data('commentid', commentid).data('statekey', statekey);
    }
  }, {
    key: "CommitSubscriptionDelete",
    value: function CommitSubscriptionDelete() {
      $('#subscription-delete-progress').show();
      var id = parseInt($('#dialog-delete-subscription').data('id'), 10);
      if (!isNaN(id) && id > 0) {
        $.ajax({
          type: "POST",
          cache: false,
          async: true,
          // ReSharper disable once UseOfImplicitGlobalInFunctionScope
          url: window.deleteSocialSubscriptionUrl,
          dataType: "json",
          data: {
            Id: id
          },
          success: function success(result) {
            if (result.Ok === true) {
              toastr.success(window.YOUR_SUBSCRIPTION_HAS_BEEN_DELETED);
              if ($('#subscription-row-' + id).length) {
                $('#subscription-row-' + id).remove();
              }
            } else {
              toastr.error(result.Message);
            }
            $('#subscription-delete-progress').hide();
            $('#dialog-delete-subscription').modal('hide').data('id', null);
          },
          error: function error(result) {
            $('#subscription-delete-progress').hide();
            alert("Network failure");
          }
        });
      }
    }
  }, {
    key: "CommitCategoryDelete",
    value: function CommitCategoryDelete() {
      $('#category-delete-progress').show();
      setTimeout(function () {
        var categoryId = parseInt($('#dialog-delete-forum-category').modal('show').data('categoryid'), 10);
        if (!isNaN(categoryId) && categoryId > 0) {
          $.ajax({
            type: "POST",
            cache: false,
            // ReSharper disable once UseOfImplicitGlobalInFunctionScope
            url: "/api/forum/categories/delete",
            dataType: "json",
            data: {
              categoryId: categoryId
            },
            success: function success(result) {
              if (result.Success === true) {
                toastr.success("Your category has been deleted");
                if ($('.forum-item.category[data-categoryid=' + categoryId + ']').length) {
                  $('.forum-item.category[data-categoryid=' + categoryId + ']').remove();
                }
              } else {
                toastr.error(result.Message);
              }
              $('#category-delete-progress').hide();
              $('#dialog-delete-forum-category').modal('hide').data('categoryid', null);
            },
            error: function error(result) {
              $('#category-delete-progress').hide();
              alert("Network failure");
            }
          });
        }
      }, 0);
    }
  }, {
    key: "CommitTopicDelete",
    value: function CommitTopicDelete() {
      $('#topic-delete-progress').show();
      setTimeout(function () {
        var topicId = parseInt($('#dialog-delete-forum-topic').modal('show').data('topicid'), 10);
        if (!isNaN(topicId) && topicId > 0) {
          $.ajax({
            type: "POST",
            cache: false,
            // ReSharper disable once UseOfImplicitGlobalInFunctionScope
            url: "/api/forum/topics/delete",
            dataType: "json",
            data: {
              topicId: topicId
            },
            success: function success(result) {
              if (result.Success === true) {
                toastr.success("Your discussion has been deleted");
                if ($('.forum-item.topic[data-topicid="' + topicId + '"]').length) {
                  $('.forum-item.topic[data-topicid="' + topicId + '"]').remove();
                }
              } else {
                toastr.error(result.Message);
              }
              $('#topic-delete-progress').hide();
              $('#dialog-delete-forum-topic').modal('hide').data('topicid', null);
            },
            error: function error(result) {
              $('#topic-delete-progress').hide();
              alert("Network failure");
            }
          });
        }
      }, 0);
    }
  }, {
    key: "CommitPostDelete",
    value: function CommitPostDelete() {
      var _this8 = this;
      $('#post-delete-progress').show();
      setTimeout(function () {
        var postId = parseInt($('#dialog-delete-forum-post').modal('show').data('postid'), 10);
        var statekey = $('#dialog-delete-forum-post').data('statekey');
        if (!isNaN(postId) && postId > 0) {
          $.ajax({
            type: "POST",
            cache: false,
            // ReSharper disable once UseOfImplicitGlobalInFunctionScope
            url: window.deleteSocialPostUrl,
            dataType: "json",
            data: {
              postId: postId
            },
            success: function success(result) {
              var state = _this8.GetState(statekey);
              if (result.Ok === true) {
                toastr.success(window.YOUR_POST_HAS_BEEN_DELETED);
                var index = 0;
                if (state.forumMode === 'InlineForum') {
                  var _index = state.dataState.reviewModel.Posts.findIndex(function (obj) {
                    return obj.PostId === postId;
                  });
                  if (result.HasReplies === true) {
                    state.dataState.reviewModel.Posts[_index].DeletedPost = true;
                    state.dataState.reviewModel.Posts[_index].Content = '';
                  } else {
                    if (_index > -1) {
                      state.dataState.reviewModel.Posts.splice(_index, 1); // Remove the element at the specified index
                    }
                  }
                  _this8.ProcessInlineForumData(0, 0, statekey);
                } else if (state.forumMode === 'LatestPosts') {
                  index = state.dataState.Posts.findIndex(function (obj) {
                    return obj.EntityId === postId && obj.EntityType == 'post';
                  });
                  if (result.HasReplies === true) {
                    state.dataState.Posts[index].DeletedPost = true;
                    state.dataState.Posts[index].Content = '';
                  } else {
                    if (index > -1) {
                      state.dataState.Posts.splice(index, 1); // Remove the element at the specified index
                    }
                  }
                  _this8.ProcessLatestPostsForumData(statekey);
                }
              } else {
                toastr.error(result.Message);
              }
              $('#post-delete-progress').hide();
              $('#dialog-delete-forum-post').modal('hide').data('postid', null).data('statekey', null);
            },
            error: function error(result) {
              $('#post-delete-progress').hide();
              alert("Network failure");
            }
          });
        }
      }, 0);
    }
  }, {
    key: "CommitCommentDelete",
    value: function CommitCommentDelete() {
      var _this9 = this;
      $('#comment-delete-progress').show();
      setTimeout(function () {
        var postId = parseInt($('#dialog-delete-forum-comment').data('postid'), 10);
        var commentId = parseInt($('#dialog-delete-forum-comment').data('commentid'), 10);
        var statekey = $('#dialog-delete-forum-comment').data('statekey');
        if (!isNaN(postId) && postId > 0 && !isNaN(commentId) && commentId > 0) {
          $.ajax({
            type: "POST",
            cache: false,
            // ReSharper disable once UseOfImplicitGlobalInFunctionScope
            url: window.deleteSocialCommentUrl,
            dataType: "json",
            data: {
              postId: postId,
              commentId: commentId
            },
            success: function success(result) {
              if (result.Ok === true) {
                var state = _this9.GetState(statekey);
                var stateresult = state.dataState;
                toastr.success(window.YOUR_POST_HAS_BEEN_DELETED);
                $('#comment-delete-progress').hide();
                $('#dialog-delete-forum-comment').modal("hide");
                if (state.forumMode === 'InlineForum') {
                  var index = stateresult.reviewModel.Comments.findIndex(function (obj) {
                    return obj.Id === commentId;
                  });
                  if (result.HasReplies) {
                    stateresult.reviewModel.Comments[index].DeletedComment = true;
                    stateresult.reviewModel.Comments[index].Content = '';
                    stateresult.reviewModel.Comments[index].Status = 'deleted';
                  } else {
                    if (index > -1) {
                      stateresult.reviewModel.Comments[index] = stateresult.reviewModel.Comments[stateresult.reviewModel.Comments.length - 1]; // Swap with the last element
                      stateresult.reviewModel.Comments.pop(); // Remove the last element
                    }
                  }
                  _this9.ProcessInlineForumData(postId, 0, statekey);
                  var commentsForPost = stateresult.reviewModel.Comments.filter(function (obj) {
                    return obj.PostId === postId;
                  });
                  window.SocialProfile.OpenCommentToView(statekey, postId, commentsForPost);
                } else if (state.forumMode === 'LatestPosts') {
                  var _index2 = stateresult.Posts.findIndex(function (obj) {
                    return obj.EntityId === commentId && obj.EntityType === 'comment';
                  });
                  if (_index2 > -1) {
                    stateresult.Posts[_index2] = stateresult.Posts[stateresult.Posts.length - 1]; // Swap with the last element
                    stateresult.Posts.pop(); // Remove the last element
                  }
                  _this9.ProcessLatestPostsForumData(statekey);
                }
                _this9.UpdateReplyCounts(result);
              } else {
                toastr.error(result.Message);
              }
              $('#post-delete-progress').hide();
              $('#dialog-delete-forum-post').modal('hide').data('postid', null).data('statekey', null);
            },
            error: function error(result) {
              $('#post-delete-progress').hide();
              alert("Network failure");
            }
          });
        }
      }, 0);
    }
  }, {
    key: "ScrollTo",
    value: function ScrollTo(forumStateKey, elementId) {
      var postId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var el = document.getElementById(elementId);
      var div = $(el);
      if (div.length) {
        div.find('.review-box').first().addClass('highlight');
        setTimeout(function () {
          div.find('.review-box').removeClass('highlight');
          ;
        }, 1000);
        if (postId != undefined) {
          div.find('.review-box').first().get(0).scrollIntoView({
            block: "center",
            behavior: 'smooth'
          });
        } else {
          el.scrollIntoView({
            block: "center",
            behavior: 'smooth'
          });
        }
      } else if (parseInt(postId, 10) > 0) {
        window.SocialProfile.OpenCommentToView(forumStateKey, postId).then(function () {
          setTimeout(function () {
            var el = document.getElementById(elementId);
            div = $(el);
            el.scrollIntoView({
              block: "center",
              behavior: 'smooth'
            });
            div.find('.review-box').first().addClass('highlight');
            setTimeout(function () {
              div.find('.review-box').removeClass('highlight');
              ;
            }, 1000);
          }, 100);
        });
      }
    }
  }, {
    key: "GoToNotifications",
    value: function GoToNotifications() {
      var langSlug = "";
      if (CURRENT_LANG !== DEFAULT_LANG) {
        langSlug = "/" + CURRENT_LANG;
      }
      document.location.href = langSlug + "/dashboard/notifications";
    }
  }, {
    key: "GoToPost",
    value: function GoToPost(postId) {
      document.location.href = "/forum/go-to-post/" + postId;
    }
  }, {
    key: "GoToComment",
    value: function GoToComment(commentId, postId) {
      document.location.href = "/forum/go-to-post/" + postId + "/" + commentId;
    }
  }, {
    key: "GoToThread",
    value: function GoToThread(topicId) {
      document.location.href = "/forum/go-to-thread/" + topicId;
    }
  }, {
    key: "GoToReview",
    value: function GoToReview(reviewId) {
      document.location.href = "/forum/go-to-review/" + reviewId;
    }
  }, {
    key: "GoToReviewComment",
    value: function GoToReviewComment(commentId) {
      document.location.href = "/forum/go-to-review/comment/" + commentId;
    }
  }, {
    key: "GoToSocialProfile",
    value: function GoToSocialProfile(profileId) {
      if (profileId == null) {
        profileId = $('#social-profile-id').val();
      }
      if (profileId !== undefined && profileId !== null && profileId !== 0) {
        if (window.CURRENT_LANG === window.DEFAULT_LANG) {
          if (isNaN(profileId)) {
            profileId = 0;
          }
          document.location.href = "/social-profile/view?spid=" + profileId;
        } else {
          var langSlug = "/" + CURRENT_LANG;
          document.location.href = langSlug + "/social-profile/view?spid=" + profileId;
        }
      }
    }
  }, {
    key: "GoToStatsPage",
    value: function GoToStatsPage(statsId) {
      if (statsId !== undefined && statsId !== null) {
        if (window.CURRENT_LANG === window.DEFAULT_LANG) {
          if (isNaN(statsId)) {
            statsId = 0;
          }
          document.location.href = "/trading-account?said=".concat(statsId, "&tab=discuss");
        } else {
          var langSlug = "/" + CURRENT_LANG;
          document.location.href = langSlug + "/trading-account?said=".concat(statsId, "&tab=discuss");
        }
      }
    }
  }, {
    key: "GoToContestPage",
    value: function GoToContestPage(contestId) {
      if (contestId !== undefined && contestId !== null) {
        if (window.CURRENT_LANG === window.DEFAULT_LANG) {
          if (isNaN(contestId)) {
            contestId = 0;
          }
          document.location.href = "/contests/".concat(contestId, "?tab=discuss");
        } else {
          var langSlug = "/" + CURRENT_LANG;
          document.location.href = langSlug + "/contests/".concat(contestId, "?tab=discuss");
        }
      }
    }
  }, {
    key: "GoToNewsPage",
    value: function GoToNewsPage(newsId) {
      if (newsId !== undefined && newsId !== null) {
        if (window.CURRENT_LANG === window.DEFAULT_LANG) {
          if (isNaN(newsId)) {
            newsId = 0;
          }
          document.location.href = "/news/item/".concat(newsId);
        } else {
          var langSlug = "/" + CURRENT_LANG;
          document.location.href = langSlug + "/news/item/".concat(newsId);
        }
      }
    }
  }, {
    key: "GoToThreadHostPage",
    value: function GoToThreadHostPage(threadId) {
      if (threadId !== undefined && threadId !== null) {
        if (window.CURRENT_LANG === window.DEFAULT_LANG) {
          if (isNaN(threadId)) {
            threadId = 0;
          }
          document.location.href = "/forum/go-to-thread/".concat(threadId);
        } else {
          var langSlug = "/" + CURRENT_LANG;
          document.location.href = langSlug + "/forum/go-to-thread/".concat(threadId);
        }
      }
    }
  }, {
    key: "ActivityFeed",
    value: function ActivityFeed(el, socProfId) {
      var action = $(el).val();
      $('#feed-load-progress').show();
      $.ajax({
        type: "POST",
        cache: false,
        // ReSharper disable once UseOfImplicitGlobalInFunctionScope
        url: window.feedUrl,
        dataType: "json",
        data: {
          action: action,
          socProfileId: socProfId
        },
        success: function success(result) {
          if (result.Success === true) {
            $('#activity-feed').html(result.pageView);
            $('#feed-load-progress').hide();
          } else {}
        },
        error: function error(result) {
          alert("Network failure");
        }
      });
    }
  }, {
    key: "ExpandPostPreview",
    value: function ExpandPostPreview(entityType, entityId, action) {
      var textbox = $('#post-box-' + entityType + "-" + entityId).find('.text-body');
      var $this = $(textbox);
      var targetHeight = $this.data('target-height');
      var fade = $this.next('.preview-fade');
      var shown = $(fade).next('.preview-show');
      if (action == "open") {
        $this.animate({
          'max-height': targetHeight
        }, 500, function () {
          $(shown).show().css('display', 'flex');
          $(fade).hide();
        });
      } else {
        $(shown).hide();
        $(fade).show(); //.css('background', 'linear-gradient(180deg,rgba(244,245,247,0) 1.04%,#f4f5f7 55.78%)');

        $this.animate({
          'max-height': 96
        }, 500);
      }
    }
  }, {
    key: "AddTopic",
    value: function AddTopic(categoryId, containerId) {
      this.RemoveState(containerId);
      this.AddState(containerId, {}, '', 'HostedForum', 0, true);
      if (window.userIsOnline) {
        this.BringToAddTopic(categoryId, containerId);
      } else {
        var data = JSON.stringify({
          categoryId: categoryId,
          containerId: containerId
        });
        window.Access.LoginWithPurpose('BringToAddTopic', window.YOU_MUST_BE_LOGGED_IN_TO_PERFORM_THIS_ACTION, 'login', '', data, 'window.SocialProfile');
      }
    }
  }, {
    key: "EditTopic",
    value: function EditTopic(topicId) {
      if (!window.userIsOnline) {
        return;
      }
      var topicDiv = $(".forum-item.topic[data-topicid=\"".concat(topicId, "\"]"));
      var title = topicDiv.find('.item-title').text();
      this.BringToEditTopic(null, {
        id: topicId,
        title: title
      });
    }
  }, {
    key: "CreateInlineTopic",
    value: function CreateInlineTopic(entityType, entityId) {
      $("#dialog-add-post #topic-title-input").hide();
      if (window.userIsOnline) {
        this.Lightbox.IgniteAddPostPhotoButton();
        this.BringToPost(entityType, entityId);
      } else {
        window.Access.LoginWithPurpose('BringToPost', window.YOU_MUST_BE_LOGGED_IN_TO_PERFORM_THIS_ACTION, 'login', '', '', 'window.SocialProfile');
      }
    }
  }, {
    key: "AddInlineEntityPost",
    value: function AddInlineEntityPost(categoryId, entityType, entityId) {
      $("#dialog-add-post #topic-title-input").hide();
      var containerId = 'dummy-container-id';
      this.CurrentInputState = {
        entityType: entityType,
        entityId: entityId,
        categoryId: categoryId,
        containerId: 'dummy-container-id'
      };
      if (window.userIsOnline) {
        this.Lightbox.IgniteAddPostPhotoButton();
        this.BringToPost(containerId);
      } else {
        var data = {};
        data.containerId = containerId;
        window.Access.LoginWithPurpose('BringToPost', window.YOU_MUST_BE_LOGGED_IN_TO_PERFORM_THIS_ACTION, 'login', '', data, 'window.SocialProfile');
      }
    }
  }, {
    key: "AddPost",
    value: function AddPost(containerId) {
      $("#dialog-add-post #topic-title-input").hide();
      this.CurrentInputState = {
        containerId: containerId
      };
      if (window.userIsOnline) {
        this.Lightbox.IgniteAddPostPhotoButton();
        this.BringToPost(containerId);
      } else {
        var data = {};
        data.containerId = containerId;
        window.Access.LoginWithPurpose('BringToPost', window.YOU_MUST_BE_LOGGED_IN_TO_PERFORM_THIS_ACTION, 'login', '', data, 'window.SocialProfile');
      }
    }
  }, {
    key: "BringToPost",
    value: function () {
      var _BringToPost = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(containerId) {
        var _this0 = this;
        var stateForForum, draftKey, hasDraft, draftJson, draft, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              stateForForum = this.GetState(containerId);
              draftKey = "forumDraft-post-topic-".concat(stateForForum.topicId);
              this.Lightbox.resetTmpFilesForDraft(draftKey);
              this.Lightbox.currentContext = "draft";
              this.Lightbox.currentDraftKey = draftKey;
              this.activeContainerId = containerId;
              hasDraft = !!localStorage.getItem(draftKey);
              if (this.Lightbox.currentContext === "draft" && hasDraft) {
                $('#clear-post-draft-cell').show();
                $('#dialog-add-post .draft-saved-hint').show();
              } else {
                $('#clear-post-draft-cell').hide();
                $('#dialog-add-post .draft-saved-hint').hide();
              }
              $('#dialog-add-post .has-danger').removeClass('has-danger');
              $('#submit-post-progress').hide();
              $("#img-post-frames").html('');
              document.getElementById('post-input-editor').innerHTML = '';
              $('#dialog-add-post').off('shown.bs.modal');
              $('#add-post-body').show();

              // Restore draft from localStorage
              draftJson = localStorage.getItem(draftKey);
              if (!draftJson) {
                _context2.n = 4;
                break;
              }
              _context2.p = 1;
              draft = JSON.parse(draftJson);
              if (draft.body) {
                document.getElementById('post-input-editor').innerHTML = draft.body;
              }
              if (!(Array.isArray(draft.imageRefs) && draft.imageRefs.length > 0)) {
                _context2.n = 2;
                break;
              }
              _context2.n = 2;
              return this.Lightbox.RenderImageRefsFromDraft(draft.imageRefs, "#img-post-frames", draftKey);
            case 2:
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t = _context2.v;
              console.warn("Failed to parse post draft:", _t);
            case 4:
              this.GetNotificationStatus();
              this.initiateDraftForEditor('post-input-editor', containerId, draftKey);
              _context2.n = 5;
              return this.initiateTaggingForEditor('#post-input-editor');
            case 5:
              $('#dialog-add-post').off('hidden.bs.modal').on('hidden.bs.modal', function (e) {
                if (_this0.tagHandler) {
                  _this0.tagHandler.destroy("destroy handler");
                }
                _this0.removeDraftListenerForEditor('post-input-editor');
              }).modal('show');
            case 6:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3]]);
      }));
      function BringToPost(_x) {
        return _BringToPost.apply(this, arguments);
      }
      return BringToPost;
    }()
  }, {
    key: "ExtractEditorContent",
    value: function ExtractEditorContent() {
      var editorId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'post-input-editor';
      var editor = document.getElementById(editorId);
      if (!editor) return '';
      var clone = editor.cloneNode(true);
      clone.querySelectorAll('.forum-mention').forEach(function (el) {
        var userId = el.getAttribute('user-id');
        var handle = el.getAttribute('handle');
        if (userId && handle) {
          var mention = document.createElement('mention');
          mention.setAttribute('user-id', userId);
          mention.setAttribute('handle', handle);
          mention.textContent = "".concat(handle);
          mention.className = 'forum-mention';
          mention.contentEditable = 'false';
          el.replaceWith(mention);
        } else {
          console.warn("Invalid mention element:", el);
          el.replaceWith(document.createTextNode(el.textContent));
        }
      });
      var rawHtml = clone.innerHTML.trim();
      if (this._EditorSecurity) {
        return this._EditorSecurity.sanitizeToMentionsOnly(rawHtml);
      }
      return rawHtml;
    }
  }, {
    key: "EditCategory",
    value: function EditCategory(categoryId) {
      if (window.userIsOnline) {
        var categoryDiv = $(".forum-item.category[data-categoryid=\"".concat(categoryId, "\"]"));
        var weight = categoryDiv.data('categoryweight');
        var title = categoryDiv.find('.item-title').text();
        var description = categoryDiv.find('.item-description').text();
        this.BringToAddOrEditCategory({
          id: categoryId,
          title: title,
          description: description,
          weight: weight
        });
      }
    }
  }, {
    key: "AddCategory",
    value: function AddCategory() {
      if (window.userIsOnline) {
        this.BringToAddOrEditCategory();
      }
    }
  }, {
    key: "SubscribeToDiscussion",
    value: function SubscribeToDiscussion(r) {
      var state = this.GetState(r);
      if (window.userIsOnline) {
        this.BringToSubscription("Topic", state.topicId);
      } else {
        var subscribeData = {};
        subscribeData.EntityId = state.topicId;
        subscribeData.EntityType = "Topic";
        var data = JSON.stringify(subscribeData);
        window.Access.LoginWithPurpose('BringToSubscription', window.YOU_MUST_BE_LOGGED_IN_TO_PERFORM_THIS_ACTION, 'login', '', data, 'window.SocialProfile');
      }
    }
  }, {
    key: "SubscribeToReview",
    value: function SubscribeToReview() {
      if (window.userIsOnline) {
        this.BringToReviewSubscription("BrokerReviews", this.brokerId);
      } else {
        var subscribeData = {};
        subscribeData.EntityId = this.brokerId;
        subscribeData.EntityType = "BrokerBeingReviewed";
        var data = JSON.stringify(subscribeData);
        window.Access.LoginWithPurpose('BringToReviewSubscription', window.YOU_MUST_BE_LOGGED_IN_TO_PERFORM_THIS_ACTION, 'login', '', data, 'window.SocialProfile');
      }
    }
  }, {
    key: "DeleteSubscription",
    value: function DeleteSubscription(id) {
      $('#dialog-delete-subscription').data('id', id);
      $('#dialog-delete-subscription').modal('show');
    }
  }, {
    key: "FilterReviews",
    value: function () {
      var _FilterReviews = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var module, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              if (window.BrokerReview) {
                _context3.n = 6;
                break;
              }
              _context3.p = 1;
              _context3.n = 2;
              return Promise.resolve().then(function () {
                return _interopRequireWildcard(require('./SocialProfile/BrokerReview/Controller.js'));
              });
            case 2:
              module = _context3.v;
              window.BrokerReview = module;
              if (!(typeof window.BrokerReview.FilterReviews === 'function')) {
                _context3.n = 3;
                break;
              }
              return _context3.a(2, window.BrokerReview.FilterReviews());
            case 3:
              _context3.n = 5;
              break;
            case 4:
              _context3.p = 4;
              _t2 = _context3.v;
              console.error('Failed to load BrokerReview module to Filter Reviews:', _t2);
            case 5:
              _context3.n = 7;
              break;
            case 6:
              return _context3.a(2, window.BrokerReview.FilterReviews());
            case 7:
              return _context3.a(2);
          }
        }, _callee3, null, [[1, 4]]);
      }));
      function FilterReviews() {
        return _FilterReviews.apply(this, arguments);
      }
      return FilterReviews;
    }()
  }, {
    key: "ProcessReviewFeedData",
    value: function () {
      var _ProcessReviewFeedData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(forumStateKey) {
        var _yield$import, ProcessBrokerReviewFeedData, _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              if (this.ProcessBrokerReviewFeedData) {
                _context4.n = 6;
                break;
              }
              _context4.p = 1;
              _context4.n = 2;
              return Promise.resolve().then(function () {
                return _interopRequireWildcard(require('./SocialProfile/BrokerReview/Utilities/ProcessBrokerReviewFeedData.js'));
              });
            case 2:
              _yield$import = _context4.v;
              ProcessBrokerReviewFeedData = _yield$import.ProcessBrokerReviewFeedData;
              if (!(typeof ProcessBrokerReviewFeedData === 'function')) {
                _context4.n = 3;
                break;
              }
              this.ProcessBrokerReviewFeedData = ProcessBrokerReviewFeedData.bind(this);
              _context4.n = 4;
              break;
            case 3:
              console.error('ProcessBrokerReviewFeedData is not a function');
              return _context4.a(2);
            case 4:
              _context4.n = 6;
              break;
            case 5:
              _context4.p = 5;
              _t3 = _context4.v;
              console.error('Failed to load ProcessBrokerReviewFeedData:', _t3);
              return _context4.a(2);
            case 6:
              return _context4.a(2, this.ProcessBrokerReviewFeedData(forumStateKey));
          }
        }, _callee4, this, [[1, 5]]);
      }));
      function ProcessReviewFeedData(_x2) {
        return _ProcessReviewFeedData.apply(this, arguments);
      }
      return ProcessReviewFeedData;
    }()
  }, {
    key: "SwitchToRejectedTab",
    value: function SwitchToRejectedTab() {
      // if spam is selected, need to switch to Rejected tab
      return window.BrokerReview.SwitchToRejectedTab();
    }
  }, {
    key: "AddOrEditReview",
    value: function () {
      var _AddOrEditReview = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(brokerId, evt, logoSrc, evtSrcId) {
        var rowIndex, _window, _window$BrokerReview, _t4;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              rowIndex = 0;
              if (evtSrcId == 3) {
                //submit review opened thru promotions
                logoSrc = window.location.origin + "/Content/dist/brokers/images/" + logoSrc;
              } else if (evtSrcId == 2) {
                //submit review opened brokers list page
                rowIndex = $(evt).closest('tr').index();
                rowIndex = rowIndex ? rowIndex + 1 : 1;
              } else if (evtSrcId == 1) {//submit review opened thru broker profile page
              }
              if (!brokerId) {
                brokerId = this.brokerId;
              }
              if (brokerId) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2);
            case 1:
              if (!window.userIsOnline) {
                _context5.n = 11;
                break;
              }
              if (window.BrokerReview) {
                _context5.n = 8;
                break;
              }
              _context5.p = 2;
              if (!((_window$BrokerReview = (_window = window).BrokerReview) !== null && _window$BrokerReview !== void 0)) {
                _context5.n = 3;
                break;
              }
              _window$BrokerReview;
              _context5.n = 5;
              break;
            case 3:
              _context5.n = 4;
              return Promise.resolve().then(function () {
                return _interopRequireWildcard(require('./SocialProfile/BrokerReview/Controller.js'));
              });
            case 4:
              _window.BrokerReview = _context5.v;
            case 5:
              window.BrokerReview.SetState({
                BrokerId: null
              });
              window.BrokerReview.SetState({
                Tmp_files: []
              });
              _context5.n = 6;
              return window.BrokerReview.AddOrEditReview(brokerId, rowIndex, logoSrc, evtSrcId);
            case 6:
              return _context5.a(2, _context5.v);
            case 7:
              _context5.p = 7;
              _t4 = _context5.v;
              console.error('Failed to load BrokerReview module:', _t4);
              _context5.n = 10;
              break;
            case 8:
              window.BrokerReview.SetState({
                BrokerId: null
              });
              window.BrokerReview.SetState({
                Tmp_files: []
              });
              _context5.n = 9;
              return window.BrokerReview.AddOrEditReview(brokerId, rowIndex, logoSrc, evtSrcId);
            case 9:
              return _context5.a(2, _context5.v);
            case 10:
              _context5.n = 12;
              break;
            case 11:
              this.brokerId = brokerId;
              window.Access.LoginWithPurpose('AddOrEditReview', window.YOU_MUST_BE_LOGGED_IN_TO_PERFORM_THIS_ACTION, 'login', '', '', 'window.SocialProfile');
            case 12:
              return _context5.a(2);
          }
        }, _callee5, this, [[2, 7]]);
      }));
      function AddOrEditReview(_x3, _x4, _x5, _x6) {
        return _AddOrEditReview.apply(this, arguments);
      }
      return AddOrEditReview;
    }()
  }, {
    key: "BringToSubscription",
    value: function BringToSubscription(EntityType, EntityId) {
      $('#subscribe-to-discussion-dialog-progress').addClass('hide');
      $('#subscribe-to-discussion-dialog').off('shown.bs.modal');
      if (EntityId !== undefined && EntityId !== null) {
        $('#subscribe-to-discussion-dialog').data('entityId', EntityId);
      }
      if (EntityType !== undefined && EntityType !== null) {
        $('#subscribe-to-discussion-dialog').data('entityType', EntityType);
      }
      $('#subscribe-to-discussion-dialog').modal('show');
    }
  }, {
    key: "BringToReviewSubscription",
    value: function BringToReviewSubscription() {
      var entityType = 'BrokerBeingReviewed';
      var entityId = this.brokerId;
      $('#subscribe-to-discussion-dialog-progress').addClass('hide');
      $('#subscribe-to-discussion-dialog').off('shown.bs.modal');
      if (entityId !== undefined && entityId !== null) {
        $('#subscribe-to-discussion-dialog').data('entityId', entityId);
      }
      if (entityType !== undefined && entityType !== null) {
        $('#subscribe-to-discussion-dialog').data('entityType', entityType);
      }
      $('#subscribe-to-discussion-dialog').modal('show');
    }
  }, {
    key: "BringToReview",
    value: function BringToReview(brokerId) {
      if (!brokerId) brokerId = this.brokerId;
      $('#dialog-add-review .has-danger').removeClass('has-danger');
      $('#no-rating-checkbox').prop('checked', false);
      $('li.clicked').removeClass('clicked');
      $('#review-rating').val('');
      $('#submit-review-progress').hide();
      $('#add-review-verified').hide();
      $('#add-review-unverified').hide();
      $('#is-verified-value').val('');
      $("#img-frames").html('');
      $('#add-review-body').show();
      $('#dialog-add-review').modal('show');
      $.ajax({
        type: "POST",
        cache: false,
        // ReSharper disable once UseOfImplicitGlobalInFunctionScope
        url: window.verifyForBrokerUrl,
        dataType: "json",
        data: {
          brokerId: brokerId
        },
        success: function success(result) {
          if (result.isVerified) {
            $('#add-review-verified').show();
            $('#is-verified-value').val('1');
          } else {
            $('#add-review-unverified').show();
            $('#is-verified-value').val('0');
          }
        },
        error: function error(result) {}
      });
    }
  }, {
    key: "LoadMTBrokers",
    value: function LoadMTBrokers(brokerId) {
      if (!brokerId) brokerId = this.brokerId;
      $.ajax({
        type: "POST",
        cache: false,
        // ReSharper disable once UseOfImplicitGlobalInFunctionScope
        url: window.loadMTBrokersUrl,
        dataType: "json",
        data: {
          brokerId: brokerId
        },
        success: function success(result) {
          if (result.length > 0) {
            var options = '';
            for (var i = 0; i < result.length; i++) {
              var srv = result[i].BrokerName + ' (' + (result[i].PlatformType == 0 ? 'MT4' : 'MT5') + ')';
              options += '<option value="' + srv + '">' + srv + '</option>';
            }
            $("#mt-broker-select").append(options);
            $("#mt-broker-select-cell").show();
          } else {
            $("#mt-broker-select-cell").hide();
          }
        },
        error: function error(result) {}
      });
    }
  }, {
    key: "LoadLatestPosts",
    value: function LoadLatestPosts() {
      var _this1 = this;
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var containerId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'forum-list-wrap';
      var data = {
        Page: page,
        RenderPagination: true,
        ContainerId: containerId
      };
      $.ajax({
        type: "POST",
        cache: false,
        // ReSharper disable once UseOfImplicitGlobalInFunctionScope
        url: window.loadLatestPostsUrl,
        dataType: "json",
        data: data,
        success: function success(result) {
          if (result != null) {
            _this1.IsMasquerade = result.IsMasquerade;
            _this1.AddState('forum-list-wrap', result, 'forum-list-wrap-pager', 'LatestPosts', 0, result.Moderate == true);
            _this1.moderator = result.Moderate == true;
            _this1.ProcessLatestPostsForumData('forum-list-wrap');
          }
        },
        error: function error(result) {}
      });
    }
  }, {
    key: "LoadTopicPosts",
    value: function LoadTopicPosts(topicId) {
      var _this10 = this;
      var jumpToPostId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var counterId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var jumpToCommentId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var containerId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'inline-forum';
      var pagerId = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'inline-forum-pager';
      var jumpTo = parseInt(jumpToPostId, 10);
      var jumpToC = parseInt(jumpToCommentId, 10);
      if (parseInt(topicId, 10) > 0) {
        var data = {
          TopicId: topicId,
          RenderPagination: true,
          JumpToPostId: jumpTo,
          ContainerId: containerId
        };
        $.ajax({
          type: "POST",
          cache: false,
          // ReSharper disable once UseOfImplicitGlobalInFunctionScope
          url: window.loadInlineTopicUrl,
          dataType: "json",
          data: data,
          success: function success(result) {
            _this10.AddState(containerId, result, pagerId, 'InlineForum', topicId);
            _this10.moderator = result.Moderate == true;
            if (result != null) {
              var topicTitle = result.reviewModel.TopicTitle;
              if (topicTitle === null || topicTitle === undefined) {
                topicTitle = '';
              }
              // reload topic meta details
              //$('div.topic-meta-information').html(this.InitForumTopicMetaControl(result.reviewModel.TopicCreatedAt, result.reviewModel.TotalPostAndReplies, result.reviewModel.NumParticipants, topicId, topicTitle));

              _this10.moderator = result.Moderate == true;
              if (counterId !== '' && counterId !== undefined && parseInt(result.reviewModel.TotalPostAndReplies, 10) > 0 && counterId !== null && $('#' + counterId).length) {
                var outString = $('#' + counterId).data('orgtext');
                if (!outString) outString = $('#' + counterId).html();
                $('#' + counterId).html(outString.replace("{0}", result.reviewModel.TotalPostAndReplies));
              } else if (counterId !== '' && counterId !== undefined && parseInt(result.reviewModel.TotalPosts, 10) > 0 && counterId !== null && $('#' + counterId).length) {
                var _outString2 = $('#' + counterId).data('orgtext');
                if (!_outString2) _outString2 = $('#' + counterId).html();
                $('#' + counterId).html(_outString2.replace("{0}", result.reviewModel.TotalPosts));
              }
              _this10.ProcessInlineForumData(jumpToPostId, jumpToC, containerId);
            }
          },
          error: function error(result) {}
        });
      }
    }
  }, {
    key: "WaitForProcessInlineForumData",
    value: function WaitForProcessInlineForumData() {
      var _this11 = this;
      var jumpToPostId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var jumpToCommentId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var containerId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'inline-forum';
      return new Promise(function (resolve, reject) {
        _this11.ProcessInlineForumData(jumpToPostId, jumpToCommentId, containerId);
        resolve(true);
      });
    }
  }, {
    key: "ProcessInlineForumData",
    value: function ProcessInlineForumData() {
      var _this12 = this;
      var jumpToPostId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var jumpToCommentId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var containerId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'inline-forum';
      var state = this.GetState(containerId);
      var result = state.dataState;
      var commentDivToJumpTo = '';
      var jumpTo = parseInt(jumpToPostId, 10);
      var jumpToC = parseInt(jumpToCommentId, 10);
      var myVote = '';
      var isAnon = !(result.reviewModel && result.reviewModel.MyProfile && result.reviewModel.MyProfile.Id !== null && result.reviewModel.MyProfile.Id !== undefined && parseInt(result.reviewModel.MyProfile.Id, 10) > 0);
      this.IsMasquerade = result.IsMasquerade;
      if (isAnon) {
        this.GetAnonLikesFromStorage();
      } else {
        this.MyProfile = result.reviewModel.MyProfile;
      }
      if (result.reviewModel == undefined || result.reviewModel == null || result.reviewModel.Posts == null || result.reviewModel.Posts.length == 0) {
        $('#' + containerId).html("<h3>".concat(window.BE_THE_FIRST_PERSON_TO_POST_IN_THIS_DISCUSSION, "</h3>"));
      } else {
        $('#' + containerId).html('');
      }
      result.reviewModel.Posts && result.reviewModel.Posts.forEach(function (num, index) {
        myVote = '';
        if (!isAnon) {
          var downString = result.reviewModel.Posts[index].DownVoters;
          var upString = result.reviewModel.Posts[index].UpVoters;
          if (upString != null && upString != '') {
            var UpVotes = upString.split(',');
            if (UpVotes.includes(result.reviewModel.MyProfile.Id.toString())) {
              myVote = 'up';
            }
          }
          if (myVote == '') {
            if (downString != null && downString != '') {
              var DownVotes = downString.split(',');
              if (DownVotes.includes(result.reviewModel.MyProfile.Id.toString())) {
                myVote = 'down';
              }
            }
          }
        } else if (_this12.AnonSocialProfileLikes.length) {
          var intId = parseInt(result.reviewModel.Posts[index].PostId, 10);
          myVote = _this12.GetAnonThumbState(intId, 'Post');
        }
        var commentsForPost = result.reviewModel.Comments.filter(function (item) {
          return item.AttachedToPostId === parseInt(result.reviewModel.Posts[index].PostId, 10);
        });
        if (result.reviewModel.Posts[index].DeletedPost !== true || commentsForPost.length > 0) {
          var post = _this12.RenderForumPost(containerId, result.reviewModel.Posts[index], myVote, result.reviewModel.TopicOwnerId);
          $('#' + containerId).append(post);
          if (commentsForPost.length > 0) {
            var doCommentDiv = true;
            if (jumpToCommentId > 0) {
              if (commentDivToJumpTo === '' && commentsForPost.filter(function (c) {
                return c.Id == jumpToCommentId;
              }).length) {
                commentDivToJumpTo = 'forum-comment-box-' + jumpToCommentId;
              }
              ;
            }
            if (doCommentDiv) {
              var commentToPaint = commentsForPost[0];
              var isLast = true;
              var numMoreComments = 0;
              var moreCommentsLink = '';
              if (commentsForPost && commentsForPost.length > 1) {
                isLast = false;
                numMoreComments = commentsForPost.length;
                moreCommentsLink = _this12.RenderMoreCommentsLink(containerId, numMoreComments, commentToPaint.AttachedToPostId);
              }
              var startWith = _this12.RenderForumComment(containerId, commentToPaint, isAnon, true, isLast);
              if (moreCommentsLink != '') {
                $('#comment-list-' + commentToPaint.AttachedToPostId).html(startWith + moreCommentsLink);
              } else {
                $('#comment-list-' + commentToPaint.AttachedToPostId).html(startWith);
              }
              $('#comment-post-' + commentToPaint.AttachedToPostId).show();
            }
          }
        }
      });
      this.Lightbox.InitializeLBImages('forum-items-container');
      this.Lightbox.InitializeLBImages('inline-forum-template');
      if (result.reviewModel.PagerHtml) {
        $('#' + containerId + '-pager').html(result.reviewModel.PagerHtml).show();
      }
      if (!isNaN(jumpTo) && jumpTo > 0 && document.getElementById('post-box-' + jumpTo) != null) {
        var div = '';
        if (!isNaN(jumpToC) && jumpToC > 0) {
          var commentsForPost = result.reviewModel.Comments.filter(function (item) {
            return item.AttachedToPostId === parseInt(jumpTo, 10);
          });
          window.SocialProfile.OpenCommentToView(containerId, jumpTo, commentsForPost).then(function () {
            document.getElementById(commentDivToJumpTo);
            div = $('#' + commentDivToJumpTo);
            div.find('.review-box').first().addClass('highlight').get(0).scrollIntoView({
              block: "center",
              behavior: 'smooth'
            });
            setTimeout(function () {
              div.find('.review-box').removeClass('highlight');
            }, 1000);
          });
        } else {
          document.getElementById('post-box-' + jumpTo).scrollIntoView({
            block: "center",
            behavior: 'smooth'
          });
          div = $('#post-box-' + jumpTo);
          div.find('.review-box').first().addClass('highlight');
          setTimeout(function () {
            div.find('.review-box').removeClass('highlight');
            ;
          }, 1000);
        }
      }
      if ($('#topic-meta-information').length) {
        if (result.reviewModel && result.reviewModel.LastPostBySocialProfileId > 0) {
          var topicTitle = result.reviewModel.TopicTitle;
          if (topicTitle === null || topicTitle === undefined) {
            topicTitle = '';
          }
          var controlHtml = this.InitForumTopicMetaControl(result.reviewModel.TopicCreatedAt, result.reviewModel.TotalPostAndReplies, result.reviewModel.NumParticipants, result.reviewModel.TopicId, topicTitle);
          $('#topic-meta-information').html(controlHtml);
        } else {
          $('#topic-meta-information').html('');
        }
      }
      this.IgnitePopOverMenus();
    }
  }, {
    key: "WaitForProcessLatestPostsForumData",
    value: function WaitForProcessLatestPostsForumData(forumStateKey) {
      var _this13 = this;
      return new Promise(function (resolve, reject) {
        _this13.ProcessLatestPostsForumData(forumStateKey);
        resolve(true);
      });
    }
  }, {
    key: "ProcessLatestPostsForumData",
    value: function ProcessLatestPostsForumData(stateForumKey) {
      var _this14 = this;
      var myVote = '';
      var stateForForum = this.GetState(stateForumKey);
      if (stateForForum instanceof DataContainer) {
        var result = stateForForum.dataState;
        var isAnon = !(result.SocialProfileId && result.SocialProfileId !== null && result.SocialProfileId !== undefined && parseInt(result.SocialProfileId, 10) > 0);
        if (isAnon) {
          this.GetAnonLikesFromStorage();
        }
        $('#' + stateForumKey).html('');
        result && result.Posts && result.Posts.forEach(function (num, index) {
          myVote = '';
          if (!isAnon) {
            var downString = result.Posts[index].DownVotes;
            var upString = result.Posts[index].UpVotes;
            if (upString != null && upString != '') {
              var UpVotes = upString.split(',');
              if (UpVotes.includes(result.SocialProfileId.toString())) {
                myVote = 'up';
              }
            }
            if (myVote == '') {
              if (downString != null && downString != '') {
                var DownVotes = downString.split(',');
                if (DownVotes.includes(result.SocialProfileId.toString())) {
                  myVote = 'down';
                }
              }
            }
          } else if (_this14.AnonSocialProfileLikes.length) {
            var intId;
            if (result.Posts[index].EntityType == "comment") {
              intId = parseInt(result.Posts[index].EntityId, 10);
              myVote = _this14.GetAnonThumbState(intId, 'ForumComment');
            } else {
              intId = parseInt(result.Posts[index].PostId, 10);
              myVote = _this14.GetAnonThumbState(intId, 'Post');
            }
          }
          $('#' + stateForumKey).append(_this14.RenderLatestForumPost(stateForumKey, result.Posts[index], myVote));
        });
        result && result.HotTopics && result && result.HotTopics.length > 0 && $('#hot-topics-list').html('');
        result && result.HotTopics && result.HotTopics.forEach(function (num, index) {
          $('#hot-topics-list').append(_this14.RenderHotTopic(result.HotTopics[index]));
        });
        if (result.PagerHtml && $('#' + stateForumKey + '-pager').length) {
          if ($('#' + stateForumKey + '-pager').length) {
            $('#' + stateForumKey + '-pager').html(result.PagerHtml).show();
          } else if ($('#' + stateForForum.pagerContainer).length) {
            $('#' + stateForForum.pagerContainer).html(result.PagerHtml).show();
          }
        }

        /* setTimeout(() => {*/
        $('.text-body').each(function (index, el) {
          if (el.scrollHeight > el.clientHeight) {
            $(el).data('target-height', el.scrollHeight).next('.preview-fade').css('display', 'flex');
          }
        });
        /*  }, 0);*/

        this.Lightbox.InitializeLBImages('forum-page-wrap');
        this.IgnitePopOverMenus();
      } else {
        console.log("stateForForum is NOT an instance of DataContainer");
      }
    }
  }, {
    key: "WaitForProcessReviewCommentsFeedData",
    value: function WaitForProcessReviewCommentsFeedData(forumStateKey) {
      var _this15 = this;
      return new Promise(function (resolve, reject) {
        _this15.ProcessReviewCommentsFeedData(forumStateKey);
        resolve(true);
      });
    }
  }, {
    key: "ProcessReviewCommentsFeedData",
    value: function ProcessReviewCommentsFeedData(stateKey) {
      var _this16 = this;
      var myVote = '';
      var state = this.GetState(stateKey);
      var result = state.dataState;
      var isAnon = !(result.SocialProfileId && result.SocialProfileId !== null && result.SocialProfileId !== undefined && parseInt(result.SocialProfileId, 10) > 0);
      if (isAnon) {
        this.GetAnonLikesFromStorage();
      }
      $('#' + stateKey).html('');
      result && result.Posts && result.Posts.forEach(function (num, index) {
        myVote = '';
        if (!isAnon) {
          var downString = result.Posts[index].DownVotes;
          var upString = result.Posts[index].UpVotes;
          if (upString != null && upString != '') {
            var UpVotes = upString.split(',');
            if (UpVotes.includes(result.SocialProfileId.toString())) {
              myVote = 'up';
            }
          }
          if (myVote == '') {
            if (downString != null && downString != '') {
              var DownVotes = downString.split(',');
              if (DownVotes.includes(result.SocialProfileId.toString())) {
                myVote = 'down';
              }
            }
          }
        } else if (_this16.AnonSocialProfileLikes.length) {
          var intId;
          intId = parseInt(result.Posts[index].EntityId, 10);
          myVote = _this16.GetAnonThumbState(intId, 'ReviewComment');
        }
        $('#' + stateKey).append(_this16.RenderReviewCommentForProfileFeed(result.Posts[index], myVote));
      });
      if (result.PagerHtml) {
        $('#' + stateKey + '-pager').html(result.PagerHtml).show();
      }

      /* setTimeout(() => {*/
      $('.text-body').each(function (index, el) {
        if (el.scrollHeight > el.clientHeight) {
          $(el).data('target-height', el.scrollHeight).next('.preview-fade').css('display', 'flex');
        }
      });
      /*  }, 0);*/

      this.Lightbox.InitializeLBImages('review-comments-list-wrap');
      this.IgnitePopOverMenus();
      this.IgniteReviewerStatusTooltip();
    }
  }, {
    key: "WaitForProcessVotesFeedData",
    value: function WaitForProcessVotesFeedData(result) {
      var _this17 = this;
      return new Promise(function (resolve, reject) {
        _this17.ProcessVotesFeedData(result);
        resolve(true);
      });
    }
  }, {
    key: "ProcessVotesFeedData",
    value: function ProcessVotesFeedData(result) {
      var _this18 = this;
      var myVote = '';
      var isAnon = !(result.SocialProfileId && result.SocialProfileId !== null && result.SocialProfileId !== undefined && parseInt(result.SocialProfileId, 10) > 0);
      if (isAnon) {
        this.GetAnonLikesFromStorage();
      }
      $('#vote-list-wrap').html('');
      result && result.List && result.List.forEach(function (num, index) {
        var entityType = result.List[index].EntityType;
        myVote = '';
        if (!isAnon) {
          var downString = result.List[index].DownVotes;
          var upString = result.List[index].UpVotes;
          if (upString != null && upString != '') {
            var UpVotes = upString.split(',');
            if (UpVotes.includes(result.SocialProfileId.toString())) {
              myVote = 'up';
            }
          }
          if (myVote == '') {
            if (downString != null && downString != '') {
              var DownVotes = downString.split(',');
              if (DownVotes.includes(result.SocialProfileId.toString())) {
                myVote = 'down';
              }
            }
          }
        } else if (_this18.AnonSocialProfileLikes.length) {
          var intId;
          intId = parseInt(result.List[index].EntityId, 10);
          myVote = _this18.GetAnonThumbState(intId, entityType);
        }
        $('#vote-list-wrap').append(_this18.RenderVoteEntityForProfileFeed(result.List[index], myVote));
      });
      if (result.PagerHtml) {
        $('#vote-list-pagination').html(result.PagerHtml).show();
      }

      /* setTimeout(() => {*/
      $('.text-body').each(function (index, el) {
        if (el.scrollHeight > el.clientHeight) {
          $(el).data('target-height', el.scrollHeight).next('.preview-fade').css('display', 'flex');
        }
      });
      /*  }, 0);*/

      this.Lightbox.InitializeLBImages('vote-list-wrap');
    }
  }, {
    key: "GetAnonThumbState",
    value: function GetAnonThumbState(intId, channel) {
      var myVote = '';
      var upThumbData = {
        direction: 'up',
        channel: channel,
        id: intId
      };
      var upThumb = this.Hash(JSON.stringify(upThumbData), 23);
      var downThumbData = {
        direction: 'down',
        channel: channel,
        id: intId
      };
      var downThumb = this.Hash(JSON.stringify(downThumbData), 23);
      if (this.AnonSocialProfileLikes.includes(downThumb)) {
        myVote = 'down';
      } else if (this.AnonSocialProfileLikes.includes(upThumb)) {
        myVote = 'up';
      }
      return myVote;
    }
  }, {
    key: "GetAnonLikesFromStorage",
    value: function GetAnonLikesFromStorage() {
      if (localStorage.getItem("SocialProfileLikes") != null) {
        var storedLikeData = localStorage.getItem("SocialProfileLikes");
        if (storedLikeData !== null) {
          this.AnonSocialProfileLikes = JSON.parse(storedLikeData);
        }
      }
    }
  }, {
    key: "RenderNotification",
    value: function RenderNotification(notification) {
      var who = "<span class=\"notification-field actor\">".concat(notification.Actor, " ");
      if (notification.NumActors > 1) {
        if (notification.NumActors == 2) {
          who += "&nbsp;".concat(AND_ONE_OTHER);
        } else {
          who += "&nbsp;".concat(AND_X_OTHERS.replace('{0}', notification.NumActors - 1));
        }
      }
      who += "</span>";
      var myDate = moment.duration(moment.utc(notification.CreatedAt).diff(this.now)).humanize(true);
      return "<div id=\"\" class=\"notification-wrap-".concat(notification.Id, " notification-wrap ").concat(function () {
        if (notification.CreatorShownAt == null) {
          return "active";
        }
        return "";
      }(), "\">\n        <div class=\"notification-item font-13\">\n        <div class=\"notification-left\">\n            <div class=\"notification-field avatar social-profile-navigate\" data-profile-id=\"").concat(notification.ActorId, "\">\n                <img class=\"social-profile-navigate\" src=\"").concat(this.avatarPath).concat(notification.ActorAvatar, "\" data-profile-id=\"").concat(notification.ActorId, "\">\n            </div>\n            </div>\n            <div class=\"notification-right  acknowledge-notification\" onclick=\"window.SocialProfile.AcknowledgeNotification(").concat(notification.Id, ")\">\n\n            ").concat(function () {
        switch (notification.ActionType) {
          case "ReviewApprovedOnBrokerUserOwns":
            return "".concat(who, " ").concat(HAS_POSTED_A_REVIEW_OF_X.replace('{0}', notification.ContentPreview));
            break;
          case "UserMentionedInComment":
            return "".concat(who, " mentioned you in a comment");
            break;
          case "UserMentionedInPost":
            return "".concat(who, " mentioned you in a forum post");
            break;
          case "ReviewCommentApprovedOnBrokerUserOwns":
            return "".concat(who, " ").concat(X_COMMENTED_ON_A_REVIEW_OF_Y.replace('{0}', notification.ContentPreview).replace('{1}', notification.ContentPreview));
            break;
          case "ReviewApprovedOnBrokerUserSubscribed":
            return "".concat(who, " ").concat(REVIEWED_A_BROKER_YOU_SUBSCRIBED_TO);
            break;
          case "ReviewApprovedOnBrokerUserOwns":
            return "".concat(who, " ").concat(HAS_POSTED_A_REVIEW_OF_X.replace('{0}', notification.ContentPreview));
            break;
          case "PostCreatedOnTopicUserSubscribed":
            return "".concat(who, " ").concat(POSTED_IN_A_DISCUSSION_YOU_SUBSCRIBED_TO);
            break;
          case "SubscribedToTopic":
            return "".concat(who, " ").concat(SUBSCRIBED_TO_A_DISCUSSION_YOU_STARTED);
            break;
          case "SubscribedToBrokerReview":
            return "".concat(X_SUBSCRIBED_TO_A_BROKER_YOU_OWN.replace('{0}', who));
            break;
          case "BrokerReviewApproved":
            return "".concat(who, " ").concat(HAS_POST_A_REVIEW_OF_A_BROKER_YOU_FOLLOW);
            break;
          case "MyReviewApproved":
            return "".concat(who, " ").concat(HAS_APPROVED_YOUR_BROKER_REVIEW);
            break;
          case "MyReviewCommentApproved":
            return "".concat(X_HAS_APPROVED_YOUR_BROKER_REVIEW_COMMENT.replace('{0}', who));
            break;
          case "PostCreatedOnTopicUserCreated":
            return "".concat(who, " ").concat(POSTED_IN_A_DISCUSSION_YOU_STARTED);
            break;
          case "RespondToComment":
          case "RespondedToComment":
            return "".concat(who, " ").concat(RESPONDED_TO_YOUR_COMMENT);
            break;
          case "RespondToPost":
          case "RespondedToPost":
          case "CommentedOnPost":
            return "".concat(who, " ").concat(RESPONDED_TO_YOUR_POST);
            break;
          case "CommentedOnReview":
            return "".concat(X_COMMENTED_ON_REVIEW.replace('{0}', who));
            break;
          case "UserUpVoted":
            if (notification.EntityType == "ForumComment" || notification.EntityType == "ReviewComment") {
              return "".concat(who, " ").concat(UPVOTED_YOUR_COMMENT);
            } else if (notification.EntityType == "Post") {
              return "".concat(who, " ").concat(UPVOTED_YOUR_POST);
            } else if (notification.EntityType == "Review") {
              return "".concat(who, " ").concat(UPVOTED_YOUR_REVIEW);
            }
            break;
          case "UserDownVoted":
            if (notification.EntityType == "ForumComment" || notification.EntityType == "ReviewComment") {
              return "".concat(who, " ").concat(DOWNVOTED_YOUR_COMMENT);
            } else if (notification.EntityType == "Post") {
              return "".concat(who, " ").concat(DOWNVOTED_YOUR_POST);
            } else if (notification.EntityType == "Review") {
              return "".concat(who, " ").concat(DOWNVOTED_YOUR_REVIEW);
            }
            break;
          default:
            return notification.ActionType;
            break;
        }
        return "";
      }(), "\n            \n            <span class=\"notification-field preview\">\n            ").concat(function () {
        switch (notification.ActionType) {
          case "ReviewApprovedOnBrokerUserOwns":
          case "UserUpVoted":
          case "UserDownVoted":
            return "\"".concat(notification.UserActionContentPreview, "\"");
            break;
          default:
            return "\"".concat(notification.ContentPreview, "\"");
            break;
        }
        return "";
      }(), "\n            </span>\n            <div class=\"notificaiton-position\">\n                <div class=\"notification-field date\">").concat(myDate, "</div>\n            </div>\n            </div>\n        </div>\n    </div >");
    }
  }, {
    key: "RenderNotificationFooter",
    value: function RenderNotificationFooter() {
      return "<div onclick=\"window.SocialProfile.GoToNotifications()\" class=\"notification-footer\">".concat(SEE_ALL_NOTIFICATIONS, " <i class=\"arrow-right-icon icon-16\"> </i></div>");
    }
  }, {
    key: "RenderHotTopic",
    value: function RenderHotTopic(topic) {
      var topicString = "<div class='hot-topic'>\n            <div class=\"discussion-icon\">\n                <div class=\"icon-wrap\">\n                    <img style=\"width:24px; height: 24px;\" src=\"/Content/dist/images/icons/discussion.svg\" />\n                </div>\n            </div>\n            <div class=\"hot-topic-text\">\n                <div class=\"hot-topic-headline\"><a href=\"/forum?discussion=".concat(topic.TopicId, "\">").concat(topic.Headline, "</a></div>\n                <div class=\"hot-topic-meta\">\n                    <div class=\"control-group\">\n                        <div class=\"control first\">\n                            <i class=\"participants-in-thread icon\"></i>\n                        </div>\n                        <div class=\"control\"><span class=\"topic-").concat(topic.TopicId, "-participants\">\n                        ").concat(function () {
        if (topic.Participants === 1) {
          return "".concat(window.ONE_PARTICIPANT);
        } else {
          return "".concat(window.X_PARTICIPANTS.replace('{0}', topic.Participants));
        }
        return "";
      }(), "</span>\n                        </div>\n                    </div>\n                    <div class=\"control-group\">\n                        <div class=\"control\">\n                            <i class=\"reply-to-post icon\"></i>\n                        </div>\n                        <div class=\"control\"><span class=\"topic-").concat(topic.TopicId, "-replies\">\n                        ").concat(function () {
        if (topic.Replies === 1) {
          return "".concat(window.ONE_POST);
        } else {
          return "".concat(window.X_POSTS.replace('{0}', topic.Replies));
        }
        return "";
      }(), "</span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>");
      return topicString;
    }
  }, {
    key: "RenderLatestForumPost",
    value: function RenderLatestForumPost(forumStateKey, post, myVote) {
      var _this19 = this;
      var myDate = moment.duration(moment.utc(post.CreatedAtString).diff(this.now)).humanize(true);
      var stringTemplate = "<div class='forum-post-wrap latest-post' id='post-box-".concat(post.EntityType, "-").concat(post.EntityId, "'>\n            <div class=\"frn-flex-row column review-box\">\n                <div class=\"cell-group review-header\">\n                    <div class=\"cell image-cell\">\n                        <img class=\"reviewer-image social-profile-navigate\" src=\"").concat(this.avatarPath).concat(post.Author.ImageKey, "?w=64&h=64\" data-profile-id=\"").concat(post.Author.Id, "\"/>\n                    </div>\n                    <div class=\"cell-group reviewer-info column buffer min-144\">\n\n                        <div class=\"cell-group verification-group\">\n                            <span class=\"name-cell social-profile-navigate title-text\" data-profile-id=\"").concat(post.Author.Id, "\">").concat(post.Author.Handle, "</span>\n                        </div>\n                         ").concat(function () {
        if (post.Author.Country != null && post.Author.Country != undefined) {
          return "<div class=\"cell reviewer-info lesser-text\">".concat(window.LOCATION, ": ").concat(post.Author.Country, "</div>");
        }
        return "";
      }(), "\n            ").concat(function () {
        if (post.Author.JoinedDate != null && post.Author.JoinedDate != undefined) {
          return "<div class=\"cell reviewer-info lesser-text\">".concat(window.JOINED, ": ").concat(moment.duration(moment.utc(post.Author.JoinedDateString).diff(_this19.now)).humanize(true), "</div>");
        }
        return "";
      }(), "\n                    </div>\n\n                    <div class=\"cell-group column buffer hide-when-small\">\n                    ").concat(function () {
        if (post.InlineEntity === window.ENTITY_TYPE_SOCIAL_PROFILE_PAGE) {
          var linkToPost = "<a href=\"/forum?discussion=".concat(post.TopicId, "\">").concat(post.Headline, "</a>");
          return " <div class=\"cell-group verification-group\">\n                            <img style=\"width:16px; height: 16px;\" class=\"reviewer-image social-profile-navigate\" src=\"".concat(_this19.avatarPath).concat(post.TopicOwnerAvatar, "?w=16&h=16\" data-profile-id=\"").concat(post.TopicOwnerId, "\">\n                            <span class=\"link-to-post\">").concat(linkToPost, "</span>\n                        </div>");
        }
        return " <div class=\"cell-group verification-group\">\n                            <img style=\"width:16px; height: 16px;\" src=\"/Content/dist/images/icons/discussion.svg\" />\n                            <span class=\"link-to-post\"><a href=\"/forum?discussion=".concat(post.TopicId, "\">").concat(post.Headline, "</a></span>\n                        </div>");
      }(), "\n                       \n                        ").concat(function () {
        if (post.EntityType == 'comment') {
          if (post.ReplyToCommentId != undefined && post.ReplyToCommentId != null && post.ReplyToCommentId > 0) {
            return "<div class='cell replying-to-info'>".concat(window.REPLYING_TO_COMMENT_BY.replace('{0}', "<a href=\"/forum?discussion=".concat(post.TopicId, "&post=").concat(post.PostId, "&comment=").concat(post.ReplyToCommentId, "\">").concat(post.ReplyingTo, "</a>")), "</div>");
          }
          return "<div class=\"cell replying-to-info\">".concat(window.REPLYING_TO_COMMENT_BY.replace('{0}', "<a href=\"/forum?discussion=".concat(post.TopicId, "&post=").concat(post.PostId, "\">").concat(post.ReplyingTo, "</a>")), "</div>");
        }
        return "";
      }(), "\n                    </div>\n                    <div class=\"cell-group last\">\n                        <div class=\"cell buffer lesser-text date-block\">").concat(myDate, "</div>\n                        ").concat(function () {
        if (post.ViewerCanEdit === true) {
          return "<div class=\"cell last dots\"><img src=\"/Content/dist/images/icons/3dots.svg\"  \n                                                        data-toggle='post-edit-menu'\n                                                        data-forum-holder='".concat(forumStateKey, "'\n                                                        data-target-id='forum-edit-menu'\n                                                        data-placement='top'\n                                                        data-trigger='hover toggle'\n                                                        data-html='true'\n                                                        data-authorid='").concat(post.Author.Id, "'\n                                                        ").concat(function () {
            if (post.EntityType === 'comment') {
              return "data-commentid=".concat(post.EntityId);
            }
            return "";
          }(), "\n                                                        data-postid='").concat(post.PostId, "'/></div>");
        }
        return "";
      }(), "\n                    </div>\n\n\n                </div>                    \n                <div class=\"cell-group column show-when-small\" style=\"padding-top:16px\" >\n\n             \n\n                        <div class=\"cell-group verification-group\">\n                         ").concat(function () {
        if (post.InlineEntity === window.ENTITY_TYPE_SOCIAL_PROFILE_PAGE) {
          var linkToPost = "<a href=\"/forum?discussion=".concat(post.TopicId, "\">").concat(post.Headline, "</a>");
          return " \n                            <img style=\"width:16px; height: 16px;\" class=\"reviewer-image social-profile-navigate\" src=\"".concat(_this19.avatarPath).concat(post.TopicOwnerAvatar, "?w=16&h=16\" data-profile-id=\"").concat(post.TopicOwnerId, "\">\n                            <span class=\"link-to-post\">").concat(linkToPost, "</span>\n                        ");
        } else {
          var link = "";
          if (post.EntityType == 'comment') {
            link = "<a id=\"link-to-post-".concat(post.EntityId, "\" href=\"/forum?discussion=").concat(post.TopicId, "&post=").concat(post.PostId, "&comment=").concat(post.EntityId, "\">").concat(post.Headline, "</a>");
          } else {
            link = "<a id=\"link-to-post-".concat(post.PostId, "\" href=\"/forum?discussion=").concat(post.TopicId, "&post=").concat(post.PostId, "\">").concat(post.Headline, "</a>");
          }
          return " \n                            <img style=\"width:16px; height: 16px;\" src=\"/Content/dist/images/icons/discussion.svg\" />\n                            <span class=\"link-to-post\">".concat(link, "</span>\n                        ");
        }
      }(), "\n\n                            </span>\n                        </div>\n                    </div>\n                <div class=\"cell review-body text-body\" ").concat(function () {
        if (post.EntityType == 'comment') {
          return " id='comment-content-".concat(post.EntityId, "' ");
        }
        return " id='post-content-".concat(post.PostId, "'");
      }(), " data-comment-author='").concat(post.Author.Handle, "' >").concat(pendingBadge(post)).concat(function () {
        if (post.DeletedPost === true) {
          return window.DELETED_POST;
        }
        if (post.Content !== undefined && post.Content !== null) {
          return post.Content.trim();
        }
        return "";
      }()).concat(function () {
        if (post.DeletedPost !== true) {
          var imageGallery = '';
          if (post.DeletedPost != true && post.Images !== undefined) {
            if (post.Images.length) {
              imageGallery = "<div class=\"image-row\">";
            }
            post.Images.forEach(function (num, index) {
              var img = post.Images[index];
              if (post.EntityType == 'comment') {
                imageGallery += "<img src=\"".concat(_this19.imagePathComment).concat(img.FileName, "\" class=\"review-img lightbox-slide\" />");
              } else {
                imageGallery += "<img src=\"".concat(_this19.imagePathForum).concat(img.FileName, "\" class=\"review-img lightbox-slide\" />");
              }
            });
            if (imageGallery.length > 0) {
              imageGallery += "</div>";
            }
          }
          return imageGallery;
        }
        return "";
      }(), "</div>\n                <div class=\"cell preview-fade\">\n                    <a id=\"expand-button-post-").concat(post.EntityType, "-").concat(post.EntityId, "\" href=\"javascript:void(0)\" class=\"hover-underline\" onClick=\"window.SocialProfile.ExpandPostPreview('").concat(post.EntityType, "','").concat(post.EntityId, "','open')\">").concat(window.SHOW_MORE, "  <img style=\"width:13px; height: 13px;\" src=\"/Content/dist/images/icons/DownArrow.svg\" /></a>\n                </div>\n                <div class=\"cell preview-show\">\n                    <a id=\"contract-button-post-").concat(post.EntityType, "-").concat(post.EntityId, "\" href=\"javascript:void(0)\" class=\"hover-underline\" onClick=\"window.SocialProfile.ExpandPostPreview('").concat(post.EntityType, "','").concat(post.EntityId, "','close')\">").concat(window.SHOW_LESS, "  <img style=\"width:13px; height: 13px;\" src=\"/Content/dist/images/icons/UpArrow.svg\" /></a>\n                </div>\n                <div class=\"cell hr expand\"></div>\n                <div class=\"baseline-controls ").concat(function () {
        if (_this19.IsMasquerade) {
          return "hide";
        } else {
          return "";
        }
      }(), "\">\n                <div class=\"control-group\">\n\n                ").concat(function () {
        if (forumStateKey === 'activity-list-wrap') {
          return "<div class=\"control vote-score\">".concat(window.VOTE_SCORE, ": ").concat(function () {
            if (post !== undefined && post !== null && post.VoteScore !== undefined) {
              return "".concat(post.VoteScore);
            } else {
              return "0";
            }
          }(), "\n            </div>");
        } else {
          return "<div class=\"control\">\n                        <i class=\"thumbsup icon buffer ".concat(function () {
            if (myVote === 'up') {
              return "my";
            }
          }() || '', "\" onClick=\"window.SocialProfile.Thumbs('up','").concat(function () {
            if (post.EntityType == 'comment') return "ForumComment";
            return "Post";
          }(), "','").concat(post.EntityId, "',this)\"></i>\n                    </div>\n                    <div class=\"control vote-score\">").concat(function () {
            if (post !== undefined && post !== null && post.VoteScore !== undefined) {
              return "".concat(post.VoteScore);
            } else {
              return "0";
            }
          }(), "\n            </div>\n                    <div class=\"control\">\n                        <i class=\"thumbsdown icon ").concat(function () {
            if (myVote === 'down') {
              return "my";
            }
          }() || '', "\" onClick=\"window.SocialProfile.Thumbs('down','").concat(function () {
            if (post.EntityType == 'comment') return "ForumComment";
            return "Post";
          }(), "','").concat(post.EntityId, "',this)\"></i>\n                    </div>");
        }
      }(), "\n                    </div>\n\n                    ").concat(function () {
        if (forumStateKey === 'activity-list-wrap') {
          return "";
        }
        var control = "\n                                    <div class=\"control-group reply-control\">\n                                        <div class=\"control\">\n                                            <i class=\"reply-to-post icon\"></i>\n                                        </div>\n                                        <div class=\"control\">";
        if (post.EntityType == 'comment') {
          control += "<a href=\"javascript:void(0)\" class=\"hover-underline\" onClick=\"window.SocialProfile.OpenCommentForCreate(this, '".concat(post.PostId, "','").concat(post.EntityId, "','").concat(forumStateKey, "')\">").concat(window.REPLY, "</a>");
        } else {
          control += "<a href = \"javascript:void(0)\" class=\"hover-underline\" onClick = \"window.SocialProfile.OpenCommentForCreate(this, '".concat(post.PostId, "','','").concat(forumStateKey, "')\" > ").concat(window.REPLY, "</a>");
        }
        control += "</div>\n                            </div>";
        return control;
      }(), "\n                    <div class=\"control-group last\">\n                    \n                    <div class=\"control\">\n                    ").concat(function () {
        if (post.EntityType == 'comment') {
          return "<a href=\"/forum?discussion=".concat(post.TopicId, "&post=").concat(post.PostId, "&comment=").concat(post.EntityId, "\" class=\"waves-effect go-to-task-button\">").concat(window.GO_TO_POST, "</a>");
        }
        return "<a href=\"/forum?discussion=".concat(post.TopicId, "&post=").concat(post.PostId, "\" class=\"waves-effect go-to-task-button\">").concat(window.GO_TO_POST, "</a>");
      }(), "\n\n                    </div>\n                    </div>\n                    </div>\n\n                </div>\n               \n            </div>\n        </div>");
      return stringTemplate;
    }
  }, {
    key: "RenderVoteEntityForProfileFeed",
    value: function RenderVoteEntityForProfileFeed(post, myVote) {
      var _this20 = this;
      var myDate = moment.duration(moment.utc(post.ContentCreatedOnDateString).diff(this.now)).humanize(true);
      var when = moment.duration(moment.utc(post.VotedOnDateString).diff(this.now)).humanize(true);
      var stringTemplate = "\n        <div class='forum-post-wrap latest-post' id='vote-box-".concat(post.EntityType, "-").concat(post.EntityId, "'>\n            \n                \n            <div class=\"frn-flex-row column review-box\">\n                <div class=\"cell vote-meta\">\n                    <div class=\"cell image-cell\">\n                        <img class=\"reviewer-image reviewer-image-icon\" src=\"").concat(this.avatarPath).concat(post.Voter.ImageKey, "\"/>\n                    </div>\n                    <div class=\"vote-action\">\n                        ").concat(function () {
        if (post.EntityType == 'ForumComment' || post.EntityType == 'ReviewComment') {
          if (post.ActionType == 'UserUpVoted') {
            return "".concat(window.USERNAME_UPVOTED_COMMENT.replace('{0}', post.Voter.PublicName));
          }
          return "".concat(window.USERNAME_DOWNVOTED_COMMENT.replace('{0}', post.Voter.PublicName));
        } else if (post.EntityType == 'Review') {
          if (post.ActionType == 'UserUpVoted') {
            return "".concat(window.USERNAME_UPVOTED_REVIEW.replace('{0}', post.Voter.PublicName));
          }
          return "".concat(window.USERNAME_DOWNVOTED_REVIEW.replace('{0}', post.Voter.PublicName));
        } else if (post.EntityType == 'Post') {
          if (post.ActionType == 'UserUpVoted') {
            return "".concat(window.USERNAME_UPVOTED_POST.replace('{0}', post.Voter.PublicName));
          }
          return "".concat(window.USERNAME_DOWNVOTED_POST.replace('{0}', post.Voter.PublicName));
        }
      }(), "\n                        <span class=\"when\">").concat(when, "</span>\n                    </div>\n                </div>\n                <div class=\"cell-group review-header\">\n                    <div class=\"cell image-cell\">\n                        <img class=\"reviewer-image social-profile-navigate\" src=\"").concat(this.avatarPath).concat(post.Author.ImageKey, "?w=64&h=64\" data-profile-id=\"").concat(post.Author.Id, "\"/>\n                    </div>\n                    <div class=\"cell-group reviewer-info column buffer min-144\">\n\n                        <div class=\"cell-group verification-group\">\n                            <span class=\"name-cell social-profile-navigate title-text\" data-profile-id=\"").concat(post.Author.Id, "\">").concat(post.Author.Handle, "</span>\n                        </div>\n                         ").concat(function () {
        if (post.Author.Country != null && post.Author.Country != undefined) {
          return "<div class=\"cell reviewer-info lesser-text\">".concat(window.LOCATION, ": ").concat(post.Author.Country, "</div>");
        }
        return "";
      }(), "\n            ").concat(function () {
        if (post.Author.JoinedDate != null && post.Author.JoinedDate != undefined) {
          return "<div class=\"cell reviewer-info lesser-text\">".concat(window.JOINED, ": ").concat(moment.duration(moment.utc(post.Author.JoinedDateString).diff(_this20.now)).humanize(true), "</div>");
        }
        return "";
      }(), "\n                    </div>\n                    ").concat(function () {
        if ((post.EntityType == 'ForumComment' || post.EntityType == 'Post') && post.Headline !== undefined && post.Headline !== null) {
          return "\n                                    <div class=\"cell column buffer hide-when-small expand center\">\n                     \n                                            <img style=\"width:16px; height: 16px;\" src=\"/Content/dist/images/icons/discussion.svg\" />\n                                            <span class=\"link-to-post\"><a href=\"/forum?discussion=".concat(post.TopicId, "\">").concat(post.Headline, "</a></span>\n                                \n                                    </div>");
        }
        if (post.EntityType == 'Review') {
          return "\n                <div class=\"cell-group verification-group activity-description hide-when-small\">\n                    ".concat(_this20.RenderStatusBadge(post.Author.IsCompanyRepForBrokers, post.Author.VerifiedForBroker), "\n                </div>");
        }
        if (post.EntityType == 'ReviewComment') {
          return "\n                <div class=\"cell-group verification-group activity-description hide-when-small\">\n                    ".concat(_this20.RenderStatusBadge(post.Author.IsCompanyRepForBrokers, post.Author.VerifiedForBroker), "\n                </div>");
        }
        return "";
      }(), "\n                    \n                    <div class=\"cell-group last\">\n                        <div class=\"cell buffer lesser-text date-block\">").concat(myDate, "</div>\n\n                \n                    </div>\n\n\n                </div>                    \n                <div class=\"cell-group column show-when-small\" style=\"padding-top:16px\" >\n                        <div class=\"cell-group verification-group\">\n                            <img style=\"width:16px; height: 16px;\" src=\"/Content/dist/images/icons/discussion.svg\"/>\n\n                            <span class=\"link-to-post\">\n                                ").concat(function () {
        if ((post.EntityType == 'ForumComment' || post.EntityType == 'Post') && post.Headline !== undefined && post.Headline !== null) {
          return "<a href=\"/forum?discussion=".concat(post.TopicId, "\">").concat(post.Headline, "</a>");
        }
        return "";
      }(), "\n                            </span>\n                        </div>\n                    </div>\n                <div class=\"cell text-body\">\n\n                ").concat(function () {
        var moderatorNotes = '';
        if (post.EntityType == 'Review' && post.ModerationNotes != null && post.ModerationNotes != '' && post.ModerationNotes != undefined) {
          moderatorNotes = "<div class=\"alert alert-primary\">\n                        <strong>".concat(window.MODERATOR_NOTES, "</strong>\n                        <br>").concat(post.ModerationNotes, "</div>");
        }
        return moderatorNotes;
      }(), "   ").concat(pendingBadge(post), "\n                ").concat(function () {
        if (post.DeletedPost === true) {
          return window.DELETED_POST;
        }
        if (post.Content !== undefined && post.Content !== null) {
          return post.Content.trim();
        }
        return "";
      }()).concat(function () {
        var imageGallery = '';
        if (post.DeletedPost != true && post.Images !== undefined) {
          if (post.Images.length) {
            imageGallery = "<div class=\"image-row\">";
          }
          post.Images.forEach(function (num, index) {
            var img = post.Images[index];
            if (post.EntityType == 'ForumComment' || post.EntityType == 'Post') {
              imageGallery += "<img src=\"".concat(_this20.imagePathForum).concat(img, " \" class=\"review-img lightbox-slide\" />");
            }
            if (post.EntityType == 'Review') {
              imageGallery += "<img src=\"".concat(_this20.imagepath).concat(img, "\" class=\"review-img lightbox-slide\" />");
            }
          });
          if (imageGallery.length > 0) {
            imageGallery += "</div>";
          }
        }
        return imageGallery;
      }(), "</div>\n                <div class=\"cell preview-fade\">\n                    <a id=\"expand-button-post-").concat(post.EntityType, "-").concat(post.EntityId, "\" href=\"javascript:void(0)\" class=\"hover-underline\" onClick=\"window.SocialProfile.ExpandPostPreview('").concat(post.EntityType, "','").concat(post.EntityId, "','open')\">").concat(window.SHOW_MORE, "  <img style=\"width:13px; height: 13px;\" src=\"/Content/dist/images/icons/DownArrow.svg\" /></a>\n                </div>\n                <div class=\"cell preview-show\">\n                    <a id=\"contract-button-post-").concat(post.EntityType, "-").concat(post.EntityId, "\" href=\"javascript:void(0)\" class=\"hover-underline\" onClick=\"window.SocialProfile.ExpandPostPreview('").concat(post.EntityType, "','").concat(post.EntityId, "','close')\">").concat(window.SHOW_LESS, "  <img style=\"width:13px; height: 13px;\" src=\"/Content/dist/images/icons/UpArrow.svg\" /></a>\n                </div>\n                                <div class=\"cell hr expand\"></div>\n                <div class=\"baseline-controls\">\n                <div class=\"control-group\">\n\n                    <div class=\"control vote-score\">").concat(window.VOTE_SCORE, ": ").concat(function () {
        if (post !== undefined && post !== null && post.VoteScore !== undefined) {
          return "".concat(post.VoteScore);
        } else {
          return "0";
        }
      }(), "\n            </div>\n                   \n                    </div>\n                    \n                    <div class=\"control-group last\">\n                    \n                    <div class=\"control\">\n                    ").concat(function () {
        if (post.EntityType == 'Review') {
          return "<a href=\"javascript:void(0)\" class=\"waves-effect go-to-task-button\" onClick=\"window.SocialProfile.GoToReview('".concat(post.EntityId, "')\">").concat(window.GO_TO_BROKER_REVIEW, "</a>");
        }
        if (post.EntityType == 'ReviewComment') {
          return "<a href=\"javascript:void(0)\" class=\"waves-effect go-to-task-button\"  onClick=\"window.SocialProfile.GoToReviewComment('".concat(post.EntityId, "')\">").concat(window.GO_TO_COMMENT, "</a>");
        }
        if (post.EntityType == 'ForumComment') {
          return "<a href=\"/forum?discussion=".concat(post.TopicId, "&comment=").concat(post.AttachedToPostId, "\" class=\"waves-effect go-to-task-button\" onClick=\"window.SocialProfile.GoToComment('").concat(post.EntityId, "','").concat(post.AttachedToPostId, "')\">").concat(window.GO_TO_POST, "</a>");
        }
        return "<a href=\"/forum?discussion=".concat(post.TopicId, "&post=").concat(post.PostId, "\" class=\"waves-effect go-to-task-button\">").concat(window.GO_TO_POST, "</a>");
      }(), "\n\n                    </div>\n                    </div>\n                    </div>\n\n                </div>\n               \n            </div>\n        </div>");
      return stringTemplate;
    }
  }, {
    key: "RenderReviewCommentForProfileFeed",
    value: function RenderReviewCommentForProfileFeed(post, myVote) {
      var myDate = moment.duration(moment.utc(post.CreatedAt).diff(this.now)).humanize(true);
      var stringTemplate = "<div class='forum-post-wrap latest-post' id='post-box-".concat(post.EntityType, "-").concat(post.EntityId, "'>\n            <div class=\"frn-flex-row column review-box\">\n                <div class=\"cell-group show-when-small activity-description\" style=\"padding-bottom:16px\">\n                        <div class=\"single-string\">\n                         ").concat(function () {
        if (parseInt(post.ReplyToCommentId, 10) > 0) {
          return "".concat(window.REPLYING_TO_COMMENT_BY_X_ON_Y.replace('{0}', "".concat(post.Reviewer.PublicName)).replace('{1}', "<a href='".concat(window.langSlug, "/social-profile/").concat(post.ReplyingToCommentUserId, "'>").concat(post.ReplyingToCommentName, "</a>")).replace('{2}', "<a href='".concat(window.langSlug, "/brokers/").concat(post.BrokerId, "/").concat(post.BrokerCode, "'>").concat(post.Name, "</a>")));
        } else {
          return "".concat(window.COMMENTED_ON_REVIEW_LEFT_BY_X.replace('{0}', "".concat(post.Reviewer.PublicName)).replace('{1}', "<a href='".concat(window.langSlug, "/brokers/").concat(post.BrokerId, "/").concat(post.BrokerCode, "'>").concat(post.Name, "</a>")).replace('{2}', "<a href='".concat(window.langSlug, "/social-profile/").concat(post.ReplyingToReviewerId, "'>").concat(post.ReplyingToReviewerName, "</a>")));
        }
      }(), "\n                         </div>\n                    \n                </div>\n                <div class=\"cell-group review-header\">\n                    <div class=\"cell image-cell\">\n                        <img class=\"reviewer-image\" src=\"/content/dist/brokers/images/").concat(post.FileName, "?w=56&h=56\"/>\n                    </div>\n                     <div class=\"cell image-cell image-cell-sub\">\n                        <img class=\"reviewer-image reviewer-image-sub social-profile-navigate\" src=\"").concat(this.avatarPath).concat(post.Reviewer.ImageKey, "?w=48&h=48\" data-profile-id=\"").concat(post.Reviewer.Id, "\"/>\n                    </div>\n                    <div class=\"cell-group reviewer-info column buffer min-144\">\n\n                        <div class=\"cell-group verification-group activity-description hide-when-small\">\n                        <div class=\"single-string\">\n                         ").concat(function () {
        if (parseInt(post.ReplyToCommentId, 10) > 0) {
          return "".concat(window.REPLYING_TO_COMMENT_BY_X_ON_Y.replace('{0}', "".concat(post.Reviewer.PublicName)).replace('{1}', "<a href='".concat(window.langSlug, "/social-profile/").concat(post.ReplyingToCommentUserId, "'>").concat(post.ReplyingToCommentName, "</a>")).replace('{2}', "<a href='".concat(window.langSlug, "/brokers/").concat(post.BrokerId, "/").concat(post.BrokerCode, "'>").concat(post.Name, "</a>")));
        } else {
          return "".concat(window.COMMENTED_ON_REVIEW_LEFT_BY_X.replace('{0}', "".concat(post.Reviewer.PublicName)).replace('{1}', "<a href='".concat(window.langSlug, "/brokers/").concat(post.BrokerId, "/").concat(post.BrokerCode, "'>").concat(post.Name, "</a>")).replace('{2}', "<a href='".concat(window.langSlug, "/social-profile/").concat(post.ReplyingToReviewerId, "'>").concat(post.ReplyingToReviewerName, "</a>")));
        }
      }(), "\n                         </div>\n                        </div>\n                    </div>\n\n                    <div class=\"cell-group last\">\n                        <div class=\"cell buffer lesser-text date-block\">").concat(myDate, "</div>\n                    </div>\n\n\n                </div>                    \n                <div class=\"cell-group column show-when-small\" style=\"padding-top:16px\" >\n                        <div class=\"cell-group verification-group\">\n                            <img style=\"width:16px; height: 16px;\" src=\"/Content/dist/images/icons/discussion.svg\"/>\n\n                            <span class=\"link-to-post\">\n                               <a id=\"link-to-post-").concat(post.EntityId, "\" href=\"/forum?discussion=").concat(post.TopicId, "&post=").concat(post.PostId, "&comment=").concat(post.EntityId, "\">").concat(post.Headline, "</a>\n                            </span>\n                        </div>\n                    </div>\n                <div class=\"cell review-body text-body\" id='comment-content-").concat(post.EntityId, "' data-comment-author='").concat(post.Reviewer.PublicName, "' >").concat(pendingBadge(post)).concat(function () {
        if (post.DeletedPost === true) {
          return window.DELETED_POST;
        }
        if (post.Comment !== undefined && post.Comment !== null) {
          return post.Comment.trim();
        }
        return "";
      }()).concat(function () {
        if (post.HasTranslation) {
          return "<div class='translation-div font-13'><br /><em>".concat(window.TRANSLATION, ":</em><br />").concat(post.Translation, "</div>");
        }
        return '';
      }(), "</div>\n                <div class=\"cell preview-fade\">\n                    <a id=\"expand-button-post-").concat(post.EntityType, "-").concat(post.EntityId, "\" href=\"javascript:void(0)\" class=\"hover-underline\" onClick=\"window.SocialProfile.ExpandPostPreview('").concat(post.EntityType, "','").concat(post.EntityId, "','open')\">").concat(window.SHOW_MORE, "  <img style=\"width:13px; height: 13px;\" src=\"/Content/dist/images/icons/DownArrow.svg\" /></a>\n                </div>\n                <div class=\"cell preview-show\">\n                    <a id=\"contract-button-post-").concat(post.EntityType, "-").concat(post.EntityId, "\" href=\"javascript:void(0)\" class=\"hover-underline\" onClick=\"window.SocialProfile.ExpandPostPreview('").concat(post.EntityType, "','").concat(post.EntityId, "','close')\">").concat(window.SHOW_LESS, "  <img style=\"width:13px; height: 13px;\" src=\"/Content/dist/images/icons/UpArrow.svg\" /></a>\n                </div>\n                                <div class=\"cell hr expand\"></div>\n                <div class=\"baseline-controls\">\n                <div class=\"control-group\">\n                    <div class=\"control\">\n                        <i class=\"thumbsup icon buffer ").concat(function () {
        if (myVote === 'up') {
          return "my";
        }
      }() || '', "\" onClick=\"window.SocialProfile.Thumbs('up','ReviewComment','").concat(post.EntityId, "',this)\"></i>\n                    </div>\n                    <div class=\"control vote-score\">").concat(function () {
        if (post !== undefined && post !== null && post.VoteScore !== undefined) {
          return "".concat(post.VoteScore);
        } else {
          return "0";
        }
      }(), "\n            </div>\n                    <div class=\"control\">\n                        <i class=\"thumbsdown icon ").concat(function () {
        if (myVote === 'down') {
          return "my";
        }
      }() || '', "\" onClick=\"window.SocialProfile.Thumbs('down','ReviewComment','").concat(post.EntityId, "',this)\"></i>\n                    </div>\n                    </div>\n                   \n                    <div class=\"control-group last\">\n                    \n                        <div class=\"control\">\n                            <a href=\"javascript:void(0)\" class=\"waves-effect go-to-task-button\" onClick=\"window.SocialProfile.GoToReviewComment('").concat(post.EntityId, "')\">").concat(window.GO_TO_COMMENT, "</a>\n                        </div>\n                    </div>\n                    </div>\n\n                </div>\n            </div>\n        </div>");
      return stringTemplate;
    }
  }, {
    key: "RenderReviewForProfileFeed",
    value: function () {
      var _RenderReviewForProfileFeed = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(post, myVote) {
        var _yield$import2, _RenderReviewForProfileFeed2;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              if (this._RenderReviewForProfileFeed) {
                _context6.n = 2;
                break;
              }
              _context6.n = 1;
              return Promise.resolve().then(function () {
                return _interopRequireWildcard(require('./SocialProfile/BrokerReview/Templates/ReviewForProfileFeed.js'));
              });
            case 1:
              _yield$import2 = _context6.v;
              _RenderReviewForProfileFeed2 = _yield$import2.RenderReviewForProfileFeed;
              this._RenderReviewForProfileFeed = _RenderReviewForProfileFeed2;
            case 2:
              _context6.n = 3;
              return this._RenderReviewForProfileFeed(post, myVote, {
                avatarPath: this.avatarPath,
                imagePath: this.imagepath,
                now: this.now
              });
            case 3:
              return _context6.a(2, _context6.v);
          }
        }, _callee6, this);
      }));
      function RenderReviewForProfileFeed(_x7, _x8) {
        return _RenderReviewForProfileFeed.apply(this, arguments);
      }
      return RenderReviewForProfileFeed;
    }()
  }, {
    key: "RenderForumPost",
    value: function RenderForumPost(forumStateKey, post, myVote, topicSocialProfileId) {
      var _this21 = this;
      var myDate = moment.duration(moment.utc(post.CreatedAtString).diff(this.now)).humanize(true);
      var stringTemplate = "<div class='forum-post-wrap is-post' id='post-box-".concat(post.PostId, "'>\n            <div class=\"frn-flex-row column review-box\">\n                <div class=\"cell lesser-text show-when-small\" style=\"margin-top:-10px\">").concat(myDate, "</div>\n                <div class=\"cell-group review-header\">\n                    <div class=\"cell image-cell\">\n                        <img class=\"reviewer-image social-profile-navigate\" src=\"").concat(this.avatarPath).concat(post.Reviewer.ImageKey, "?w=64&h=64\" data-profile-id=\"").concat(post.Reviewer.Id, "\"/>\n                    </div>\n                    <div class=\"cell-group reviewer-info column\">\n                        <div class=\"cell-group verification-group\">\n                            <span class=\"name-cell social-profile-navigate\" data-profile-id=\"").concat(post.Reviewer.Id, "\">").concat(post.Reviewer.Handle, "</span>\n                            ").concat(function () {
        if (post.ReviewerIsCompanyRep) {
          return "<div class=\"reviewer-status representative d-flex\">\n                                                                <div class=\"verified-icon\">\n                                                                    <img src=\"/Content/dist/images/icons/company-rep-icon.svg\" caption=\"false\">\n                                                                </div>\n                                                                <div class=\"verified-icon-text\">".concat(window.COMPANY_REPRESENTATIVE, "</div>\n                                                            </div>");
        }
        return "";
      }(), "\n                            ").concat(function () {
        if (topicSocialProfileId == post.SocialProfileId) {
          return "<div class=\"cell\"> <span class=\"cell lesser-text inline-forum-label-discussion-starter ml-2\"> <img src=\"/Content/dist/images/icons/rocket.svg\" />".concat(window.DISCUSSION_STARTER, " </span> </div>");
        }
        return "";
      }(), "\n                            ").concat(function () {
        if (post.Reviewer.IsModerator) {
          return "<div class=\"cell\"> <span class=\"cell lesser-text inline-forum-label-moderator ml-2\"> ".concat(window.PORTAL_CODE, " ").concat(window.MODERATOR, " </span> </div>");
        }
        return "";
      }(), "\n                            ").concat(function () {
        if (post.IsPinned) {
          return " \n                                            <div class=\"cell pl-2\"> <img src=\"/Content/dist/images/icons/pin.svg\" /> </div > ";
        }
        return "";
      }(), "\n\n                        </div>\n                        ").concat(function () {
        if (post.Reviewer.Country != null && post.Reviewer.Country != undefined) {
          return "<div class=\"cell reviewer-info lesser-text\">".concat(window.LOCATION, ": ").concat(post.Reviewer.Country, "</div>");
        }
        return "";
      }(), "\n            ").concat(function () {
        if (post.Reviewer.JoinedDate != null && post.Reviewer.JoinedDate != undefined) {
          return "<div class=\"cell reviewer-info lesser-text\">".concat(window.JOINED, ": ").concat(moment.duration(moment.utc(post.Reviewer.JoinedDateString).diff(_this21.now)).humanize(true), "</div>");
        }
        return "";
      }(), "\n                    </div>\n                    <div class=\"cell-group last\">\n\n                        ").concat(function () {
        if (post.CanModerate && !post.IsPinned) {
          return "\n                                    <div class=\"spinner-border spinner-border-sm hide\" role=\"status\" style=\"margin-right: 15px\"> <span class=\"sr-only\">Loading...</span> </div>\n                                    <div onClick=\"window.SocialProfile.PinPost(this, ".concat(post.PostId, ", true)\" class=\"cell inline-forum-pin pr-3\"> <img src=\"/Content/dist/images/icons/unpin.svg\" style=\"height: 18px;\" /> </div>");
        } else if (post.CanModerate && post.IsPinned) {
          return "\n                                    <div class=\"spinner-border spinner-border-sm hide\" role=\"status\" style=\"margin-right: 15px\"> <span class=\"sr-only\">Loading...</span> </div>\n                                    <div onClick=\"window.SocialProfile.PinPost(this, ".concat(post.PostId, ", false)\" class=\"cell inline-forum-pin pr-3\"> <img src=\"/Content/dist/images/icons/pin.svg\" style=\"height: 18px;\" /> </div>");
        }
        return "";
      }(), "\n\n                    <div class=\"cell buffer lesser-text hide-when-small\" style=\"margin-top:-3px\">").concat(myDate, "</div>\n                     ").concat(function () {
        if (post.ViewerCanEdit === true) {
          return "<div class=\"cell dots\"><img src=\"/Content/dist/images/icons/3dots.svg\"  \n                                                        data-toggle='post-edit-menu'\n                                                        data-target-id='forum-edit-menu'\n                                                        data-placement='top'\n                                                        data-forum-holder='".concat(forumStateKey, "'\n                                                        data-trigger='hover toggle'\n                                                        data-html='true'\n                                                        data-entityType = 'POST'\n                                                        data-authorid='").concat(post.Reviewer.Id, "'\n                                                        data-postid='").concat(post.PostId, "'/></div>");
        }
        return "";
      }(), "\n                </div>\n                </div>\n\n                <div class=\"cell-group review-body row\"  data-comment-author=\"").concat(post.Reviewer.Handle, "\"  \n                id=\"post-content-").concat(post.PostId, "\">").concat(pendingBadge(post)).concat(forumModControls(post, post.PostId, 'Post'), "\n                ").concat(function () {
        if (post.DeletedPost === true) {
          return window.DELETED_POST;
        }
        if (post.Content !== undefined && post.Content !== null) {
          return post.Content.trim();
        }
        return "";
      }(), "</div>").concat(function () {
        if (post.DeletedPost != true && post.Images !== undefined) {
          var imageGallery = '';
          if (post.Images.length) {
            imageGallery = "<div class=\"image-row\">";
          }
          post.Images.forEach(function (num, index) {
            var img = post.Images[index];
            imageGallery += "<img src=\"".concat(_this21.imagePathForum).concat(img.FileName, "\" class=\"review-img lightbox-slide\" />");
          });
          if (imageGallery.length > 0) {
            imageGallery += "</div>";
          }
          return imageGallery;
        }
        return "";
      }(), "<div class=\"cell hr expand\"></div>\n                <div class=\"baseline-controls ").concat(function () {
        if (_this21.IsMasquerade) {
          return "hide";
        } else {
          return "";
        }
      }(), "\">\n                <div class=\"control-group\">\n                    <div class=\"control\">\n                    ").concat(function () {
        if (post.DeletedPost !== true) {
          return "<i class=\"thumbsup icon buffer ".concat(function () {
            if (myVote === 'up') {
              return "my";
            }
          }() || '', "\" onClick=\"window.SocialProfile.Thumbs('up','Post','").concat(post.PostId, "',this)\"></i>");
        }
      }() || '', "\n                    </div>\n                    <div class=\"control vote-score\">").concat(function () {
        if (post !== undefined && post !== null && post.VoteScore !== undefined) {
          return "".concat(post.VoteScore);
        } else {
          return "0";
        }
      }(), "</div>\n                    <div class=\"control\">\n                                        ").concat(function () {
        if (post.DeletedPost !== true) {
          return "<i class=\"thumbsdown icon ".concat(function () {
            if (myVote === 'down') {
              return "my";
            }
          }() || '', "\" onClick=\"window.SocialProfile.Thumbs('down','Post','").concat(post.PostId, "',this)\"></i>");
        }
      }() || '', "</div>\n                    </div>\n                    <div class=\"control-group\">\n                        <div class=\"control\">\n                        <i class=\"reply-to-post icon\"></i>\n                        </div> \n                        <div class=\"control\">\n                            <a href=\"javascript:void(0)\"  id='open-post-comment-").concat(post.PostId, "' onClick=\"window.SocialProfile.OpenCommentForCreate(this, '").concat(post.PostId, "','','").concat(forumStateKey, "')\">").concat(window.LEAVE_A_REPLY, "</a>\n                        </div>\n                    </div>\n                    </div>\n                </div>\n            </div>\n            <div class='comment-wrap' id='comment-post-").concat(post.PostId, "'>\n                <div id='comment-list-").concat(post.PostId, "'></div>\n               \n            </div> \n        </div>");
      return stringTemplate;
    }
  }, {
    key: "RenderForumComment",
    value: function RenderForumComment(forumStateKey, comment) {
      var _this22 = this;
      var isAnon = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var isFirst = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var isLast = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var replies = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
      var myDate = moment.duration(moment.utc(comment.CreatedAtString).diff(this.now)).humanize(true);
      var myVote = '';
      if (!isAnon) {
        if (comment.UpVoters.includes(this.MyProfile.Id.toString())) {
          myVote = 'up';
        } else if (comment.DownVoters.includes(this.MyProfile.Id.toString())) {
          myVote = 'down';
        }
      } else if (this.AnonSocialProfileLikes.length) {
        var intId = parseInt(comment.Id, 10);
        myVote = this.GetAnonThumbState(intId, 'ForumComment');
      }
      var stringTemplate = "\n        <div class='comment-combo'>\n            <div class='reply-trail ".concat(function () {
        if (replies.length) {
          return "comment-has-replies";
        } else {
          return "";
        }
      }(), "' >\n                <div class='reply-trail-col'>\n                    <div class='reply-trail-line ").concat(function () {
        if (isFirst) {
          return "first";
        }
        return "";
      }(), "'></div>    \n                    <div class='reply-trail-line-tail ").concat(function () {
        if (isLast) {
          return "hide";
        }
        return "";
      }(), "'></div>\n                </div>\n            </div>\n            <div class='forum-post-wrap is-comment' id='forum-comment-box-").concat(comment.Id, "'>\n                <div class=\"frn-flex-row column review-box\">\n                <div class=\"cell lesser-text show-when-small\" style=\"margin-top:-10px\">").concat(myDate, "</div>\n                    <div class=\"cell-group review-header mb-2\">\n                        <div class=\"cell-group profile-header frn-flex-middle expand buffer min-144\">\n                            <div class=\"cell image-cell\">\n                                <img class=\"reviewer-image social-profile-navigate\" src=\"").concat(this.avatarPath).concat(comment.Author.ImageKey, "?w=64&h=64\" data-profile-id=\"").concat(comment.Author.Id, "\"/>\n                            </div>\n                                <div class=\"cell-group reviewer-info column expand\">\n                                    <div class=\"cell-group verification-group \">\n                                        <span class=\"name-cell social-profile-navigate\" data-profile-id=\"").concat(comment.Author.Id, "\">").concat(comment.Author.Handle, "</span>\n                                        ").concat(function () {
        if (comment.AuthorIsTopicCreator === true) {
          return "<div class=\"cell\"> <span class=\"cell lesser-text inline-forum-label-discussion-starter ml-2\"> <img src=\"/Content/dist/images/icons/rocket.svg\" />".concat(window.DISCUSSION_STARTER, " </span> </div>");
        }
        return "";
      }(), "\n              ").concat(function () {
        if (comment.Author.IsModerator) {
          return "<div class=\"cell\"> <span class=\"cell lesser-text inline-forum-label-moderator ml-2\"> ".concat(window.PORTAL_CODE, " ").concat(window.MODERATOR, " </span> </div>");
        }
        return "";
      }(), "\n                                    </div>\n                                    <div class=\"cell-group expand\">\n                                    <div class=\"cell-group column lesser-text\">\n                                    ").concat(function () {
        if (comment.Author.Country != null && comment.Author.Country != undefined) {
          return "<div class=\"cell reviewer-info\">".concat(window.LOCATION, ": ").concat(comment.Author.Country, "</div>");
        }
        return "";
      }(), "\n\n                ").concat(function () {
        if (comment.Author.JoinedDate != null && comment.Author.JoinedDate != undefined) {
          return "<div class=\"cell reviewer-info\">".concat(window.JOINED, ": ").concat(moment.duration(moment.utc(comment.Author.JoinedDateString).diff(_this22.now)).humanize(true), "</div>");
        }
        return "";
      }(), "      </div>\n                    <div class=\"cell-group expand middle\">\n                     ").concat(function () {
        if (parseInt(comment.ReplyToCommentId, 10) > 0) {
          return "<div class='cell replying-to-info'>".concat(window.REPLYING_TO_COMMENT_BY.replace('{0}', "<a href=\"javascript:void(0)\" onClick=\"window.SocialProfile.ScrollTo('".concat(forumStateKey, "','forum-comment-box-").concat(comment.ReplyToCommentId, "', '").concat(comment.AttachedToPostId, "')\">").concat(comment.ReplyingTo, "</a>")), "</div>");
        } else {
          return "<div class='cell replying-to-info'>".concat(window.REPLYING_TO_POST_BY.replace('{0}', "<a href=\"javascript:void(0)\" onClick=\"window.SocialProfile.ScrollTo('".concat(forumStateKey, "','post-box-").concat(comment.AttachedToPostId, "')\">").concat(comment.ReplyingTo, "</a>")), "</div>");
        }
      }(), "\n            </div>\n            </div>\n                                </div>\n                          \n                            </div>\n                  \n                        <div class=\"cell-group last\">\n                            <div class=\"cell buffer lesser-text hide-when-small\" style=\"margin-top:-3px\">").concat(myDate, "</div>\n                              ").concat(function () {
        if (comment.ViewerCanEdit === true) {
          return "<div class=\"cell last dots\"><img src=\"/Content/dist/images/icons/3dots.svg\"  \n                                                            data-toggle='comment-edit-menu'\n                                                            data-forum-holder='".concat(forumStateKey, "'\n                                                            data-target-id='forum-edit-column-menu'\n                                                            data-placement='top'\n                                                            data-trigger='hover toggle'\n                                                            data-html='true'\n                                                            data-commentid='").concat(comment.Id, "'\n                                                            data-postid='").concat(comment.AttachedToPostId, "'/></div>");
        }
        return "";
      }(), "\n                        </div>\n                    </div>\n                   <div class='flex'>\n               \n                   </div>\n                    <div class=\"cell-group review-body row\" data-comment-author=\"").concat(comment.Author.Handle, "\" \n                    id=\"comment-content-").concat(comment.Id, "\">").concat(pendingBadge(comment)).concat(forumModControls(comment, comment.Id, 'ForumComment'), "\n                    ").concat(function () {
        if (comment.DeletedComment === true) {
          return window.DELETED_POST;
        }
        if (comment.Content !== undefined && comment.Content !== null) {
          return comment.Content.trim();
        }
        return "";
      }(), "</div> ").concat(function () {
        if (comment.DeletedComment === true) {
          return "";
        }
        var imageCommentGallery = '';
        if (comment.Images.length) {
          imageCommentGallery = "<div class=\"image-row\">";
        }
        comment.Images.forEach(function (num, index) {
          var img = comment.Images[index];
          imageCommentGallery += "<img src=\"".concat(_this22.imagePathComment).concat(img.FileName, "\" class=\"review-img lightbox-slide\" />");
        });
        if (imageCommentGallery.length > 0) {
          imageCommentGallery += "</div>";
        }
        return imageCommentGallery;
      }(), "\n\n                    ").concat(function () {
        return "\n                            <div class=\"cell hr expand\"></div>\n                            <div class=\"baseline-controls ".concat(function () {
          if (_this22.IsMasquerade) {
            return "hide";
          } else {
            return "";
          }
        }(), "\">\n                                <div class=\"control-group\">\n                                    <div class=\"control\"> ").concat(function () {
          if (comment.Status.toLowerCase() === 'approved') {
            return "<i class=\"thumbsup icon buffer ".concat(function () {
              if (myVote === 'up') {
                return "my";
              }
            }() || '', "\" onClick=\"window.SocialProfile.Thumbs('up','ForumComment','").concat(comment.Id, "',this)\"></i>");
          }
        }() || '', "\n                                    </div>\n                                    <div class=\"control vote-score\">").concat(comment.VoteScore, "</div>\n                                    <div class=\"control\"> ").concat(function () {
          if (comment.Status.toLowerCase() === 'approved') {
            return "<i class=\"thumbsdown icon  ".concat(function () {
              if (myVote === 'down') {
                return "my";
              }
            }() || '', "\" onClick=\"window.SocialProfile.Thumbs('down','ForumComment','").concat(comment.Id, "',this)\"></i>");
          }
        }() || '', "\n                                    </div>\n                                </div>\n                                <div class=\"control-group\">\n                                    <div class=\"control\">\n                                        <i class=\"reply-to-post icon\"></i>\n                                    </div>\n                                    <div class=\"control\">\n                                        <a href=\"javascript:void(0)\" id='open-comment-reply-").concat(comment.Id, "' onClick=\"window.SocialProfile.OpenCommentForCreate(this, '").concat(comment.AttachedToPostId, "','").concat(comment.Id, "','").concat(forumStateKey, "')\">").concat(window.LEAVE_A_REPLY, "</a>\n                                    </div>\n                                </div>\n                            </div>");
      }(), "\n                </div>\n                ").concat(function () {
        if (replies.length) {
          var repliesToCommentString = '';
          var isFirstCommentInList = false;
          var isLastCommentInList = false;
          var numberofComments = replies.length;
          _this22.SortCommentByDate(replies);
          replies.forEach(function (num, index) {
            if (index == 0) {
              isFirstCommentInList = true;
            } else {
              isFirstCommentInList = false;
            }
            if (index == numberofComments - 1) {
              isLastCommentInList = true;
            } else {
              isLastCommentInList = false;
            }
            repliesToCommentString += _this22.RenderForumComment(forumStateKey, replies[index], isAnon, isFirstCommentInList, isLastCommentInList);
          });
          return "<div class='reply-wrap' data-show-under-comment='".concat(comment.Id, "' style='display:block' id='reply-post-").concat(comment.Id, "'>").concat(repliesToCommentString, "</div>");
        }
        return "";
      }(), "\n            </div>\n           \n        </div>\n          ");
      return stringTemplate;
    }
  }, {
    key: "RenderMoreCommentsLink",
    value: function RenderMoreCommentsLink(forumStateKey, numMoreComments, postId) {
      var view_x_replies = VIEW_ALL_X_REPLIES.replace('{0}', numMoreComments);
      var stringTemplate = "\n        <div class='comment-combo'>\n            <div class='reply-trail'>\n                <div class='reply-trail-col'>\n                    <div class='reply-trail-line'></div>    \n                </div>\n            </div>\n            <div class=\"forum-post-wrap\">\n                <div class=\"control\">\n                    <a href=\"javascript:void(0)\"  id='open-post-comment-".concat(postId, "' onClick=\"window.SocialProfile.OpenForumComment('").concat(forumStateKey, "','").concat(postId, "')\">").concat(view_x_replies, "</a>\n                </div>\n            </div>\n        </div>");
      return stringTemplate;
    }
  }, {
    key: "RenderStatusBadge",
    value: function RenderStatusBadge(IsCompanyRepForBrokers, isVerified) {
      var statusClass = '';
      var statusText = '';
      var statusBadge = 'checkcircle.svg';
      if (IsCompanyRepForBrokers && IsCompanyRepForBrokers.length > 0) {
        statusClass = 'representative';
        statusText = window.COMPANY_REPRESENTATIVE;
        statusBadge = 'company-rep-icon.svg';
      } else if (isVerified) {
        statusClass = 'verified';
        statusText = window.VERIFIED_REVIEWER;
      } else {
        statusClass = 'unverified';
        statusText = window.UNVERIFIED_REVIEWER;
      }
      var badge = "\n        <div class=\"reviewer-status ".concat(statusClass, " d-flex\" style=\"margin-left:unset;\">\n            <div class=\"verified-icon\">\n                <img src=\"/Content/dist/images/icons/").concat(statusBadge, "\" caption=\"false\">\n            </div>\n            <div class=\"verified-icon-text\">").concat(statusText, "</div>\n        </div>\n    ");
      return badge;
    }
  }, {
    key: "GetNotificationStatus",
    value: function GetNotificationStatus() {
      var _this23 = this;
      $.ajax({
        type: "POST",
        cache: false,
        url: window.notificationStatusUrl,
        dataType: "json",
        success: function success(result) {
          if (!_this23.notificationChangeState) {
            if ($('input[name=RepliesToMyPosts]').length) {
              $('input[name=RepliesToMyPosts]').prop('checked', result.SubscriptionStatus.RepliesToMyPostsNotifications);
            }
          }
        },
        error: function error(result) {},
        failure: function failure() {}
      });
      ;
    }
  }, {
    key: "GetExistingPostContent",
    value: function GetExistingPostContent(postId) {
      var _this24 = this;
      $.ajax({
        type: "POST",
        cache: false,
        url: window.openForumPostForEditUrl,
        dataType: "json",
        data: {
          postId: postId
        },
        success: function () {
          var _success = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(result) {
            var files, _iterator4, _step4, file, _t5;
            return _regenerator().w(function (_context7) {
              while (1) switch (_context7.p = _context7.n) {
                case 0:
                  $('#submit-post-progress').hide();
                  if (!(result.Ok === true)) {
                    _context7.n = 10;
                    break;
                  }
                  _this24.TopicId = result.TopicId;
                  _context7.n = 1;
                  return _this24.initiateTaggingForEditor();
                case 1:
                  window.SocialProfile.Lightbox.currentContext = "edit";
                  _context7.n = 2;
                  return window.SocialProfile.Lightbox.clearImageSession();
                case 2:
                  document.getElementById('post-input-editor').innerHTML = result.Content.Values.PostBody;
                  document.getElementById('img-post-frames').innerHTML = '';
                  files = result.Content.Values.FileNames;
                  _iterator4 = _createForOfIteratorHelper(files);
                  _context7.p = 3;
                  _iterator4.s();
                case 4:
                  if ((_step4 = _iterator4.n()).done) {
                    _context7.n = 6;
                    break;
                  }
                  file = _step4.value;
                  _context7.n = 5;
                  return window.SocialProfile.Lightbox.LoadServerImage(file, '#img-post-frames');
                case 5:
                  _context7.n = 4;
                  break;
                case 6:
                  _context7.n = 8;
                  break;
                case 7:
                  _context7.p = 7;
                  _t5 = _context7.v;
                  _iterator4.e(_t5);
                case 8:
                  _context7.p = 8;
                  _iterator4.f();
                  return _context7.f(8);
                case 9:
                  _this24.Lightbox.IgniteAddPostPhotoButton();
                  return _context7.a(2, true);
                case 10:
                  toastr.error(result.Message);
                  return _context7.a(2, false);
                case 11:
                  return _context7.a(2);
              }
            }, _callee7, null, [[3, 7, 8, 9]]);
          }));
          function success(_x9) {
            return _success.apply(this, arguments);
          }
          return success;
        }(),
        error: function error(result) {
          $('#submit-post-progress').hide();
          alert("An error has occurred " + result.Message);
          return false;
        },
        failure: function failure() {
          $('#submit-post-progress').hide();
          alert("Network error");
          return false;
        }
      });
      ;
    }
  }, {
    key: "GetExistingCommentContent",
    value: function GetExistingCommentContent(commentId) {
      var _this25 = this;
      $.ajax({
        type: "POST",
        cache: false,
        url: window.openForumCommentForEditUrl,
        dataType: "json",
        data: {
          commentId: commentId
        },
        success: function () {
          var _success2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(result) {
            var files, _iterator5, _step5, file, _t6;
            return _regenerator().w(function (_context8) {
              while (1) switch (_context8.p = _context8.n) {
                case 0:
                  $('#submit-comment-progress').hide();
                  if (!(result.Ok === true)) {
                    _context8.n = 10;
                    break;
                  }
                  _this25.TopicId = result.TopicId;
                  _context8.n = 1;
                  return _this25.initiateTaggingForEditor('#comment-input-editor');
                case 1:
                  window.SocialProfile.Lightbox.currentContext = "edit";
                  _context8.n = 2;
                  return window.SocialProfile.Lightbox.clearImageSession();
                case 2:
                  document.getElementById('comment-input-editor').innerHTML = result.Content.Body;
                  document.getElementById('img-comment-frames').innerHTML = '';
                  files = result.Content.FileNames;
                  _iterator5 = _createForOfIteratorHelper(files);
                  _context8.p = 3;
                  _iterator5.s();
                case 4:
                  if ((_step5 = _iterator5.n()).done) {
                    _context8.n = 6;
                    break;
                  }
                  file = _step5.value;
                  _context8.n = 5;
                  return window.SocialProfile.Lightbox.LoadServerImage(file, '#img-comment-frames');
                case 5:
                  _context8.n = 4;
                  break;
                case 6:
                  _context8.n = 8;
                  break;
                case 7:
                  _context8.p = 7;
                  _t6 = _context8.v;
                  _iterator5.e(_t6);
                case 8:
                  _context8.p = 8;
                  _iterator5.f();
                  return _context8.f(8);
                case 9:
                  _this25.Lightbox.IgniteAddPostPhotoButton();
                  if ($('input[name=RepliesToMyPosts]').length) {
                    $('input[name=RepliesToMyPosts]').prop('checked', result.RepliesToMyPostsNotifications);
                  }
                  $("#submit-comment-button").off("click").on("click", window.SocialProfile.SaveEditedComment);
                  return _context8.a(2, true);
                case 10:
                  toastr.error(result.Message);
                  $('#dialog-add-comment').modal("hide");
                case 11:
                  return _context8.a(2);
              }
            }, _callee8, null, [[3, 7, 8, 9]]);
          }));
          function success(_x0) {
            return _success2.apply(this, arguments);
          }
          return success;
        }(),
        error: function error(result) {
          $('#submit-comment-progress').hide();
          alert("An error has occurred " + result.Message);
          return false;
        },
        failure: function failure() {
          $('#submit-comment-progress').hide();
          alert("Network error");
          return false;
        }
      });
    }
  }, {
    key: "OpenPostForEdit",
    value: function OpenPostForEdit(containerId, postId) {
      var _this26 = this;
      $('[data-toggle="post-edit-menu"]').each(function () {
        // Hide the popover when clicking outside
        if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
          $(this).popover('hide');
        }
      });
      $('#submit-post-progress').show();
      $('#dialog-add-post').modal("show");
      $('#dialog-add-post').off('shown.bs.modal').on('shown.bs.modal', function (e) {
        _this26.activeContainerId = containerId;
        _this26.CurrentInputState = {
          postId: postId,
          containerId: containerId
        };
        _this26.Lightbox.currentContext = "edit";
        $("#clear-post-draft-cell").hide();
        _this26.removeDraftListenerForEditor('post-input-editor');
        window.SocialProfile.GetExistingPostContent(postId);
      });
    }
  }, {
    key: "OpenCommentForEdit",
    value: function OpenCommentForEdit(containerId, commentId, postId) {
      window.SocialProfile.PrepareEditCommentInput(containerId, commentId, postId).then(function (res) {
        if (res) {
          window.SocialProfile.GetExistingCommentContent(commentId);
        }
      });
    }
  }, {
    key: "PrepareEditCommentInput",
    value: function PrepareEditCommentInput(containerId, commentId, postId) {
      var _this27 = this;
      return new Promise(function (resolve, reject) {
        $('[data-toggle="comment-edit-menu"]').each(function () {
          // Hide the popover when clicking outside
          if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
            $(this).popover('hide');
          }
        });
        document.getElementById('comment-input-editor').innerHTML = "loading...";
        _this27.removeDraftListenerForEditor('comment-input-editor');
        $('#dialog-add-comment').off('shown.bs.modal').on('shown.bs.modal', function (e) {
          _this27.activeContainerId = containerId;
          _this27.CurrentInputState = {
            postId: postId,
            commentId: commentId,
            containerId: containerId
          };
          $('#submit-comment-button').off('click').on('click', window.SocialProfile.SaveEditedComment);
        }).modal("show");
        $('#submit-comment-progress').show();
        resolve(true);
      });
    }
  }, {
    key: "OpenCommentForCreate",
    value: function () {
      var _OpenCommentForCreate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(embeddedbutton, postId, replyToCommentId, containerId) {
        var _this28 = this;
        var draftKey, container, data, hasDraft, author, draftJson, draft, _t7;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              draftKey = "forumDraft-comment-post-".concat(postId);
              this.Lightbox.resetTmpFilesForDraft(draftKey);
              if (!containerId) {
                container = embeddedbutton.closest('div.forum-holder');
                if (container) {
                  containerId = container.id;
                }
              }
              if (window.userIsOnline) {
                _context9.n = 1;
                break;
              }
              data = {
                postId: postId,
                replyToCommentId: replyToCommentId,
                containerId: containerId
              };
              window.Access.LoginWithPurpose('OpenCommentForCreate', window.YOU_MUST_BE_LOGGED_IN_TO_PERFORM_THIS_ACTION, 'login', '', JSON.stringify(data), 'window.SocialProfile');
              return _context9.a(2);
            case 1:
              this.CurrentInputState = {
                postId: postId,
                replyToCommentId: replyToCommentId,
                containerId: containerId
              };
              this.activeContainerId = containerId;
              hasDraft = !!localStorage.getItem(draftKey);
              this.Lightbox.currentContext = "draft";
              this.Lightbox.currentDraftKey = draftKey;

              // Draft UI visibility
              if (hasDraft) {
                $('#clear-comment-draft-cell').show();
                $('#dialog-add-comment .draft-saved-hint').show();
                $('#clear-comment-draft-cell a').off('click').on('click', function () {
                  _this28.ClearDraft();
                });
              } else {
                $('#clear-comment-draft-cell').hide();
                $('#dialog-add-comment .draft-saved-hint').hide();
              }

              // Reset inputs and preview
              $('#img-comment-frames').empty();
              $('#submit-comment-progress').hide();
              document.getElementById('comment-input-editor').innerHTML = "";
              $('#dialog-add-comment .has-danger').removeClass('has-danger');

              // Setup reply prompt
              author = "";
              if (replyToCommentId) {
                author = $('#comment-content-' + replyToCommentId).data('comment-author');
              } else if (postId) {
                author = $('#post-content-' + postId).data('comment-author');
              }
              $('#replying-comment-prompt').html("replying to <a href='javascript:void(0)'>".concat(author, "</a>"));

              // Restore draft
              draftJson = localStorage.getItem(draftKey);
              if (!draftJson) {
                _context9.n = 5;
                break;
              }
              _context9.p = 2;
              draft = JSON.parse(draftJson);
              if (draft.body) {
                document.getElementById('comment-input-editor').innerHTML = draft.body;
              }
              if (!(Array.isArray(draft.imageRefs) && draft.imageRefs.length > 0)) {
                _context9.n = 3;
                break;
              }
              _context9.n = 3;
              return this.Lightbox.RenderImageRefsFromDraft(draft.imageRefs, "#img-comment-frames", draftKey);
            case 3:
              _context9.n = 5;
              break;
            case 4:
              _context9.p = 4;
              _t7 = _context9.v;
              console.warn("[Draft Restore] Failed to parse comment draft:", _t7);
            case 5:
              this.initiateDraftForEditor('comment-input-editor', containerId, draftKey);
              _context9.n = 6;
              return this.initiateTaggingForEditor('#comment-input-editor');
            case 6:
              // Show dialog and wire up confirm button
              $('#dialog-add-comment').off('shown.bs.modal').on('shown.bs.modal', function () {
                $('#submit-comment-button').off('click').on('click', _this28.SaveNewComment);
              }).off('hidden.bs.modal').on('hidden.bs.modal', function (e) {
                _this28.removeDraftListenerForEditor('comment-input-editor');
              }).modal("show");
            case 7:
              return _context9.a(2);
          }
        }, _callee9, this, [[2, 4]]);
      }));
      function OpenCommentForCreate(_x1, _x10, _x11, _x12) {
        return _OpenCommentForCreate.apply(this, arguments);
      }
      return OpenCommentForCreate;
    }()
  }, {
    key: "SaveNewComment",
    value: function SaveNewComment() {
      var _this29 = this;
      $('#submit-comment-progress').show();
      $('#submit-comment-button').off('click');
      setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var containerId, _this29$CurrentInputS, postId, commentId, _containerId3, replyToCommentId, draftKey, progress, comment, formData, repliesToMyPosts;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              containerId = _this29.activeContainerId;
              if (!(typeof containerId === "string")) {
                _context1.n = 3;
                break;
              }
              _this29$CurrentInputS = _this29.CurrentInputState, postId = _this29$CurrentInputS.postId, commentId = _this29$CurrentInputS.commentId, _containerId3 = _this29$CurrentInputS.containerId, replyToCommentId = _this29$CurrentInputS.replyToCommentId;
              draftKey = "forumDraft-comment-post-".concat(postId);
              progress = true;
              comment = _this29.ExtractEditorContent('comment-input-editor');
              if (comment === '') {
                $('#comment-input-editor').parent().addClass('has-danger');
                progress = false;
                $('#submit-comment-progress').hide();
              }
              if (progress) {
                _context1.n = 1;
                break;
              }
              $('#submit-comment-button').off('click').on('click', window.SocialProfile.SaveNewComment);
              return _context1.a(2);
            case 1:
              // Create a new FormData object.
              formData = new FormData();
              _context1.n = 2;
              return _this29.Lightbox.AppendForumImagesToFormData(formData, draftKey);
            case 2:
              repliesToMyPosts = document.querySelector('#RepliesToMyPostsViaComments').checked;
              formData.append('RepliesToMyPosts', repliesToMyPosts);
              formData.append('Body', comment);
              if (replyToCommentId != null && replyToCommentId != undefined && replyToCommentId !== "") {
                formData.append('ReplyToCommentId', replyToCommentId);
              } else {}
              formData.append('PostId', postId);
              formData.append('AnonKey', _this29.DeviceId);
              $.ajax({
                type: "POST",
                cache: false,
                // ReSharper disable once UseOfImplicitGlobalInFunctionScope
                processData: false,
                contentType: false,
                url: window.submitForumPostCommentUrl,
                dataType: "json",
                data: formData,
                async: false,
                success: function success(result) {
                  _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
                    var repliesStr, participantsStr, stateForForum, index, commentToRender, headline, renderedComment, currentList;
                    return _regenerator().w(function (_context0) {
                      while (1) switch (_context0.n) {
                        case 0:
                          if (!(result.Success === true)) {
                            _context0.n = 1;
                            break;
                          }
                          _this29.now = moment.utc();
                          $('#dialog-add-comment').modal("hide");
                          _this29.ClearDraft();
                          result.Comment.ViewerCanEdit = true;
                          result.Comment.PostId = result.ParentPostId;
                          if (typeof _containerId3 === "string") {
                            repliesStr = window.forumStrings['_0Replies'].replace("{0}", result.TopicReplies);
                            participantsStr = window.forumStrings['_0Participants'].replace("{0}", result.TopicParticipants);
                            stateForForum = _this29.GetState(_containerId3);
                            $("span.topic-".concat(result.TopicId, "-replies")).html(repliesStr);
                            $("span.topic-".concat(result.TopicId, "-participants")).html(participantsStr);
                            if (stateForForum.forumMode === 'InlineForum' && $('#' + _containerId3).length) {
                              index = stateForForum.dataState.reviewModel.Comments.length;
                              stateForForum.dataState.reviewModel.Comments[index] = result.Comment;
                              _this29.OpenForumComment(_containerId3, postId);
                              setTimeout(function () {
                                document.getElementById('forum-comment-box-' + result.Comment.Id).scrollIntoView({
                                  block: "center",
                                  behavior: 'smooth'
                                });
                              }, 3);
                            } else if ($('#forum-list-wrap').length) {
                              commentToRender = result.Comment;
                              commentToRender.EntityId = result.Comment.Id;
                              commentToRender.EntityType = 'comment';
                              headline = $("#-".concat(result.Comment.AttachToPostId)).text();
                              commentToRender.Headline = headline;
                              renderedComment = window.SocialProfile.RenderLatestForumPost(_containerId3, commentToRender);
                              currentList = $('#forum-list-wrap').html();
                              $('#forum-list-wrap').html(renderedComment + currentList);
                            }
                            _this29.Lightbox.InitializeLBImages('inline-forum-template');
                            _this29.Lightbox.InitializeLBImages('forum-items-container');
                            if ($(location).attr('href').includes('forum/latest/posts')) {
                              window.SocialProfile.IgniteLatestPostsList();
                              window.scrollTo({
                                top: 0,
                                behavior: 'smooth'
                              });
                            }
                          }
                          return _context0.a(2, true);
                        case 1:
                          $('#submit-comment-progress').hide();
                          toastr.error(result.Message);
                          return _context0.a(2, false);
                        case 2:
                          return _context0.a(2);
                      }
                    }, _callee0);
                  }))(); // <- call it immediately
                },
                error: function error(result) {
                  $('#submit-comment-progress').hide();
                  alert("An error has occurred " + result.Message);
                  return false;
                },
                failure: function failure() {
                  $('#submit-comment-progress').hide();
                  alert("Network error");
                  return false;
                }
              });
              _context1.n = 4;
              break;
            case 3:
              console.error("Invalid key type.");
            case 4:
              return _context1.a(2);
          }
        }, _callee1);
      })), 50);
    }
  }, {
    key: "SaveEditedComment",
    value: function SaveEditedComment() {
      var _this30 = this;
      $('#submit-comment-progress').show();
      setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
        var progress, review, _this30$CurrentInputS, postId, commentId, containerId, stateForForum, formData, repliesToMyPosts;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              progress = true;
              review = _this30.ExtractEditorContent('comment-input-editor');
              if (review === '') {
                $('#comment-input-editor').parent().addClass('has-danger');
                $('#submit-comment-progress').hide();
                progress = false;
              }
              if (!progress) {
                _context11.n = 2;
                break;
              }
              _this30$CurrentInputS = _this30.CurrentInputState, postId = _this30$CurrentInputS.postId, commentId = _this30$CurrentInputS.commentId, containerId = _this30$CurrentInputS.containerId;
              stateForForum = _this30.GetState(containerId);
              formData = new FormData();
              _context11.n = 1;
              return _this30.Lightbox.AppendForumImagesToFormData(formData);
            case 1:
              formData.append('PostBody', review);
              repliesToMyPosts = document.querySelector('#RepliesToMyPostsViaComments').checked;
              formData.append("RepliesToMyPosts", repliesToMyPosts);
              formData.append("CommentBody", review);
              formData.append("CommentId", commentId);
              formData.append("PostId", postId);
              formData.append("AnonKey", _this30.DeviceId);
              $.ajax({
                type: "POST",
                cache: false,
                processData: false,
                contentType: false,
                url: window.submitForumCommentUrl,
                dataType: "json",
                data: formData,
                async: false,
                success: function () {
                  var _success3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(result) {
                    return _regenerator().w(function (_context10) {
                      while (1) switch (_context10.n) {
                        case 0:
                          if (!(result.Success === true)) {
                            _context10.n = 2;
                            break;
                          }
                          _context10.n = 1;
                          return window.Lightbox.clearImageSession();
                        case 1:
                          if ($('#forum-list-wrap').length) {
                            _this30.LoadLatestPosts(1, 'forum-list-wrap');
                          }
                          if ($('#activity-list-wrap').length) {
                            window.LoadPosts();
                          }
                          if (stateForForum !== undefined) {
                            if (stateForForum.forumMode === 'InlineForum' && $('#' + containerId).length) {
                              _this30.LoadTopicPosts(stateForForum.topicId, 0, '', 0, containerId);
                            }
                          }
                          $('#dialog-add-comment').modal("hide");
                          return _context10.a(2, true);
                        case 2:
                          $('#submit-comment-progress').hide();
                          toastr.error(result.Message);
                          return _context10.a(2, false);
                        case 3:
                          return _context10.a(2);
                      }
                    }, _callee10);
                  }));
                  function success(_x13) {
                    return _success3.apply(this, arguments);
                  }
                  return success;
                }(),
                error: function error(result) {
                  $('#submit-comment-progress').hide();
                  alert("An error has occurred " + result.Message);
                  return false;
                },
                failure: function failure() {
                  $('#submit-comment-progress').hide();
                  alert("Network error");
                  return false;
                }
              });
              _context11.n = 3;
              break;
            case 2:
              $('#submit-comment-progress').hide();
            case 3:
              return _context11.a(2);
          }
        }, _callee11);
      })), 0);
    }
  }, {
    key: "SubmitSubscribe",
    value: function SubmitSubscribe() {
      var _this31 = this;
      $('#subscribe-to-discussion-dialog-progress').removeClass('hide');
      setTimeout(function () {
        var progress = true;
        if (progress) {
          //;) {

          // Create a new FormData object.
          var formData = new FormData();
          formData.append('TopicId', _this31.TopicId);
          formData.append('AnonKey', _this31.DeviceId);
          formData.append('EmailFrequency', $('#email-frequency-select option:selected').val());
          var entityId = $('#subscribe-to-discussion-dialog').data("entityId");
          var entityType = $('#subscribe-to-discussion-dialog').data("entityType");
          if (entityId != null && entityType != null) {
            formData.append('EntityId', entityId);
            formData.append('EntityType', entityType);
          }
          $.ajax({
            type: "POST",
            cache: false,
            // ReSharper disable once UseOfImplicitGlobalInFunctionScope
            processData: false,
            contentType: false,
            url: window.submitSubscriptionUrl,
            dataType: "json",
            data: formData,
            success: function success(result) {
              if (result.Success === true) {
                $('#subscribe-to-discussion-dialog-progress').addClass('hide');
                $('#subscribe-to-discussion-dialog').modal("hide");
                toastr.success(window.YOUR_TOPIC_HAS_BEEN_SUBSCRIBED);
                return true;
              } else {
                $('#subscribe-to-discussion-dialog-progress').addClass('hide');
                $('#subscribe-to-discussion-dialog').modal("hide");
                toastr.error(result.Message);
                return false;
              }
            },
            error: function error(result) {
              $('#subscribe-to-discussion-dialog-progress').addClass('hide');
              alert("An error has occurred " + result.Message);
              return false;
            },
            failure: function failure() {
              $('#subscribe-to-discussion-dialog-progress').addClass('hide');
              alert("Network error");
              return false;
            }
          });
        } else {
          $('#subscribe-to-discussion-dialog-progress').addClass('hide');
        }
      }, 50);
    }
  }, {
    key: "CreateInlineForum",
    value: function CreateInlineForum(entityId, entityType, forumStateKey) {
      var _this32 = this;
      setTimeout(function () {
        // Create a new FormData object.
        var formData = new FormData();
        formData.append("EntityId", entityId);
        formData.append("EntityType", entityType);
        $.ajax({
          type: "POST",
          cache: false,
          // ReSharper disable once UseOfImplicitGlobalInFunctionScope
          processData: false,
          contentType: false,
          url: window.createInlineTopicUrl,
          dataType: "json",
          data: formData,
          async: false,
          success: function success(result) {
            if (result.Success === true) {
              if (result.NewlyMintedTopicId !== undefined && result.NewlyMintedTopicId > 0) {
                _this32.LoadTopicPosts(result.NewlyMintedTopicId, 0, '', 0, forumStateKey);
                _this32.moderator = result.Moderate == true;
              }
              _this32.now = moment().utc();
              if (forumStateKey === 'inline-forum') {
                $('#add-post-button').show();
                $('#subscribe-button').show();
              } else if ($('#forum-list-wrap').length) {
                if (result.Posts > 0) {
                  _this32.LoadLatestPosts(1, 'forum-list-wrap');
                }
              } else {}
            }
          },
          error: function error(result) {
            console.log("Back from creation error");
            console.log(result);
          },
          failure: function failure(result) {
            console.log("Back from creation failure");
          }
        });
      }, 50);
    }
  }, {
    key: "SubmitForumPost",
    value: function SubmitForumPost() {
      var _this33 = this;
      $('#submit-post-progress').show();
      var myThis = this;
      /* let containerId = $('#dialog-add-post').data("containerId");*/
      var containerId = this.activeContainerId;
      if (typeof containerId === "string") {
        var _this$Lightbox5;
        var context = (_this$Lightbox5 = this.Lightbox) === null || _this$Lightbox5 === void 0 ? void 0 : _this$Lightbox5.currentContext;
        var stateForForum = this.GetState(containerId);
        var draftKey = "forumDraft-post-topic-".concat(stateForForum.topicId);
        setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13() {
          var progress, review, topicTitle, repliesToMyPosts, formData, _this33$CurrentInputS, postId, entityId, entityType, categoryId, intpostId;
          return _regenerator().w(function (_context13) {
            while (1) switch (_context13.n) {
              case 0:
                progress = true;
                review = _this33.ExtractEditorContent('post-input-editor');
                topicTitle = $('#dialog-add-post #topic-title-input').val();
                repliesToMyPosts = document.querySelector('#RepliesToMyPosts').checked;
                if (review === '') {
                  document.getElementById('post-input-editor').classList.add('has-danger');
                  progress = false;
                }
                if ($('#dialog-add-post #topic-title-input').is(':visible') && topicTitle === '') {
                  $('#dialog-add-post #topic-title-input').parent().addClass('has-danger');
                  progress = false;
                }
                if (!progress) {
                  _context13.n = 2;
                  break;
                }
                //;) {
                formData = new FormData();
                _context13.n = 1;
                return _this33.Lightbox.AppendForumImagesToFormData(formData, draftKey);
              case 1:
                formData.append('PostBody', review);
                formData.append('RepliesToMyPosts', repliesToMyPosts);
                if (stateForForum !== undefined) {
                  formData.append('TopicId', stateForForum.topicId);
                }
                formData.append('AnonKey', _this33.DeviceId);
                _this33$CurrentInputS = _this33.CurrentInputState, postId = _this33$CurrentInputS.postId, entityId = _this33$CurrentInputS.entityId, entityType = _this33$CurrentInputS.entityType, categoryId = _this33$CurrentInputS.categoryId;
                intpostId = parseInt(postId, 10);
                if (intpostId != null && intpostId > 0) {
                  formData.append('PostId', intpostId);
                } else if (entityId != null && entityType != null) {
                  formData.append('EntityId', entityId);
                  formData.append('EntityType', entityType);
                }
                if (categoryId != null && categoryId > 0) {
                  formData.append('CategoryId', categoryId);
                  formData.append("TopicTitle", topicTitle);
                }
                $.ajax({
                  type: "POST",
                  cache: false,
                  // ReSharper disable once UseOfImplicitGlobalInFunctionScope
                  processData: false,
                  contentType: false,
                  url: window.submitForumPostUrl,
                  dataType: "json",
                  data: formData,
                  success: function () {
                    var _success4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(result) {
                      var newUrl;
                      return _regenerator().w(function (_context12) {
                        while (1) switch (_context12.n) {
                          case 0:
                            if (!(result.Success === true)) {
                              _context12.n = 4;
                              break;
                            }
                            _this33.now = moment().utc();
                            if (!(context === "draft")) {
                              _context12.n = 2;
                              break;
                            }
                            console.log("removing the draft for " + draftKey);
                            localStorage.removeItem(draftKey); // remove text + imageRefs
                            _context12.n = 1;
                            return _this33.Lightbox.clearImageSession(false, draftKey);
                          case 1:
                            _context12.n = 3;
                            break;
                          case 2:
                            console.log("context is not draft, so not removing anything");
                          case 3:
                            if (result.NewlyMintedTopicId !== undefined && result.NewlyMintedTopicId > 0) {
                              if ($('#forum-items-container').length) {
                                if (result.NewlyMintedTopicId !== undefined && result.NewlyMintedTopicId > 0) {
                                  newUrl = '/forum?discussion=' + result.NewlyMintedTopicId;
                                  window.history.replaceState({
                                    path: newUrl
                                  }, '', newUrl);
                                  myThis.InitForumPage();
                                } else {
                                  myThis.InitForumTopicPage(result.NewlyMintedTopicId);
                                }
                              }
                            } else {
                              if (stateForForum !== undefined) {
                                if (stateForForum.forumMode === 'InlineForum' && $('#' + containerId).length) {
                                  _this33.LoadTopicPosts(stateForForum.topicId, 0, '', 0, containerId);
                                } else if ($('#forum-list-wrap').length) {
                                  _this33.LoadLatestPosts(1, 'forum-list-wrap');
                                }
                              }
                            }
                            $('#dialog-add-post').modal("hide");
                            toastr.success(window.YOUR_COMMENT_HAS_BEEN_SUBMITTED);
                            return _context12.a(2, true);
                          case 4:
                            $('#dialog-add-post').modal("hide");
                            toastr.error(result.Message);
                            return _context12.a(2, false);
                          case 5:
                            return _context12.a(2);
                        }
                      }, _callee12);
                    }));
                    function success(_x14) {
                      return _success4.apply(this, arguments);
                    }
                    return success;
                  }(),
                  error: function error(result) {
                    $('#submit-post-progress').hide();
                    alert("An error has occurred " + result.Message);
                    return false;
                  },
                  failure: function failure() {
                    $('#submit-post-progress').hide();
                    alert("Network error");
                    return false;
                  }
                });
                _context13.n = 3;
                break;
              case 2:
                $('#submit-post-progress').hide();
              case 3:
                return _context13.a(2);
            }
          }, _callee13);
        })), 50);
      } else {
        console.error("Invalid key type.");
      }
    }
  }, {
    key: "Thumbs",
    value: function Thumbs(direction, channel, id, e) {
      var _this34 = this;
      var intId = parseInt(id, 10);
      var thumbData = {
        direction: direction,
        channel: channel,
        id: intId
      };
      var hashData = this.Hash(JSON.stringify(thumbData), 23);
      thumbData.anonKey = this.DeviceId;
      $.ajax({
        type: "POST",
        cache: false,
        // ReSharper disable once UseOfImplicitGlobalInFunctionScope
        url: window.thumbsUrl,
        dataType: "json",
        data: thumbData,
        success: function success(result) {
          if (result.state.Ok) {
            $(e).closest('div.baseline-controls').find('i.my').removeClass('my');
            if (result.state.PointThumb) {
              $(e).addClass('my');
            }
            var voteScore = $(e).closest('div.baseline-controls').find('div.vote-score');
            voteScore.text(result.state.NewScore);
            if (result.state.SocialProfileId == null && result.state.SocProcAnonKey.length > 0) {
              if (_this34.DeviceId == null) {
                _this34.DeviceId = result.state.SocProcAnonKey;
                localStorage.setItem("SocialProfileDevice", result.state.SocProcAnonKey);
              }
              var SocialProfileLikes = [];
              if (localStorage.getItem("SocialProfileLikes") != null) {
                var data = localStorage.getItem("SocialProfileLikes");
                SocialProfileLikes = JSON.parse(data);
              }
              if (result.state.PointThumb) {
                SocialProfileLikes.push(hashData);
              } else {
                var removeData = {};
                if (direction === 'up') {
                  removeData = {
                    direction: 'down',
                    channel: channel,
                    id: intId
                  };
                } else {
                  removeData = {
                    direction: 'up',
                    channel: channel,
                    id: intId
                  };
                }
                var removeHash = _this34.Hash(JSON.stringify(removeData), 23);
                SocialProfileLikes = _this34.RemoveThumbFromAnonList(removeHash);
              }
              _this34.AnonSocialProfileLikes = SocialProfileLikes;
              localStorage.setItem("SocialProfileLikes", JSON.stringify(SocialProfileLikes));
            }
          } else {
            toastr.error(result.state.Message);
          }
        },
        error: function (_error) {
          function error(_x15) {
            return _error.apply(this, arguments);
          }
          error.toString = function () {
            return _error.toString();
          };
          return error;
        }(function (result) {
          console.log(error);
        })
      });
    }
  }, {
    key: "RemoveThumbFromAnonList",
    value: function RemoveThumbFromAnonList(entry) {
      if (this.AnonSocialProfileLikes.length) {
        var outcome = this.AnonSocialProfileLikes.filter(function (el) {
          return el !== entry;
        });
        return outcome;
      }
      return [];
    }
  }, {
    key: "OpenForumComment",
    value: function OpenForumComment(forumStateKey, postId) {
      this.OpenCommentToView(forumStateKey, postId);
    }
  }, {
    key: "OpenCommentToView",
    value: function OpenCommentToView(forumStateKey, postId) {
      var _this35 = this;
      return new Promise(function (resolve, reject) {
        var loadedComments = [];
        var state = _this35.GetState(forumStateKey);
        var result = state.dataState;
        if (state.forumMode === 'InlineForum') {
          loadedComments = state.dataState.reviewModel.Comments;
        }
        if (loadedComments !== undefined) {
          var intId = parseInt(postId, 10);
          var levelOneRepliesToPost = loadedComments.filter(function (k) {
            return k.AttachedToPostId === intId;
          }).filter(function (k) {
            return !(k.DisplayUnderCommentId > 0);
          });
          levelOneRepliesToPost.sort(function (a, b) {
            return a.CreatedAt > b.CreatedAt ? 1 : -1;
          });
          var output = '';
          if (levelOneRepliesToPost.length > 0) {
            var isAnon = true;
            if (_this35.MyProfile.Id !== undefined) {
              isAnon = false;
            }
            if (Array.isArray(levelOneRepliesToPost)) {
              var isFirstCommentInList = false;
              var isLastCommentInList = false;
              var numberofComments = levelOneRepliesToPost.length;
              levelOneRepliesToPost.forEach(function (num, index) {
                if (index == 0) {
                  isFirstCommentInList = true;
                } else {
                  isFirstCommentInList = false;
                }
                if (index == numberofComments - 1) {
                  isLastCommentInList = true;
                } else {
                  isLastCommentInList = false;
                }
                var comment = levelOneRepliesToPost[index];
                var replies = loadedComments.filter(function (k) {
                  return k.AttachedToPostId === intId;
                }).filter(function (k) {
                  return k.DisplayUnderCommentId === comment.Id;
                });
                var renderedComment = _this35.RenderForumComment(forumStateKey, comment, isAnon, isFirstCommentInList, isLastCommentInList, replies);
                output += renderedComment;
              });
            } else {
              output = _this35.RenderForumComment(forumStateKey, levelOneRepliesToPost, isAnon);
            }
          }
          $('#comment-list-' + postId).html(output);
          $('.comment-has-replies').each(function (index, el) {
            var replyTrailLine = $(el).find('.reply-trail-line').first();
            var replyTrailLineTail = $(el).find('.reply-trail-line-tail').first();
            var commentContentDiv = $(el).siblings('div.forum-post-wrap.is-comment').find('div.frn-flex-row.column.review-box').first();
            var commentReplyListDiv = $(commentContentDiv).parent().find('div.reply-wrap').first();
            var commentHeight = commentContentDiv.prop('scrollHeight');
            var replyListHeight = commentReplyListDiv.prop('scrollHeight');
            replyTrailLine.css('height', 'calc((' + commentHeight + 'px / 2) + 15px)');
            replyTrailLineTail.css('height', 'calc((' + commentHeight + 'px / 2) + ' + replyListHeight + 'px + 12px)');
          });
          $('#comment-post-' + postId).show();
          if ($('#forum-items-container').length) {
            _this35.Lightbox.InitializeLBImages('forum-items-container');
          }
          if ($('div.inline-forum-template').length) {
            _this35.Lightbox.InitializeLBImages('inline-forum-template');
          }
          _this35.IgnitePopOverMenus();
        }
        resolve(true);
      });
    }
  }, {
    key: "UpdateReplyCounts",
    value: function UpdateReplyCounts(result) {
      if (result.ParentCommentId > 0 && $('#open-comment-reply-' + result.ParentCommentId).length) {
        if (result.ParentCommentReplies > 0) {
          if (result.ParentCommentReplies === 1) {
            $('#open-comment-reply-' + result.ParentCommentId).html(window.ONE_REPLY);
          } else if (result.ParentCommentReplies > 0) {
            $('#open-comment-reply-' + result.ParentCommentId).html(window.X_REPLIES.replace('{0}', result.ParentCommentReplies));
          }
        } else {
          $('#open-comment-reply-' + result.ParentCommentId).html(window.LEAVE_A_REPLY);
        }
      }
      if (result.ParentPostId > 0 && $('#open-post-comment-' + result.ParentPostId).length) {
        if (result.ParentPostReplies > 0) {
          if (result.ParentPostReplies === 1) {
            $('#open-post-comment-' + result.ParentPostId).html(window.ONE_REPLY);
          } else if (result.ParentPostReplies > 0) {
            $('#open-post-comment-' + result.ParentPostId).html(window.X_REPLIES.replace('{0}', result.ParentPostReplies));
          }
        } else {
          $('#open-post-comment-' + result.ParentPostId).html(window.LEAVE_A_REPLY);
        }
      }
    }
  }, {
    key: "Hash",
    value: function Hash(str) {
      var seed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var h1 = 0xdeadbeef ^ seed,
        h2 = 0x41c6ce57 ^ seed;
      for (var i = 0, ch; i < str.length; i++) {
        ch = str.charCodeAt(i);
        h1 = Math.imul(h1 ^ ch, 2654435761);
        h2 = Math.imul(h2 ^ ch, 1597334677);
      }
      h1 = Math.imul(h1 ^ h1 >>> 16, 2246822507) ^ Math.imul(h2 ^ h2 >>> 13, 3266489909);
      h2 = Math.imul(h2 ^ h2 >>> 16, 2246822507) ^ Math.imul(h1 ^ h1 >>> 13, 3266489909);
      return 4294967296 * (2097151 & h2) + (h1 >>> 0);
    }
  }, {
    key: "RoundNumberToTwoDecimalPlaces",
    value: function RoundNumberToTwoDecimalPlaces(num) {
      var number = Number(new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(num));
      return number;
    }
    // Function to find an object by ID
  }, {
    key: "FindObjectById",
    value: function FindObjectById(arr, id) {
      return $.grep(arr, function (item) {
        return item.id === id;
      })[0]; // [0] to return the first match
    }
  }, {
    key: "SortCommentByDate",
    value: function SortCommentByDate(filteredComments) {
      // Sort comments based on the CreatedAtString field

      filteredComments.sort(function (a, b) {
        if (isNaN(a.Id) || isNaN(a.Id)) {
          return 0; // Return 0 if one of the dates is invalid to keep original order
        }
        return a.Id - b.Id;
      });
    }
  }, {
    key: "PinPost",
    value: function PinPost(el, postId, state) {
      $(el).addClass('hide');
      $(el).siblings('.spinner-border-sm').removeClass('hide');
      setTimeout(function () {
        var progress = true;
        if (progress) {
          var formData = new FormData();
          if (postId != null && state != null) {
            formData.append('postid', postId);
            formData.append('state', state);
          }
          $.ajax({
            type: "POST",
            cache: false,
            processData: false,
            contentType: false,
            url: window.forumPinpostUrl,
            dataType: "json",
            data: formData,
            success: function success(data) {
              if (data.result.Success === true) {
                toastr.success(data.result.Message);
                window.SocialProfile.IgniteInlineForum(window.SocialProfile.TopicId, 0, 'discussion-counter', 0);
                return true;
              } else {
                toastr.error(data.result.Message);
                return false;
              }
            },
            error: function error(result) {
              return false;
            },
            failure: function failure() {
              return false;
            },
            complete: function complete() {
              $(el).removeClass('hide');
              $(el).siblings('.spinner-border-sm').addClass('hide');
            }
          });
        } else {}
      }, 50);
    }
  }, {
    key: "BringToAddOrEditCategory",
    value: function BringToAddOrEditCategory(categoryObj) {
      $('#dialog-add-category .has-danger').removeClass('has-danger');
      $('#submit-category-progress').hide();
      if (categoryObj !== undefined) {
        $('#category-title-input').val(categoryObj.title);
        $('#category-description-input').val(categoryObj.description);
        $('#category-weight-input').val(categoryObj.weight);
        $('#category-id').val(categoryObj.id);
      } else {
        $('#category-title-input').val('');
        $('#category-description-input').val('');
        $('#category-weight-input').val('');
        $('#category-id').val('');
      }
      $('#dialog-add-category').off('shown.bs.modal');
      $('#add-category-body').show();
      $('#dialog-add-category').modal('show');
    }
  }, {
    key: "SubmitForumCategory",
    value: function SubmitForumCategory() {
      var myThis = this;
      var title = $('#category-title-input').val();
      var description = $('#category-description-input').val();
      var weight = $('#category-weight-input').val();
      var id = $('#category-id').val();
      var validated = true;
      if (title === '') {
        $('#category-title-input').parent().addClass("has-danger");
        validated = false;
      }
      if (validated) {
        //;) {
        $('#submit-category-progress').show();

        // Create a new FormData object.
        var formData = new FormData();
        if (id != '' && id != undefined && id != null) {
          formData.append('CategoryId', id);
        }
        if (weight == '') 0, _readOnlyError("weight");
        formData.append('Name', title);
        formData.append('Description', description);
        formData.append('Weight', weight);
        $.ajax({
          type: "POST",
          cache: false,
          // ReSharper disable once UseOfImplicitGlobalInFunctionScope
          processData: false,
          contentType: false,
          url: '/api/forum/categories/submit',
          dataType: "json",
          data: formData,
          async: false,
          success: function success(result) {
            if (result.Success === true) {
              myThis.LoadCategories();
              $('#submit-category-progress').hide();
              $('#dialog-add-category').modal("hide");
              toastr.success("Category is submitted successfully");
              return true;
            } else {
              $('#submit-category-progress').hide();
              $('#dialog-add-category').modal("hide");
              toastr.error(result.Message);
              return false;
            }
          },
          error: function error(result) {
            $('#submit-category-progress').hide();
            alert("An error has occurred " + result.Message);
            return false;
          },
          failure: function failure() {
            $('#submit-category-progress').hide();
            alert("Network error");
            return false;
          }
        });
      }
    }
  }, {
    key: "BringToAddTopic",
    value: function BringToAddTopic(categoryId, containerId) {
      if (!categoryId) categoryId = this.CategoryId;
      this.CurrentInputState = {
        categoryId: categoryId,
        containerId: containerId
      };
      this.activeContainerId = containerId;
      $("#dialog-add-post #topic-title-input").show();
      $("#dialog-add-post #topic-title-input").val('');
      this.BringToPost(containerId);
    }
  }, {
    key: "BringToEditTopic",
    value: function BringToEditTopic(categoryId, topicObj) {
      if (!categoryId) categoryId = this.CategoryId;
      $('#dialog-add-topic .has-danger').removeClass('has-danger');
      $('#submit-topic-progress').hide();
      $('#dialog-add-topic').data('categoryId', categoryId);
      if (topicObj !== undefined) {
        $('#dialog-add-topic #topic-title-input').val(topicObj.title);
        $('#dialog-add-topic').data('topicId', topicObj.id);
      } else {
        $('#dialog-add-topic #topic-title-input').val('');
        $('#dialog-add-topic').data('topicId', '');
      }
      $('#dialog-add-topic').off('shown.bs.modal');
      $('#add-topic-body').show();
      $('#dialog-add-topic').modal('show');
    }
  }, {
    key: "SubmitForumTopic",
    value: function SubmitForumTopic() {
      var myThis = this;
      var title = $('#dialog-add-topic #topic-title-input').val();
      var categoryid = $('#dialog-add-topic').data('categoryId');
      var id = $('#dialog-add-topic').data('topicId');
      var validated = true;
      if (title === '') {
        $('#dialog-add-topic #topic-title-input').parent().addClass("has-danger");
        validated = false;
      }
      if (!categoryid) {
        alert("Invalid operation");
      }
      if (validated) {
        $('#submit-topic-progress').show();

        // Create a new FormData object.
        var formData = new FormData();
        formData.append('CategoryId', categoryid);
        if (id != null && id != undefined && id != '') {
          formData.append("TopicId", id);
        }
        formData.append('TopicTitle', title);
        $.ajax({
          type: "POST",
          cache: false,
          // ReSharper disable once UseOfImplicitGlobalInFunctionScope
          processData: false,
          contentType: false,
          url: '/api/forum/topics/submit',
          dataType: "json",
          data: formData,
          async: false,
          success: function success(result) {
            $('#submit-topic-progress').hide();
            $('#dialog-add-topic').modal("hide");
            if (result.Success === true) {
              myThis.LoadCategoryTopics(categoryid);
              toastr.success("Discussion is submitted successfully");
              return true;
            } else {
              toastr.error(result.Message);
              return false;
            }
          },
          error: function error(result) {
            $('#submit-topic-progress').hide();
            alert("An error has occurred " + result.Message);
            return false;
          },
          failure: function failure() {
            $('#submit-topic-progress').hide();
            alert("Network error");
            return false;
          }
        });
      }
    }
  }, {
    key: "InitForumPage",
    value: function InitForumPage() {
      var urlParam = new URLSearchParams(location.search);
      if (urlParam.has('category')) {
        this.InitForumCategoryPage(urlParam.get('category'));
      } else if (urlParam.has('discussion')) {
        var postId = urlParam.get('post');
        var commentId = urlParam.get('comment');
        if (postId === null) {
          postId = urlParam.get('postId');
        }
        if (commentId === null) {
          commentId = urlParam.get('commentId');
        }
        this.IgniteForumTopicPage(urlParam.get('discussion'), postId, commentId);
      } else {
        this.InitForumMainPage();
        $('.forum-page-description').hide();
      }
    }
  }, {
    key: "InitForumPageSkeleton",
    value: function InitForumPageSkeleton(pageType) {
      if (!pageType) {
        var urlParam = new URLSearchParams(location.search);
        if (urlParam.has('category')) {
          pageType = 'category';
        } else if (urlParam.has('discussion')) {
          pageType = 'discussion';
        } else {
          pageType = 'main';
        }
      }
      $("#forum-page-moderator-controls").hide();
      $("#forum-items-container").removeClass('category').removeClass('discussion').removeClass('main');
      $("#forum-items-container").addClass(pageType);
      if (pageType == 'main') {
        var containerHtml = window.forumTemplates['skeleton'] + window.forumTemplates['skeleton'] + window.forumTemplates['skeleton'] + window.forumTemplates['skeleton'];
        $("#forum-items-container").html(containerHtml);
        $("#forum-items-container-pager").html('');
        $("#forum-page-head-controls").html(window.forumTemplates['mainHeadSkeleton']);
      } else if (pageType == 'category') {
        var _containerHtml = window.forumTemplates['skeleton'] + window.forumTemplates['skeleton'] + window.forumTemplates['skeleton'] + window.forumTemplates['skeleton'];
        $("#forum-items-container").html(_containerHtml);
        $("#forum-items-container-pager").html('');
        $("#forum-page-head-controls").html(window.forumTemplates['categoryHeadSkeleton']);
      } else if (pageType == 'discussion') {
        var _containerHtml2 = window.forumTemplates['postItemSkeleton'] + window.forumTemplates['postItemSkeleton'] + window.forumTemplates['postItemSkeleton'] + window.forumTemplates['postItemSkeleton'];
        $("#forum-items-container").html(_containerHtml2);
        $("#forum-items-container-pager").html('');
        $("#forum-page-head-controls").html(window.forumTemplates['topicHeadSkeleton']);
      }
    }
  }, {
    key: "InitForumCategoryPage",
    value: function InitForumCategoryPage(categoryId) {
      this.InitForumPageSkeleton('category');
      this.CategoryId = categoryId;
      this.LoadCategoryTopics(categoryId);
      this.Lightbox.IgniteAddPostPhotoButton();
    }
  }, {
    key: "LoadCategoryTopics",
    value: function LoadCategoryTopics(categoryId) {
      var myThis = this;
      var container = $('#forum-items-container-pager').pagination({
        dataSource: '/api/forum/topics',
        locator: 'Topics.Data',
        pageSize: 25,
        pageRange: 1,
        autoHidePrevious: true,
        autoHideNext: true,
        className: 'paginationjs-small',
        totalNumberLocator: function totalNumberLocator(response) {
          return response.Topics.Count;
        },
        ajax: {
          data: {
            CategoryId: categoryId
          },
          traditional: true,
          type: 'POST'
        },
        formatAjaxError: function formatAjaxError(jqXHR, textStatus, errorThrown) {
          console.log('error', jqXHR, textStatus, errorThrown);
        },
        callback: function callback(data, pagination) {
          if (pagination.originalResponse.CanModerate == true) {
            myThis.moderator = true;
          }
          var html = '<a class="breadcrumb-item" href="/">Home</a>';
          html += '<a class="breadcrumb-item forum-navigation-link" href="/forum">Forums</a>';
          html += '<span class="breadcrumb-item">' + pagination.originalResponse.CategoryName + '</span>';
          $("#site-breadcrumb").html(html);
          myThis.InitForumCategoryPageHeadControls(pagination.originalResponse, categoryId, 'forum-items-container');
          $("#forum-items-container-pager-top").html('');
          $("#forum-items-container-pager-top").append($('#forum-items-container-pager .paginationjs').clone(true));
          $("#forum-items-container").html('');
          for (var i = 0; i < data.length; i++) {
            var _topic$Replies, _topic$NumParticipant;
            var topic = data[i];
            var template = window.forumTemplates['topicItem'];
            template = template.replace(/{{ForumItemId}}/g, topic.Id);
            template = template.replace("{{ForumItemTitle}}", topic.Title);
            var createdBy = 'Created: ';
            var creationDate = moment.utc(topic.CreationDate).format("MMM DD,YYYY");
            createdBy += creationDate;
            template = template.replace("{{ForumItemTopicStarter}}", createdBy);
            var repliesStr = window.forumStrings['_0Replies'].replace("{0}", (_topic$Replies = topic.Replies) !== null && _topic$Replies !== void 0 ? _topic$Replies : 0);
            template = template.replace("{{ForumItemReplies}}", repliesStr);
            var participantsStr = window.forumStrings['_0Participants'].replace("{0}", (_topic$NumParticipant = topic.NumParticipants) !== null && _topic$NumParticipant !== void 0 ? _topic$NumParticipant : 0);
            template = template.replace("{{ForumItemParticipants}}", participantsStr);
            template = template.replace("{{ForumItemLastPostBy}}", topic.LastPostBy || '');
            template = template.replace("{{ForumItemLastPostBySocialId}}", topic.LastPostBySocialProfileId);
            if (topic.LastPostBy) {
              var myDate = moment.duration(moment.utc(topic.LastUpdateDate).diff(moment().utc())).humanize(true);
              template = template.replace(/{{ForumItemLastPostAt}}/g, myDate);
            } else {
              template = template.replace(/{{ForumItemLastPostAt}}/g, '');
            }
            if (topic.ViewerCanEdit == true) {
              var menuHtml = "<ul class=\"dropdown-menu forum-item-moderation-menu\">";
              menuHtml = menuHtml + "<li onclick=\"window.SocialProfile.EditTopic(".concat(topic.Id, ")\">Edit</li>");
              if (!topic.InlineEntity) {
                menuHtml = menuHtml + "<li onclick=\"window.SocialProfile.DeleteTopic(".concat(topic.Id, ")\">Delete</li>");
              }
              if (!topic.InlineEntity && window.SocialProfile.moderator) {
                menuHtml = menuHtml + "<li onclick=\"window.SocialProfile.CurtailUserActivity(".concat(topic.SocialProfileId, ")\">Ban user</li>");
                menuHtml = menuHtml + "<li onclick=\"window.SocialProfile.RemoveUserActivity(".concat(topic.SocialProfileId, ")\">Scrub user activity</li>");
                menuHtml = menuHtml + "<li onclick=\"window.SocialProfile.ManageProbation(".concat(topic.SocialProfileId, ")\">Manage probation</li>");
              }
              menuHtml += "</ul>";
              var moderatorControlsHtml = "<div><a data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" data-topicid=\"".concat(topic.Id, "\"><img src='/Content/dist/images/icons/3dots.svg'/></a>").concat(menuHtml, "</div>");
              template = template.replace("{{ForumItemModeratorControls}}", moderatorControlsHtml);
            } else {
              template = template.replace("{{ForumItemModeratorControls}}", '');
            }
            var itemDiv = $(template);
            if (!topic.LastPostBy) {
              itemDiv.find('.last-post-data').remove();
            }
            $("#forum-items-container").append(itemDiv);
          }
          $('.forum-page-description').hide();
        }
      });
    }
  }, {
    key: "InitForumMainPageHomeControls",
    value: function InitForumMainPageHomeControls() {
      var headHtml = window.forumTemplates['headControls'];
      $("#forum-page-head-controls").html(headHtml);
      $("#forum-page-head-controls #forum-page-title").html(window.forumStrings['CommunityForums']);
      $("title").html(window.forumStrings['CommunityForums']);
      $("#forum-page-head-controls #forum-page-controls").html("");
    }
  }, {
    key: "InitForumMainPage",
    value: function InitForumMainPage() {
      this.InitForumPageSkeleton('main');
      var html = '<a class="breadcrumb-item" href="/">Home</a>';
      html += '<span class="breadcrumb-item">Forums</span>';
      $("#site-breadcrumb").html(html);
      this.InitForumMainPageHomeControls();
      this.LoadCategories();
    }
  }, {
    key: "LoadCategories",
    value: function LoadCategories() {
      var myThis = this;
      $.ajax({
        url: '/api/forum/categories',
        type: 'POST',
        cache: false,
        success: function success(result) {
          // ReSharper disable once UseOfImplicitGlobalInFunctionScope

          if (!result.Success) {
            console.error(result.Message);
            return;
          }
          if (result.CanModerate == true) {
            myThis.moderator = true;
            $("#forum-page-head-controls #forum-page-moderator-controls").html("<a id=\"add-category-button\" style=\"\" href=\"javascript:void(0)\" onclick=\"window.SocialProfile.AddCategory()\" role=\"button\" class=\"waves-effect frn-button medium navy navy-border-no-hover curved\">\n                                Add Category\n                            </a>");
            $('#forum-page-moderator-controls').show();
          }
          $("#forum-items-container").html('');
          for (var i = 0; i < result.Categories.length; i++) {
            var _category$Replies, _category$NumParticip;
            var category = result.Categories[i];
            var template = window.forumTemplates['categoryItem'];
            template = template.replace(/{{ForumItemId}}/g, category.CategoryId);
            template = template.replace(/{{ForumItemWeight}}/g, category.Weight);
            template = template.replace("{{ForumItemTitle}}", category.Name);
            template = template.replace("{{ForumItemDescription}}", category.Description);
            var repliesStr = window.forumStrings['_0Replies'].replace("{0}", (_category$Replies = category.Replies) !== null && _category$Replies !== void 0 ? _category$Replies : 0);
            template = template.replace("{{ForumItemReplies}}", repliesStr);
            var participantsStr = window.forumStrings['_0Participants'].replace("{0}", (_category$NumParticip = category.NumParticipants) !== null && _category$NumParticip !== void 0 ? _category$NumParticip : 0);
            template = template.replace("{{ForumItemParticipants}}", participantsStr);
            if (category.LastPostBy) {
              template = template.replace("{{ForumItemLastPostBy}}", category.LastPostBy);
              template = template.replace("{{ForumItemLastPostBySocialId}}", category.LastPostBySocialProfileId);
              var myDate = moment.duration(moment.utc(category.LastPostAt).diff(moment().utc())).humanize(true);
              template = template.replace(/{{ForumItemLastPostAt}}/g, myDate);
            } else {
              template = template.replace("{{ForumItemLastPostBy}}", '');
              template = template.replace("{{ForumItemLastPostBySocialId}}", '');
              template = template.replace(/{{ForumItemLastPostAt}}/g, '');
            }
            if (result.CanModerate == true) {
              var menuHtml = "<ul class=\"dropdown-menu forum-item-moderation-menu\">";
              menuHtml = menuHtml + "<li onclick=\"window.SocialProfile.EditCategory(".concat(category.CategoryId, ")\">Edit</li>");
              if (!category.EntityType) {
                menuHtml = menuHtml + "<li onclick=\"window.SocialProfile.DeleteCategory(".concat(category.CategoryId, ")\">Delete</li>");
              }
              menuHtml += "</ul>";
              var moderatorControlsHtml = "<div><a data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" data-categoryid=\"".concat(category.CategoryId, "\"><img src='/Content/dist/images/icons/3dots.svg'/></a>").concat(menuHtml, "</div>");
              template = template.replace("{{ForumItemModeratorControls}}", moderatorControlsHtml);
            } else {
              template = template.replace("{{ForumItemModeratorControls}}", '');
            }
            var itemDiv = $(template);
            if (!category.LastPostBy) {
              itemDiv.find('.last-post-data').remove();
            }
            $("#forum-items-container").append(itemDiv);
          }
        },
        error: function error(result) {
          // ReSharper disable once UseOfImplicitGlobalInFunctionScope

          alert("there was an error");
        }
      });
    }
  }, {
    key: "InitForumTopicPage",
    value: function InitForumTopicPage(topicId) {
      var _this36 = this;
      var jumpToPostId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var jumpToCommentId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var containerId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'forum-items-container';
      var myThis = this;
      this.InitForumPageSkeleton('discussion');
      var jumpTo = parseInt(jumpToPostId, 10);
      var jumpToC = parseInt(jumpToCommentId, 10);
      if (parseInt(topicId, 10) > 0) {
        var data = {
          TopicId: topicId,
          RenderPagination: true,
          JumpToPostId: jumpTo,
          ContainerId: containerId
        };
        $.ajax({
          type: "POST",
          cache: false,
          // ReSharper disable once UseOfImplicitGlobalInFunctionScope
          url: loadInlineTopicUrl,
          dataType: "json",
          data: data,
          success: function success(result) {
            if (result != null) {
              if (result.Success) {
                _this36.moderator = result.Moderate === true;
                var html = '<a class="breadcrumb-item" href="/">Home</a>';
                html += '<a class="breadcrumb-item forum-navigation-link" href="/forum">Forums</a>';
                html += '<a class="breadcrumb-item forum-navigation-link" href="/forum?category=' + result.reviewModel.CategoryId + '">' + result.reviewModel.CategoryName + '</a>';
                html += '<span class="breadcrumb-item">' + result.reviewModel.TopicTitle + '</span>';
                $("#site-breadcrumb").html(html);
                myThis.InitForumTopicPageHeadControls(result);
                _this36.AddState(containerId, result, "".concat(containerId, "-pager"), 'InlineForum', result.reviewModel.TopicId);
                myThis.ProcessInlineForumData(jumpToPostId, jumpToC, containerId);
                window.Tracker.RecordSocialActivity({
                  'Topic': topicId
                });
                var el = document.getElementById('forum-page-head-controls');
                if (isNaN(jumpTo) && isNaN(jumpToC)) {
                  el.scrollIntoView({
                    block: "start",
                    behavior: 'smooth'
                  });
                }
              } else {
                toastr.error(result.Message);
                _this36.InitForumMainPage();
              }
            }
          },
          error: function error(result) {}
        });
      }
    }
  }, {
    key: "InitForumCategoryPageHeadControls",
    value: function InitForumCategoryPageHeadControls(result, categoryId, containerId) {
      if ($("#forum-page-controls").length == 0) {
        var headHtml = window.forumTemplates['headControls'];
        $("#forum-page-head-controls").html(headHtml);
        $("#forum-page-head-controls #forum-page-title").html(result.CategoryName);
        $('title').html(result.CategoryName);
        $("#forum-page-head-controls #forum-page-controls").html("<div class=\"topic-head-buttons\">\n                        <a id=\"add-topic-button\" style=\"\" href=\"javascript:void(0)\" onclick=\"window.SocialProfile.AddTopic(".concat(categoryId, ", '").concat(containerId, "')\" role=\"button\" class=\"waves-effect frn-button medium navy navy-border-no-hover curved\">\n                            <img class=\"ml-1 mr-1\" src=\"/Content/dist/images/icons/new-message-icon.svg\" />Create Thread\n                        </a>\n                    </div>\n                    "));
      }
    }
  }, {
    key: "InitForumTopicPageHeadControls",
    value: function InitForumTopicPageHeadControls(result) {
      var _result$reviewModel, _result$reviewModel2;
      var headHtml = window.forumTemplates['headControls'];
      $("#forum-page-head-controls").html(headHtml);
      $("#forum-page-head-controls #forum-page-title").html((_result$reviewModel = result.reviewModel) === null || _result$reviewModel === void 0 ? void 0 : _result$reviewModel.TopicTitle);
      $('title').html((_result$reviewModel2 = result.reviewModel) === null || _result$reviewModel2 === void 0 ? void 0 : _result$reviewModel2.TopicTitle);
      var controlHtml = '<div class="topic-head-description d-flex flex-column" style="gap: 8px;">';
      if (result.reviewModel && result.reviewModel.LastPostBySocialProfileId > 0) {
        var topicTitle = result.reviewModel.TopicTitle;
        if (topicTitle === null || topicTitle === undefined) {
          topicTitle = '';
        }
        controlHtml += this.InitForumTopicMetaControl(result.reviewModel.TopicCreatedAt, result.reviewModel.TotalPostAndReplies, result.reviewModel.NumParticipants, result.reviewModel.TopicId, topicTitle);
      }
      if (this.IsMasquerade != true) {
        controlHtml += "<div class=\"topic-head-buttons\">\n                    <a id=\"add-post-button\" style=\"\" href=\"javascript:void(0)\" onclick=\"window.SocialProfile.AddPost('forum-items-container')\" role=\"button\" class=\"waves-effect frn-button medium navy navy-border-no-hover curved\">\n                        ".concat(window.ADD_A_POST, "\n                    </a>\n                    <a id=\"subscribe-button\" style=\"\" href=\"javascript:void(0)\" onclick=\"window.SocialProfile.SubscribeToDiscussion('forum-items-container')\" role=\"button\" class=\"waves-effect frn-button medium transparent navy-border curved\">\n                        ").concat(window.SUBSCRIBE_TO_THIS_DISCUSSION, "\n                    </a>\n                </div>");
      }
      controlHtml += "</div>";
      $("#forum-page-topic-page-head-controls").html(controlHtml);
      switch (result.reviewModel.EntityType) {
        case window.ENTITY_TYPE_SOCIAL_PROFILE_PAGE:
          var entitylink = "<a href=\"javascript:void(0)\" class=\"social-profile-navigate\" data-profile-id=\"".concat(result.reviewModel.TopicOwnerId, "\">").concat(result.reviewModel.TopicOwner, "</a>");
          var description = window.FORUM_ENTITY_TYPE_SOCIAL_PROFILE_PAGE_DESCRIPTION.replace("{0}", entitylink);
          var avatar = '';
          if (result.reviewModel.TopicOwnerAvatar !== null && result.reviewModel.TopicOwnerAvatar !== undefined) {
            avatar = "<img class=\"social-profile-navigate\" src=\"".concat(this.avatarPath).concat(result.reviewModel.TopicOwnerAvatar, "?w=136&h=136\" style=\"border-radius:50%\" data-profile-id=\"").concat(result.reviewModel.TopicOwnerId, "\">");
          }
          $('#forum-page-description').html(description);
          $('#forum-page-avatar').html(avatar);
          break;
        case window.ENTITY_TYPE_CONTEST_PAGE:
          entitylink = "<a href=\"javascript:void(0)\" class=\"contest-navigate\" data-contest-id=\"".concat(result.reviewModel.EntityId, "\">").concat(result.reviewModel.EntityTitle, "</a>");
          var contest_description = window.FORUM_ENTITY_TYPE_CONTEST_PAGE_DESCRIPTION.replace("{0}", entitylink);
          var contest_logo = '';
          if (result.reviewModel.EntityId !== null && result.reviewModel.EntityId !== undefined) {
            contest_logo = "<img class=\"contest-navigate\" src=\"/content/dist/contests/images/".concat(result.reviewModel.EntityId, "?w=136&h=136\" style=\"border-radius:50%\" data-contest-id=\"").concat(result.reviewModel.EntityId, "\">");
          }
          $('#forum-page-description').html(contest_description);
          $('#forum-page-avatar').html(contest_logo);
          break;
        case window.ENTITY_TYPE_NEWS_PAGE:
          entitylink = "<a href=\"javascript:void(0)\" class=\"news-navigate\" data-news-id=\"".concat(result.reviewModel.EntityId, "\">").concat(result.reviewModel.EntityTitle, "</a>");
          var news_description = window.FORUM_ENTITY_TYPE_NEWS_PAGE_DESCRIPTION.replace("{0}", entitylink);
          var news_logo = '';
          if (result.reviewModel.EntityId !== null && result.reviewModel.EntityId !== undefined && result.reviewModel.EntityThumb !== null && result.reviewModel.EntityThumb !== undefined && result.reviewModel.EntityThumb !== '') {
            news_logo = "<img class=\"news-navigate\" src=\"".concat(this.newsImagePath, "?imageUrl=").concat(result.reviewModel.EntityThumb, "&w=136&h=136\" style=\"border-radius:50%\" data-contest-id=\"").concat(result.reviewModel.EntityId, "\">");
          }
          $('#forum-page-description').html(news_description);
          $('#forum-page-avatar').html(news_logo);
          break;
        case window.ENTITY_TYPE_STATS_PAGE:
          entitylink = "<a href=\"javascript:void(0)\" class=\"stats-navigate\" data-stats-id=\"".concat(result.reviewModel.EntityId, "\">").concat(result.reviewModel.EntityId, "</a>");
          var stats_description = "";
          var stats_logo = '';
          if (result.reviewModel.EntityId !== null && result.reviewModel.EntityId !== undefined) {
            stats_description = window.FORUM_ENTITY_TYPE_STATS_PAGE_DESCRIPTION.replace("{0}", entitylink);
            stats_logo = "<img class=\"stats-navigate\" src=\"/content/dist/performance/images/chart.png?w=136&h=136\" style=\"border-radius:50%\" data-stats-id=\"".concat(result.reviewModel.EntityId, "\">");
          }
          $('#forum-page-description').html(stats_description);
          $('#forum-page-avatar').html(stats_logo);
          break;
        case window.ENTITY_TYPE_BROKER_VIEW:
        case window.ENTITY_TYPE_BROKER_REBATE_PROGRAM:
        case window.ENTITY_TYPE_BROKER_CRYPTO_EXCHANGE:
        case window.ENTITY_TYPE_BROKER_PROP_FIRM:
          var brokerLink = "<a href=\"javascript:void(0)\" class=\"thread-navigate\" data-thread-id=\"".concat(result.reviewModel.TopicId, "\">").concat(result.reviewModel.EntityTitle, "</a>");
          var company_description = "";
          var company_logo = '';
          if (result.reviewModel.EntityId !== null && result.reviewModel.EntityId !== undefined) {
            if (result.reviewModel.EntityTitle !== null && result.reviewModel.EntityTitle !== undefined) {
              company_description = window.FORUM_ENTITY_TYPE_COMPANY_PAGE_DESCRIPTION.replace("{0}", brokerLink);
            }
            company_logo = "<img class=\"thread-navigate\" src=\"/content/dist/company/images/".concat(result.reviewModel.EntityId, "/company_logo.png?w=136&h=136\" style=\"border-radius:50%\" data-thread-id=\"").concat(result.reviewModel.TopicId, "\">");
          }
          $('#forum-page-description').html(company_description);
          $('#forum-page-avatar').html(company_logo);
          break;
      }
    }
  }, {
    key: "InitForumTopicMetaControl",
    value: function InitForumTopicMetaControl(topicCreatedAt, replies, participants, topicId) {
      var topicTitle = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
      var myDate = moment.utc(topicCreatedAt);
      var repliesStr = window.forumStrings['_0Replies'].replace("{0}", replies);
      var participantsStr = window.forumStrings['_0Participants'].replace("{0}", participants);
      if ($('#topic-headline').length) {
        if (topicTitle !== '') {
          $('#topic-headline').html(topicTitle);
        }
      }
      return "<div id=\"topic-meta-information\" class=\"topic-meta-information\">\n                        <span>Created: ".concat(myDate.format('LL'), "</span>\n                        <div class=\"d-flex\" style=\"gap: 16px\">\n                            <div class=\"d-flex align-items-center\" style=\"gap: 4px;\"><i class=\"reply-to-post icon\"></i><span class=\"topic-").concat(topicId, "-replies\">").concat(repliesStr, "</span></div>\n                            <div class=\"d-flex align-items-center\" style=\"gap: 4px;\"><i class=\"participants-in-thread icon\"></i><span class=\"topic-").concat(topicId, "-participants\">").concat(participantsStr, "</span></div>\n                        </div>\n                        \n                        \n                    </div>");
    }
  }, {
    key: "removeDraftListenerForEditor",
    value: function removeDraftListenerForEditor() {
      var editorSelector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'post-input-editor';
      console.log("removing draft recorder for ".concat(editorSelector));
      var editor = document.getElementById(editorSelector);
      editor.removeEventListener('input', this._draftListener);
      return editor;
    }
  }, {
    key: "initiateDraftForEditor",
    value: function () {
      var _initiateDraftForEditor = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14() {
        var _this37 = this;
        var editorSelector,
          containerId,
          draftKey,
          editor,
          _args14 = arguments;
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.n) {
            case 0:
              editorSelector = _args14.length > 0 && _args14[0] !== undefined ? _args14[0] : 'post-input-editor';
              containerId = _args14.length > 1 ? _args14[1] : undefined;
              draftKey = _args14.length > 2 ? _args14[2] : undefined;
              editor = this.removeDraftListenerForEditor(editorSelector);
              this._draftListener = debounce(function () {
                // Extract + store draft
                var draftContent = _this37.ExtractEditorContent(editorSelector);
                var draft = {
                  body: draftContent,
                  imageRefs: window.Lightbox.getCurrentImageRefs(),
                  containerId: containerId
                };
                localStorage.setItem(draftKey, JSON.stringify(draft));
              }, 300);
              editor.addEventListener('input', this._draftListener);
              console.log("the ".concat(editorSelector, " editor is recording a draft"));
            case 1:
              return _context14.a(2);
          }
        }, _callee14, this);
      }));
      function initiateDraftForEditor() {
        return _initiateDraftForEditor.apply(this, arguments);
      }
      return initiateDraftForEditor;
    }()
  }, {
    key: "initiateTaggingForEditor",
    value: function () {
      var _initiateTaggingForEditor = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15() {
        var _this38 = this;
        var editorSelector,
          _yield$import3,
          TagHandler,
          _yield$import4,
          fetchTagsDebounced,
          editorEl,
          _args15 = arguments;
        return _regenerator().w(function (_context15) {
          while (1) switch (_context15.n) {
            case 0:
              editorSelector = _args15.length > 0 && _args15[0] !== undefined ? _args15[0] : '#post-input-editor';
              if (!(!this._TagHandlerClass || !this.fetchTagsDebounced)) {
                _context15.n = 3;
                break;
              }
              _context15.n = 1;
              return Promise.resolve().then(function () {
                return _interopRequireWildcard(require('./SocialProfile/ForumTagging/TagHandler.v6.js'));
              });
            case 1:
              _yield$import3 = _context15.v;
              TagHandler = _yield$import3["default"];
              _context15.n = 2;
              return Promise.resolve().then(function () {
                return _interopRequireWildcard(require('./SocialProfile/ForumTagging/TagFetcher.v2.js'));
              });
            case 2:
              _yield$import4 = _context15.v;
              fetchTagsDebounced = _yield$import4.fetchTagsDebounced;
              this._TagHandlerClass = TagHandler;
              this.fetchTagsDebounced = fetchTagsDebounced;
            case 3:
              if (this._EditorSecurity) {
                _context15.n = 5;
                break;
              }
              _context15.n = 4;
              return Promise.resolve().then(function () {
                return _interopRequireWildcard(require('./SocialProfile/ForumTagging/EditorSecurity.v1.js'));
              });
            case 4:
              this._EditorSecurity = _context15.v;
            case 5:
              editorEl = document.querySelector(editorSelector);
              if (editorEl) {
                //remove duplicate paste handlers
                this._EditorSecurity.removePasteEventHandler(editorEl);
                // Idempotent hardening — safe to call multiple times
                this._EditorSecurity.secureEditor(editorEl);
              }

              // Create a new handler bound to the current editor
              this.tagHandler = new this._TagHandlerClass(editorSelector, function (prefix) {
                return new Promise(function (resolve) {
                  _this38.fetchTagsDebounced(prefix, resolve);
                });
              });
            case 6:
              return _context15.a(2);
          }
        }, _callee15, this);
      }));
      function initiateTaggingForEditor() {
        return _initiateTaggingForEditor.apply(this, arguments);
      }
      return initiateTaggingForEditor;
    }()
  }, {
    key: "attachMentionPopoversLazy",
    value: function () {
      var _attachMentionPopoversLazy = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16() {
        var root,
          _yield$import5,
          initMentionPopovers,
          _args16 = arguments;
        return _regenerator().w(function (_context16) {
          while (1) switch (_context16.n) {
            case 0:
              root = _args16.length > 0 && _args16[0] !== undefined ? _args16[0] : document;
              if (this._initMentionPopovers) {
                _context16.n = 2;
                break;
              }
              _context16.n = 1;
              return Promise.resolve().then(function () {
                return _interopRequireWildcard(require('./SocialProfile/ForumTagging/MentionPopOver.v1.js'));
              });
            case 1:
              _yield$import5 = _context16.v;
              initMentionPopovers = _yield$import5["default"];
              this._initMentionPopovers = initMentionPopovers;
            case 2:
              this._mentionPopoverApi = this._initMentionPopovers(root, {
                apiBase: '/api/social-profiles'
              });
            case 3:
              return _context16.a(2);
          }
        }, _callee16, this);
      }));
      function attachMentionPopoversLazy() {
        return _attachMentionPopoversLazy.apply(this, arguments);
      }
      return attachMentionPopoversLazy;
    }()
  }]);
}();
var _default = exports["default"] = SocialProfile;

},{"./SocialProfile/BrokerReview/Controller.js":6,"./SocialProfile/BrokerReview/Templates/ReviewForProfileFeed.js":20,"./SocialProfile/BrokerReview/Utilities/ProcessBrokerReviewFeedData.js":26,"./SocialProfile/ForumTagging/EditorSecurity.v1.js":27,"./SocialProfile/ForumTagging/MentionPopOver.v1.js":28,"./SocialProfile/ForumTagging/TagFetcher.v2.js":30,"./SocialProfile/ForumTagging/TagHandler.v6.js":31}],30:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchTagsDebounced = fetchTagsDebounced;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var timer;
function fetchTagsDebounced(prefix, callback) {
  clearTimeout(timer);
  timer = setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var res, users;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.n = 1;
          return fetch("/api/forum/users/autocomplete?prefix=".concat(encodeURIComponent(prefix)));
        case 1:
          res = _context.v;
          _context.n = 2;
          return res.json();
        case 2:
          users = _context.v;
          callback(users);
        case 3:
          return _context.a(2);
      }
    }, _callee);
  })), 300);
}

},{}],27:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hardenDnD = hardenDnD;
exports.hardenPaste = hardenPaste;
exports.removePasteEventHandler = removePasteEventHandler;
exports.sanitizeToMentionsOnly = sanitizeToMentionsOnly;
exports.secureEditor = secureEditor;
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
// EditorSecurity.v1.js
function hardenDnD(editor) {
  var stop = function stop(e) {
    e.preventDefault();
    e.stopPropagation();
  };
  editor.addEventListener('dragenter', stop);
  editor.addEventListener('dragover', stop);
  editor.addEventListener('dragleave', stop);
  editor.addEventListener('drop', stop);
}
function handlePaste(e) {
  e.preventDefault();
  var text = (e.clipboardData || window.clipboardData).getData('text/plain');
  if (!text) return;
  if (document.queryCommandSupported && document.queryCommandSupported('insertText')) {
    document.execCommand('insertText', false, text);
  } else {
    var sel = window.getSelection();
    if (!sel || !sel.rangeCount) return;
    var range = sel.getRangeAt(0);
    range.deleteContents();
    range.insertNode(document.createTextNode(text));
    sel.collapseToEnd();
  }
}
function hardenPaste(editor) {
  editor.addEventListener('paste', handlePaste);
}
function removePasteEventHandler(editor) {
  editor.removeEventListener("paste", handlePaste);
}

// Only keep <mention> (with attrs: user-id, handle, class) and text (optionally <br>)
function sanitizeToMentionsOnly(html) {
  if (!html) return '';
  var parser = new DOMParser();
  var doc = parser.parseFromString("<div>".concat(html, "</div>"), 'text/html');
  var root = doc.body.firstChild;
  var allowedAttr = new Set(['user-id', 'handle', 'class']);
  function clean(node) {
    if (node.nodeType === Node.TEXT_NODE) return;
    if (node.nodeType === Node.ELEMENT_NODE) {
      var tag = node.nodeName.toLowerCase();
      if (tag === 'mention') {
        _toConsumableArray(node.attributes).forEach(function (a) {
          if (!allowedAttr.has(a.name.toLowerCase())) node.removeAttribute(a.name);
        });
        node.setAttribute('contenteditable', 'false');
        var handle = (node.getAttribute('handle') || '').trim();
        // Force leading '@' in attribute
        if (handle && !handle.startsWith('@')) {
          handle = '@' + handle;
          node.setAttribute('handle', handle);
        }
        var txt = (node.textContent || '').trim();
        // Force visible text to equal attribute (with '@')
        if (handle && txt !== handle) {
          node.textContent = handle;
        }
      } else if (tag === 'br') {
        // optional: allow line breaks; otherwise replace like others
      } else {
        var text = doc.createTextNode(node.textContent || '');
        node.parentNode.replaceChild(text, node);
        return; // replaced, stop recursion on this branch
      }
    }
    Array.from(node.childNodes).forEach(clean);
  }
  clean(root);
  return root.innerHTML;
}
function secureEditor(editor) {
  hardenDnD(editor);
  hardenPaste(editor);
  return editor;
}

},{}],28:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = initMentionPopovers;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
// MentionPopover.v1.js
// Default export: initMentionPopovers(root?, options?) -> { destroy(), preload(userId) }

var CACHE = new Map(); // userId -> mini-profile json
var popoverEl = null;
var currentAnchor = null;
function createPopover() {
  var el = document.createElement('div');
  el.className = 'mention-popover';
  el.setAttribute('role', 'dialog');
  el.setAttribute('aria-modal', 'false');
  el.style.position = 'fixed';
  el.style.display = 'none';
  el.innerHTML = "\n    <div class=\"mp-card\">\n      <div class=\"mp-head\">\n        <img class=\"mp-avatar\" alt=\"\">\n        <div class=\"mp-id\">\n            <div class=\"mp-name\"></div>\n            <div class=\"mp-handle\"></div>\n            \n   \n        </div>\n      </div>\n      <div class=\"mp-bio\"></div>\n      <div class=\"social-profile-since-info\">\n        <span class=\"mp-location info-item\"></span>\n        <span class=\"mp-joined info-item\"></span>\n      </div>\n      <div class=\"mp-stats\"></div>\n      <div class=\"mp-actions\">\n        <a class=\"mp-view\" href=\"#\" rel=\"noopener\">View profile</a>\n      </div>\n    </div>\n  ";
  document.body.appendChild(el);
  return el;
}
function fetchMini(_x, _x2) {
  return _fetchMini.apply(this, arguments);
}
function _fetchMini() {
  _fetchMini = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(userId, apiBase) {
    var res, data;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          if (!CACHE.has(userId)) {
            _context.n = 1;
            break;
          }
          return _context.a(2, CACHE.get(userId));
        case 1:
          _context.n = 2;
          return fetch("".concat(apiBase, "/").concat(encodeURIComponent(userId), "/mini"), {
            credentials: 'same-origin'
          });
        case 2:
          res = _context.v;
          if (res.ok) {
            _context.n = 3;
            break;
          }
          throw new Error("Mini fetch failed: ".concat(res.status));
        case 3:
          _context.n = 4;
          return res.json();
        case 4:
          data = _context.v;
          CACHE.set(userId, data);
          return _context.a(2, data);
      }
    }, _callee);
  }));
  return _fetchMini.apply(this, arguments);
}
function renderPopover(data) {
  var _data$Posts, _data$Comments;
  var langSlug = "";
  if (window.CURRENT_LANG !== window.DEFAULT_LANG) {
    langSlug = "/" + CURRENT_LANG;
  }
  var img = popoverEl.querySelector('.mp-avatar');
  var name = popoverEl.querySelector('.mp-name');
  var handle = popoverEl.querySelector('.mp-handle');
  var bio = popoverEl.querySelector('.mp-bio');
  var stats = popoverEl.querySelector('.mp-stats');
  var link = popoverEl.querySelector('.mp-view');
  var location = popoverEl.querySelector('.mp-location');
  var joined = popoverEl.querySelector('.mp-joined');
  img.src = "".concat(window.assetServer, "/assets/images/profiles/").concat(data.AvatarUrl);
  img.alt = "".concat(data.Handle || data.DisplayName, "'s avatar");
  name.textContent = data.DisplayName || '';
  handle.textContent = data.Handle || '';
  bio.textContent = (data.Bio || '').trim();
  stats.textContent = "Posts: ".concat((_data$Posts = data.Posts) !== null && _data$Posts !== void 0 ? _data$Posts : 0, " \xB7 Comments: ").concat((_data$Comments = data.Comments) !== null && _data$Comments !== void 0 ? _data$Comments : 0);
  link.href = data.ProfileUrl || '#';
  location.textContent = data.Country ? "".concat(window.LOCATION, ": ").concat(data.Country) : '';
  if (data.JoinedDateString) {
    var joinedDate = moment.utc(data.JoinedDateString);
    joined.textContent = "".concat(window.JOINED, " ").concat(joinedDate.fromNow());
  } else {
    joined.textContent = '';
  }
}
function positionPopover(anchor) {
  var rect = anchor.getBoundingClientRect();
  var pw = 300;
  var ph = popoverEl.offsetHeight || 180;
  var top = rect.bottom + 8;
  var left = rect.left;
  var vw = window.innerWidth;
  if (left + pw > vw - 8) left = Math.max(8, vw - pw - 8);
  var vh = window.innerHeight;
  if (top + ph > vh - 8) top = Math.max(8, rect.top - ph - 8);
  popoverEl.style.top = "".concat(Math.round(top), "px");
  popoverEl.style.left = "".concat(Math.round(left), "px");
}
function showPopover(anchor) {
  currentAnchor = anchor;
  popoverEl.style.display = 'block';
  positionPopover(anchor);
}
function hidePopover() {
  if (!popoverEl) return;
  popoverEl.style.display = 'none';
  currentAnchor = null;
}
function isMention(el) {
  var _el$matches;
  return !!el && ((_el$matches = el.matches) === null || _el$matches === void 0 ? void 0 : _el$matches.call(el, 'mention.forum-mention, .forum-mention[handle][user-id]'));
}
function getUserIdFrom(el) {
  return el.getAttribute('user-id');
}
function initMentionPopovers() {
  var root = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$apiBase = _ref.apiBase,
    apiBase = _ref$apiBase === void 0 ? '/api/social-profiles' : _ref$apiBase;
  if (!popoverEl) popoverEl = createPopover();
  var onDocClick = function onDocClick(e) {
    var _e$target$closest, _e$target;
    var target = (_e$target$closest = (_e$target = e.target).closest) === null || _e$target$closest === void 0 ? void 0 : _e$target$closest.call(_e$target, 'mention.forum-mention, .forum-mention');
    if (isMention(target)) {
      e.preventDefault();
      var userId = getUserIdFrom(target);
      if (!userId) return;
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '0');
      popoverEl.querySelector('.mp-name').textContent = 'Loading…';
      popoverEl.querySelector('.mp-handle').textContent = '';
      popoverEl.querySelector('.mp-bio').textContent = '';
      popoverEl.querySelector('.mp-stats').textContent = '';
      popoverEl.querySelector('.mp-view').href = '#';
      showPopover(target);
      fetchMini(userId, apiBase).then(function (data) {
        renderPopover(data);
        positionPopover(target);
      })["catch"](function () {
        popoverEl.querySelector('.mp-name').textContent = 'Unavailable';
        popoverEl.querySelector('.mp-bio').textContent = 'Could not load profile.';
      });
      return;
    }
    if (!popoverEl.contains(e.target)) hidePopover();
  };
  var onKey = function onKey(e) {
    if (e.key === 'Escape') hidePopover();
    if ((e.key === 'Enter' || e.key === ' ') && isMention(e.target)) {
      e.preventDefault();
      e.target.click();
    }
  };
  var onScrollOrResize = function onScrollOrResize() {
    if (currentAnchor) positionPopover(currentAnchor);
  };
  root.addEventListener('click', onDocClick);
  root.addEventListener('keydown', onKey);
  window.addEventListener('scroll', onScrollOrResize, {
    passive: true
  });
  window.addEventListener('resize', onScrollOrResize);
  return {
    destroy: function destroy() {
      root.removeEventListener('click', onDocClick);
      root.removeEventListener('keydown', onKey);
      window.removeEventListener('scroll', onScrollOrResize);
      window.removeEventListener('resize', onScrollOrResize);
      hidePopover();
    },
    preload: function preload(userId) {
      return fetchMini(userId, apiBase);
    }
  };
}

},{}],26:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProcessBrokerReviewFeedData = ProcessBrokerReviewFeedData;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ProcessBrokerReviewFeedData(_x) {
  return _ProcessBrokerReviewFeedData.apply(this, arguments);
}
function _ProcessBrokerReviewFeedData() {
  _ProcessBrokerReviewFeedData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(forumStateKey) {
    var state, result, isAnon, _iterator, _step, post, myVote, _post$UpVotes, _post$DownVotes, upVotes, downVotes, intId, review, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          state = this.GetState(forumStateKey);
          result = state.dataState;
          isAnon = !parseInt(result.MySocialProfileId, 10);
          if (isAnon) {
            this.GetAnonLikesFromStorage();
          }
          $('#' + forumStateKey).html('');
          if (!(result && result.Posts)) {
            _context.n = 9;
            break;
          }
          _iterator = _createForOfIteratorHelper(result.Posts);
          _context.p = 1;
          _iterator.s();
        case 2:
          if ((_step = _iterator.n()).done) {
            _context.n = 6;
            break;
          }
          post = _step.value;
          myVote = '';
          if (!isAnon) {
            upVotes = ((_post$UpVotes = post.UpVotes) === null || _post$UpVotes === void 0 ? void 0 : _post$UpVotes.split(',')) || [];
            downVotes = ((_post$DownVotes = post.DownVotes) === null || _post$DownVotes === void 0 ? void 0 : _post$DownVotes.split(',')) || [];
            if (upVotes.includes(result.MySocialProfileId.toString())) {
              myVote = 'up';
            } else if (downVotes.includes(result.MySocialProfileId.toString())) {
              myVote = 'down';
            }
          } else if (this.AnonSocialProfileLikes.length) {
            intId = parseInt(post.EntityId, 10);
            myVote = this.GetAnonThumbState(intId, post.ActivityType);
          }
          if (!(post.ActivityType === 'Comment')) {
            _context.n = 3;
            break;
          }
          $('#' + forumStateKey).append(this.RenderReviewCommentForProfileFeed(post, myVote));
          _context.n = 5;
          break;
        case 3:
          _context.n = 4;
          return this.RenderReviewForProfileFeed(post, myVote);
        case 4:
          review = _context.v;
          $('#' + forumStateKey).append(review);
        case 5:
          _context.n = 2;
          break;
        case 6:
          _context.n = 8;
          break;
        case 7:
          _context.p = 7;
          _t = _context.v;
          _iterator.e(_t);
        case 8:
          _context.p = 8;
          _iterator.f();
          return _context.f(8);
        case 9:
          //if (result.PagerHtml) {

          //    $('#' + forumStateKey + "-pager").html(result.PagerHtml);
          //}

          $('.text-body').each(function (index, el) {
            if (el.scrollHeight > el.clientHeight) {
              $(el).data('target-height', el.scrollHeight).next('.preview-fade').css('display', 'flex');
            }
          });
          this.Lightbox.InitializeLBImages('review-list-wrap');
          this.IgnitePopOverMenus();
          this.IgniteReviewerStatusTooltip();
        case 10:
          return _context.a(2);
      }
    }, _callee, this, [[1, 7, 8, 9]]);
  }));
  return _ProcessBrokerReviewFeedData.apply(this, arguments);
}

},{}],31:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var TagHandler = exports["default"] = /*#__PURE__*/function () {
  function TagHandler(textareaSelector, fetchTagsFn, insertFn) {
    var _this = this;
    _classCallCheck(this, TagHandler);
    this.textarea = document.querySelector(textareaSelector);
    this.fetchTags = fetchTagsFn;
    this.insertTag = insertFn;
    this.dropdown = null;

    // bind once and keep references so we can remove them later
    this._onInput = this.onInput.bind(this);
    this._onKeyDown = this.onKeyDown.bind(this);
    this._onBlur = this.onBlur.bind(this);
    this._onHide = function () {
      var _this$dropdown;
      return (_this$dropdown = _this.dropdown) === null || _this$dropdown === void 0 ? void 0 : _this$dropdown.hide();
    };
    this._onBeforeInput = this.onBeforeInput.bind(this);
    this._mentionAnchorRange = null;
    this.init();
  }
  return _createClass(TagHandler, [{
    key: "init",
    value: function init() {
      try {
        this.textarea.addEventListener('beforeinput', this._onBeforeInput);
        this.textarea.addEventListener('input', this._onInput);
        this.textarea.addEventListener('keydown', this._onKeyDown);
        this.textarea.addEventListener('blur', this._onBlur);
        var dialog = document.getElementById('dialog-add-post');
        if (dialog) {
          dialog.addEventListener('hide.bs.modal', this._onHide);
        }
      } catch (e) {
        console.warn("[Tag Handle] Failed to Init:", e);
      }
    }
  }, {
    key: "onInput",
    value: function () {
      var _onInput = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
        var _this2 = this;
        var caretPos, fullText, textBeforeCursor, match, prefix, suggestions, _yield$import, TagDropdown, _this$dropdown2, _this$dropdown3;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              caretPos = this.getCaretPosition();
              fullText = this.textarea.innerText || '';
              textBeforeCursor = fullText.slice(0, caretPos);
              match = textBeforeCursor.match(/@(\w{2,})$/);
              if (!match) {
                _context.n = 6;
                break;
              }
              prefix = match[1];
              _context.n = 1;
              return this.fetchTags(prefix);
            case 1:
              suggestions = _context.v;
              if (!suggestions.length) {
                _context.n = 4;
                break;
              }
              if (this.dropdown) {
                _context.n = 3;
                break;
              }
              _context.n = 2;
              return Promise.resolve().then(function () {
                return _interopRequireWildcard(require('./TagDropdown.v4.js'));
              });
            case 2:
              _yield$import = _context.v;
              TagDropdown = _yield$import["default"];
              // Pass our onSelect callback so TagHandler controls insertion
              this.dropdown = new TagDropdown(this.textarea, function (handle, userId) {
                _this2.insertMentionFromDropdown(handle, userId);
              });
            case 3:
              this.dropdown.showSuggestions(suggestions, prefix);
              _context.n = 5;
              break;
            case 4:
              (_this$dropdown2 = this.dropdown) === null || _this$dropdown2 === void 0 || _this$dropdown2.hide();
            case 5:
              _context.n = 7;
              break;
            case 6:
              (_this$dropdown3 = this.dropdown) === null || _this$dropdown3 === void 0 || _this$dropdown3.hide();
              this._mentionAnchorRange = null; // no active mention
            case 7:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function onInput(_x) {
        return _onInput.apply(this, arguments);
      }
      return onInput;
    }()
  }, {
    key: "onBeforeInput",
    value: function onBeforeInput(e) {
      // Save an anchor *before* the '@' is committed to the DOM
      if (e.inputType === 'insertText' && e.data === '@') {
        var sel = window.getSelection();
        if (sel && sel.rangeCount) {
          this._mentionAnchorRange = sel.getRangeAt(0).cloneRange();
        }
      }
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(e) {
      var _this$dropdown4;
      if ((_this$dropdown4 = this.dropdown) !== null && _this$dropdown4 !== void 0 && _this$dropdown4.isVisible()) {
        this.dropdown.handleKeyDown(e);
      }
    }

    /** Hide the dropdown when the editor loses focus */
  }, {
    key: "onBlur",
    value: function onBlur(event) {
      var dd = this.dropdown;
      if (dd && dd.isVisible()) {
        dd.hide();
      }
    }
  }, {
    key: "getCaretPosition",
    value: function getCaretPosition() {
      var selection = window.getSelection();
      if (!selection || selection.rangeCount === 0) return 0;
      var range = selection.getRangeAt(0);
      var preCaretRange = range.cloneRange();
      preCaretRange.selectNodeContents(this.textarea);
      preCaretRange.setEnd(range.endContainer, range.endOffset);
      return preCaretRange.toString().length;
    }
    /** Call this when the dialog closes to un‐wire everything */
  }, {
    key: "destroy",
    value: function destroy(cry) {
      this.textarea.removeEventListener('input', this._onInput);
      this.textarea.removeEventListener('keydown', this._onKeyDown);
      this.textarea.removeEventListener('blur', this._onBlur, true);
      var dialog = document.getElementById('dialog-add-post');
      if (dialog) {
        dialog.removeEventListener('hide.bs.modal', this._onHide);
      }

      // remove the dropdown DOM if it exists
      if (this.dropdown && this.dropdown.parentNode) {
        this.dropdown.parentNode.removeChild(this.dropdown);
      }
      this.dropdown = null;
    }
  }, {
    key: "insertMentionFromDropdown",
    value: function insertMentionFromDropdown(handle, userId) {
      var sel = window.getSelection();
      if (!sel || !sel.rangeCount) return;

      // Normalize to include '@' (your invariant)
      var h = (handle || '').startsWith('@') ? handle : '@' + handle;

      // Build mention node
      var mention = document.createElement('mention');
      mention.setAttribute('user-id', String(userId));
      mention.setAttribute('handle', h);
      mention.className = 'forum-mention';
      mention.contentEditable = 'false';
      mention.textContent = h;

      // Define replacement range: from saved '@' anchor to current caret
      var end = sel.getRangeAt(0).cloneRange();
      var replace = document.createRange();
      if (this._mentionAnchorRange) {
        replace.setStart(this._mentionAnchorRange.startContainer, this._mentionAnchorRange.startOffset);
        replace.setEnd(end.endContainer, end.endOffset);

        // If the first char at start is '@', include it; otherwise OK
        try {
          var probe = replace.cloneRange();
          if (probe.startContainer.nodeType === Node.TEXT_NODE && probe.startOffset < probe.startContainer.textContent.length) {
            probe.setEnd(probe.startContainer, probe.startOffset + 1);
            if (probe.toString() !== '@') {
              // nothing
            }
          }
        } catch (_unused) {}
      } else {
        // Fallback: replace just the local @prefix in the current text node
        var container = end.startContainer;
        if (container.nodeType === Node.TEXT_NODE) {
          var text = container.textContent;
          var beforeCaret = text.slice(0, end.startOffset);
          var m = beforeCaret.match(/@(\w{2,})$/);
          if (m) {
            var startIdx = end.startOffset - m[0].length; // includes '@'
            replace.setStart(container, startIdx);
            replace.setEnd(container, end.startOffset);
          } else {
            // No match—insert at caret
            replace = end;
          }
        } else {
          replace = end;
        }
      }

      // Replace contents with the mention
      replace.deleteContents();
      replace.insertNode(mention);

      // Insert a non-breaking space and move caret after it
      var space = document.createTextNode("\xA0");
      mention.after(space);
      var after = document.createRange();
      after.setStart(space, space.length);
      after.setEnd(space, space.length);
      sel.removeAllRanges();
      sel.addRange(after);

      // Clear anchor and notify drafts
      this._mentionAnchorRange = null;
      this.textarea.dispatchEvent(new Event('input', {
        bubbles: true
      }));
    }
  }]);
}();

},{"./TagDropdown.v4.js":29}],20:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RenderReviewForProfileFeed = RenderReviewForProfileFeed;
var _RenderStars = require("./RenderStars.js");
var _Urls = require("../Urls.js");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/**
 * Renders a full review post as HTML string
 * @param {object} post - The post object with full details
 * @param {string} myVote - The user's vote state ('up', 'down', or '')
 * @param {object} config - Optional config (avatarPath, imagePath, now, etc.)
 * @returns {Promise<string>} - HTML string
 */
function RenderReviewForProfileFeed(_x, _x2) {
  return _RenderReviewForProfileFeed.apply(this, arguments);
}
function _RenderReviewForProfileFeed() {
  _RenderReviewForProfileFeed = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(post, myVote) {
    var _post$Reviewer, _post$Images;
    var config,
      now,
      myDate,
      imageKey,
      imageGallery,
      stringTemplate,
      _args = arguments;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          config = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
          now = config.now || new Date();
          myDate = moment.duration(moment.utc(post.CreatedAt).diff(now)).humanize(true);
          imageKey = ((_post$Reviewer = post.Reviewer) === null || _post$Reviewer === void 0 ? void 0 : _post$Reviewer.ImageKey) || 'default_user_avatar.png';
          imageGallery = '';
          if ((_post$Images = post.Images) !== null && _post$Images !== void 0 && _post$Images.length) {
            imageGallery = "<div class=\"image-row\">";
            post.Images.forEach(function (img) {
              imageGallery += "<img src=\"".concat((0, _Urls.GetReviewImageUrl)(img), "\" class=\"review-img lightbox-slide\" />");
            });
            imageGallery += "</div>";
          }
          stringTemplate = "<div class='forum-post-wrap latest-post' id='post-box-".concat(post.EntityType, "-").concat(post.EntityId, "'>\n            <div class=\"frn-flex-row column review-box\">\n                <div class=\"cell-group show-when-small activity-description\" style=\"padding-bottom:16px\">\n                    ").concat(window.LEFT_A_REVIEW_FOR.replace('{0}', "".concat(post.Reviewer.PublicName)).replace('{1}', " <a href='".concat(window.langSlug, "/brokers/").concat(post.BrokerId, "/").concat(post.BrokerCode, "'>").concat(post.Name, "</a>")), "\n                </div>\n                <div class=\"cell-group review-header\">\n                    <div class=\"cell image-cell\">\n                        <img class=\"reviewer-image\" src=\"/content/dist/brokers/images/").concat(post.FileName, "?w=56&h=56\"/>\n                    </div>\n                    <div class=\"cell image-cell image-cell-sub\">\n                        <img class=\"reviewer-image reviewer-image-sub social-profile-navigate\" src=\"").concat((0, _Urls.GetAvatarPath)(imageKey), "?w=48&h=48\" data-profile-id=\"").concat(post.Reviewer.Id, "\"/>\n                    </div>\n                    <div class=\"cell-group reviewer-info column buffer min-144\">\n\n                        <div class=\"cell-group verification-group activity-description hide-when-small\">\n                           ").concat(window.LEFT_A_REVIEW_FOR.replace('{0}', "".concat(post.Reviewer.PublicName)).replace('{1}', " <a href='".concat(window.langSlug, "/brokers/").concat(post.BrokerId, "/").concat(post.BrokerCode, "'>").concat(post.Name, "</a>")), "\n                           ").concat(this.RenderStatusBadge(post.IsCompanyRepFor, post.ReviewerIsVerified), "\n                        </div>\n                        <div class=\"cell-group column\">\n                            ").concat((0, _RenderStars.RenderStars)(post.Rating), "\n                            <span class=\"show-when-small\">").concat(this.RenderStatusBadge(post.IsCompanyRepFor, post.ReviewerIsVerified), "</span>\n                        </div>\n                    </div>\n                    \n                   \n                    <div class=\"cell-group column last\">\n                        <div class=\"cell buffer lesser-text date-block\">").concat(myDate, "</div>\n\n                        <div class=\"cell lesser-text\"><span class=\"status-badge\">\n                        ").concat(function () {
            if (post.Status.toLowerCase() === 'approved') {
              return "".concat(window.STATUS_APPROVED);
            } else if (post.Status.toLowerCase() === 'pending') {
              return "".concat(window.STATUS_PENDING);
            }
            return "".concat(window.STATUS_REJECTED);
          }(), "\n                        </span></div>\n                    </div>\n\n\n                </div>                    \n\n                <div class=\"cell text-body\" id='post-content-").concat(post.PostId, "' data-comment-author='").concat(post.Reviewer.PublicName, "' >\n                 ").concat(function () {
            var moderatorNotes = '';
            if (post.ModerationNotes != null && post.ModerationNotes != '' && post.ModerationNotes != undefined) {
              moderatorNotes = "<div class=\"alert alert-primary\">\n                        <strong>".concat(window.MODERATOR_NOTES, "</strong>\n                        <br>").concat(post.ModerationNotes, "</div>");
            }
            return moderatorNotes;
          }(), "\n                ").concat(function () {
            if (post.DeletedPost === true) {
              return window.DELETED_POST;
            }
            if (post.Comment !== undefined && post.Comment !== null) {
              return post.Comment.trim();
            }
            return "";
          }()).concat(function () {
            if (post.HasTranslation) {
              return "<div class='translation-div font-13'><br /><em>".concat(window.TRANSLATION, ":</em><br />").concat(post.Translation, "</div>");
            }
            return '';
          }(), "\n        ").concat(imageGallery, "\n    \n        </div>\n                <div class=\"cell preview-fade\">\n                    <a id=\"expand-button-post-").concat(post.EntityType, "-").concat(post.EntityId, "\" href=\"javascript:void(0)\" class=\"hover-underline\" onClick=\"window.SocialProfile.ExpandPostPreview('").concat(post.EntityType, "','").concat(post.EntityId, "','open')\">").concat(window.SHOW_MORE, "  <img style=\"width:13px; height: 13px;\" src=\"/Content/dist/images/icons/DownArrow.svg\" /></a>\n                </div>\n                <div class=\"cell preview-show\">\n                    <a id=\"contract-button-post-").concat(post.EntityType, "-").concat(post.EntityId, "\" href=\"javascript:void(0)\" class=\"hover-underline\" onClick=\"window.SocialProfile.ExpandPostPreview('").concat(post.EntityType, "','").concat(post.EntityId, "','close')\">").concat(window.SHOW_LESS, "  <img style=\"width:13px; height: 13px;\" src=\"/Content/dist/images/icons/UpArrow.svg\" /></a>\n                </div>\n                                <div class=\"cell hr expand\"></div>\n                <div class=\"baseline-controls\">\n                <div class=\"control-group\">\n                    <div class=\"control\">\n                        <i class=\"thumbsup icon buffer ").concat(function () {
            if (myVote === 'up') {
              return "my";
            }
          }() || '', "\" onClick=\"window.SocialProfile.Thumbs('up','Review','").concat(post.EntityId, "',this)\"></i>\n                    </div>\n                    <div class=\"control vote-score\">").concat(function () {
            if (post !== undefined && post !== null && post.VoteScore !== undefined) {
              return "".concat(post.VoteScore);
            } else {
              return "0";
            }
          }(), "\n            </div>\n                    <div class=\"control\">\n                        <i class=\"thumbsdown icon ").concat(function () {
            if (myVote === 'down') {
              return "my";
            }
          }() || '', "\" onClick=\"window.SocialProfile.Thumbs('down','Review','").concat(post.EntityId, "',this)\"></i>\n                    </div>\n                    </div>\n                   \n                    <div class=\"control-group last\">\n                    \n                    <div class=\"control\">\n                    <a href=\"javascript:void(0)\" class=\"waves-effect go-to-task-button\" onClick=\"window.SocialProfile.GoToReview('").concat(post.ReviewId, "')\">").concat(window.GO_TO_BROKER_REVIEW, "</a>\n\n                    </div>\n                    </div>\n                    </div>\n\n                </div>\n               \n            </div>\n        </div>");
          return _context.a(2, stringTemplate);
      }
    }, _callee, this);
  }));
  return _RenderReviewForProfileFeed.apply(this, arguments);
}

},{"../Urls.js":24,"./RenderStars.js":18}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddOrEditReview = AddOrEditReview;
exports.AddReviewComment = AddReviewComment;
exports.BringToAddOrEditReview = BringToAddOrEditReview;
exports.EditReview = EditReview;
exports.FilterReviews = FilterReviews;
exports.GetStateProp = GetStateProp;
exports.InflateComment = InflateComment;
exports.LoadBrokerRatings = LoadBrokerRatings;
exports.LoadMiniReviews = LoadMiniReviews;
exports.NotRated = NotRated;
exports.OpenComment = OpenComment;
exports.OpenDisputeDialog = OpenDisputeDialog;
exports.OpenDisputeResponseDialog = OpenDisputeResponseDialog;
exports.OpenReply = OpenReply;
Object.defineProperty(exports, "RemoveDisputeImage", {
  enumerable: true,
  get: function get() {
    return _DisputeResponse.RemoveDisputeImage;
  }
});
exports.RemoveImage = RemoveImage;
exports.SaveReply = SaveReply;
exports.SetState = SetState;
Object.defineProperty(exports, "ShowImageLightbox", {
  enumerable: true,
  get: function get() {
    return _DisputeResponse.ShowImageLightbox;
  }
});
exports.SubmitDisputeResponse = SubmitDisputeResponse;
exports.SubmitReview = SubmitReview;
exports.SwitchToRejectedTab = SwitchToRejectedTab;
var _State = require("../Shared/State.js");
var _Likes = require("../Shared/Likes.js");
var _UIHooks = require("../Shared/UIHooks.js");
var _State2 = require("./State.js");
var _index = require("./Templates/index.js");
var _Hooks = require("./Hooks.js");
var _Review = require("./Review.js");
var _LightBox = require("./LightBox.js");
var _Utilities = require("./Utilities.js");
var _Urls = require("./Urls.js");
var _DisputeResponse = require("./DisputeResponse.js");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _readOnlyError(r) { throw new TypeError('"' + r + '" is read-only'); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function EditReview() {
  if (window.userIsOnline) {
    BringToAddOrEditReview();
  } else {
    window.Access.LoginWithPurpose('BringToAddOrEditReview', window.YOU_MUST_BE_LOGGED_IN_TO_PERFORM_THIS_ACTION, 'login', '', '', 'window.BrokerReview');
  }
}
function AddOrEditReview(_x) {
  return _AddOrEditReview.apply(this, arguments);
}
function _AddOrEditReview() {
  _AddOrEditReview = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(brokerId) {
    var rowIndex,
      logoSrc,
      evtSrcId,
      _args = arguments;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          rowIndex = _args.length > 1 && _args[1] !== undefined ? _args[1] : 0;
          logoSrc = _args.length > 2 && _args[2] !== undefined ? _args[2] : null;
          evtSrcId = _args.length > 3 && _args[3] !== undefined ? _args[3] : 1;
          if (!window.userIsOnline) {
            _context.n = 2;
            break;
          }
          _context.n = 1;
          return BringToAddOrEditReview(brokerId, rowIndex, logoSrc, evtSrcId);
        case 1:
          _context.n = 3;
          break;
        case 2:
          window.Access.LoginWithPurpose('BringToAddOrEditReview', window.YOU_MUST_BE_LOGGED_IN_TO_PERFORM_THIS_ACTION, 'login', '', '', 'window.BrokerView');
        case 3:
          return _context.a(2);
      }
    }, _callee);
  }));
  return _AddOrEditReview.apply(this, arguments);
}
function SubmitReview() {
  var progress = true;
  var parsed = parseInt($('#review-rating').val(), 10);
  var brokerId = parseInt(_State2.ReviewState.BrokerId, 10);
  var isVerified = parseInt($('#is-verified-value').val(), 10);
  var allAccountTypesChecked = $('#acc-type-all').is(':checked');
  var noRatingChecked = $('#no-rating-checkbox').is(':checked');
  var review = $('#review-input').val();
  var verifyBy = $('input[type="radio"][name="VerificationOption"]:checked').val();
  var parser = new DOMParser();
  var doc = parser.parseFromString(review, 'text/html');
  var parsedReview = doc.body.textContent || "";
  // Extract text content from the body of the parsed document

  if (review != parsedReview) {
    alert('Html tags were automatically removed.\nPlease check and submit your review again.');
    $('#review-input').val(parsedReview);
    return;
  }
  var login = '';
  var pass = '';
  var mtServer = '';
  if (!allAccountTypesChecked) {
    var accountChecked = false;
    $('#account-type-checkboxes input[type=checkbox]').each(function (i, e) {
      if ($(e).is(":checked")) {
        accountChecked = true;
      }
      ;
    });
    if (!accountChecked) {
      $('#account-type-error').parent().addClass('has-danger');
      progress = false;
    }
  }
  if (isNaN(parsed) || parsed < 1) {
    if (!noRatingChecked) {
      $('#review-rating').parent().addClass('has-danger');
      progress = false;
    }
  }
  if (review === '') {
    $('#review-input').parent().addClass('has-danger');
    progress = false;
  }
  if (isVerified !== 1) {
    if (verifyBy === undefined || verifyBy.isNaN) {
      $('#VerificationOption-error').parent().addClass('has-danger');
      progress = false;
    } else if (verifyBy === "1") {
      login = $('#investor-login').val();
      pass = $('#investor-password').val();
      if (login === undefined || login === "") {
        $('#investor-error').parent().addClass('has-danger');
        progress = false;
      }
      if (pass === undefined || pass === "") {
        $('#investor-password-error').parent().addClass('has-danger');
        progress = false;
      }
      if ($("#mt-broker-select-cell").is(':visible')) {
        mtServer = $("#mt-broker-select").val();
        if (!mtServer) {
          $("#mt-broker-select-error").parent().addClass("has-danger");
          progress = false;
        }
      }
    }
  }
  if (progress) {
    //;) {
    $('#submit-review-progress').show();

    // Create a new FormData object.
    var formData = new FormData();
    (0, _LightBox.AppendForumImagesToFormData)(formData);
    var hasChecked = false;
    $('div#account-type-checkboxes input[type=checkbox]').each(function () {
      if ($(this).is(":checked")) {
        formData.append('AccountTypes', $(this).val());
        hasChecked = false;
      }
    });
    if (!hasChecked) {
      formData.append('AccountTypes', []);
    }
    formData.append('AllChecked', allAccountTypesChecked === true);
    formData.append('Rating', parsed);
    formData.append('NoRating', noRatingChecked);
    formData.append('PostBody', review);
    formData.append('BrokerId', brokerId);
    formData.append('IsVerified', isVerified);
    formData.append('VerifyBy', verifyBy);
    //formData.append('AccountTypes', rebateAccounts);
    if (verifyBy === "1") {
      formData.append('Login', login);
      formData.append('Pass', pass);
      formData.append("MTBroker", mtServer);
    }
    $.ajax({
      type: "POST",
      cache: false,
      // ReSharper disable once UseOfImplicitGlobalInFunctionScope
      processData: false,
      contentType: false,
      url: window.submitBrokerReviewUrl,
      dataType: "json",
      data: formData,
      async: false,
      success: function success(result) {
        if (result.Success === true) {
          $('#add-review-body').html(result.output);
          (0, _Review.LoadCustomReviewData)();
          $('#submit-review-progress').hide();
          (0, _Hooks.IgniteReviewForm)();
          $('#dialog-add-review').modal("hide");
          toastr.success(window.YOUR_COMMENT_HAS_BEEN_SUBMITTED);
          return true;
        } else {
          $('#submit-review-progress').hide();
          $('#dialog-add-review').modal("hide");
          toastr.error(result.Message);
          return false;
        }
      },
      error: function error(result) {
        $('#submit-review-progress').hide();
        alert("An error has occurred " + result.Message);
        return false;
      },
      failure: function failure() {
        $('#submit-review-progress').hide();
        alert("Network error");
        return false;
      }
    });
  }
}
function LoadBrokerRatings(brokerId) {
  return (0, _Utilities.LoadBrokerRatingValues)(brokerId);
}
function FilterReviews() {
  var targetContainer = $('#review-template').is(":visible") ? 'review-template' : 'rejected-review-template';
  (0, _Utilities.FilterBrokerReviews)({
    page: 1,
    url: _Urls.FetchBrokerReviewsUrl,
    callback: _Review.ProcessBrokerReviews,
    dataContainerId: targetContainer,
    doScroll: false
  });
}
function SwitchToRejectedTab() {
  var rejectedTab = document.querySelector('.fxv-review-tab[data-target="#fxv-rejected-review-content"]');
  if (rejectedTab) {
    (0, _Utilities.HandleTabSwitch)(rejectedTab);
  }
  if ($("#check-spam").is(":checked")) {
    var _rejectedTab = document.querySelector('.fxv-review-tab[data-target="#fxv-rejected-review-content"]');
    if (_rejectedTab) {
      (0, _Utilities.HandleTabSwitch)(_rejectedTab);
    }
  } else {
    var approvedTab = document.querySelector('.fxv-review-tab[data-target="#fxv-approved-review-content"]');
    if (approvedTab) {
      (0, _Utilities.HandleTabSwitch)(approvedTab);
    }
  }
}
function BringToAddOrEditReview(_x2) {
  return _BringToAddOrEditReview.apply(this, arguments);
}
function _BringToAddOrEditReview() {
  _BringToAddOrEditReview = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(brokerId) {
    var rowIndex,
      logoSrc,
      evtSrcId,
      brokerIdInput,
      rawSrc,
      _document$querySelect,
      _document$querySelect2,
      _document$querySelect3,
      bp,
      response,
      result,
      renderedHtml,
      _args2 = arguments,
      _t;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          rowIndex = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : 0;
          logoSrc = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : null;
          evtSrcId = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : 1;
          if (!brokerId) brokerId = _State2.ReviewState.BrokerId;
          if (!brokerId) {
            brokerIdInput = document.getElementById('brokerId');
            if (brokerIdInput) {
              brokerId = brokerIdInput.value;
            }
          }
          if (brokerId) {
            _context2.n = 1;
            break;
          }
          alert("brokerId not found");
          return _context2.a(2);
        case 1:
          if (_State2.ReviewState.BrokerId !== brokerId) _State2.ReviewState.BrokerId = brokerId;
          rawSrc = '';
          if (evtSrcId == 1) {
            //get image source from broker detail pane
            rawSrc = (_document$querySelect = document.querySelector('div.broker-detail-top-pane > div.broker-detail-summary-pane > div.broker-image > img.broker-pic')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.src;
          } else if (evtSrcId == 2) {
            //get image source from broker list table
            rawSrc = (_document$querySelect2 = document.querySelector('#broker-list-table > tbody > tr:nth-child(' + rowIndex + ') > td.fixed-column > div > a > img.broker-list-item-logo')) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.src;
          } else if (evtSrcId == 3 && logoSrc) {
            rawSrc = logoSrc;
          } else {
            rawSrc = (_document$querySelect3 = document.querySelector('div.broker-detail-top-pane > div.broker-detail-summary-pane > div.broker-image > img.broker-pic')) === null || _document$querySelect3 === void 0 ? void 0 : _document$querySelect3.src;
          }
          bp = rawSrc ? new URL(rawSrc).origin + new URL(rawSrc).pathname : null;
          document.querySelector('#dialog-add-review [data-id=broker-image]').src = "".concat(bp, "?w=50&h=50");
          document.getElementById('add-review-body').style.display = 'none';
          document.getElementById('submit-review-progress').style.display = 'block';
          $('#dialog-add-review').modal('show');
          _context2.p = 2;
          _context2.n = 3;
          return fetch(window.editReviewUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              brokerId: brokerId
            })
          });
        case 3:
          response = _context2.v;
          if (response.ok) {
            _context2.n = 4;
            break;
          }
          throw new Error("Server responded with ".concat(response.status));
        case 4:
          _context2.n = 5;
          return response.json();
        case 5:
          result = _context2.v;
          document.querySelector('#dialog-add-review [data-id=broker-name]').innerHTML = result.brokerName;
          renderedHtml = (0, _index.RenderAddReviewInputForm)(result.model);
          document.getElementById('add-review-body').innerHTML = renderedHtml;
          document.getElementById('add-review-body').style.display = 'block';
          document.getElementById('submit-review-progress').style.display = 'none';
          _context2.n = 6;
          return (0, _Utilities.LayoutReviewImages)(result.model.Values.FileNames);
        case 6:
          (0, _Hooks.IgniteReviewForm)();
          _context2.n = 8;
          break;
        case 7:
          _context2.p = 7;
          _t = _context2.v;
          console.error('[BringToAddOrEditReview] Failed:', _t);
          // You can show an error message in the UI here
        case 8:
          return _context2.a(2);
      }
    }, _callee2, null, [[2, 7]]);
  }));
  return _BringToAddOrEditReview.apply(this, arguments);
}
function OpenDisputeDialog(reviewId, socialProfileId) {
  $('#dispute-review-id').val(reviewId);
  $('#dispute-social-profile-id').val(socialProfileId);
  $("#dispute-review-dialog").modal('show');
}
function OpenComment(id) {
  var wrappers = document.querySelectorAll(".review-comment-wrap[data-comment-post-id=\"".concat(id, "\"]"));
  wrappers.forEach(function (wrapper) {
    var commentList = wrapper.querySelector(".comment-list-".concat(id));
    if (!commentList) return;
    var isVisible = wrapper.style.display !== 'none';
    if (isVisible) {
      wrapper.style.display = 'none';
    } else {
      if (_State2.ReviewState.LoadedReviewComments !== undefined) {
        var intId = parseInt(id, 10);
        var commentsForReview = _State2.ReviewState.LoadedReviewComments.filter(function (k) {
          return k.AttachedToPostId === intId;
        }).filter(function (k) {
          return !(k.ReplyToCommentId > 0);
        });
        var pendingCommentsForReview = _State2.ReviewState.MyPendingComments.filter(function (k) {
          return k.AttachedToPostId === intId;
        }).filter(function (k) {
          return !(k.ReplyToCommentId > 0);
        });
        var combinedComments = _toConsumableArray(new Set([].concat(_toConsumableArray(commentsForReview), _toConsumableArray(pendingCommentsForReview))));
        combinedComments.sort(function (a, b) {
          return a.UpdatedAt > b.UpdatedAt ? 1 : -1;
        });
        var output = '';
        var myVote = '';
        if (combinedComments.length > 0) {
          var isAnon = true;
          if (_State.SocialProfileState.MyProfile != null && _State.SocialProfileState.MyProfile.Id !== undefined) {
            isAnon = false;
          }
          if (Array.isArray(combinedComments)) {
            combinedComments.forEach(function (num, index) {
              myVote = '';
              if (!isAnon) {
                if (combinedComments[index].UpVotes.includes(_State.SocialProfileState.MyProfile.Id.toString())) {
                  myVote = 'up';
                } else if (combinedComments[index].DownVotes.includes(_State.SocialProfileState.MyProfile.Id.toString())) {
                  myVote = 'down';
                }
              } else if (_State.AnonState.Likes.length) {
                var _intId = parseInt(combinedComments[index].Id, 10);
                myVote = (0, _Likes.GetAnonThumbState)(_intId, 'ReviewComment');
              }
              var comment = combinedComments[index];
              var cthml = (0, _index.RenderComment)(comment, myVote);
              output += cthml;
            });
          } else {
            myVote = '';
            if (!isAnon) {
              if (combinedComments[index].UpVotes.includes(_State.SocialProfileState.MyProfile.Id)) {
                myVote = 'up';
              } else if (combinedComments[index].DownVotes.includes(_State.SocialProfileState.MyProfile.Id)) {
                myVote = 'down';
              }
            } else if (_State.AnonState.Likes.length) {
              var _intId2 = parseInt(combinedComments[index].Id, 10);
              myVote = (0, _Likes.GetAnonThumbState)(_intId2, 'ReviewComment');
            }
            output = (0, _index.RenderComment)(combinedComments, myVote);
          }
        }
        commentList.innerHTML = output;
        wrapper.style.display = 'block';
      }
    }
  });
}
function OpenReply(replyToCommentId, postId, source) {
  var wrappers = document.querySelectorAll(".reply-wrap[data-reply-post-id=\"".concat(replyToCommentId, "\"]"));
  wrappers.forEach(function (wrapper) {
    var isVisible = wrapper.style.display !== 'none';
    if (isVisible) {
      wrapper.style.display = 'none';
    } else {
      var isAnon = !(_State.SocialProfileState.MyProfile != null && parseInt(_State.SocialProfileState.MyProfile.Id, 10) > 0);
      if (_State2.ReviewState.LoadedReviewComments !== undefined) {
        var intReplyToCommentId = parseInt(replyToCommentId, 10);
        var intPostId = parseInt(postId, 10);
        var commentsForReview = _State2.ReviewState.LoadedReviewComments.filter(function (k) {
          return k.AttachedToPostId === intPostId;
        }).filter(function (k) {
          return k.ReplyToCommentId === intReplyToCommentId;
        });
        var pendingRepliesForReview = _State2.ReviewState.MyPendingComments.filter(function (k) {
          return k.AttachedToPostId === intPostId;
        }).filter(function (k) {
          return k.ReplyToCommentId === intReplyToCommentId;
        });
        var replyFrame = (0, _index.RenderReplyFrame)(replyToCommentId, postId);
        var replies = '';
        var combinedComments = _toConsumableArray(new Set([].concat(_toConsumableArray(commentsForReview), _toConsumableArray(pendingRepliesForReview))));
        combinedComments.sort(function (a, b) {
          return a.UpdatedAt > b.UpdatedAt ? 1 : -1;
        });
        console.log(combinedComments);
        if (combinedComments.length > 0) {
          if (Array.isArray(combinedComments)) {
            combinedComments.forEach(function (num, index) {
              var comment = combinedComments[index];
              replies += (0, _index.RenderReply)(comment);
            });
          } else {
            replies += (0, _index.RenderReply)(combinedComments);
          }
        }
        wrapper.innerHTML = ''; // clear wrapper

        wrapper.innerHTML = replyFrame; // inject reply frame
        var commentList = wrapper.querySelector(".reply-list-".concat(replyToCommentId));
        if (commentList) {
          commentList.innerHTML = replies;
        }
        (0, _UIHooks.IgnitePopOverMenus)();
        wrapper.style.display = 'block';
      }
    }
  });
}
function AddReviewComment(el, parentId) {
  console.log(el);
  console.log($(el));
  var input = $(el).closest('div.add-comment.frn-flex-row').find('input');
  if (input.val() === "" || input.val() === undefined || input.val() === null) {
    input.closest('div.cell').addClass('has-danger');
  } else {
    if (window.userIsOnline) {
      SaveReviewComment(el, parentId);
    } else {
      var accountData = {};
      accountData.elId = el.id;
      accountData.parentId = parentId;
      var data = JSON.stringify(accountData);
      window.Access.LoginWithPurpose('InflateComment', window.YOU_MUST_BE_LOGGED_IN_TO_PERFORM_THIS_ACTION, 'login', '', data, 'window.BrokerReview');
    }
  }
}
function InflateComment() {
  var dataString = $('#loginModal').data('task-data');
  $('#loginModal').removeData('task-data');
  $('#loginModal').removeData('callback');
  var data = JSON.parse(dataString);
  var el = $('#' + data.elId);
  SaveReviewComment(el, data.parentId);
}
function SaveReply(el, postId, replyToCommentId) {
  var brokerId = _State2.ReviewState.BrokerId;
  if (!brokerId) {
    var brokerIdInput = document.getElementById('brokerId');
    if (brokerIdInput) {
      brokerIdInput.value, _readOnlyError("brokerId");
    }
  }
  if (!brokerId) {
    alert("brokerId not found");
    return;
  }
  var url = window.postCommentReplyUrl;
  var data = {};
  var input = $(el).closest('div.add-reply.frn-flex-row').find('input');
  if (input.val() === "" || input.val() === undefined || input.val() === null) {
    input.closest('div.cell').addClass('has-danger');
  } else {
    input.closest('div.cell').removeClass('has-danger').find('.progress').show();
    data = {
      parentId: replyToCommentId,
      grandParentId: postId,
      entityId: brokerId,
      body: input.val(),
      Action: 'ReviewCommentReply'
    };
    $.ajax({
      type: "POST",
      cache: false,
      // ReSharper disable once UseOfImplicitGlobalInFunctionScope
      url: url,
      dataType: "json",
      data: data,
      success: function success(result) {
        if (result.Success) {
          input.closest('div.cell').find('.progress').hide();
          input.val('');
          var comm = '';
          comm = (0, _index.RenderReply)(result.Comment, '');
          var wrappers = document.querySelectorAll(".reply-wrap[data-reply-post-id=\"".concat(replyToCommentId, "\"]"));
          wrappers.forEach(function (wrapper) {
            var commentList = wrapper.querySelector(".reply-list-".concat(replyToCommentId));
            if (commentList) {
              commentList.innerHTML += comm;
            }
          });
          (0, _UIHooks.IgnitePopOverMenus)();
          (0, _Hooks.IgniteReviewerStatusTooltip)();
        } else {
          input.closest('div.cell').addClass('has-danger').find('.progress').hide();
          if (result.Message != undefined && result.Message != "") {
            toastr.error(result.Message);
          }
        }
      },
      error: function error(result) {
        input.closest('div.cell').addClass('has-danger').find('.progress').hide();
        alert("Network failure");
      }
    });
  }
  ;
}
function LoadMiniReviews() {
  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var brokerId = _State2.ReviewState.BrokerId;
  if (brokerId !== null) {
    var data = {
      brokerId: brokerId,
      page: page
    };
    $("#mini-review-paginator").html('<img src="/content/dist/images/PageElements/ajax-loader.gif" />');
    $.ajax({
      type: "POST",
      cache: false,
      // ReSharper disable once UseOfImplicitGlobalInFunctionScope
      url: _Urls.MiniReviewsUrl,
      dataType: "json",
      data: data,
      success: function success(result) {
        console.log("returned from sender", result);
        (0, _Utilities.ProcessMiniReviewData)(result, data, page == 0);
        (0, _LightBox.InitializeLBImages)('review-template');
      },
      error: function error(result) {
        $("#mini-review-paginator").html('');
      }
    });
  }
}
function SaveReviewComment(el, parentId) {
  var url = window.postBrokerReviewCommentUrl;
  var data = {};
  var input = $(el).closest('div.add-comment.frn-flex-row').find('input');
  if (input.val() === "" || input.val() === undefined || input.val() === null) {
    input.closest('div.cell').addClass('has-danger');
  } else {
    data = {
      parentId: parentId,
      entityId: _State2.ReviewState.BrokerId,
      body: input.val(),
      Action: 'ReviewComment'
    };
    input.closest('div.cell').removeClass('has-danger').find('.progress').show();
    $.ajax({
      type: "POST",
      cache: false,
      // ReSharper disable once UseOfImplicitGlobalInFunctionScope
      url: url,
      dataType: "json",
      data: data,
      success: function success(result) {
        if (result.Success) {
          toastr.success(window.YOUR_COMMENT_HAS_BEEN_SUBMITTED);
          var comm = (0, _index.RenderComment)(result.Comment, '');
          input.closest('div.cell').removeClass('has-danger').find('.progress').hide();
          $('.comment-list-' + parentId).append(comm);
          (0, _State2.AddToReviewComments)(result.Comment);
        } else {
          input.closest('div.cell').addClass('has-danger').find('.progress').hide();
          if (result.Message != undefined && result.Message != "") {
            toastr.error(result.Message);
          }
        }
      },
      error: function error(result) {
        input.closest('div.cell').addClass('has-danger').find('.progress').hide();
        alert("Network failure");
      }
    });
  }
  ;
}
function NotRated() {
  $('#heart-rate li').removeClass('clicked');
  $('#review-rating').val(0);
}
function RemoveImage(fileName) {
  var frameId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "#img-frames";
  (0, _LightBox.RemoveImage)(fileName, frameId);
}
function SetState(newState) {
  Object.assign(_State2.ReviewState, newState);
}
function GetStateProp(key) {
  return _State2.ReviewState[key];
}
function OpenDisputeResponseDialog(reviewId) {
  // Fetch dispute data from server
  fetch("/api/reviews/".concat(reviewId, "/dispute"), {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(function (response) {
    return response.json();
  }).then(function (data) {
    if (data.success) {
      (0, _DisputeResponse.OpenDisputeResponseDialog)(reviewId, data);
    } else {
      toastr.error(data.message || 'Failed to load dispute information.');
    }
  })["catch"](function (error) {
    console.error('Error loading dispute:', error);
    toastr.error('An error occurred while loading the dispute.');
  });
}
function SubmitDisputeResponse() {
  (0, _DisputeResponse.SubmitDisputeResponse)();
}

},{"../Shared/Likes.js":32,"../Shared/State.js":33,"../Shared/UIHooks.js":34,"./DisputeResponse.js":7,"./Hooks.js":8,"./LightBox.js":9,"./Review.js":12,"./State.js":13,"./Templates/index.js":23,"./Urls.js":24,"./Utilities.js":25}],33:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SocialProfileState = exports.AnonState = void 0;
var SocialProfileState = exports.SocialProfileState = {
  MyProfile: null
};
var AnonState = exports.AnonState = {
  Likes: []
};

},{}],34:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IgnitePopOverMenus = IgnitePopOverMenus;
function IgnitePopOverMenus() {
  var ACTIVE_CLASS = 'custom-popover-active';
  function closeAllPopovers(event) {
    document.querySelectorAll('.custom-popover').forEach(function (popover) {
      if (!popover.contains(event.target)) {
        popover.remove();
      }
    });
    document.querySelectorAll("[data-toggle][aria-expanded=\"true\"]").forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    });
  }
  function createPopoverContent(trigger) {
    var type = trigger.dataset.toggle;
    var postId = trigger.dataset.postid;
    var authorId = trigger.dataset.authorid;
    var commentId = trigger.dataset.commentid;
    var containerKey = trigger.dataset.forumHolder;
    var out = '';
    var isComment = parseInt(commentId, 10) > 0;
    if (isComment) {
      out += "\n                <div class=\"post-edit-menu-options\">\n                    <a href=\"javascript:void(0)\" onclick=\"window.SocialProfile.OpenCommentForEdit('".concat(containerKey, "',").concat(commentId, ", ").concat(postId, ")\">").concat(window.EDIT_COMMENT, "</a>\n                    <a href=\"javascript:void(0)\" onclick=\"window.SocialProfile.DeleteComment('").concat(containerKey, "',").concat(commentId, ", ").concat(postId, ")\">").concat(window.DELETE_COMMENT, "</a>");
      if (window.SocialProfile.moderator) {
        out += "\n                    <a href=\"javascript:void(0)\" onclick=\"window.SocialProfile.CurtailUserActivity(".concat(authorId, ")\">Ban user</a>\n                    <a href=\"javascript:void(0)\" onclick=\"window.SocialProfile.RemoveUserActivity(").concat(authorId, ")\">Scrub user activity</a>");
      }
      out += "</div>";
    } else {
      out += "\n                <div class=\"post-edit-menu-options\">\n                    <a href=\"javascript:void(0)\" onclick=\"window.SocialProfile.OpenPostForEdit('".concat(containerKey, "',").concat(postId, ")\">").concat(window.EDIT_POST, "</a>\n                    <a href=\"javascript:void(0)\" onclick=\"window.SocialProfile.DeletePost('").concat(containerKey, "',").concat(postId, ")\">").concat(window.DELETE_POST, "</a>");
      if (window.SocialProfile.moderator) {
        out += "\n                    <a href=\"javascript:void(0)\" onclick=\"window.SocialProfile.CurtailUserActivity(".concat(authorId, ")\">Ban user</a>\n                    <a href=\"javascript:void(0)\" onclick=\"window.SocialProfile.RemoveUserActivity(").concat(authorId, ")\">Scrub user activity</a>");
      }
      out += "</div>";
    }
    return out;
  }
  function handlePopoverClick(e) {
    e.stopPropagation();
    closeAllPopovers(e);
    var trigger = e.currentTarget;
    var popoverHtml = createPopoverContent(trigger);
    var rect = trigger.getBoundingClientRect();
    var popover = document.createElement('div');
    popover.classList.add('custom-popover');
    popover.innerHTML = popoverHtml;
    document.body.appendChild(popover);
    popover.style.position = 'absolute';
    popover.style.zIndex = '9999';
    popover.style.top = "".concat(window.scrollY + rect.bottom + 5, "px");
    var desiredLeft = window.scrollX + rect.left;
    var maxLeft = window.scrollX + window.innerWidth - popover.offsetWidth - 5;
    popover.style.left = "".concat(Math.max(0, Math.min(desiredLeft, maxLeft)), "px");
    trigger.setAttribute('aria-expanded', 'true');
  }

  // Initialize post and comment edit popovers
  document.querySelectorAll('[data-toggle="post-edit-menu"], [data-toggle="comment-edit-menu"]').forEach(function (trigger) {
    trigger.addEventListener('click', handlePopoverClick);
    trigger.setAttribute('aria-expanded', 'false');
  });

  // Global body click handler to close any open popovers
  document.body.addEventListener('click', closeAllPopovers);
}

},{}],13:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddToReviewComments = AddToReviewComments;
exports.ReviewState = void 0;
var ReviewState = exports.ReviewState = {
  LoadedReviewComments: [],
  BrokerId: null,
  MyPendingComments: [],
  Tmp_files: []
};
function AddToReviewComments(comment) {
  if (typeof LoadedReviewComments !== "undefined") {
    var index = LoadedReviewComments.length;
    LoadedReviewComments[index] = comment;
  } else if (typeof ReviewState.LoadedReviewComments !== "undefined") {
    var _index = ReviewState.LoadedReviewComments.length;
    ReviewState.LoadedReviewComments[_index] = comment;
    console.log(ReviewState.LoadedReviewComments);
  } else {
    console.log("neitehr of thosee were trye");
  }
}

},{}],24:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FetchBrokerReviewsUrl = /* common-shake removed: exports.EditBrokerReviewUrl = */ /* common-shake removed: exports.DeleteBrokerReviewUrl = */ void 0;
exports.GetAvatarPath = GetAvatarPath;
exports.GetReviewImageUrl = GetReviewImageUrl;
/* common-shake removed: exports.SaveBrokerReviewUrl = */ exports.MiniReviewsUrl = exports.LoadBrokerRatingsUrl = void 0;
// Urls.js – 
// Endpoints for Broker Review Features
var AvatarPath = "".concat(window.assetServer, "/assets/images/profiles/");
var ReviewImagePath = "".concat(window.assetServer, "/assets/images/reviews/");
var SaveBrokerReviewUrl = /* common-shake removed: exports.SaveBrokerReviewUrl = */ withLangPrefix('/reviews/save');
var EditBrokerReviewUrl = /* common-shake removed: exports.EditBrokerReviewUrl = */ withLangPrefix('/reviews/edit');
var DeleteBrokerReviewUrl = /* common-shake removed: exports.DeleteBrokerReviewUrl = */ withLangPrefix('/reviews/delete');
var FetchBrokerReviewsUrl = exports.FetchBrokerReviewsUrl = withLangPrefix('/api/brokers/reviews/load');
var MiniReviewsUrl = exports.MiniReviewsUrl = withLangPrefix('/brokers/mini-reviews/load');
var LoadBrokerRatingsUrl = exports.LoadBrokerRatingsUrl = withLangPrefix('/api/brokers/ratings/');
function GetAvatarPath(avatarKey) {
  var cleanPath = "".concat(AvatarPath.replace(/\/$/, ''), "/").concat(avatarKey.replace(/^\//, ''));
  return cleanPath;
}
function GetReviewImageUrl(imageKey) {
  var cleanPath = "".concat(ReviewImagePath.replace(/\/$/, ''), "/").concat(imageKey.replace(' ', '').replace(/^\//, ''));
  return cleanPath;
}
function withLangPrefix(path) {
  if (typeof CURRENT_LANG === 'string' && typeof DEFAULT_LANG === 'string' && CURRENT_LANG !== DEFAULT_LANG) {
    return "/".concat(CURRENT_LANG).concat(path);
  }
  return path;
}

},{}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OpenDisputeResponseDialog = OpenDisputeResponseDialog;
exports.RemoveDisputeImage = RemoveDisputeImage;
exports.ShowImageLightbox = ShowImageLightbox;
exports.SubmitDisputeResponse = SubmitDisputeResponse;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
* DisputeResponse.js
* Handles functionality for the dispute response dialog including rich text editing,
* image uploads, and form submission.
*/
var DisputeResponseManager = /*#__PURE__*/function () {
  function DisputeResponseManager() {
    _classCallCheck(this, DisputeResponseManager);
    this.maxImages = 5;
    this.maxFileSize = 10 * 1024 * 1024; // 10MB
    this.allowedTypes = ['image/jpeg', 'image/png', 'image/gif'];
    this.uploadedImages = [];
    this.currentReviewId = null;
    this.initializeModalEventListeners();
  }

  /**
   * Initialize event listeners for modal close
   */
  return _createClass(DisputeResponseManager, [{
    key: "initializeModalEventListeners",
    value: function initializeModalEventListeners() {
      $(document).on('hidden.bs.modal', '#dispute-response-dialog', function () {
        // Remove disputeResponseId parameter from URL and reload
        var url = new URL(window.location.href);
        if (url.searchParams.has('disputeResponseId')) {
          url.searchParams["delete"]('disputeResponseId');
          window.location.href = url.toString();
        }
      });
    }

    /**
     * Opens the dispute response dialog and loads dispute data
     * @param {number} reviewId - ID of the disputed review
     * @param {object} disputeData - Dispute information from server
     */
  }, {
    key: "openDialog",
    value: function openDialog(reviewId, disputeData) {
      this.currentReviewId = reviewId;
      this.uploadedImages = [];

      // Set review ID
      document.getElementById('dispute-review-id').value = reviewId;
      document.getElementById('response-review-id').value = reviewId;
      document.getElementById('response-social-profile-id').value = disputeData.socialProfileId;

      // Display original review content
      this.renderOriginalReview(disputeData.originalReview);

      // Display company's dispute message
      document.getElementById('dispute-content-display').innerHTML = disputeData.disputeContent || '';

      // Display dispute images as clickable buttons if any
      if (disputeData.images && disputeData.images.length > 0) {
        var imagesHtml = '<div>';
        disputeData.images.forEach(function (img, index) {
          imagesHtml += "\n                    <div class=\"flex align-items-center\" style=\"gap:8px; cursor: pointer\" onclick=\"window.BrokerReview.ShowImageLightbox('".concat(img, "')\">\n                        <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"17\" height=\"17\" viewBox=\"0 0 17 17\" fill=\"none\">\n                            <path d=\"M1.80775 17C1.30258 17 0.875 16.825 0.525 16.475C0.175 16.125 0 15.6974 0 15.1923V1.80775C0 1.30258 0.175 0.875 0.525 0.525C0.875 0.175 1.30258 0 1.80775 0H15.1923C15.6974 0 16.125 0.175 16.475 0.525C16.825 0.875 17 1.30258 17 1.80775V15.1923C17 15.6974 16.825 16.125 16.475 16.475C16.125 16.825 15.6974 17 15.1923 17H1.80775ZM4.154 13.25H12.923C13.1038 13.25 13.2378 13.1679 13.325 13.0038C13.4122 12.8398 13.3987 12.6808 13.2845 12.527L10.9 9.33275C10.8063 9.21225 10.6858 9.152 10.5385 9.152C10.391 9.152 10.2705 9.21225 10.177 9.33275L7.73075 12.5192L6.09225 10.4192C5.99875 10.3051 5.87983 10.248 5.7355 10.248C5.59133 10.248 5.47242 10.3083 5.37875 10.429L3.802 12.527C3.6815 12.6808 3.66483 12.8398 3.752 13.0038C3.83917 13.1679 3.97317 13.25 4.154 13.25Z\" fill=\"#4085F3\"/>\n                        </svg>\n                        <span style=\"font-size: 16px; color: #4085F3\">Image ").concat(index + 1, "</span>\n                    </div>\n                ");
        });
        imagesHtml += '</div>';
        document.getElementById('dispute-images-display').innerHTML = imagesHtml;
      } else {
        document.getElementById('dispute-images-display').innerHTML = '';
      }

      // Show modal
      $('#dispute-response-dialog').modal('show');
    }

    /**
     * Renders the original review content with rating
     * @param {object} review - Original review data
     */
  }, {
    key: "renderOriginalReview",
    value: function renderOriginalReview(review) {
      var ratingStars = this.generateStarRating(review.rating);
      var reviewImagesHtml = '';
      if (review.images && review.images.length > 0) {
        reviewImagesHtml = '<div class="review-images">';
        review.images.forEach(function (img, index) {
          reviewImagesHtml += "\n                    <div class=\"flex align-items-center\" style=\"gap:8px; cursor: pointer\" onclick=\"window.BrokerReview.ShowImageLightbox('".concat(img, "')\">\n                        <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"17\" height=\"17\" viewBox=\"0 0 17 17\" fill=\"none\">\n                            <path d=\"M1.80775 17C1.30258 17 0.875 16.825 0.525 16.475C0.175 16.125 0 15.6974 0 15.1923V1.80775C0 1.30258 0.175 0.875 0.525 0.525C0.875 0.175 1.30258 0 1.80775 0H15.1923C15.6974 0 16.125 0.175 16.475 0.525C16.825 0.875 17 1.30258 17 1.80775V15.1923C17 15.6974 16.825 16.125 16.475 16.475C16.125 16.825 15.6974 17 15.1923 17H1.80775ZM4.154 13.25H12.923C13.1038 13.25 13.2378 13.1679 13.325 13.0038C13.4122 12.8398 13.3987 12.6808 13.2845 12.527L10.9 9.33275C10.8063 9.21225 10.6858 9.152 10.5385 9.152C10.391 9.152 10.2705 9.21225 10.177 9.33275L7.73075 12.5192L6.09225 10.4192C5.99875 10.3051 5.87983 10.248 5.7355 10.248C5.59133 10.248 5.47242 10.3083 5.37875 10.429L3.802 12.527C3.6815 12.6808 3.66483 12.8398 3.752 13.0038C3.83917 13.1679 3.97317 13.25 4.154 13.25Z\" fill=\"#4085F3\"/>\n                        </svg>\n                        <span style=\"font-size: 16px; color: #4085F3\">Image ").concat(index + 1, "</span>\n                    </div>\n                ");
        });
        reviewImagesHtml += '</div>';
      }
      var reviewHtml = "\n        <div class=\"d-flex align-items-center\">\n            <div class=\"review-stars\">".concat(ratingStars, "</div>\n            <span class=\"ml-2\" style=\"font-size: 16px; font-weight: 600\">").concat(review.rating.toFixed(1), "</span>\n        </div>\n        <p class=\"review-content\">").concat(this.escapeHtml(review.content), "</p>\n        ").concat(reviewImagesHtml, "\n    ");
      document.getElementById('dispute-original-review-display').innerHTML = reviewHtml;
    }

    /**
     * Generates star rating HTML
     * @param {number} rating - Rating value (0-5)
     * @returns {string} HTML string for stars
     */
  }, {
    key: "generateStarRating",
    value: function generateStarRating(rating) {
      var colors = ['#FA4C3B', '#FA9529', '#FDC240', '#85DF2C', '#27AE1E'];
      var roundedRating = Math.round(rating);
      var half = Math.ceil(rating / 0.5) * 0.5 % 1 > 0.490;
      var stars = "<div class=\"star-rating-sm\"><div class=\"star-holder\" style=\"color: ".concat(colors[roundedRating - 1], "\">");
      stars += '<span class="typcn stars-' + roundedRating + '"></span>';
      if (half) {
        stars += '<span class="typcn typcn-star-half-outline"></span>';
      }
      stars += '<span class="typcn outline-stars-' + (5 - roundedRating - (half ? 1 : 0)) + '"></span>';
      stars += "</div></div>";
      return stars;
    }

    /**
     * Submits the dispute response
     */
  }, {
    key: "submitResponse",
    value: (function () {
      var _submitResponse = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var reviewId, socialProfileId, responseMessage, formData;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              reviewId = $("#response-review-id").val();
              socialProfileId = $("#response-social-profile-id").val();
              responseMessage = $("#dispute-response-message").val();
              formData = new FormData();
              formData.append('ReviewId', reviewId);
              formData.append('SocialProfileId', socialProfileId);
              formData.append('ResponseMessage', responseMessage);
              window.selectedFiles.forEach(function (file) {
                formData.append('Files', file, file.name);
              });
              $.ajax({
                type: "POST",
                cache: false,
                // ReSharper disable once UseOfImplicitGlobalInFunctionScope
                processData: false,
                contentType: false,
                url: window.submitBrokerReviewDisputeResponseUrl,
                dataType: "json",
                data: formData,
                async: false,
                success: function success(result) {
                  if (result.Success) {
                    toastr.success("Dispute response submitted successfully.");
                  }
                  $("#dispute-response-dialog").modal('hide');
                },
                error: function error(result) {
                  alert("An error has occurred " + result.Message);
                  return false;
                },
                failure: function failure() {
                  alert("Network error");
                  return false;
                }
              });
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }));
      function submitResponse() {
        return _submitResponse.apply(this, arguments);
      }
      return submitResponse;
    }()
    /**
     * Escapes HTML to prevent XSS
     * @param {string} text - Text to escape
     * @returns {string} Escaped text
     */
    )
  }, {
    key: "escapeHtml",
    value: function escapeHtml(text) {
      var div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }
  }]);
}(); // Initialize and export
var disputeResponseManager = new DisputeResponseManager();
function OpenDisputeResponseDialog(reviewId, disputeData) {
  disputeResponseManager.openDialog(reviewId, disputeData);
}
function RemoveDisputeImage(imageId) {
  disputeResponseManager.removeImage(imageId);
}
function SubmitDisputeResponse() {
  disputeResponseManager.submitResponse();
}
function ShowImageLightbox(imagePath) {
  // Simple lightbox implementation with fitted image
  var lightboxHtml = "\n        <div class=\"modal fade\" id=\"image-lightbox-modal\" tabindex=\"-1\">\n            <div class=\"modal-dialog modal-dialog-centered\" style=\"max-width: none; margin: 0; width: 100vw; height: 100vh;\">\n                <div class=\"modal-content bg-transparent border-0\" style=\"height: 100%; display: flex; align-items: center; justify-content: center;\">\n                    <div class=\"modal-body p-0 text-center flex align-items-center\" style=\"position: relative; max-width: 90vw; max-height: 90vh;\">\n                        <img src=\"".concat(window.assetServer, "/assets/images/reviews/").concat(imagePath, "\" \n                             class=\"img-fluid\" \n                             style=\"max-width: 100%; max-height: 90vh; width: auto; height: auto; display: block; margin: 0 auto; cursor: default;\"\n                             onclick=\"event.stopPropagation();\">\n                    </div>\n                </div>\n            </div>\n        </div>\n    ");

  // Remove existing lightbox if any
  $('#image-lightbox-modal').remove();

  // Add and show new lightbox
  $('body').append(lightboxHtml);
  var $modal = $('#image-lightbox-modal');

  // Add gray backdrop
  $modal.css('background-color', 'rgba(0, 0, 0, 0.6)');

  // Close on click outside image
  $modal.find('.modal-dialog, .modal-content, .modal-body').on('click', function (e) {
    if (e.target === this) {
      $modal.modal('hide');
    }
  });

  // Show modal
  $modal.modal({
    backdrop: false,
    // Disable default backdrop since we're using custom styling
    keyboard: true // Allow ESC key to close
  });

  // Clean up after close
  $modal.on('hidden.bs.modal', function () {
    $(this).remove();
    console.log("close light box");
    var openModals = $('.modal.show, .modal.in').length;

    // If modals are still open, ensure body keeps modal-open class
    if (openModals > 0) {
      setTimeout(function () {
        if (!$('body').hasClass('modal-open')) {
          $('body').addClass('modal-open');
        }
      }, 50);
    }
  });
}

},{}],32:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GetAnonThumbState = GetAnonThumbState;
exports.GetMyVote = GetMyVote;
exports.LoadAnonLikesFromStorage = LoadAnonLikesFromStorage;
/* common-shake removed: exports.SetAnonThumbState = */ void SetAnonThumbState;
var _State = require("./State.js");
function LoadAnonLikesFromStorage() {
  try {
    var stored = localStorage.getItem('SocialProfileLikes');
    _State.AnonState.Likes = stored ? JSON.parse(stored) : [];
  } catch (_unused) {
    _State.AnonState.Likes = [];
  }
}
function GetAnonThumbState(entityId, channel) {
  var intId = parseInt(entityId, 10);
  var myVote = '';
  if (intId > 0) {
    var upThumbData = {
      direction: 'up',
      channel: channel,
      id: intId
    };
    var upThumb = Hash(JSON.stringify(upThumbData), 23);
    var downThumbData = {
      direction: 'down',
      channel: channel,
      id: intId
    };
    var downThumb = Hash(JSON.stringify(downThumbData), 23);
    if (_State.AnonState.Likes.includes(downThumb)) {
      myVote = 'down';
    } else if (_State.AnonState.Likes.includes(upThumb)) {
      myVote = 'up';
    }
  }
  return myVote;
}
function SetAnonThumbState(entityId, activityType, vote) {
  _State.AnonState.Likes = _State.AnonState.Likes.filter(function (x) {
    return !(x.EntityId === entityId && x.ActivityType === activityType);
  });
  _State.AnonState.Likes.push({
    EntityId: entityId,
    ActivityType: activityType,
    Vote: vote
  });
  localStorage.setItem('SocialProfileLikes', JSON.stringify(AnonSocialProfileLikes));
}
function GetMyVote(likeableEntity, myId, isAnon) {
  if (!isAnon && myId) {
    var _likeableEntity$UpVot, _likeableEntity$UpVot2, _likeableEntity$DownV, _likeableEntity$DownV2;
    var upVotes = (_likeableEntity$UpVot = (_likeableEntity$UpVot2 = likeableEntity.UpVotes) === null || _likeableEntity$UpVot2 === void 0 ? void 0 : _likeableEntity$UpVot2.split(',')) !== null && _likeableEntity$UpVot !== void 0 ? _likeableEntity$UpVot : [];
    var downVotes = (_likeableEntity$DownV = (_likeableEntity$DownV2 = likeableEntity.DownVotes) === null || _likeableEntity$DownV2 === void 0 ? void 0 : _likeableEntity$DownV2.split(',')) !== null && _likeableEntity$DownV !== void 0 ? _likeableEntity$DownV : [];
    if (upVotes.includes(myId)) return 'up';
    if (downVotes.includes(myId)) return 'down';
  } else {
    var _AnonState$Likes;
    if ((_AnonState$Likes = _State.AnonState.Likes) !== null && _AnonState$Likes !== void 0 && _AnonState$Likes.length) {
      return GetAnonThumbState(parseInt(likeableEntity.EntityId), likeableEntity.ActivityType);
    }
  }
  return '';
}
function Hash(str) {
  var seed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var h1 = 0xdeadbeef ^ seed,
    h2 = 0x41c6ce57 ^ seed;
  for (var i = 0, ch; i < str.length; i++) {
    ch = str.charCodeAt(i);
    h1 = Math.imul(h1 ^ ch, 2654435761);
    h2 = Math.imul(h2 ^ ch, 1597334677);
  }
  h1 = Math.imul(h1 ^ h1 >>> 16, 2246822507) ^ Math.imul(h2 ^ h2 >>> 13, 3266489909);
  h2 = Math.imul(h2 ^ h2 >>> 16, 2246822507) ^ Math.imul(h1 ^ h1 >>> 13, 3266489909);
  return 4294967296 * (2097151 & h2) + (h1 >>> 0);
}

},{"./State.js":33}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppendForumImagesToFormData = AppendForumImagesToFormData;
/* common-shake removed: exports.IgniteAddPhotoButton = */ void IgniteAddPhotoButton;
exports.InitializeLBImages = InitializeLBImages;
exports.PaintRestoredImage = PaintRestoredImage;
exports.RemoveImage = RemoveImage;
/* common-shake removed: exports.allowedFileTypes = */ void void 0;
var _State = require("./State.js");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function InitializeLBImages(containerClass) {
  var images = $('.' + containerClass + ' img.lightbox-slide:not(.lightbox-image)');
  for (var i = 0; i < images.length; i++) {
    if ($(images[i]).parent().is('a')) continue;
    var srcLink = $(images[i]).attr('src');
    $(images[i]).wrap("<a href='".concat(srcLink, "' data-toggle='lightbox-image' data-target-id='lightbox-image-holder'>"));
  }
  $('[data-toggle="lightbox-image"]').on('click', function (e) {
    var _this = this;
    e.preventDefault();
    var clickedIndex = 0;
    var gallery = $(this).closest('.image-row').find('img');
    var id = $(this).data("target-id");
    var srclink = $(this).attr('href');
    $('#' + id + " img.lightbox-image").attr('src', srclink);
    var modelPopUp = $('#' + id);
    modelPopUp.removeClass('has-next has-prev');
    modelPopUp.data('gallery', []);
    if (gallery.length > 1) {
      modelPopUp.data('gallery', gallery);
      gallery.each(function (i, el) {
        if (el.src === _this.href) clickedIndex = i;
      });
      modelPopUp.data('currentIndex', clickedIndex);
      if (clickedIndex > 0) modelPopUp.addClass('has-prev');
      if (clickedIndex + 1 < gallery.length) modelPopUp.addClass('has-next');
    }
    $('.XofY .x').html(clickedIndex + 1);
    $('.XofY .y').html(gallery.length);
    setTimeout(function () {
      return modelPopUp.modal('show');
    }, 100);
    return false;
  });
}
function IgniteAddPhotoButton() {
  imgInp.onchange = function (evt) {
    var _imgInp$files = _slicedToArray(imgInp.files, 1),
      file = _imgInp$files[0];
    if (!file) return;

    // Validate file type
    if (!allowedFileTypes.includes(file.type)) {
      alert(window.INVALID_FILE_TYPE);
      return;
    }

    // Validate file size (2 MB limit)
    if (file.size > 2 * 1024 * 1024) {
      alert(window.FILE_SIZE_TOO_BIG);
      return;
    }

    // Paint preview
    PaintImage(file, "#img-frames"); // assuming target ID

    // Store with metadata
    _State.ReviewState.Tmp_files.push({
      file: file,
      name: file.name,
      type: "new",
      deleted: false
    });
  };
}
function PaintRestoredImage(file) {
  var frameId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "#img-frames";
  // specialized version for editing mode
  var reader = new FileReader();
  reader.onload = function (e) {
    var imgHTML = "<div class='attached-files'>\n            <img src='".concat(e.target.result, "' class=\"review-image\" style=\"max-width: 100%; height: auto;\">\n            <svg fill=\"currentColor\"\n     onclick=\"window.BrokerReview.RemoveImage('").concat(file.name, "','").concat(frameId, "')\"\n     preserveAspectRatio=\"xMidYMid meet\"\n     height=\"25\"\n     width=\"25\"\n     viewBox=\"0 0 40 40\"\n     class=\"delete-review-image\"\n     style=\"vertical-align: middle; color: rgb(51, 51, 51);\">\n    <g>\n        <path d=\"m30.1 21.4v-2.8q0-0.6-0.4-1t-1-0.5h-17.1q-0.6 0-1 0.5t-0.5 1v2.8q0 0.6 0.5 1t1 0.5h17.1q0.6 0 1-0.5t0.4-1z \n                 m7.2-1.4q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 \n                 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z\"></path>\n    </g>\n</svg>\n\n        </div>");
    $(frameId).append(imgHTML);
  };
  reader.readAsDataURL(file);
}
;
function AppendForumImagesToFormData(formData) {
  var deletedRestored = [];
  var preservedRestored = [];
  var _iterator = _createForOfIteratorHelper(_State.ReviewState.Tmp_files),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _meta$file;
      var meta = _step.value;
      if (meta.type === "new" && !meta.deleted && (_meta$file = meta.file) !== null && _meta$file !== void 0 && (_meta$file = _meta$file.type) !== null && _meta$file !== void 0 && _meta$file.match('image.*')) {
        formData.append('Files', meta.file, meta.name);
      }
      if (meta.type === "restored" && meta.deleted) {
        deletedRestored.push(meta.name);
      }
      if (meta.type === "restored" && !meta.deleted) {
        preservedRestored.push(meta.name);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  deletedRestored.forEach(function (name) {
    return formData.append('DeletedFileNames', name);
  });
  preservedRestored.forEach(function (name) {
    return formData.append('PreservedFileNames', name);
  });
}
function RemoveImage(fileName) {
  var frameId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "#img-frames";
  // Mark matching image as deleted
  var _iterator2 = _createForOfIteratorHelper(_State.ReviewState.Tmp_files),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var entry = _step2.value;
      if (entry.name === fileName) {
        entry.deleted = true;
      }
    }

    // Clear image preview container
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  $(frameId).html('');

  // Re-render only non-deleted images
  var _iterator3 = _createForOfIteratorHelper(_State.ReviewState.Tmp_files),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _entry = _step3.value;
      if (!_entry.deleted) {
        PaintImage(_entry, frameId);
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
}
var allowedFileTypes = /* common-shake removed: exports.allowedFileTypes = */ ["image/jpeg", "image/png", "image/gif", "image/webp", "image/heic", "image/heif"];
function PaintImage(fileOrObject) {
  var frameId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "#img-frames";
  var entry = fileOrObject.file ? fileOrObject : {
    file: fileOrObject,
    name: fileOrObject.name
  };
  var imageHTML = "\n        <div class='attached-files'>\n            <img src='".concat(URL.createObjectURL(entry.file), "' class=\"review-image\">\n            ").concat(GetDeleteIcon(entry.name, frameId), "\n        </div>");
  $(frameId).append(imageHTML);
}
function GetDeleteIcon(fileName, frameId) {
  return "<svg fill=\"currentColor\"\n        onclick=\"window.BrokerReview.RemoveImage('".concat(fileName, "','").concat(frameId, "')\"\n        preserveAspectRatio=\"xMidYMid meet\"\n        height=\"25\" width=\"25\"\n        viewBox=\"0 0 40 40\"\n        class=\"delete-review-image\"\n        style=\"vertical-align: middle; color: rgb(51, 51, 51);\">\n        <g>\n            <path d=\"m30.1 21.4v-2.8q0-0.6-0.4-1t-1-0.5h-17.1q-0.6 0-1 0.5t-0.5 1v2.8q0 0.6 0.5 1t1 0.5h17.1q0.6 0 1-0.5t0.4-1z \n                     m7.2-1.4q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 \n                     2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z\"></path>\n        </g>\n    </svg>");
}

},{"./State.js":13}],25:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterBrokerReviews = FilterBrokerReviews;
exports.HandleTabSwitch = HandleTabSwitch;
exports.LayoutReviewImages = LayoutReviewImages;
exports.LoadBrokerRatingValues = LoadBrokerRatingValues;
/* common-shake removed: exports.LoadReviews = */ void LoadReviews;
exports.ProcessMiniReviewData = ProcessMiniReviewData;
exports.RenderAjaxPagination = RenderAjaxPagination;
exports.RenderBrokerFilter = RenderBrokerFilter;
var _LightBox = require("./LightBox.js");
var _State = require("./State.js");
var _Hooks = require("./Hooks.js");
var _Render = require("./Render.js");
var _Likes = require("../Shared/Likes.js");
var _State2 = require("../Shared/State.js");
var _Urls = require("./Urls.js");
var _Review = require("./Review.js");
var _Controller = require("./Controller.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function RenderBrokerFilter(brokerRatings, accountTypeSelectList) {
  if (brokerRatings != null) {
    var fiveStarPercent = RoundNumberToTwoDecimalPlaces(brokerRatings.PercentageFive * 100);
    var fourStarPercent = RoundNumberToTwoDecimalPlaces(brokerRatings.PercentageFour * 100);
    var threeStarPercent = RoundNumberToTwoDecimalPlaces(brokerRatings.PercentageThree * 100);
    var twoStarPercent = RoundNumberToTwoDecimalPlaces(brokerRatings.PercentageTwo * 100);
    var oneStarPercent = RoundNumberToTwoDecimalPlaces(brokerRatings.PercentageOne * 100);
    $('#inner-bar-five').css('width', fiveStarPercent + "%");
    $('#broker-ratings-five').html(fiveStarPercent + "%");
    $('#inner-bar-four').css('width', fourStarPercent + "%");
    $('#broker-ratings-four').html(fourStarPercent + "%");
    $('#inner-bar-three').css('width', threeStarPercent + "%");
    $('#broker-ratings-three').html(threeStarPercent + "%");
    $('#inner-bar-two').css('width', twoStarPercent + "%");
    $('#broker-ratings-two').html(twoStarPercent + "%");
    $('#inner-bar-one').css('width', oneStarPercent + "%");
    $('#broker-ratings-one').html(oneStarPercent + "%");
    var accTypeContainer = document.getElementById('review-acc-type-select');
    (0, _Render.RenderAccountTypeSelectList)(accTypeContainer, accountTypeSelectList);
    var spamStarPercent = 0;
    if (!brokerRatings.ReviewCount) brokerRatings.ReviewCount = 0;
    if (!brokerRatings.RejectedCount) brokerRatings.RejectedCount = 0;
    if (brokerRatings.ReviewCount + brokerRatings.RejectedCount != 0) spamStarPercent = RoundNumberToTwoDecimalPlaces(brokerRatings.RejectedCount / (brokerRatings.ReviewCount + brokerRatings.RejectedCount) * 100);
    $('#inner-bar-spam').css('width', spamStarPercent + "%");
    $('#broker-ratings-spam').html(brokerRatings.RejectedCount);
    var rejectedTab = document.querySelector('.fxv-review-tab[data-target="#fxv-rejected-review-content"] a');
    var count = brokerRatings.RejectedCount || 0;
    if (rejectedTab) {
      rejectedTab.innerHTML = "".concat(window.SPAM, " &nbsp;<span id=\"review-rejected-review-count\">(").concat(count, ")</span>");
    }
    $("#review-approved-review-count").html('(' + brokerRatings.ReviewCount + ')');
  }
}
function HandleTabSwitch(tabElement) {
  var targetSelector = tabElement.getAttribute('data-target');
  var isRejectedTab = targetSelector === '#fxv-rejected-review-content';
  var loadOptions = {
    loadRejected: isRejectedTab,
    page: 1,
    url: _Urls.FetchBrokerReviewsUrl,
    callback: _Review.ProcessBrokerReviews,
    dataContainerId: isRejectedTab ? 'rejected-review-template' : 'review-template',
    doScroll: false,
    filters: {}
  };
  var loadFn = isRejectedTab ? FilterBrokerReviews : LoadReviews;
  loadFn(loadOptions)["catch"](function (err) {
    console.error("[HandleTabSwitch] Failed to load ".concat(isRejectedTab ? 'rejected' : 'normal', " reviews:"), err);
  });

  // Toggle tab classes
  document.querySelectorAll('.fxv-review-tab').forEach(function (el) {
    return el.classList.remove('fxv-review-tab-active');
  });
  tabElement.classList.add('fxv-review-tab-active');

  // Toggle tab content visibility
  document.querySelectorAll('.fxv-review-tab-content').forEach(function (content) {
    content.classList.remove('fxv-review-tab-active');
  });
  var targetContent = document.querySelector(targetSelector);
  if (targetContent) {
    targetContent.classList.add('fxv-review-tab-active');
  }
}
function LoadBrokerRatingValues(brokerId) {
  fetch("".concat(_Urls.LoadBrokerRatingsUrl).concat(brokerId), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    cache: 'no-store'
  }).then(function (response) {
    if (!response.ok) throw new Error("Failed to load broker ratings: ".concat(response.statusText));
    return response.json();
  }).then(function (result) {
    window.brokerRatings = result;
    if (result.UserCountryAvailability) {
      window.brokerCountries = result.AllCountries;
      var availability = result.UserCountryAvailability.Availability;
      var countryName = result.UserCountryAvailability.CountryName;
      var link = "<a href=\"javascript:void(0);\" onclick=\"OpenCountryAvailabilityDialog();\">".concat(countryName, "</a>");
      var availabilityElement = document.getElementById("broker-availability");
      var message = '';
      var icon = '';
      if (availability === 2) {
        message = window.NOT_AVAILABLE_IN_0.replace('{0}', link);
        icon = '/Content/dist/images/icons/cons-check.svg';
      } else if (availability === 0) {
        message = window.UNKNOWN_AVAILABILITY_IN_0.replace('{0}', link);
        icon = '/Content/dist/images/icons/cons-check.svg';
      } else if (availability === 1) {
        message = window.AVAILABLE_IN_0.replace('{0}', link);
        icon = '/Content/dist/images/icons/pros-check.svg';
      }
      availabilityElement.innerHTML = "<img src=\"".concat(icon, "\" /> ").concat(message);
      availabilityElement.style.display = 'block';
    }
  })["catch"](function (err) {
    console.error('[LoadBrokerRatings] Error:', err);
  });
}
function ProcessMiniReviewData(result, data, isInit) {
  var isAnon = !(result.reviewModel && result.reviewModel.MyProfile && result.reviewModel.MyProfile.Id !== null && result.reviewModel.MyProfile.Id !== undefined && parseInt(result.reviewModel.MyProfile.Id, 10) > 0);
  var isMasquerade = result.reviewModel.IsMasquerade;
  if (isAnon) {
    (0, _Likes.LoadAnonLikesFromStorage)();
  } else {
    _State2.SocialProfileState.MyProfile = result.reviewModel.MyProfile;
  }
  populateReviewTab(result.reviewModel.Reviews, result.reviewModel.MyProfile, 'mini-review-template', isAnon, result.reviewModel.Page != 1, isMasquerade);
  $("#mini-review-template").data('page', result.reviewModel.Page);
  if (result.reviewModel.HasNextPage) {
    var nextPage = isInit ? 1 : result.reviewModel.Page + 1;
    $('#mini-review-paginator').html("<a class=\"waves-effect frn-button medium navy curved mini-review-load-more\" role=\"button\" href=\"javascript:void(0);\" data-page=\"".concat(nextPage, "\">").concat(window.SHOW_MORE_0_TOTAL.replace('{0}', result.reviewModel.TotalReviews), "</a>"));

    // Attach event listener to the newly created button
    $('#mini-review-paginator .mini-review-load-more').off('click').on('click', function (e) {
      e.preventDefault();
      var pageToLoad = parseInt($(this).attr('data-page'), 10);
      (0, _Controller.LoadMiniReviews)(pageToLoad);
    });
  } else {
    $('#mini-review-paginator').html("");
  }
  _State.ReviewState.LoadedReviewComments = result.reviewModel.Comments;
}
function LayoutReviewImages(_x) {
  return _LayoutReviewImages.apply(this, arguments);
}
/**
 * Renders an AJAX-based pagination control and hooks up click handlers to fetch pages dynamically.
 *
 * @param {Object} paginationMeta - Pagination metadata.
 * @param {number} paginationMeta.PageCount - Total number of pages.
 * @param {number} paginationMeta.PageNumber - Current page number.
 * @param {string} containerId - The ID of the DOM element to render the pagination inside.
 * @param {string} url - The endpoint to fetch the paginated content.
 * @param {function|null} callback - A callback to execute once the data is successfully fetched.
 * @param {string} dataContainerId - ID of the content container where results will be injected.
 * @param {Object} [filters={}] - Additional filters to persist across page changes.
 */
function _LayoutReviewImages() {
  _LayoutReviewImages = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(fileNames) {
    var processRestoredImage, _processRestoredImage, _iterator, _step, file, _t;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          _processRestoredImage = function _processRestoredImage3() {
            _processRestoredImage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(fileName) {
              var loadFile, response, blob, mime, file;
              return _regenerator().w(function (_context) {
                while (1) switch (_context.n) {
                  case 0:
                    loadFile = "/local/assets/images/reviews/" + fileName;
                    _context.n = 1;
                    return fetch(loadFile);
                  case 1:
                    response = _context.v;
                    _context.n = 2;
                    return response.blob();
                  case 2:
                    blob = _context.v;
                    mime = blob.type || (fileName.endsWith(".png") ? "image/png" : fileName.endsWith(".gif") ? "image/gif" : fileName.endsWith(".webp") ? "image/webp" : "image/jpeg");
                    file = new File([blob], fileName, {
                      type: mime
                    }); // Store with metadata
                    _State.ReviewState.Tmp_files.push({
                      file: file,
                      name: file.name,
                      type: "restored",
                      deleted: false
                    });

                    // Render it
                    (0, _LightBox.PaintRestoredImage)(file, "#img-frames");
                  case 3:
                    return _context.a(2);
                }
              }, _callee);
            }));
            return _processRestoredImage.apply(this, arguments);
          };
          processRestoredImage = function _processRestoredImage2(_x4) {
            return _processRestoredImage.apply(this, arguments);
          };
          _State.ReviewState.Tmp_files = [];
          _iterator = _createForOfIteratorHelper(fileNames);
          _context2.p = 1;
          _iterator.s();
        case 2:
          if ((_step = _iterator.n()).done) {
            _context2.n = 4;
            break;
          }
          file = _step.value;
          _context2.n = 3;
          return processRestoredImage(file);
        case 3:
          _context2.n = 2;
          break;
        case 4:
          _context2.n = 6;
          break;
        case 5:
          _context2.p = 5;
          _t = _context2.v;
          _iterator.e(_t);
        case 6:
          _context2.p = 6;
          _iterator.f();
          return _context2.f(6);
        case 7:
          ;
        case 8:
          return _context2.a(2);
      }
    }, _callee2, null, [[1, 5, 6, 7]]);
  }));
  return _LayoutReviewImages.apply(this, arguments);
}
function RenderAjaxPagination(paginationMeta, containerId, url) {
  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var dataContainerId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  var filters = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var PageCount = paginationMeta.PageCount,
    PageNumber = paginationMeta.PageNumber;
  var currentPage = parseInt(PageNumber, 10);
  var container = document.getElementById(containerId);
  if (!container) return;
  container.innerHTML = '';
  var loadRejcted = containerId.includes("rejected");
  var ul = document.createElement('ul');
  ul.className = 'pagination';

  /**
   * Creates a pagination list item.
   *
   * @param {string|number} text - The display text (number or symbol).
   * @param {boolean} isActive - Whether this page is currently active.
   * @param {number|null} page - The page number to link to.
   * @param {boolean} [isLink=true] - Whether the item is clickable.
   * @returns {HTMLElement} The constructed <li> element.
   */
  var createPageItem = function createPageItem(text, isActive, page) {
    var isLink = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var li = document.createElement('li');
    if (isActive) li.classList.add('active');
    var el = isLink ? document.createElement('a') : document.createElement('span');
    el.textContent = text;
    if (isLink) {
      el.href = 'javascript:void(0)';
      el.addEventListener('click', function () {
        LoadReviews({
          page: page,
          url: url,
          callback: callback,
          dataContainerId: dataContainerId,
          filters: filters,
          loadRejected: loadRejcted
        });
      });
    }
    li.appendChild(el);
    return li;
  };
  var range = 2; // how many pages to show on either side of current
  var start = Math.max(1, currentPage - range);
  var end = Math.min(PageCount, currentPage + range);

  // << First
  if (currentPage > 1) {
    ul.appendChild(createPageItem('«', false, 1, 'PagedList-skipToFirst'));
  }

  // < Previous
  if (currentPage > 1) {
    ul.appendChild(createPageItem('‹', false, currentPage - 1, 'PagedList-skipToPrevious'));
  }

  // Ellipsis before range
  if (start > 2) {
    ul.appendChild(createPageItem('…', false, null, 'PagedList-ellipses', true));
  }

  // Page Numbers
  for (var i = start; i <= end; i++) {
    ul.appendChild(createPageItem(i, i === currentPage, i));
  }

  // Ellipsis after range
  if (end < PageCount - 1) {
    ul.appendChild(createPageItem('…', false, null, 'PagedList-ellipses', true));
  }

  // > Next
  if (currentPage < PageCount) {
    ul.appendChild(createPageItem('›', false, currentPage + 1, 'PagedList-skipToNext'));
  }

  // >> Last
  if (currentPage < PageCount) {
    ul.appendChild(createPageItem('»', false, PageCount, 'PagedList-skipToLast'));
  }
  var wrapper = document.createElement('div');
  wrapper.className = 'pagination-container';
  wrapper.appendChild(ul);
  container.appendChild(wrapper);
}

/**
 * Loads paginated review data via AJAX and processes it via callback.
 *
 * @param {Object} options
 * @param {number} options.page - The target page number to load.
 * @param {string} options.url - The endpoint to request data from.
 * @param {Function} options.callback - Function to call with response data and container ID.
 * @param {string} options.dataContainerId - ID of the DOM element to scroll into view after load.
 * @param {Object} [options.filters={}] - Additional filtering parameters to send with the request.
 * @param {bool} options.loadRejected - Load rejected views when true, load regular reviews when false.
 * @param {bool} options.doScroll - Scroll to top of container post load when true.
 */
function LoadReviews(_x2) {
  return _LoadReviews.apply(this, arguments);
}
function _LoadReviews() {
  _LoadReviews = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(_ref) {
    var page, url, callback, dataContainerId, _ref$filters, filters, _ref$loadRejected, loadRejected, _ref$doScroll, doScroll, payload, queryString, requestUrl, response, json, scrollTarget, _t2;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.p = _context3.n) {
        case 0:
          page = _ref.page, url = _ref.url, callback = _ref.callback, dataContainerId = _ref.dataContainerId, _ref$filters = _ref.filters, filters = _ref$filters === void 0 ? {} : _ref$filters, _ref$loadRejected = _ref.loadRejected, loadRejected = _ref$loadRejected === void 0 ? false : _ref$loadRejected, _ref$doScroll = _ref.doScroll, doScroll = _ref$doScroll === void 0 ? true : _ref$doScroll;
          // Combine default parameters with pagination
          payload = _objectSpread({
            Page: page,
            LoadRejected: loadRejected,
            BrokerId: _State.ReviewState.BrokerId
          }, filters); // Convert parameters into a query string
          queryString = new URLSearchParams(payload).toString();
          requestUrl = "".concat(url, "?").concat(queryString);
          _context3.p = 1;
          _context3.n = 2;
          return fetch(requestUrl, {
            method: 'GET',
            headers: {
              'Accept': 'application/json'
            }
          });
        case 2:
          response = _context3.v;
          if (response.ok) {
            _context3.n = 3;
            break;
          }
          throw new Error("Failed to fetch page: ".concat(response.statusText));
        case 3:
          _context3.n = 4;
          return response.json();
        case 4:
          json = _context3.v;
          // Process response via callback
          if (typeof callback === 'function') {
            callback(json, dataContainerId);
            if (doScroll) {
              // Smooth scroll to the top of the results container
              scrollTarget = document.getElementById(dataContainerId);
              if (scrollTarget) {
                window.scrollTo({
                  top: scrollTarget.offsetTop - 64,
                  behavior: 'smooth'
                });
              }
            }
          } else {
            console.warn('[LoadReviews] No callback provided to handle result.');
          }
          _context3.n = 6;
          break;
        case 5:
          _context3.p = 5;
          _t2 = _context3.v;
          // Log any network or parsing errors
          console.error('[LoadReviews] Error loading review page:', _t2);
        case 6:
          return _context3.a(2);
      }
    }, _callee3, null, [[1, 5]]);
  }));
  return _LoadReviews.apply(this, arguments);
}
function FilterBrokerReviews(_x3) {
  return _FilterBrokerReviews.apply(this, arguments);
}
function _FilterBrokerReviews() {
  _FilterBrokerReviews = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(loadData) {
    var filter;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          filter = {};
          filter.OneStar = $("#check-one").is(":checked");
          filter.TwoStar = $("#check-two").is(":checked");
          filter.ThreeStar = $("#check-three").is(":checked");
          filter.FourStar = $("#check-four").is(":checked");
          filter.FiveStar = $("#check-five").is(":checked");
          filter.Page = $('#reviews-page').val();
          filter.AccTypeId = $('#review-acc-types option:selected').val();
          filter.Sort = $('#review-sort option:selected').val();
          LoadReviews({
            loadRejected: loadData.dataContainerId === 'review-template' ? false : true,
            page: loadData.page,
            url: loadData.url,
            callback: loadData.callback,
            dataContainerId: loadData.dataContainerId,
            doScroll: loadData.doScroll,
            filters: filter
          });
        case 1:
          return _context4.a(2);
      }
    }, _callee4);
  }));
  return _FilterBrokerReviews.apply(this, arguments);
}
function buildPageUrl(page, filterParams) {
  var url = new URL('/brokers/reviews/load', window.location.origin);
  url.searchParams.set('Page', page);
  for (var _i = 0, _Object$entries = Object.entries(filterParams); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      key = _Object$entries$_i[0],
      val = _Object$entries$_i[1];
    url.searchParams.set(key, val);
  }
  return url.pathname + url.search;
}
function populateReviewTab(reviews, myProfile, id, isAnon) {
  var append = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var isMasquerade = arguments.length > 5 ? arguments[5] : undefined;
  var myVote = '';
  if (!append) {
    $('#' + id).html('');
  }
  reviews && reviews.forEach(function (num, index) {
    myVote = '';
    if (!isAnon) {
      if (reviews[index].UpVotes.includes(myProfile.Id.toString())) {
        myVote = 'up';
      } else if (reviews[index].DownVotes.includes(myProfile.Id.toString())) {
        myVote = 'down';
      }
    } else if (_State2.AnonState.Likes.length) {
      var intId = parseInt(reviews[index].Id, 10);
      myVote = (0, _Likes.GetAnonThumbState)(intId, 'Review');
      console.log("Like for ".concat(intId, " = ").concat(myVote));
    }
    var container = document.getElementById(id);
    var el = document.createElement('div');
    (0, _Render.RenderReviewInto)(el, reviews[index], myVote, myProfile, isMasquerade);
    container.append(el);
  });
  (0, _LightBox.InitializeLBImages)(id);
  (0, _Hooks.IgniteReviewerStatusTooltip)();
}
function RoundNumberToTwoDecimalPlaces(num) {
  var number = Number(new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(num));
  return number;
}

},{"../Shared/Likes.js":32,"../Shared/State.js":33,"./Controller.js":6,"./Hooks.js":8,"./LightBox.js":9,"./Render.js":11,"./Review.js":12,"./State.js":13,"./Urls.js":24}],8:[function(require,module,exports){
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
/* common-shake removed: exports.BindReviewActions = */ void BindReviewActions;
exports.IgniteReviewForm = IgniteReviewForm;
exports.IgniteReviewerStatusTooltip = IgniteReviewerStatusTooltip;
exports.InitializeReviewTabs = InitializeReviewTabs;
var ReviewController = _interopRequireWildcard(require("./Controller.js"));
var _Lightbox = require("./Lightbox.js");
var _Utilities = require("./Utilities.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function IgniteReviewerStatusTooltip() {
  $('.reviewer-status.unverified').tooltip('dispose').tooltip({
    boundary: 'window',
    title: window.APPROVED_REVIEWER_POPOVER
  });
  $('.reviewer-status.verified').tooltip('dispose').tooltip({
    boundary: 'window',
    title: window.VERIFIED_REVIEWER_POPOVER
  });
  $('.reviewer-status.suspicious').tooltip('dispose').tooltip({
    boundary: 'window',
    title: window.SUSPICIOUS_REVIEWER_POPOVER
  });
}
var reviewTabsInitialized = false;
function InitializeReviewTabs() {
  if (reviewTabsInitialized) {
    return; // Already initialized, do nothing
  }
  reviewTabsInitialized = true; // Set the guard
  document.addEventListener('click', function (event) {
    var tab = event.target.closest('.fxv-review-tab');
    if (tab) {
      (0, _Utilities.HandleTabSwitch)(tab);
    }
  });
}
function BindReviewActions() {
  var _container$getElement, _document$getElementB;
  var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  container.querySelectorAll('[data-action="edit-review"]').forEach(function (btn) {
    var reviewId = parseInt(btn.dataset.reviewId, 10);
    btn.addEventListener('click', function () {
      return ReviewController.EditReview(reviewId);
    });
  });
  container.querySelectorAll('[data-action="delete-review"]').forEach(function (btn) {
    var reviewId = parseInt(btn.dataset.reviewId, 10);
    btn.addEventListener('click', function () {
      return ReviewController.DeleteReview(reviewId);
    });
  });
  (_container$getElement = container.getElementById) === null || _container$getElement === void 0 || (_container$getElement = _container$getElement.call(container, 'submit-review-button')) === null || _container$getElement === void 0 || _container$getElement.addEventListener('click', function () {
    ReviewController.SubmitReview();
  });
  (_document$getElementB = document.getElementById('submit-review-button')) === null || _document$getElementB === void 0 || _document$getElementB.addEventListener('click', Review.SubmitReview);
  container.querySelectorAll('[data-review-edit]').forEach(function (btn) {
    var reviewId = btn.getAttribute('data-review-edit');
    btn.addEventListener('click', function () {
      return Review.EditReview(reviewId);
    });
  });
  container.querySelectorAll('[data-review-delete]').forEach(function (btn) {
    var reviewId = btn.getAttribute('data-review-delete');
    btn.addEventListener('click', function () {
      return Review.DeleteReview(reviewId);
    });
  });
}
function IgniteReviewForm() {
  $('#acc-type-all').click(function () {
    if ($(this).is(":checked")) {
      $('.acc-type').each(function (i, e) {
        if ($(e).is(":checked")) {} else {
          $(e).trigger('click');
        }
      });
    }
  });
  $('.acc-type').click(function () {
    if ($(this).is(":checked")) {} else {
      if ($('#acc-type-all').is(":checked")) {
        $('#acc-type-all').trigger('click');
      }
    }
  });
  $('#heart-rate li').mouseover(function () {
    var current = $(this);
    $("#heart-rate li").each(function (i) {
      $(this).addClass('hovered');
      if (i === current.index()) {
        return false;
      }
    });
  });
  $('#heart-rate li').mouseleave(function () {
    $("#heart-rate li").removeClass('hovered');
  });
  $('#heart-rate li').click(function () {
    if ($('#no-rating-checkbox').is(":checked")) {
      $('#no-rating-checkbox').trigger("click");
    }
    $('#heart-rate li').removeClass('clicked');
    $('.hovered').addClass('clicked');
    $('#review-rating').val($('#heart-rate li.clicked').length);
  });
  $('li').mouseover(function () {
    var _this = this;
    var current = $(this);
    $("li").each(function (i) {
      $(_this).add('hovered');
      if (i === current.index()) {
        return false;
      }
    });
  });
  (0, _Lightbox.IgniteAddPhotoButton)();
}

},{"./Controller.js":6,"./Lightbox.js":10,"./Utilities.js":25}],12:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadCustomReviewData = LoadCustomReviewData;
exports.ProcessBrokerReviews = ProcessBrokerReviews;
var _Render = require("./Render.js");
var _State = require("./State.js");
var _State2 = require("../Shared/State.js");
var _LightBox = require("./LightBox.js");
var _UIHooks = require("../Shared/UIHooks.js");
var _Hooks = require("./Hooks.js");
var _Likes = require("../Shared/Likes.js");
var _Utilities = require("./Utilities.js");
var _Urls = require("./Urls.js");
function ProcessBrokerReviews(model, containerId) {
  var _result$MySocialProfi;
  var result = model.reviewModel;
  var isMasquerade = model.reviewModel.IsMasquerade.toString().toLowerCase();
  var container = document.getElementById(containerId);
  if (!container) {
    console.warn("[InitializeReviewModule] Container not found.");
    return;
  }
  ;

  //console.log("are reviews empty? ", result);
  //if (!result?.Reviews) {
  //    console.warn("[InitializeReviewModule] Reviews are empty.");
  //    return;
  //};

  container.innerHTML = '';
  var myId = (_result$MySocialProfi = result.MySocialProfileId) === null || _result$MySocialProfi === void 0 ? void 0 : _result$MySocialProfi.toString();
  var isAnon = !myId || parseInt(myId) <= 0;
  if (isAnon) {
    (0, _Likes.LoadAnonLikesFromStorage)();
  }
  if (result.Comments.length) _State.ReviewState.LoadedReviewComments = result.Comments;
  console.log("comments", _State.ReviewState.LoadedReviewComments);
  _State2.SocialProfileState.MyProfile = result.MyProfile || null;
  if (result.Filter.LoadRejected) {
    var rejectContainer = document.getElementById('rejected-review-template');
    if (rejectContainer) {
      var _result$Reviews;
      if ((_result$Reviews = result.Reviews) !== null && _result$Reviews !== void 0 && _result$Reviews.length) {
        result.Reviews.forEach(function (review) {
          var likebaleEntity = {
            EntityId: review.Id,
            ActivityType: "Review",
            UpVotes: review.UpVotes,
            DownVotes: review.DownVotes
          };
          var myVote = (0, _Likes.GetMyVote)(likebaleEntity, myId, isAnon);
          var el = document.createElement('div');
          (0, _Render.RenderReviewInto)(el, review, myVote, result.MyProfile, isMasquerade);
          rejectContainer.appendChild(el);
        });
      } else {
        rejectContainer.innerHTML = "There are no results to show with current filter settings";
      }
    }
  } else {
    var _result$Reviews2;
    if ((_result$Reviews2 = result.Reviews) !== null && _result$Reviews2 !== void 0 && _result$Reviews2.length) {
      result.Reviews.forEach(function (review) {
        var likebaleEntity = {
          EntityId: review.Id,
          ActivityType: "Review",
          UpVotes: review.UpVotes,
          DownVotes: review.DownVotes
        };
        var myVote = (0, _Likes.GetMyVote)(likebaleEntity, myId, isAnon);
        var el = document.createElement('div');
        (0, _Render.RenderReviewInto)(el, review, myVote, result.MyProfile, isMasquerade);
        container.appendChild(el);
      });
    } else {
      container.innerHTML = "There are no results to show with current filter settings";
    }
  }
  document.querySelectorAll('.text-body').forEach(function (el) {
    if (el.scrollHeight > el.clientHeight) {
      el.dataset.targetHeight = el.scrollHeight;
      var fade = el.nextElementSibling;
      if (fade && fade.classList.contains('preview-fade')) {
        fade.style.display = 'flex';
      }
    }
  });
  (0, _Hooks.InitializeReviewTabs)();
  (0, _LightBox.InitializeLBImages)('review-list-wrap');
  (0, _LightBox.InitializeLBImages)('review-template');
  (0, _UIHooks.IgnitePopOverMenus)();
  (0, _Hooks.IgniteReviewerStatusTooltip)();
  if (result.BrokerRatings) {
    (0, _Utilities.RenderBrokerFilter)(result.BrokerRatings, result.BrokerRatings.AccountTypes);
  }
  var accTypeRatingsContainer = document.getElementById('account-type-ratings');
  if (accTypeRatingsContainer != null && result.AccountTypeRatingsList.length) {
    (0, _Render.RenderAccountTypeRatingList)(result.AccountTypeRatingsList, accTypeRatingsContainer);
  }
  if (result.Filter.LoadRejected) {
    var rejectPaginateContainer = document.getElementById('rejected-review-paginator');
    if (rejectPaginateContainer) {
      (0, _Utilities.RenderAjaxPagination)({
        PageCount: model.reviewModel.PageCount,
        PageNumber: model.reviewModel.Page,
        HasNextPage: model.reviewModel.HasNextPage
      }, 'rejected-review-paginator', _Urls.FetchBrokerReviewsUrl, ProcessBrokerReviews, 'rejected-review-template', {
        RejectedPage: model.reviewModel.Page || 1,
        SortOrder: model.reviewModel.Filter.SortOrder,
        OneStar: model.reviewModel.Filter.OneStar,
        TwoStar: model.reviewModel.Filter.TwoStar,
        ThreeStar: model.reviewModel.Filter.ThreeStar,
        FourStar: model.reviewModel.Filter.FourStar,
        FiveStar: model.reviewModel.Filter.FiveStar,
        BrokerId: model.reviewModel.Filter.BrokerId,
        CultureId: model.reviewModel.Filter.CultureId,
        Sort: model.reviewModel.Filter.Sort,
        AccTypeId: model.reviewModel.Filter.AccTypeId
      });
    }
  } else {
    (0, _Utilities.RenderAjaxPagination)({
      PageCount: model.reviewModel.PageCount,
      PageNumber: model.reviewModel.Page,
      HasNextPage: model.reviewModel.HasNextPage
    }, 'review-paginator', _Urls.FetchBrokerReviewsUrl, ProcessBrokerReviews, 'review-template', {
      RejectedPage: model.reviewModel.Page || 1,
      SortOrder: model.reviewModel.Filter.SortOrder,
      OneStar: model.reviewModel.Filter.OneStar,
      TwoStar: model.reviewModel.Filter.TwoStar,
      ThreeStar: model.reviewModel.Filter.ThreeStar,
      FourStar: model.reviewModel.Filter.FourStar,
      FiveStar: model.reviewModel.Filter.FiveStar,
      BrokerId: model.reviewModel.Filter.BrokerId,
      CultureId: model.reviewModel.Filter.CultureId,
      Sort: model.reviewModel.Filter.Sort,
      AccTypeId: model.reviewModel.Filter.AccTypeId
    });
  }
}
function LoadCustomReviewData() {
  $.ajax({
    type: "POST",
    cache: false,
    // ReSharper disable once UseOfImplicitGlobalInFunctionScope
    url: window.loadCustomReviewDataUrl,
    dataType: "json",
    data: {
      brokerId: _State.ReviewState.BrokerId
    },
    success: function success(result) {
      if (result.reviewModel !== undefined && result.reviewModel !== null) {
        if (result.reviewModel.MyReview !== null && result.reviewModel.MyReview.Id !== undefined) {
          $("#submit-review-btn").hide();
          var container = document.getElementById('my-review');
          if (container != null) {
            (0, _Render.RenderMyReviewPreview)(result.reviewModel.MyReview, container);
          }
          (0, _LightBox.InitializeLBImages)('review-template');
          $('#my-review-card').show();
        }
        if (result.reviewModel.Comments.length > 0) {
          _State.ReviewState.MyPendingComments = result.reviewModel.Comments;
          if (result.reviewModel !== undefined && result.reviewModel.MyProfile !== null && result.reviewModel.MyProfile !== undefined) {
            _State2.SocialProfileState.MyProfile = result.reviewModel.MyProfile;
          }
        }
      }
    },
    error: function error(result) {}
  });
}

},{"../Shared/Likes.js":32,"../Shared/State.js":33,"../Shared/UIHooks.js":34,"./Hooks.js":8,"./LightBox.js":9,"./Render.js":11,"./State.js":13,"./Urls.js":24,"./Utilities.js":25}],23:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AccountTypeRatingList", {
  enumerable: true,
  get: function get() {
    return _AccountTypeRatingsList.AccountTypeRatingList;
  }
});
Object.defineProperty(exports, "RenderAccountTypeSelect", {
  enumerable: true,
  get: function get() {
    return _AccountTypeSelect.RenderAccountTypeSelect;
  }
});
Object.defineProperty(exports, "RenderAddReviewInputForm", {
  enumerable: true,
  get: function get() {
    return _ReviewInputForm.RenderAddReviewInputForm;
  }
});
Object.defineProperty(exports, "RenderComment", {
  enumerable: true,
  get: function get() {
    return _CommentTemplate.RenderComment;
  }
});
Object.defineProperty(exports, "RenderPreview", {
  enumerable: true,
  get: function get() {
    return _RenderPreview.RenderPreview;
  }
});
Object.defineProperty(exports, "RenderReply", {
  enumerable: true,
  get: function get() {
    return _ReplyTemplate.RenderReply;
  }
});
Object.defineProperty(exports, "RenderReplyFrame", {
  enumerable: true,
  get: function get() {
    return _CommentTemplate.RenderReplyFrame;
  }
});
Object.defineProperty(exports, "RenderReview", {
  enumerable: true,
  get: function get() {
    return _ReviewTemplate.RenderReview;
  }
});
Object.defineProperty(exports, "RenderStars", {
  enumerable: true,
  get: function get() {
    return _RenderStars.RenderStars;
  }
});
var _ReviewTemplate = require("./ReviewTemplate.js");
var _CommentTemplate = require("./CommentTemplate.js");
var _RenderPreview = require("./RenderPreview.js");
var _ReplyTemplate = require("./ReplyTemplate.js");
var _ReviewInputForm = require("./ReviewInputForm.js");
var _AccountTypeSelect = require("./AccountTypeSelect.js");
var _AccountTypeRatingsList = require("./AccountTypeRatingsList.js");
var _RenderStars = require("./RenderStars.js");

},{"./AccountTypeRatingsList.js":14,"./AccountTypeSelect.js":15,"./CommentTemplate.js":16,"./RenderPreview.js":17,"./RenderStars.js":18,"./ReplyTemplate.js":19,"./ReviewInputForm.js":21,"./ReviewTemplate.js":22}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* common-shake removed: exports.AppendForumImagesToFormData = */ void AppendForumImagesToFormData;
exports.IgniteAddPhotoButton = IgniteAddPhotoButton;
/* common-shake removed: exports.InitializeLBImages = */ void InitializeLBImages;
/* common-shake removed: exports.PaintRestoredImage = */ void PaintRestoredImage;
/* common-shake removed: exports.RemoveImage = */ void RemoveImage;
/* common-shake removed: exports.allowedFileTypes = */ void void 0;
var _State = require("./State.js");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function InitializeLBImages(containerClass) {
  var images = $('.' + containerClass + ' img.lightbox-slide:not(.lightbox-image)');
  for (var i = 0; i < images.length; i++) {
    if ($(images[i]).parent().is('a')) continue;
    var srcLink = $(images[i]).attr('src');
    $(images[i]).wrap("<a href='".concat(srcLink, "' data-toggle='lightbox-image' data-target-id='lightbox-image-holder'>"));
  }
  $('[data-toggle="lightbox-image"]').on('click', function (e) {
    var _this = this;
    e.preventDefault();
    var clickedIndex = 0;
    var gallery = $(this).closest('.image-row').find('img');
    var id = $(this).data("target-id");
    var srclink = $(this).attr('href');
    $('#' + id + " img.lightbox-image").attr('src', srclink);
    var modelPopUp = $('#' + id);
    modelPopUp.removeClass('has-next has-prev');
    modelPopUp.data('gallery', []);
    if (gallery.length > 1) {
      modelPopUp.data('gallery', gallery);
      gallery.each(function (i, el) {
        if (el.src === _this.href) clickedIndex = i;
      });
      modelPopUp.data('currentIndex', clickedIndex);
      if (clickedIndex > 0) modelPopUp.addClass('has-prev');
      if (clickedIndex + 1 < gallery.length) modelPopUp.addClass('has-next');
    }
    $('.XofY .x').html(clickedIndex + 1);
    $('.XofY .y').html(gallery.length);
    setTimeout(function () {
      return modelPopUp.modal('show');
    }, 100);
    return false;
  });
}
function IgniteAddPhotoButton() {
  imgInp.onchange = function (evt) {
    var _imgInp$files = _slicedToArray(imgInp.files, 1),
      file = _imgInp$files[0];
    if (!file) return;

    // Validate file type
    if (!allowedFileTypes.includes(file.type)) {
      alert(window.INVALID_FILE_TYPE);
      return;
    }

    // Validate file size (2 MB limit)
    if (file.size > 2 * 1024 * 1024) {
      alert(window.FILE_SIZE_TOO_BIG);
      return;
    }

    // Paint preview
    PaintImage(file, "#img-frames"); // assuming target ID

    // Store with metadata
    _State.ReviewState.Tmp_files.push({
      file: file,
      name: file.name,
      type: "new",
      deleted: false
    });
  };
}
function PaintRestoredImage(file) {
  var frameId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "#img-frames";
  // specialized version for editing mode
  var reader = new FileReader();
  reader.onload = function (e) {
    var imgHTML = "<div class='attached-files'>\n            <img src='".concat(e.target.result, "' class=\"review-image\" style=\"max-width: 100%; height: auto;\">\n            <svg fill=\"currentColor\"\n     onclick=\"window.BrokerReview.RemoveImage('").concat(file.name, "','").concat(frameId, "')\"\n     preserveAspectRatio=\"xMidYMid meet\"\n     height=\"25\"\n     width=\"25\"\n     viewBox=\"0 0 40 40\"\n     class=\"delete-review-image\"\n     style=\"vertical-align: middle; color: rgb(51, 51, 51);\">\n    <g>\n        <path d=\"m30.1 21.4v-2.8q0-0.6-0.4-1t-1-0.5h-17.1q-0.6 0-1 0.5t-0.5 1v2.8q0 0.6 0.5 1t1 0.5h17.1q0.6 0 1-0.5t0.4-1z \n                 m7.2-1.4q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 \n                 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z\"></path>\n    </g>\n</svg>\n\n        </div>");
    $(frameId).append(imgHTML);
  };
  reader.readAsDataURL(file);
}
;
function AppendForumImagesToFormData(formData) {
  var deletedRestored = [];
  var preservedRestored = [];
  var _iterator = _createForOfIteratorHelper(_State.ReviewState.Tmp_files),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _meta$file;
      var meta = _step.value;
      if (meta.type === "new" && !meta.deleted && (_meta$file = meta.file) !== null && _meta$file !== void 0 && (_meta$file = _meta$file.type) !== null && _meta$file !== void 0 && _meta$file.match('image.*')) {
        formData.append('Files', meta.file, meta.name);
      }
      if (meta.type === "restored" && meta.deleted) {
        deletedRestored.push(meta.name);
      }
      if (meta.type === "restored" && !meta.deleted) {
        preservedRestored.push(meta.name);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  deletedRestored.forEach(function (name) {
    return formData.append('DeletedFileNames', name);
  });
  preservedRestored.forEach(function (name) {
    return formData.append('PreservedFileNames', name);
  });
}
function RemoveImage(fileName) {
  var frameId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "#img-frames";
  // Mark matching image as deleted
  var _iterator2 = _createForOfIteratorHelper(_State.ReviewState.Tmp_files),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var entry = _step2.value;
      if (entry.name === fileName) {
        entry.deleted = true;
      }
    }

    // Clear image preview container
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  $(frameId).html('');

  // Re-render only non-deleted images
  var _iterator3 = _createForOfIteratorHelper(_State.ReviewState.Tmp_files),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _entry = _step3.value;
      if (!_entry.deleted) {
        PaintImage(_entry, frameId);
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
}
var allowedFileTypes = /* common-shake removed: exports.allowedFileTypes = */ ["image/jpeg", "image/png", "image/gif", "image/webp", "image/heic", "image/heif"];
function PaintImage(fileOrObject) {
  var frameId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "#img-frames";
  var entry = fileOrObject.file ? fileOrObject : {
    file: fileOrObject,
    name: fileOrObject.name
  };
  var imageHTML = "\n        <div class='attached-files'>\n            <img src='".concat(URL.createObjectURL(entry.file), "' class=\"review-image\">\n            ").concat(GetDeleteIcon(entry.name, frameId), "\n        </div>");
  $(frameId).append(imageHTML);
}
function GetDeleteIcon(fileName, frameId) {
  return "<svg fill=\"currentColor\"\n        onclick=\"window.BrokerReview.RemoveImage('".concat(fileName, "','").concat(frameId, "')\"\n        preserveAspectRatio=\"xMidYMid meet\"\n        height=\"25\" width=\"25\"\n        viewBox=\"0 0 40 40\"\n        class=\"delete-review-image\"\n        style=\"vertical-align: middle; color: rgb(51, 51, 51);\">\n        <g>\n            <path d=\"m30.1 21.4v-2.8q0-0.6-0.4-1t-1-0.5h-17.1q-0.6 0-1 0.5t-0.5 1v2.8q0 0.6 0.5 1t1 0.5h17.1q0.6 0 1-0.5t0.4-1z \n                     m7.2-1.4q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 \n                     2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z\"></path>\n        </g>\n    </svg>");
}

},{"./State.js":13}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RenderAccountTypeRatingList = RenderAccountTypeRatingList;
exports.RenderAccountTypeSelectList = RenderAccountTypeSelectList;
/* common-shake removed: exports.RenderCommentInto = */ void RenderCommentInto;
exports.RenderMyReviewPreview = RenderMyReviewPreview;
exports.RenderReviewInto = RenderReviewInto;
var _index = require("./Templates/index.js");
function RenderAccountTypeSelectList(container, options, selected) {
  var dropdown = (0, _index.RenderAccountTypeSelect)(options, selected);
  container.innerHTML = '';
  container.appendChild(dropdown);
}
function RenderReviewInto(containerEl, review, myVote, myProfile) {
  var isMasquerade = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var reviewHtml = (0, _index.RenderReview)(review, myVote, myProfile, isMasquerade);
  containerEl.innerHTML = reviewHtml;
}
function RenderCommentInto(container, comment, myVote) {
  var commentHtml = (0, _index.RenderComment)(comment, myVote);
  container.insertAdjacentHTML('beforeend', commentHtml);
}
function RenderMyReviewPreview(model, container) {
  var previewHtml = (0, _index.RenderPreview)(model);
  container.innerHTML = previewHtml;
}
function RenderAccountTypeRatingList(model, container) {
  var list = (0, _index.AccountTypeRatingList)(model);
  container.innerHTML = "";
  container.appendChild(list);
}

},{"./Templates/index.js":23}],14:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountTypeRatingList = AccountTypeRatingList;
/**
* Renders a list of account types with associated user star ratings and review counts.
*
* @param {Array<{ DefaultDisplayName: string, Rating: number, Reviews: number }>} ratingList - Account type rating data.
* @returns {HTMLDivElement} A container div containing the rendered structure.
*/
function AccountTypeRatingList() {
  var ratingList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  if (!ratingList.length) return null;

  // Wrapper for the entire structure
  var wrapper = document.createElement('div');

  // Header row
  var headerRow = document.createElement('div');
  headerRow.className = 'frn-flex-row';
  var headerCell = document.createElement('div');
  headerCell.className = 'cell';
  var heading = document.createElement('h2');
  heading.className = 'no-margin-top';
  heading.textContent = window.ACCOUNT_TYPES_USER_RATING || 'Account Types User Rating';
  headerCell.appendChild(heading);
  headerRow.appendChild(headerCell);
  wrapper.appendChild(headerRow);

  // Content section
  var contentSection = document.createElement('div');
  contentSection.className = 'frn-flex-row column';

  // Build each item row
  ratingList.forEach(function (item) {
    var row = document.createElement('div');
    row.className = 'cell-group';
    var ratingCell = document.createElement('div');
    ratingCell.className = 'cell';
    var ratingBox = document.createElement('div');
    ratingBox.className = 'cell font-13';
    ratingBox.style.width = '105px';
    var stars = document.createElement('div');
    stars.className = 'star-holder';
    stars.style.fontSize = '20px';
    stars.style.color = '#FDC240';
    var filled = document.createElement('span');
    filled.className = "typcn stars-".concat(item.Rating);
    var empty = document.createElement('span');
    empty.className = "typcn outline-stars-".concat(5 - item.Rating);
    stars.appendChild(filled);
    stars.appendChild(empty);
    ratingBox.appendChild(stars);
    ratingCell.appendChild(ratingBox);
    row.appendChild(ratingCell);
    var labelCell = document.createElement('div');
    labelCell.className = 'cell';
    var displayName = item.AccountDisplayName || item.DefaultDisplayName || '';
    labelCell.textContent = "".concat(displayName, " (").concat(item.Reviews, ")");
    row.appendChild(labelCell);
    contentSection.appendChild(row);
  });
  wrapper.appendChild(contentSection);
  return wrapper;
}

},{}],15:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RenderAccountTypeSelect = RenderAccountTypeSelect;
function RenderAccountTypeSelect() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '*';
  var onChangeHandler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var wrapper = document.createElement('div');
  wrapper.className = 'cell-group column';
  var label = document.createElement('div');
  label.className = 'cell grey-text font-14';
  label.textContent = window.ACCOUNT_TYPES || 'Account Types:';
  wrapper.appendChild(label);
  var group = document.createElement('div');
  group.className = 'cell-group';
  var select = document.createElement('select');
  select.className = 'frn-override expand browser-default';
  select.id = 'review-acc-types';
  var allOption = document.createElement('option');
  allOption.value = '*';
  allOption.textContent = window.ALL || 'All';
  if (selected === '*' || selected == null) {
    allOption.selected = true;
  }
  select.appendChild(allOption);
  options.forEach(function (type) {
    var opt = document.createElement('option');
    opt.value = type.Id;
    opt.textContent = type.Name;
    if (type.Data === (selected === null || selected === void 0 ? void 0 : selected.toString())) {
      opt.selected = true;
    }
    select.appendChild(opt);
  });
  if (typeof onChangeHandler === 'function') {
    select.addEventListener('change', onChangeHandler);
  } else {
    // Lazy fallback — resolve on use
    select.addEventListener('change', function (e) {
      var _window$BrokerReview;
      if (typeof ((_window$BrokerReview = window.BrokerReview) === null || _window$BrokerReview === void 0 ? void 0 : _window$BrokerReview.FilterReviews) === 'function') {
        window.BrokerReview.FilterReviews(e);
      } else {
        console.warn('[AccountTypeSelect] BrokerReview.FilterReviews not yet available.');
      }
    });
  }
  group.appendChild(select);
  wrapper.appendChild(group);
  return wrapper;
}

},{}],16:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RenderComment = RenderComment;
exports.RenderReplyFrame = RenderReplyFrame;
var _Urls = require("../Urls.js");
var _State = require("../../Shared/State.js");
function RenderComment(comment) {
  var _comment$Images;
  var myVote = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var paths = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _paths$avatarPath = paths.avatarPath,
    avatarPath = _paths$avatarPath === void 0 ? '' : _paths$avatarPath,
    _paths$imagePathComme = paths.imagePathComment,
    imagePathComment = _paths$imagePathComme === void 0 ? '' : _paths$imagePathComme,
    _paths$now = paths.now,
    now = _paths$now === void 0 ? new Date() : _paths$now;
  var timeAgo = window.moment ? window.moment.duration(window.moment.utc(comment.CreatedAtString).diff(now)).humanize(true) : comment.CreatedAtString;
  return "\n    <div class=\"review-wrap ".concat(comment.Status.toLowerCase() === 'rejected' ? 'rejected-post' : '', "\">\n        <div class=\"frn-flex-row column review-box ").concat(comment.Status.toLowerCase(), "\" id=\"review-comment-").concat(comment.AttachedToPostId, "-").concat(comment.Id, "\">\n            <div class=\"cell-group review-header mb-2\" style=\"display:block\">\n                <div class=\"cell-group profile-header frn-flex-middle\">\n                    <div class=\"cell image-cell\">\n                        <img class=\"reviewer-image social-profile-navigate\" src=\"").concat((0, _Urls.GetAvatarPath)(comment.Author.ImageKey), "?w=64&h=64\" data-profile-id=\"").concat(comment.Author.Id, "\" />\n                    </div>\n                    <div class=\"cell-group reviewer-info column\">\n                        <div class=\"cell-group verification-group\">\n                            <span class=\"name-cell social-profile-navigate\" data-profile-id=\"").concat(comment.Author.Id, "\">").concat(comment.Author.PublicName, "</span>\n                            ").concat(renderStatus(comment), "\n                            ").concat(comment.Author.IsModerator ? "<div class=\"cell\"><span class=\"cell lesser-text inline-forum-label-moderator ml-2\">".concat(window.PORTAL_CODE, " ").concat(window.MODERATOR, "</span></div>") : '', "\n                        </div>\n                        ").concat(comment.Author.Country ? "<div class=\"cell reviewer-info lesser-text\">".concat(window.LOCATION, ":").concat(comment.Author.Country, "</div>") : '', "\n                        ").concat(comment.VerifiedAccountsList ? "<div class=\"cell reviewer-info lesser-text\">".concat(window.ACCOUNT_LIST, " ").concat(comment.VerifiedAccountsList, "</div>") : '', "\n                    </div>\n                    <div class=\"cell-group last column\">\n                        <div class=\"cell lesser-text\">").concat(timeAgo, "</div>\n                        <div class=\"cell status-cell\">").concat(renderStatusBadge(comment), "</div>\n                    </div>\n                </div>\n                <div class=\"flex justify-content-end\">").concat(renderStatus(comment, true), "</div>\n            </div>\n\n            <div class=\"cell-group review-body row\">\n                ").concat(comment.Comment, "\n            </div>\n\n            ").concat(comment.HasTranslation ? "\n            <div class=\"translation-div font-13\"><br /><em>".concat(window.TRANSLATION, ":</em><br />").concat(comment.Translation, "</div>") : '', "\n\n            ").concat((_comment$Images = comment.Images) !== null && _comment$Images !== void 0 && _comment$Images.length ? "\n            <div class=\"image-row\">\n                ".concat(comment.Images.map(function (img) {
    return "<img src=\"".concat(imagePathComment).concat(img.FileName, "\" class=\"review-img lightbox-slide\" />");
  }).join(''), "\n            </div>") : '', "\n\n            ").concat(comment.Status.toLowerCase() === 'approved' ? "\n            <div class=\"cell hr expand\"></div>\n            <div class=\"baseline-controls\">\n                <div class=\"control\">\n                    <i class=\"thumbsup icon buffer ".concat(myVote === 'up' ? 'my' : '', "\" onClick=\"window.SocialProfile.Thumbs('up','ReviewComment','").concat(comment.Id, "',this)\"></i>\n                </div>\n                <div class=\"control vote-score\">").concat(comment.VoteScore, "</div>\n                <div class=\"control\">\n                    <i class=\"thumbsdown icon ").concat(myVote === 'down' ? 'my' : '', "\" onClick=\"window.SocialProfile.Thumbs('down','ReviewComment','").concat(comment.Id, "',this)\"></i>\n                </div>\n                <div class=\"control open-reply\">\n                    ").concat(renderReplyText(comment), "\n                </div>\n            </div>\n            <div class=\"reply-wrap reply-list-").concat(comment.Id, "\" data-reply-post-id=\"").concat(comment.Id, "\" style=\"display:none\"></div>") : '', "\n        </div>\n    </div>");
}
function RenderReplyFrame(replyToCommentId, postId) {
  var _SocialProfileState$M, _SocialProfileState$M2, _SocialProfileState$M3;
  var profileId = (_SocialProfileState$M = (_SocialProfileState$M2 = _State.SocialProfileState.MyProfile) === null || _SocialProfileState$M2 === void 0 ? void 0 : _SocialProfileState$M2.Id) !== null && _SocialProfileState$M !== void 0 ? _SocialProfileState$M : 0;
  var imageKey = profileId == 0 ? 'default_user_avatar.png' : ((_SocialProfileState$M3 = _State.SocialProfileState.MyProfile) === null || _SocialProfileState$M3 === void 0 ? void 0 : _SocialProfileState$M3.ImageKey) || profileId;
  return "\n    <div class=\"add-reply frn-flex-row mt-2 pl-2\">\n        <div class=\"cell image-cell\">\n            <img class=\"reviewer-image social-profile-navigate\"\n                 src=\"".concat((0, _Urls.GetAvatarPath)(imageKey), "\"\n                 data-profile-id=\"").concat(profileId, "\" />\n        </div>\n        <div class=\"cell comment-box expand form-group\" style=\"padding-right:15px;\">\n            <input type=\"text\"\n                   class=\"comment-box-input form-control mb-0 frn-override text-box single-line\"\n                   style=\"padding-left:0; padding-right:0; text-indent: 10px\" />\n            <div class=\"progress primary-color-light tab-progress\" style=\"display: none;\">\n                <div class=\"indeterminate\"></div>\n            </div>\n        </div>\n        <div class=\"submit-comment-div last\">\n            <a href=\"javascript:void(0)\"\n               onclick=\"window.BrokerReview.SaveReply(this,'").concat(postId, "','").concat(replyToCommentId, "')\"\n               role=\"button\"\n               class=\"button waves-effect add-reply-button\">\n               ").concat(window.REPLY, "\n            </a>\n        </div>\n    </div>\n    <div class=\"reply-list-").concat(replyToCommentId, "\"></div>");
}
function renderStatus(comment) {
  var isMobile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var cls = isMobile ? 'd-flex d-sm-none' : 'd-none d-sm-flex';
  if (comment.ReviewerIsCompanyRep) {
    return "<div class=\"reviewer-status representative ".concat(cls, "\">\n            <div class=\"verified-icon\"><img src=\"/Content/dist/images/icons/company-rep-icon.svg\"></div>\n            <div class=\"verified-icon-text\">").concat(window.COMPANY_REPRESENTATIVE, "</div>\n        </div>");
  }
  if (comment.ReviewerIsVerified) {
    return "<div class=\"reviewer-status verified ".concat(cls, "\">\n            <div class=\"verified-icon\"><img src=\"/Content/dist/images/icons/checkcircle.svg\"></div>\n            <div class=\"verified-icon-text\">").concat(window.VERIFIED_REVIEWER, "</div>\n        </div>");
  }
  return "<div class=\"reviewer-status unverified ".concat(cls, "\">\n        <div class=\"verified-icon\"><img src=\"/Content/dist/images/icons/warningcircle.svg\"></div>\n        <div class=\"verified-icon-text\">").concat(window.UNVERIFIED_REVIEWER, "</div>\n    </div>");
}
function renderStatusBadge(comment) {
  var status = comment.Status.toLowerCase();
  if (status === 'pending') return "<span class=\"status-badge\">".concat(window.PENDING, "</span>");
  if (status === 'rejected') return "<span class=\"status-badge\">".concat(window.REJECTED, "</span>");
  return '';
}
function renderReplyText(comment) {
  var count = comment.ReplyCount;
  var id = comment.Id;
  var postId = comment.AttachedToPostId;
  if (count === 1) {
    return "<a href=\"javascript:void(0)\" onClick=\"window.BrokerReview.OpenReply('".concat(id, "','").concat(postId, "','Review')\">").concat(window.ONE_REPLY, "</a>");
  } else if (count > 1) {
    return "<a href=\"javascript:void(0)\" onClick=\"window.BrokerReview.OpenReply('".concat(id, "','").concat(postId, "','Review')\">").concat(window.X_REPLIES.replace('{0}', count), "</a>");
  } else {
    return "<a href=\"javascript:void(0)\" onClick=\"window.BrokerReview.OpenReply('".concat(id, "','").concat(postId, "','Review')\">").concat(window.LEAVE_A_REPLY, "</a>");
  }
}

},{"../../Shared/State.js":33,"../Urls.js":24}],17:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RenderPreview = RenderPreview;
var _Urls = require("../Urls.js");
var _RenderStars = require("./RenderStars.js");
function RenderPreview(review) {
  var _review$Reviewer, _review$Reviewer2, _review$Reviewer3, _review$Reviewer4, _review$Images;
  var paths = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _paths$avatarPath = paths.avatarPath,
    avatarPath = _paths$avatarPath === void 0 ? '' : _paths$avatarPath,
    _paths$imagePath = paths.imagePath,
    imagePath = _paths$imagePath === void 0 ? '' : _paths$imagePath;
  var country = (_review$Reviewer = review.Reviewer) === null || _review$Reviewer === void 0 ? void 0 : _review$Reviewer.Country;
  var reviewerName = ((_review$Reviewer2 = review.Reviewer) === null || _review$Reviewer2 === void 0 ? void 0 : _review$Reviewer2.PublicName) || '';
  var reviewerId = (_review$Reviewer3 = review.Reviewer) === null || _review$Reviewer3 === void 0 ? void 0 : _review$Reviewer3.Id;
  var imageKey = ((_review$Reviewer4 = review.Reviewer) === null || _review$Reviewer4 === void 0 ? void 0 : _review$Reviewer4.ImageKey) || 'default_user_avatar.png';
  var stars = (0, _RenderStars.RenderStars)(review.Rating);
  var status = review.Status;
  var imageGallery = '';
  if ((_review$Images = review.Images) !== null && _review$Images !== void 0 && _review$Images.length) {
    imageGallery = "<div class=\"image-row\">";
    review.Images.forEach(function (img) {
      imageGallery += "<img src=\"".concat((0, _Urls.GetReviewImageUrl)(img), "\" class=\"review-img lightbox-slide\" />");
    });
    imageGallery += "</div>";
  }
  var html = "\n<div class='review-wrap'>\n    <div class=\"frn-flex-row column review-box\">\n        <div class=\"cell-group review-header\">\n            <div class=\"cell image-cell\">\n                <img class=\"reviewer-image social-profile-navigate\" src=\"".concat((0, _Urls.GetAvatarPath)(imageKey), "\" data-profile-id=\"").concat(reviewerId, "\" />\n            </div>\n            <div class=\"cell-group reviewer-info column\">\n                <div class=\"cell-group verification-group\">\n                    <span class=\"name-cell social-profile-navigate\" data-profile-id=\"").concat(reviewerId, "\">").concat(reviewerName, "</span>\n                </div>\n                ").concat(country ? "<div class=\"cell reviewer-info lesser-text\">".concat(window.LOCATION, ":").concat(country, "</div>") : '', "\n            </div>\n            <div class=\"cell-group last column\">");
  if (review.Dispute == null || review.Dispute.Status == "ProcessRejected" || review.Dispute.Status == "ShowedReview" || review.Dispute.Status == "RemovedReview") {
    html += "\n                <div class=\"cell lesser-text mb-1\">\n                    <a href=\"javascript:void(0)\" onclick=\"window.BrokerReview.EditReview()\" class=\"btn btn-primary FXV frn-override waves-effect waves-light\">\n                        ".concat(window.EDIT_MY_REVIEW, "\n                    </a>\n                </div>");
  }
  html += "\n                <div class=\"cell lesser-text\">\n                    <span class=\"status-badge\">".concat(function () {
    if (status.toLowerCase() === 'approved') {
      return "".concat(window.STATUS_APPROVED);
    } else if (status.toLowerCase() === 'pending') {
      return "".concat(window.STATUS_PENDING);
    }
    return "".concat(window.STATUS_REJECTED);
  }(), "</span>\n                </div>\n            </div>\n        </div>\n        ").concat(stars, "\n        <div class=\"cell-group review-body row\">\n            ").concat(review.Content, "\n        </div>\n        ").concat(imageGallery, "\n    </div>\n</div>\n");
  return html;
}

},{"../Urls.js":24,"./RenderStars.js":18}],18:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RenderStars = RenderStars;
function RenderStars(rating) {
  if (rating > 0) {
    return "\n        <div class=\"star-holder\" style=\"font-size: 20px; color: #FDC240;\">\n            <span class=\"typcn stars-".concat(rating, "\"></span>\n            <span class=\"typcn outline-stars-").concat(5 - rating, "\"></span>\n            <span class=\"user-review-rating\">").concat(parseFloat(rating).toFixed(1), "</span>\n        </div>");
  }
  return "<div class='user-review-rating pl-0'>".concat(window.NO_RATING, "</div>");
}

},{}],19:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RenderReply = RenderReply;
var _State = require("../../Shared/State.js");
var _Urls = require("../Urls.js");
function RenderReply(comment) {
  var _comment$Author$Id, _comment$Author, _comment$Author2, _comment$Author3, _comment$Status;
  var paths = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _paths$avatarPath = paths.avatarPath,
    avatarPath = _paths$avatarPath === void 0 ? '' : _paths$avatarPath,
    _paths$now = paths.now,
    now = _paths$now === void 0 ? new Date() : _paths$now;
  var profileId = (_comment$Author$Id = comment === null || comment === void 0 || (_comment$Author = comment.Author) === null || _comment$Author === void 0 ? void 0 : _comment$Author.Id) !== null && _comment$Author$Id !== void 0 ? _comment$Author$Id : 'self';
  var imageKey = profileId == 'self' ? 'default_user_avatar.png' : (comment === null || comment === void 0 || (_comment$Author2 = comment.Author) === null || _comment$Author2 === void 0 ? void 0 : _comment$Author2.ImageKey) || profileId;
  var country = comment === null || comment === void 0 || (_comment$Author3 = comment.Author) === null || _comment$Author3 === void 0 ? void 0 : _comment$Author3.Country;
  var status = (comment === null || comment === void 0 || (_comment$Status = comment.Status) === null || _comment$Status === void 0 ? void 0 : _comment$Status.toLowerCase()) || '';
  var accounts = (comment === null || comment === void 0 ? void 0 : comment.VerifiedAccountsList) || '';
  var formattedDate = window.moment ? window.moment.utc(comment.CreatedAt).format('LL') : comment.CreatedAtString;
  return "\n    <div class=\"reply-post-wrap\">\n        <div class=\"frn-flex-row review-box\" id=\"review-comment-reply-".concat(comment.AttachedToPostId, "-").concat(comment.ReplyToCommentId, "-").concat(comment.Id, "\">\n            <div class=\"cell reply-group column expand\">\n                <div class=\"cell-group review-header mb-2\">\n                    <div class=\"cell-group profile-header frn-flex-middle ").concat(status === 'rejected' ? 'rejected-post' : '', " expand\">\n                        <div class=\"cell image-cell\">\n                            <img class=\"reviewer-image social-profile-navigate\"\n                                 src=\"").concat((0, _Urls.GetAvatarPath)(imageKey), "\"\n                                 data-profile-id=\"").concat(profileId, "\" />\n                        </div>\n                        <div class=\"cell-group reviewer-info column\">\n                            <div class=\"cell-group verification-group\">\n                                <span class=\"name-cell social-profile-navigate\"\n                                      data-profile-id=\"").concat(profileId, "\">\n                                      ").concat(comment.Author.PublicName, "\n                                </span>\n                                ").concat(renderStatus(comment), "\n                            </div>\n                            ").concat(country ? "<div class=\"cell reviewer-info lesser-text\">".concat(window.LOCATION, ": ").concat(country, "</div>") : '', "\n                            ").concat(accounts ? "<div class=\"cell reviewer-info lesser-text\">".concat(window.ACCOUNT_TYPES, ": ").concat(accounts, "</div>") : '', "\n                        </div>\n                        <div class=\"cell-group last column\">\n                            <div class=\"cell lesser-text\">").concat(formattedDate, "</div>\n                            <div class=\"cell status-cell\">").concat(renderStatusBadge(comment), "</div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"cell-group review-body row ").concat(status === 'rejected' ? 'rejected-post' : '', "\">\n                    ").concat(comment.Comment, "\n                </div>\n            </div>\n        </div>\n    </div>");
}
function renderStatus(comment) {
  if (comment.ReviewerIsCompanyRep) {
    return "<div class=\"reviewer-status representative\">\n                    <div class=\"verified-icon\">\n                        <img src=\"/Content/dist/images/icons/company-rep-icon.svg\" />\n                    </div>\n                </div>";
  }
  if (comment.ReviewerIsVerified) {
    return "<div class=\"reviewer-status verified\">\n                    <div class=\"verified-icon\">\n                        <img src=\"/Content/dist/images/icons/checkcircle.svg\" />\n                    </div>\n                </div>";
  }
  return "<div class=\"reviewer-status unverified\">\n                <div class=\"verified-icon\">\n                    <img src=\"/Content/dist/images/icons/warningcircle.svg\" />\n                </div>\n            </div>";
}
function renderStatusBadge(comment) {
  var _comment$Status2;
  var status = (_comment$Status2 = comment.Status) === null || _comment$Status2 === void 0 ? void 0 : _comment$Status2.toLowerCase();
  if (status === 'pending') return "<span class=\"status-badge\">".concat(window.PENDING, "</span>");
  if (status === 'rejected') return "<span class=\"status-badge\">".concat(window.REJECTED, "</span>");
  return '';
}

},{"../../Shared/State.js":33,"../Urls.js":24}],21:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RenderAddReviewInputForm = RenderAddReviewInputForm;
function RenderAddReviewInputForm(model) {
  var _model$Values$MTBroke;
  var BrokerName = model.BrokerName,
    Image = model.Image,
    AccountTypes = model.AccountTypes,
    Values = model.Values;
  var pass = model.Values.Pass === null ? "" : model.Values.Pass;
  var login = model.Values.Login === null ? "" : model.Values.Login;
  var brokerDropdown = renderBrokerServerDropdown(model.Servers, (_model$Values$MTBroke = model.Values.MTBroker) !== null && _model$Values$MTBroke !== void 0 ? _model$Values$MTBroke : '');
  var verifyByLogin = !!(login && pass && model.Values.MTBroker);
  var renderRating = function renderRating() {
    var stars = '';
    for (var i = 1; i <= 5; i++) {
      var clicked = Values.Rating >= i ? 'class="clicked"' : '';
      stars += "\n                <li ".concat(clicked, ">\n                    <svg fill=\"currentColor\" height=\"48\" width=\"48\" viewBox=\"0 0 20 20\">\n                        <path d=\"M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z\"></path>\n                    </svg>\n                </li>");
    }
    return "\n            <ul id=\"heart-rate\">".concat(stars, "</ul>\n            <input type=\"hidden\" id=\"review-rating\" value=\"").concat(Values.Rating, "\" />\n            <input type=\"checkbox\" id=\"no-rating-checkbox\" ").concat(Values.NoRating ? 'checked' : '', " onclick=\"window.BrokerReview.NotRated()\"/>\n            <label for=\"no-rating-checkbox\">").concat(window.NO_RATING, "</label>\n        ");
  };
  var renderAccountTypes = function renderAccountTypes() {
    return AccountTypes.map(function (acc) {
      var _Values$AccountTypes;
      var checked = (_Values$AccountTypes = Values.AccountTypes) !== null && _Values$AccountTypes !== void 0 && _Values$AccountTypes.includes(acc.Id) ? 'checked' : '';
      return "\n                <div class=\"cell buffer\">\n                    <input type=\"checkbox\" id=\"acc-type-".concat(acc.Id, "\" value=\"").concat(acc.Id, "\" class=\"acc-type\" ").concat(checked, " />\n                    <label for=\"acc-type-").concat(acc.Id, "\" class=\"cell grey-text font-14\">").concat(acc.Name, "</label>\n                </div>");
    }).join('');
  };
  var renderReviewFormAndFooter = function renderReviewFormAndFooter() {
    var _window$VERIFIED_CUST, _window$VERIFY_YOU_AR;
    return "<div class=\"frn-flex-row super-slim column information\">\n      <div class=\"cell\">\n        <span class=\"font-14\">\n          <strong>".concat(window.PLEASE_BE_VERY_DETAILED, "</strong>\n        </span>\n        <br /><br />\n      </div>\n      <div class=\"cell\">\n        ").concat(window.PLEASE_SPELL_CORRECTLY, "\n      </div>\n    </div>\n\n    <div class=\"frn-flex-row super-slim\">\n      <div class=\"form-group sm-collapse-to-col cell full-stretch first collapse-small md-form frn-form-input\">\n        <textarea rows=\"5\" type=\"text\" id=\"review-input\" class=\"frn-override form-control\" name=\"reviewInput\">").concat(model.Values.PostBody || '', "</textarea>\n        <div class=\"validation-error font-13\" id=\"reviewInput-error\">").concat(window.PLEASE_SUBMIT_YOUR_REVIEW, "</div>\n      </div>\n    </div>\n\n    <div class=\"frn-flex-row super-slim column\">\n      <div class=\"cell\" id=\"verification-status\">\n        <div id=\"add-review-verified\" ").concat(model.Values.VerifyBy != null && model.Values.IsVerified ? '' : 'style="display: none"', ">\n          <span class=\"verified-customer\">\n            ").concat((_window$VERIFIED_CUST = window.VERIFIED_CUSTOMER_OF_X) === null || _window$VERIFIED_CUST === void 0 ? void 0 : _window$VERIFIED_CUST.replace('{0}', BrokerName), " <img src=\"/Content/dist/images/icons/checkcircle.svg\" alt=\"check\" class=\"icon-check-mark\">\n          </span>\n        </div>\n\n        <div id=\"add-review-unverified\" ").concat(model.Values.VerifyBy != null && model.Values.IsVerified ? 'style="display: none"' : '', ">\n          <div class=\"h6\">").concat((_window$VERIFY_YOU_AR = window.VERIFY_YOU_ARE_A_CUSTOMER) === null || _window$VERIFY_YOU_AR === void 0 ? void 0 : _window$VERIFY_YOU_AR.replace('{0}', BrokerName), "</div>\n          <div class=\"frn-flex-row super-slim column\" style=\"width: 100%;\">\n            <div class=\"cell expand\">\n              <input type=\"radio\" id=\"VerificationOption\" name=\"VerificationOption\" value=\"1\" onclick=\"InvestorDataDiv(1)\"  ").concat(verifyByLogin ? 'checked' : '', " >\n              <label for=\"VerificationOption\">").concat(window.PROVIDE_MT4MT5_INVESTOR_LOGIN_READONLY_ACCESS, "</label>\n            </div>\n\n            <div id=\"investor-data\" class=\"cell-group expand column\" style=\"margin-left: 35px; ").concat(model.Values.IsVerified ? 'display:none' : '', "\">\n              <div id=\"investor-data-input\" class=\"cell-group expand flex-column\">\n               ").concat(brokerDropdown, "\n                <div class=\"d-flex\">\n                  <div class=\"cell buffer\" style=\"flex:1;\">\n                    <input type=\"text\" id=\"investor-login\" class=\"frn-override form-control\" placeholder=\"Login\" value=\"").concat(login, "\" />\n                    <div class=\"validation-error font-13\" id=\"investor-error\">").concat(window.REQUIRED, "</div>\n                  </div>\n                  <div class=\"cell\" style=\"flex:1;\">\n                    <input type=\"text\" id=\"investor-password\" class=\"frn-override form-control\" placeholder=\"").concat(window.INVESTOR_PASSWORD, "\" value=\"").concat(pass, "\" />\n                    <div class=\"validation-error font-13\" id=\"investor-password-error\">").concat(window.REQUIRED, "</div>\n                  </div>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"flex align-items-center\" style=\"width: 100%; ").concat(model.Values.IsVerified ? 'display:none' : '', "\">\n              <div class=\"cell expand\">\n                <input type=\"radio\" id=\"VerificationOption2\" name=\"VerificationOption\" value=\"2\" onclick=\"InvestorDataDiv(2)\" ").concat(verifyByLogin === false ? 'checked' : '', ">\n                <label for=\"VerificationOption2\">").concat(window.DONT_VERIFY_ME_YOUR_RATING_WONT_COUNT, "</label>\n              </div>\n            </div>\n\n            <div class=\"frn-flex-row super-slim\">\n              <div class=\"validation-error font-13\" id=\"VerificationOption-error\">").concat(window.PLEASE_SELECT_VERIFICATION_OPTION, "</div>\n            </div>\n\n            <input type=\"hidden\" value=\"").concat(model.Values.IsVerified ? 1 : 0, "\" id=\"is-verified-value\" />\n          </div>\n        </div>\n      </div>\n\n      <form runat=\"server\">\n        <input accept=\"image/*\" type=\"file\" multiple id=\"imgInp\" />\n        <input id=\"captcha\" type=\"hidden\" name=\"Captcha\" value=\"\" />\n      </form>\n\n      <div class=\"frn-flex-row super-slim flex-row\" id=\"img-frames\"></div>\n\n      <div class=\"frn-flex-row super-slim flex-row\">\n        <div class=\"cell\">\n          <a id=\"dialog-login-button\" href=\"javascript:void(0)\" class=\"btn btn-primary FXV frn-override waves-effect waves-light payment-dialog-width\" onclick=\"window.BrokerReview.SubmitReview()\">\n            ").concat(window.SUBMIT_REVIEW, "\n          </a>\n        </div>\n        <div class=\"cell expand\">\n          <div class=\"add-image-btn\">\n            <label for=\"imgInp\" class=\"add-image-label\">").concat(window.ADD_PHOTOS, "</label>\n          </div>\n        </div>\n      </div>\n    </div>");
  };
  return "\n        <div class=\"frn-flex-row super-slim\">\n            <div class=\"cell-group divide-sixty-per column\">\n                <div class=\"cell-group column buffer\">\n                    <div class=\"cell grey-text font-14\">".concat(window.YOUR_RATING, ":</div>\n                    <div class=\"cell form-group validation-error-killer\">\n                        ").concat(renderRating(), "\n                        <div class=\"validation-error font-13\" id=\"review-rating-error\">").concat(window.PLEASE_SELECT_A_RATING, "</div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"cell-group column expand\">\n                <div class=\"cell grey-text font-14\">").concat(window.ACCOUNT_TYPE, "</div>\n                <div class=\"cell buffer\">\n                    <input type=\"checkbox\" id=\"acc-type-all\" value=\"0\" />\n                    <label for=\"acc-type-all\" class=\"cell grey-text font-14\">").concat(window.ALL_ACCOUNT_TYPES, "</label>\n                </div>\n                <div id=\"account-type-checkboxes\">\n                    ").concat(renderAccountTypes(), "\n                </div>\n                <div class=\"frn-flex-row\">\n                    <div class=\"cell validation-error font-13\" id=\"account-type-error\">\n                        ").concat(window.PLEASE_SELECT_AN_ACCOUNT_TYPE_IF_YOU, "\n                    </div>\n                </div>\n            </div>\n        </div>\n        ").concat(renderReviewFormAndFooter(), "\n    ");
}
function renderBrokerServerDropdown() {
  var servers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var selectedValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if (!servers.length) return '';
  var options = servers.map(function (server) {
    var value = "".concat(server.BrokerName, " (").concat(server.PlatformType, ")");
    var selected = selectedValue === value ? 'selected' : '';
    return "<option value=\"".concat(value, "\" ").concat(selected, ">").concat(value, "</option>");
  });
  return "\n    <div class=\"cell\" id=\"mt-broker-select-cell\">\n      <select class=\"frn-override form-control browser-default\" name=\"mt-broker\" id=\"mt-broker-select\" style=\"margin-top: 0.2rem; font-size: 13px; height: 36px;\">\n        <option value=\"\">".concat(window.SELECT_A_SERVER, "</option>\n        ").concat(options.join('\n'), "\n      </select>\n      <div class=\"validation-error font-13\" id=\"mt-broker-select-error\">").concat(window.REQUIRED, "</div>\n    </div>\n  ");
}

},{}],22:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RenderReview = RenderReview;
var _Urls = require("../Urls.js");
var _State = require("../../Shared/State.js");
function RenderReview(review, myVote, myProfile) {
  var isMasquerade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var dateStr = moment.utc(review.CreatedAt).format('LL');
  return "\n    <div class='review-wrap' id='review-author-".concat(review.Reviewer.Id, "'>\n        <div class=\"frn-flex-row column review-box\">\n            ").concat(renderMobileDate(dateStr), "\n            ").concat(renderHeader(review, dateStr), "\n            ").concat(renderStars(review), "\n            ").concat(renderModeratorNotes(review), "\n            <div class=\"cell-group review-body row\">").concat(review.Content, "</div>\n            ").concat(renderImageGallery(review.Images), "\n            ").concat(renderTranslation(review), "\n            <div class=\"cell hr expand\"></div>\n            ").concat(renderControls(review, myVote, myProfile, isMasquerade), "\n        </div>\n        ").concat(renderCommentBlock(review), "\n    </div>");
}
function renderMobileDate(dateStr) {
  return "<div class=\"cell last lesser-text d-block d-sm-none\">".concat(dateStr, "</div>");
}
function renderHeader(review, dateStr) {
  var repStatus = getRepStatus(review);
  var location = review.Reviewer.Country ? "<div class=\"cell reviewer-info lesser-text\">".concat(window.LOCATION, ": ").concat(review.Reviewer.Country, "</div>") : '';
  var accountTypes = review.VerifiedAccountsList ? "<div class=\"cell reviewer-info lesser-text\">".concat(window.ACCOUNT_TYPES, ": ").concat(review.VerifiedAccountsList, "</div>") : '';
  return "\n    <div class=\"cell-group review-header\">\n        <div class=\"cell image-cell\">\n            <img class=\"reviewer-image social-profile-navigate\" src=\"".concat((0, _Urls.GetAvatarPath)(review.Reviewer.ImageKey), "?w=64&h=64\" data-profile-id=\"").concat(review.Reviewer.Id, "\"/>\n        </div>\n        <div class=\"cell-group reviewer-info column\">\n            <div class=\"cell-group verification-group\">\n                <span class=\"name-cell social-profile-navigate\" data-profile-id=\"").concat(review.Reviewer.Id, "\">").concat(review.Reviewer.PublicName, "</span>\n                ").concat(repStatus.desktop, "\n            </div>\n            ").concat(location, "\n            ").concat(accountTypes, "\n        </div>\n        <div class=\"cell last lesser-text d-none d-sm-block\">").concat(dateStr, "</div>\n    </div>");
}
function getRepStatus(review) {
  var html = '';
  var cls = '';
  var label = '';
  if (review.Status === "RejectedAndDisplay") {
    cls = 'suspicious';
    label = window.SUSPICIOUS_REVIEWER;
  } else if (review.ReviewerIsCompanyRep) {
    cls = 'representative';
    label = window.COMPANY_REPRESENTATIVE;
  } else if (review.ReviewerIsVerified) {
    cls = 'verified';
    label = window.VERIFIED_REVIEWER;
  } else {
    cls = 'unverified';
    label = window.UNVERIFIED_REVIEWER;
  }
  var icon;
  if (cls === 'unverified' || cls === 'suspicious') {
    icon = 'warningcircle.svg';
  } else if (cls == 'representative') {
    icon = 'company-rep-icon.svg';
  } else {
    icon = 'checkcircle.svg';
  }
  html = "\n    <div class=\"reviewer-status ".concat(cls, " d-none d-sm-flex\">\n        <div class=\"verified-icon\"><img src=\"/Content/dist/images/icons/").concat(icon, "\"></div>\n        <div class=\"verified-icon-text\">").concat(label, "</div>\n    </div>");
  var mobile = html.replace('d-none d-sm-flex', 'd-flex d-sm-none');
  return {
    desktop: html,
    mobile: mobile
  };
}
function renderStars(review) {
  var colors = ['#FA4C3B', '#FA9529', '#FDC240', '#85DF2C', '#27AE1E'];
  var rating = parseFloat(review.Rating).toFixed(1);
  var ratingHtml = '';
  if (review.Rating >= 1 && review.Rating <= 5) {
    ratingHtml = "\n        <div class=\"star-holder\" style=\"font-size: 20px; color: ".concat(colors[review.Rating - 1], "\">\n            <span class=\"typcn stars-").concat(review.Rating, "\"></span>\n            <span class=\"typcn outline-stars-").concat(5 - review.Rating, "\"></span>\n            <span class=\"user-review-rating\">").concat(rating, "</span>\n        </div>");
  } else {
    ratingHtml = "<div class='user-review-rating pl-0'>".concat(window.NO_RATING, "</div>");
  }
  return "<div class=\"d-flex align-items-center\">\n        ".concat(ratingHtml, "\n        ").concat(getRepStatus(review).mobile, "\n    </div>");
}
function renderModeratorNotes(review) {
  if (!review.ModeratorNotes) return '';
  return "<div class=\"alert alert-primary\">\n        <strong>".concat(window.MODERATOR_NOTES, "</strong><br>").concat(review.ModeratorNotes, "\n    </div>");
}
function renderImageGallery(images) {
  if (!images.length) return '';
  return "<div class=\"image-row\">\n        ".concat(images.map(function (img) {
    return "<img src=\"".concat((0, _Urls.GetReviewImageUrl)(img), "\" class=\"review-img lightbox-slide\" />");
  }).join(''), "\n    </div>");
}
function renderTranslation(review) {
  if (!review.HasTranslation) return '';
  return "<div class='translation-div font-13'><br /><em>".concat(window.TRANSLATION, ":</em><br />").concat(review.Translation, "</div>");
}
function renderControls(review, myVote, myProfile) {
  var _review$VoteScore;
  var isMasquerade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var isCompanyRep = false;
  if (myProfile) isCompanyRep = myProfile.IsCompanyRepForBrokers.includes(review.BrokerId);
  var html = "\n    <div class=\"flex justify-content-between flex-wrap\">\n        <div class=\"baseline-controls\" ".concat(function () {
    if (isMasquerade) {
      return "hide";
    } else {
      return "";
    }
  }(), ">\n            <div class=\"control\">\n                <i class=\"thumbsup icon buffer ").concat(myVote === 'up' ? 'my' : '', "\" \n                    onClick=\"window.SocialProfile.Thumbs('up','Review','").concat(review.Id, "',this)\">\n                </i>\n            </div>\n            <div class=\"control vote-score\">").concat((_review$VoteScore = review.VoteScore) !== null && _review$VoteScore !== void 0 ? _review$VoteScore : 0, "</div>\n            <div class=\"control\">\n                <i class=\"thumbsdown icon ").concat(myVote === 'down' ? 'my' : '', "\" \n                    onClick=\"window.SocialProfile.Thumbs('down','Review','").concat(review.Id, "',this)\">\n                </i>\n            </div>\n            <div class=\"control open-comment\">\n                ").concat(renderCommentLabel(review), "\n            </div>\n        </div>");
  if (isCompanyRep == true && (review.Dispute == null || review.Dispute.Status == "ProcessRejected" || review.Dispute.Status == "ShowedReview" || review.Dispute.Status == "RemovedReview")) {
    html += "<div class=\"control open-comment\" style=\"margin-top: 7px\">\n            <a href=\"javascript:void(0)\" style=\"margin-left: 0px\" class=\"hover-underline\" onClick=\"window.BrokerReview.OpenDisputeDialog('".concat(review.Id, "', '").concat(myProfile.Id, "')\">").concat(window.DISPUTE_THIS_REVIEW, "</a>\n        </div>");
  }
  if (review.Dispute != null && review.Dispute.Status != "ProcessRejected" && review.Dispute.Status != "ShowedReview" && review.Dispute.Status != "RemovedReview") {
    html += "<div class=\"control open-comment\" style=\"margin-top: 7px\">\n            <span class=\"dispute-on-going\">".concat(window.DISPUTE_ONGOING, "</span>\n        </div>");
  }
  html += "</div>";
  return html;
}
function renderCommentLabel(review) {
  if (review.CommentCount === 1) {
    return "<a href=\"javascript:void(0)\" class=\"hover-underline\" onClick=\"window.BrokerReview.OpenComment('".concat(review.Id, "')\">").concat(window.ONE_COMMENTS, "</a>");
  }
  if (review.CommentCount > 0) {
    return "<a href=\"javascript:void(0)\" class=\"hover-underline\" onClick=\"window.BrokerReview.OpenComment('".concat(review.Id, "')\">").concat(window.X_COMMENTS.replace('{X}', review.CommentCount), "</a>");
  }
  return "<a href=\"javascript:void(0)\" class=\"hover-underline\" onClick=\"window.BrokerReview.OpenComment('".concat(review.Id, "')\">").concat(window.LEAVE_A_COMMENT, "</a>");
}
function renderCommentBlock(review) {
  var _SocialProfileState$M, _SocialProfileState$M2, _SocialProfileState$M3, _SocialProfileState$M4;
  var avatar = (0, _Urls.GetAvatarPath)((_SocialProfileState$M = (_SocialProfileState$M2 = _State.SocialProfileState.MyProfile) === null || _SocialProfileState$M2 === void 0 ? void 0 : _SocialProfileState$M2.ImageKey) !== null && _SocialProfileState$M !== void 0 ? _SocialProfileState$M : 'null');
  var socProfId = (_SocialProfileState$M3 = (_SocialProfileState$M4 = _State.SocialProfileState.MyProfile) === null || _SocialProfileState$M4 === void 0 ? void 0 : _SocialProfileState$M4.Id) !== null && _SocialProfileState$M3 !== void 0 ? _SocialProfileState$M3 : 0;
  return "<div class='comment-wrap review-comment-wrap' data-comment-post-id='".concat(review.Id, "' style=\"display:none\">\n        <div class='add-comment frn-flex-row mb-2'>\n            <div class=\"cell image-cell\">\n                <img class=\"reviewer-image social-profile-navigate\" src=\"").concat(avatar, "\" data-profile-id=\"").concat(socProfId, "\" />\n            </div>\n            <div class=\"cell comment-box expand form-group\">\n                <input type=\"text\" class=\"comment-box-input form-control mb-0 frn-override text-box single-line\"\n                       style=\"padding-left:0; padding-right:0; text-indent: 10px\"/>\n                <div class=\"progress primary-color-light tab-progress\" style=\"display: none;\">\n                    <div class=\"indeterminate\"></div>\n                </div>\n            </div>\n            <div class=\"submit-comment-div last d-none d-sm-flex\">\n                <a href=\"javascript:void(0)\" id=\"comment-button-").concat(review.Id, "-desktop\"\n                   onclick=\"window.BrokerReview.AddReviewComment(this,'").concat(review.Id, "')\"\n                   class=\"button waves-effect add-comment-button\">").concat(window.SUBMIT_COMMENT, "</a>\n            </div>\n            <div class=\"submit-comment-div last d-flex d-sm-none\">\n                <a href=\"javascript:void(0)\" id=\"comment-button-").concat(review.Id, "-mobile\"\n                   onclick=\"window.BrokerReview.AddReviewComment(this,'").concat(review.Id, "')\"\n                   class=\"button waves-effect add-comment-button\">\n                   <img style=\"width:16px; height: 16px;\" src=\"/Content/dist/images/icons/send-icon-white.svg\" />\n                </a>\n            </div>\n        </div>\n        <div class='comment-list-").concat(review.Id, "'></div>\n    </div>");
}

},{"../../Shared/State.js":33,"../Urls.js":24}],29:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var TagDropdown = exports["default"] = /*#__PURE__*/function () {
  function TagDropdown(textarea, onSelect) {
    _classCallCheck(this, TagDropdown);
    this.avatarPath = "".concat(window.assetServer, "/assets/images/profiles/");
    this.textarea = textarea;
    this.onSelect = onSelect; // TagHandler's insertion callback
    this.suggestions = [];
    this.selectedIndex = 0;
    this.mentionMap = {}; // Will be passed to parser later
    this.createDropdown();
  }
  return _createClass(TagDropdown, [{
    key: "createDropdown",
    value: function createDropdown() {
      this.dropdown = document.createElement('ul');
      this.dropdown.className = 'tag-dropdown';
      this.dropdown.style.position = 'absolute';
      this.dropdown.style.zIndex = 9999;
      this.dropdown.style.display = 'none';
      this.dropdown.style.background = 'white';
      this.dropdown.style.border = '1px solid #ccc';
      this.dropdown.style.listStyle = 'none';
      this.dropdown.style.padding = '0';
      this.dropdown.style.margin = '0';
      document.body.appendChild(this.dropdown);
    }
  }, {
    key: "showSuggestions",
    value: function showSuggestions(suggestions, prefix) {
      var _this = this;
      this.suggestions = suggestions;
      this.prefix = prefix;
      this.selectedIndex = 0;
      this.dropdown.innerHTML = '';
      this.dropdown.innerHTML = suggestions.map(function (u, i) {
        var h = (u.Handle || '').startsWith('@') ? u.Handle : '@' + u.Handle;
        return "<li class=\"tag-option ".concat(i === 0 ? 'active' : '', "\" data-handle=\"").concat(h, "\" data-id=\"").concat(u.SocialProfileId, "\">\n             <img src=\"").concat(_this.avatarPath).concat(u.AvatarPath, "\" alt=\"").concat(u.Handle, "\" style=\"width:24px; height:24px; border-radius:12px; vertical-align:middle; margin-right:8px;\">\n             <strong>").concat(u.Handle, "</strong> <span style=\"color:#666;\">(").concat(u.DisplayName, ")</span>\n         </li >");
      }).join('');
      var rect = this.textarea.getBoundingClientRect();
      this.dropdown.style.top = "".concat(rect.bottom + window.scrollY, "px");
      this.dropdown.style.left = "".concat(rect.left + window.scrollX, "px");
      this.dropdown.style.width = "".concat(rect.width, "px");
      this.dropdown.style.display = 'block';
      this.dropdown.onmousedown = function (e) {
        var li = e.target.closest('li');
        if (li) {
          var handle = (li.dataset.handle || '').startsWith('@') ? li.dataset.handle : '@' + (li.dataset.handle || '');
          var userId = li.dataset.id;
          console.log('Tag selected:', handle, userId);
          e.preventDefault(); // Prevent focus loss
          _this.insertSelected(handle, userId);
        }
      };
    }
  }, {
    key: "hide",
    value: function hide() {
      this.dropdown.style.display = 'none';
    }
  }, {
    key: "isVisible",
    value: function isVisible() {
      return this.dropdown.style.display === 'block';
    }
  }, {
    key: "insertSelected",
    value: function insertSelected(handle, userId) {
      if (typeof this.onSelect === 'function') {
        this.onSelect(handle, userId); // delegate to TagHandler
        this.hide();
      } else {
        console.warn('insertTagFn is not defined on TagDropdown.');
      }
    }

    //insertTag(handle, userId) {
    //    const sel = window.getSelection();
    //    if (!sel || sel.rangeCount === 0) return;

    //    const range = sel.getRangeAt(0);
    //    const container = range.startContainer;

    //    // We only handle text-node insertion here (most common case while typing).
    //    if (container.nodeType !== Node.TEXT_NODE) {
    //        console.warn('Caret not in a text node; consider the anchor-range approach below.');
    //        return;
    //    }

    //    const text = container.textContent;
    //    const beforeCaret = text.slice(0, range.startOffset);
    //    const match = beforeCaret.match(/@(\w{2,})$/);
    //    if (!match) {
    //        console.warn("No @prefix match.");
    //        return;
    //    }

    //    // Compute prefix bounds inside this text node
    //    const prefixStart = range.startOffset - match[0].length; // includes '@'
    //    const prefixEnd = range.startOffset;

    //    // Split the text node into: [beforePrefix][prefix][afterCaret]
    //    const beforeText = text.slice(0, prefixStart);
    //    const afterText = text.slice(prefixEnd);

    //    // Rewrite current text node to be "beforePrefix"
    //    container.textContent = beforeText;

    //    // Build mention token
    //    //const mention = document.createElement('mention');
    //    //mention.textContent = `@${handle}`;
    //    const mention = document.createElement('mention');
    //    mention.textContent = `${handle}`;
    //    mention.setAttribute('user-id', userId);
    //    mention.setAttribute('handle', handle);
    //    mention.classList.add('forum-mention');
    //    mention.contentEditable = 'false';

    //    const space = document.createTextNode(' '); // keep typing nice
    //    const afterNode = document.createTextNode(afterText);

    //    // Insert [mention][space][afterNode] right after the shortened text node
    //    const parent = container.parentNode;
    //    parent.insertBefore(mention, container.nextSibling);
    //    parent.insertBefore(space, mention.nextSibling);
    //    parent.insertBefore(afterNode, space.nextSibling);

    //    // Move caret after the space
    //    const newRange = document.createRange();
    //    newRange.setStartAfter(space);
    //    newRange.setEndAfter(space);
    //    sel.removeAllRanges();
    //    sel.addRange(newRange);

    //    // Tell drafts “content changed”
    //    this.textarea.dispatchEvent(new Event('input', { bubbles: true }));
    //}
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      var _this2 = this;
      if (e.key === 'ArrowDown') {
        this.selectedIndex = (this.selectedIndex + 1) % this.suggestions.length;
        e.preventDefault();
      } else if (e.key === 'ArrowUp') {
        this.selectedIndex = (this.selectedIndex - 1 + this.suggestions.length) % this.suggestions.length;
        e.preventDefault();
      } else if (e.key === 'Enter') {
        e.preventDefault();
        var selected = this.suggestions[this.selectedIndex];
        if (selected) this.insertSelected(selected.Handle, selected.SocialProfileId);
        return;
      }
      var items = this.dropdown.querySelectorAll('li');
      items.forEach(function (el, i) {
        return el.classList.toggle('active', i === _this2.selectedIndex);
      });
    }
  }]);
}();

},{}],35:[function(require,module,exports){
"use strict";

var _SocialProfile = _interopRequireDefault(require("../../includes/SocialProfile.js"));
var _Lightbox = _interopRequireDefault(require("../../includes/Lightbox.js"));
var _Cookie = _interopRequireDefault(require("../../includes/Cookie.js"));
var _NewsManager = _interopRequireDefault(require("../../includes/NewsManager.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
$(function () {
  window.Lightbox = new _Lightbox["default"]();
  window.SocialProfile = new _SocialProfile["default"](window.Lightbox, new _Cookie["default"]());
  window.NewsInstance = new _NewsManager["default"]();
});

},{"../../includes/Cookie.js":1,"../../includes/Lightbox.js":3,"../../includes/NewsManager.js":4,"../../includes/SocialProfile.js":5}]},{},[35]);
